

export const sampleSearchData = {
    random: [
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1767311062787907926",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNDI3NTk5ODg4",
                                    "rest_id": "2427599888",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Fri Apr 04 17:21:15 +0000 2014",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Everything you need to know about the Portuguese superstar Cristiano Ronaldo. A fan account.   DM’s are open for business enquiries/promos. \uD83D\uDCE8",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 7970,
                                        "followers_count": 307822,
                                        "friends_count": 74,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 411,
                                        "location": "",
                                        "media_count": 24933,
                                        "name": "The CR7 Timeline.",
                                        "normal_followers_count": 307822,
                                        "pinned_tweet_ids_str": [
                                            "1604536534149267461"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/2427599888/1628713802",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1528775264204906498/oufC8Yu8_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "TimelineCR7",
                                        "statuses_count": 30651,
                                        "translator_type": "none",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1767311062787907926"
                            ],
                            "editable_until_msecs": "1710198367000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "160912",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                        "legacy": {
                            "bookmark_count": 41,
                            "bookmarked": false,
                            "created_at": "Mon Mar 11 22:06:07 +0000 2024",
                            "conversation_id_str": "1767311062787907926",
                            "display_text_range": [
                                0,
                                82
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/w1dpydgmap",
                                        "expanded_url": "https://twitter.com/pubitysport/status/1767310853467148445/photo/1",
                                        "id_str": "1767310848748666880",
                                        "indices": [
                                            59,
                                            82
                                        ],
                                        "media_key": "3_1767310848748666880",
                                        "media_url_https": "https://pbs.twimg.com/media/GIa_2nNbwAA-pRK.jpg",
                                        "source_status_id_str": "1767310853467148445",
                                        "source_user_id_str": "1265056541444636673",
                                        "type": "photo",
                                        "url": "https://t.co/W1dPYDGmAp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 566,
                                                        "y": 624,
                                                        "h": 1174,
                                                        "w": 1174
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 331,
                                                        "y": 365,
                                                        "h": 687,
                                                        "w": 687
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 187,
                                                        "y": 207,
                                                        "h": 389,
                                                        "w": 389
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 566,
                                                        "y": 624,
                                                        "h": 1174,
                                                        "w": 1174
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 502,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1796,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1767310848748666880"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/W1dPYDGmAp",
                                        "expanded_url": "https://twitter.com/pubitysport/status/1767310853467148445/photo/1",
                                        "id_str": "1767310848748666880",
                                        "indices": [
                                            59,
                                            82
                                        ],
                                        "media_key": "3_1767310848748666880",
                                        "media_url_https": "https://pbs.twimg.com/media/GIa_2nNbwAA-pRK.jpg",
                                        "source_status_id_str": "1767310853467148445",
                                        "source_user_id_str": "1265056541444636673",
                                        "type": "photo",
                                        "url": "https://t.co/W1dPYDGmAp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 566,
                                                        "y": 624,
                                                        "h": 1174,
                                                        "w": 1174
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 331,
                                                        "y": 365,
                                                        "h": 687,
                                                        "w": 687
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 187,
                                                        "y": 207,
                                                        "h": 389,
                                                        "w": 389
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 566,
                                                        "y": 624,
                                                        "h": 1174,
                                                        "w": 1174
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 502,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1796,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1767310848748666880"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 3983,
                            "favorited": false,
                            "full_text": "Cristiano Ronaldo was let down by his team yet again... \uD83D\uDC94\n\nhttps://t.co/W1dPYDGmAp",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 49,
                            "reply_count": 380,
                            "retweet_count": 192,
                            "retweeted": false,
                            "user_id_str": "2427599888",
                            "id_str": "1767311062787907926"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1776288426498916658",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjQ4NDkxOQ==",
                                    "rest_id": "26484919",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Mar 25 12:26:50 +0000 2009",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "ASU, LCFI, Play Labs@MIT, Simulation Hypothesis, Wisdom of a Yogi, Startup Myths, Zen Entrepreneurship; Knights of Badassdom; Griffin Gaming Partners.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "zenentrepreneur.com",
                                                        "expanded_url": "http://www.zenentrepreneur.com",
                                                        "url": "https://t.co/SMbe2dOESO",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 25755,
                                        "followers_count": 17676,
                                        "friends_count": 7665,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 285,
                                        "location": "Mountain View, CA",
                                        "media_count": 666,
                                        "name": "Riz Virk",
                                        "normal_followers_count": 17676,
                                        "pinned_tweet_ids_str": [
                                            "1856678445452775668"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/26484919/1734891451",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/378800000002668909/f81e3ec8fa3f8c46d11118d558c0da3d_normal.jpeg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Rizstanford",
                                        "statuses_count": 9497,
                                        "translator_type": "none",
                                        "url": "https://t.co/SMbe2dOESO",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/8No4kpHf92",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "photo_image_full_size_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image",
                                        "value": {
                                            "image_value": {
                                                "height": 150,
                                                "width": 240,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=280x150"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "description",
                                        "value": {
                                            "string_value": "Escape the Matrix with bestselling author and MIT computer scientist Rizwan Virk, author of The Simulation Hypothesis, as he delves into questions of ancient yogic wisdom and modern technology by...",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "domain",
                                        "value": {
                                            "string_value": "www.watkinsbooks.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 320,
                                                "width": 513,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=800x320_1"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 513,
                                                "width": 822,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 62,
                                                "width": 100,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=100x100"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 513,
                                                "width": 822,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_original",
                                        "value": {
                                            "image_value": {
                                                "height": 513,
                                                "width": 822,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "vanity_url",
                                        "value": {
                                            "scribe_key": "vanity_url",
                                            "string_value": "watkinsbooks.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 112,
                                                            "green": 153,
                                                            "red": 224
                                                        },
                                                        "percentage": 25.96
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 70,
                                                            "green": 174,
                                                            "red": 217
                                                        },
                                                        "percentage": 21.45
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 22,
                                                            "green": 37,
                                                            "red": 64
                                                        },
                                                        "percentage": 17.49
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 156,
                                                            "green": 186,
                                                            "red": 121
                                                        },
                                                        "percentage": 17.3
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 191,
                                                            "green": 212,
                                                            "red": 217
                                                        },
                                                        "percentage": 16.74
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "title",
                                        "value": {
                                            "string_value": "Yogic Wisdom and the Simulation Hypothesis - Rizwan Virk | Watkins Bookshop",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 112,
                                                            "green": 153,
                                                            "red": 224
                                                        },
                                                        "percentage": 25.96
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 70,
                                                            "green": 174,
                                                            "red": 217
                                                        },
                                                        "percentage": 21.45
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 22,
                                                            "green": 37,
                                                            "red": 64
                                                        },
                                                        "percentage": 17.49
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 156,
                                                            "green": 186,
                                                            "red": 121
                                                        },
                                                        "percentage": 17.3
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 191,
                                                            "green": 212,
                                                            "red": 217
                                                        },
                                                        "percentage": 16.74
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 513,
                                                "width": 822,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 112,
                                                            "green": 153,
                                                            "red": 224
                                                        },
                                                        "percentage": 25.96
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 70,
                                                            "green": 174,
                                                            "red": 217
                                                        },
                                                        "percentage": 21.45
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 22,
                                                            "green": 37,
                                                            "red": 64
                                                        },
                                                        "percentage": 17.49
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 156,
                                                            "green": 186,
                                                            "red": 121
                                                        },
                                                        "percentage": 17.3
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 191,
                                                            "green": 212,
                                                            "red": 217
                                                        },
                                                        "percentage": 16.74
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 513,
                                                "width": 822,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/8No4kpHf92",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 513,
                                                "width": 822,
                                                "url": "https://pbs.twimg.com/card_img/1876005180358922240/77hTlRgU?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "summary_large_image",
                                "url": "https://t.co/8No4kpHf92",
                                "user_refs_results": []
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1776288426498916658"
                            ],
                            "editable_until_msecs": "1712338737000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "300",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 0,
                            "bookmarked": false,
                            "created_at": "Fri Apr 05 16:38:57 +0000 2024",
                            "conversation_id_str": "1776288426498916658",
                            "display_text_range": [
                                0,
                                195
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "watkinsbooks.com/event-details/…",
                                        "expanded_url": "https://www.watkinsbooks.com/event-details/yogic-wisdom-and-the-simulation-hypothesis-rizwan-virk",
                                        "url": "https://t.co/8No4kpHf92",
                                        "indices": [
                                            172,
                                            195
                                        ]
                                    }
                                ],
                                "user_mentions": [
                                    {
                                        "id_str": "54841345",
                                        "name": "Watkins Books",
                                        "screen_name": "watkinsbooks",
                                        "indices": [
                                            46,
                                            59
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 3,
                            "favorited": false,
                            "full_text": "Join me in London for a talk and book signing @watkinsbooks /   Watkins Books on May 16 at 17:00, about two of my books, the simulation hypothesis &amp; wisdom of a yogi!\n\nhttps://t.co/8No4kpHf92",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 0,
                            "reply_count": 0,
                            "retweet_count": 0,
                            "retweeted": false,
                            "user_id_str": "26484919",
                            "id_str": "1776288426498916658"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1587238232541929472",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjQ4NDkxOQ==",
                                    "rest_id": "26484919",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Mar 25 12:26:50 +0000 2009",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "ASU, LCFI, Play Labs@MIT, Simulation Hypothesis, Wisdom of a Yogi, Startup Myths, Zen Entrepreneurship; Knights of Badassdom; Griffin Gaming Partners.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "zenentrepreneur.com",
                                                        "expanded_url": "http://www.zenentrepreneur.com",
                                                        "url": "https://t.co/SMbe2dOESO",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 17129,
                                        "followers_count": 16216,
                                        "friends_count": 7704,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 280,
                                        "location": "Mountain View, CA",
                                        "media_count": 557,
                                        "name": "Riz Virk",
                                        "normal_followers_count": 16216,
                                        "pinned_tweet_ids_str": [
                                            "1779571560275460427"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/26484919/1679940641",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/378800000002668909/f81e3ec8fa3f8c46d11118d558c0da3d_normal.jpeg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Rizstanford",
                                        "statuses_count": 8735,
                                        "translator_type": "none",
                                        "url": "https://t.co/SMbe2dOESO",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/zsW6epegYC",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "description",
                                        "value": {
                                            "string_value": "It wouldn't be the first time officials put the issue to rest without a full, open-minded investigation.",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "domain",
                                        "value": {
                                            "string_value": "www.nbcnews.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "site",
                                        "value": {
                                            "scribe_key": "publisher_id",
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "14173315",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "creator",
                                        "value": {
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "14173315",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "vanity_url",
                                        "value": {
                                            "scribe_key": "vanity_url",
                                            "string_value": "nbcnews.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "title",
                                        "value": {
                                            "string_value": "Opinion | Government UFO report timed for Halloween seems to downplay spooky sightings",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/zsW6epegYC",
                                            "type": "STRING"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "summary_large_image",
                                "url": "https://t.co/zsW6epegYC",
                                "user_refs_results": [
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxNDE3MzMxNQ==",
                                            "rest_id": "14173315",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Tue Mar 18 23:19:17 +0000 2008",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "News updates from around the \uD83C\uDF0E, all day, every day.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "NBCNews.com",
                                                                "expanded_url": "http://NBCNews.com",
                                                                "url": "https://t.co/2f2PctyT1n",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 735,
                                                "followers_count": 9437317,
                                                "friends_count": 1356,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 52885,
                                                "location": "New York, NY",
                                                "media_count": 95519,
                                                "name": "NBC News",
                                                "normal_followers_count": 9437317,
                                                "pinned_tweet_ids_str": [],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/14173315/1719340221",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1726675942938980352/bxKUxCUp_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "NBCNews",
                                                "statuses_count": 402790,
                                                "translator_type": "none",
                                                "url": "https://t.co/2f2PctyT1n",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    },
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxNDE3MzMxNQ==",
                                            "rest_id": "14173315",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Tue Mar 18 23:19:17 +0000 2008",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "News updates from around the \uD83C\uDF0E, all day, every day.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "NBCNews.com",
                                                                "expanded_url": "http://NBCNews.com",
                                                                "url": "https://t.co/2f2PctyT1n",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 735,
                                                "followers_count": 9437317,
                                                "friends_count": 1356,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 52885,
                                                "location": "New York, NY",
                                                "media_count": 95519,
                                                "name": "NBC News",
                                                "normal_followers_count": 9437317,
                                                "pinned_tweet_ids_str": [],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/14173315/1719340221",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1726675942938980352/bxKUxCUp_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "NBCNews",
                                                "statuses_count": 402790,
                                                "translator_type": "none",
                                                "url": "https://t.co/2f2PctyT1n",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1587238232541929472"
                            ],
                            "editable_until_msecs": "1667263858000",
                            "is_edit_eligible": false,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 7,
                            "bookmarked": false,
                            "created_at": "Tue Nov 01 00:20:58 +0000 2022",
                            "conversation_id_str": "1587238232541929472",
                            "display_text_range": [
                                0,
                                246
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            21,
                                            31
                                        ],
                                        "text": "UAPReport"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "nbcnews.com/think/opinion/…",
                                        "expanded_url": "https://www.nbcnews.com/think/opinion/halloween-nasa-intelligence-agencies-looking-ufos-seem-gearing-play-rcna54820",
                                        "url": "https://t.co/zsW6epegYC",
                                        "indices": [
                                            205,
                                            228
                                        ]
                                    }
                                ],
                                "user_mentions": [
                                    {
                                        "id_str": "905416143313219584",
                                        "name": "NBC News THINK",
                                        "screen_name": "NBCNewsTHINK",
                                        "indices": [
                                            233,
                                            246
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 262,
                            "favorited": false,
                            "full_text": "My latest article on #UAPReport, NASA study,  the Pentagon UAP office, NYTimes article and UFOs: Let's not repeat the past!  \"Government UFO report timed for Halloween seems to downplay spooky sightings\"  https://t.co/zsW6epegYC via @NBCNewsTHINK",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 13,
                            "reply_count": 26,
                            "retweet_count": 76,
                            "retweeted": false,
                            "user_id_str": "26484919",
                            "id_str": "1587238232541929472"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1770875623738687569",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxOTAzMzgyMDU0",
                                    "rest_id": "1903382054",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Wed Sep 25 08:23:07 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "See you in Berlin.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "englandfootball.com",
                                                        "expanded_url": "https://www.englandfootball.com",
                                                        "url": "https://t.co/eULxdoltKL",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 15277,
                                        "followers_count": 6319842,
                                        "friends_count": 409,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 7520,
                                        "location": "Germany",
                                        "media_count": 23386,
                                        "name": "England",
                                        "normal_followers_count": 6319842,
                                        "pinned_tweet_ids_str": [
                                            "1812366667592470719"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1903382054/1720894722",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1724212442077478912/v_kJPhyb_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "England",
                                        "statuses_count": 53140,
                                        "translator_type": "regular",
                                        "url": "https://t.co/eULxdoltKL",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1481260802090938369",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "card://1770875621419241472",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "unified_card",
                                        "value": {
                                            "string_value": "{\"type\":\"image_website\",\"component_objects\":{\"details_1\":{\"type\":\"details\",\"data\":{\"title\":{\"content\":\"Squad update from St. George's Park\",\"is_rtl\":false},\"subtitle\":{\"content\":\"eng.football\",\"is_rtl\":false},\"destination\":\"browser_1\"}},\"media_1\":{\"type\":\"media\",\"data\":{\"id\":\"3_1770872923055591424\",\"destination\":\"browser_1\"}}},\"destination_objects\":{\"browser_1\":{\"type\":\"browser\",\"data\":{\"url_data\":{\"url\":\"https://eng.football/ODMNlN\",\"vanity\":\"eng.football\"}}}},\"components\":[\"media_1\",\"details_1\"],\"media_entities\":{\"3_1770872923055591424\":{\"id\":1770872923055591424,\"id_str\":\"1770872923055591424\",\"indices\":[0,0],\"media_url\":\"\",\"media_url_https\":\"https://pbs.twimg.com/media/GJNnioEWEAAQn7z.jpg\",\"url\":\"\",\"display_url\":\"\",\"expanded_url\":\"\",\"type\":\"photo\",\"original_info\":{\"width\":1080,\"height\":1080,\"focus_rects\":[{\"x\":0,\"y\":475,\"h\":605,\"w\":1080},{\"x\":0,\"y\":0,\"h\":1080,\"w\":1080},{\"x\":0,\"y\":0,\"h\":1080,\"w\":947},{\"x\":27,\"y\":0,\"h\":1080,\"w\":540},{\"x\":0,\"y\":0,\"h\":1080,\"w\":1080}]},\"sizes\":{\"small\":{\"w\":680,\"h\":680,\"resize\":\"fit\"},\"large\":{\"w\":1080,\"h\":1080,\"resize\":\"fit\"},\"thumb\":{\"w\":150,\"h\":150,\"resize\":\"crop\"},\"medium\":{\"w\":1080,\"h\":1080,\"resize\":\"fit\"}},\"source_user_id\":1903382054,\"source_user_id_str\":\"1903382054\",\"media_key\":\"3_1770872923055591424\",\"ext\":{\"mediaColor\":{\"r\":{\"ok\":{\"palette\":[{\"rgb\":{\"red\":125,\"green\":132,\"blue\":54},\"percentage\":28.64},{\"rgb\":{\"red\":43,\"green\":36,\"blue\":31},\"percentage\":18.97},{\"rgb\":{\"red\":246,\"green\":221,\"blue\":225},\"percentage\":15.45},{\"rgb\":{\"red\":197,\"green\":3,\"blue\":37},\"percentage\":8.02},{\"rgb\":{\"red\":19,\"green\":23,\"blue\":60},\"percentage\":6.57}]}},\"ttl\":-1}}}}}",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://twitter.com",
                                            "type": "STRING"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "unified_card",
                                "url": "card://1770875621419241472",
                                "user_refs_results": []
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1770875623738687569"
                            ],
                            "editable_until_msecs": "1711048224000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "2181327",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">Twitter for Advertisers</a>",
                        "legacy": {
                            "bookmark_count": 78,
                            "bookmarked": false,
                            "created_at": "Thu Mar 21 18:10:24 +0000 2024",
                            "conversation_id_str": "1770875623738687569",
                            "display_text_range": [
                                0,
                                182
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            25,
                                            36
                                        ],
                                        "text": "ThreeLions"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "1038874580956442625",
                                        "name": "Bukayo Saka",
                                        "screen_name": "BukayoSaka87",
                                        "indices": [
                                            166,
                                            179
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 7058,
                            "favorited": false,
                            "full_text": "Bukayo Saka has left the #ThreeLions camp and returned to his club for continued rehabilitation on an injury he reported to St. George's Park with.\n\nSpeedy recovery, @BukayoSaka87! 👊",
                            "is_quote_status": false,
                            "lang": "en",
                            "quote_count": 740,
                            "reply_count": 428,
                            "retweet_count": 648,
                            "retweeted": false,
                            "user_id_str": "1903382054",
                            "id_str": "1770875623738687569"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1771340640758137242",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjQ4NDkxOQ==",
                                    "rest_id": "26484919",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Mar 25 12:26:50 +0000 2009",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "ASU, Play Labs @ MIT, Simulation Hypothesis, Wisdom of a Yogi, Startup Myths & Models, Zen Entrepreneurship; Knights of Badassdom; Griffin Gaming Partners.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "zenentrepreneur.com",
                                                        "expanded_url": "http://www.zenentrepreneur.com",
                                                        "url": "https://t.co/SMbe2dPcIm",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 16755,
                                        "followers_count": 15975,
                                        "friends_count": 7689,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 278,
                                        "location": "Mountain View, CA",
                                        "media_count": 539,
                                        "name": "Riz Virk",
                                        "normal_followers_count": 15975,
                                        "pinned_tweet_ids_str": [
                                            "1779571560275460427"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/26484919/1679940641",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/378800000002668909/f81e3ec8fa3f8c46d11118d558c0da3d_normal.jpeg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Rizstanford",
                                        "statuses_count": 8643,
                                        "translator_type": "none",
                                        "url": "https://t.co/SMbe2dPcIm",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1771340640758137242"
                            ],
                            "editable_until_msecs": "1711159093000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "9722",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "note_tweet": {
                            "is_expandable": true,
                            "note_tweet_results": {
                                "result": {
                                    "id": "Tm90ZVR3ZWV0OjE3NzEzNDA2NDA2NjU5NzY4MzI=",
                                    "text": "This pic/article was from 2020 when Google became a validator for @Theta_Network  - the THETA blockchain and token are still going strong, now supporting not just streaming video but also edge AI processing and soon 3D rendering using its extensive distributed network of nodes.... the future is decentralized! @mitchliu",
                                    "entity_set": {
                                        "hashtags": [],
                                        "symbols": [],
                                        "urls": [],
                                        "user_mentions": [
                                            {
                                                "id_str": "918994376105197568",
                                                "name": "Theta Network",
                                                "screen_name": "Theta_Network",
                                                "indices": [
                                                    66,
                                                    80
                                                ]
                                            },
                                            {
                                                "id_str": "14074187",
                                                "name": "Mitch Liu | Theta Network",
                                                "screen_name": "mitchliu",
                                                "indices": [
                                                    311,
                                                    320
                                                ]
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1266210082506891264",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxNTgxMzE0MA==",
                                            "rest_id": "15813140",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Mon Aug 11 20:08:12 +0000 2008",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Follow along for how-tos, demos, product news, and more. For company updates, check out @GoogleCloud. Watch #GoogleCloudNext on demand ⬇️",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "goo.gle/40LpZz9",
                                                                "expanded_url": "https://goo.gle/40LpZz9",
                                                                "url": "https://t.co/ruAmIbElE5",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 5391,
                                                "followers_count": 1241143,
                                                "friends_count": 1783,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 9120,
                                                "location": "",
                                                "media_count": 6639,
                                                "name": "Google Cloud Tech",
                                                "normal_followers_count": 1241143,
                                                "pinned_tweet_ids_str": [],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/15813140/1716931234",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1219725421962571779/_qstUQx__normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "GoogleCloudTech",
                                                "statuses_count": 23680,
                                                "translator_type": "none",
                                                "url": "https://t.co/ruAmIbElE5",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1482051175142748161",
                                                "professional_type": "Business",
                                                "category": [
                                                    {
                                                        "id": 1009,
                                                        "name": "Community",
                                                        "icon_name": "IconBriefcaseStroke"
                                                    }
                                                ]
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                },
                                "card": {
                                    "rest_id": "https://t.co/SZG15NCvti",
                                    "legacy": {
                                        "binding_values": [
                                            {
                                                "key": "photo_image_full_size_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 419,
                                                        "width": 800,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=800x419"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image",
                                                "value": {
                                                    "image_value": {
                                                        "height": 150,
                                                        "width": 225,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=280x150"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "description",
                                                "value": {
                                                    "string_value": "Theta Labs announced that, from today, Google Cloud is involved in its Enterprise Validator Program, joining Binance, Gumi, and Blockchain Ventures.",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "domain",
                                                "value": {
                                                    "string_value": "chainbulletin.com",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 320,
                                                        "width": 480,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=800x320_1"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_small",
                                                "value": {
                                                    "image_value": {
                                                        "height": 202,
                                                        "width": 386,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=386x202"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_original",
                                                "value": {
                                                    "image_value": {
                                                        "height": 800,
                                                        "width": 1200,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=orig"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_small",
                                                "value": {
                                                    "image_value": {
                                                        "height": 202,
                                                        "width": 386,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=386x202"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 419,
                                                        "width": 800,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=800x419"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_small",
                                                "value": {
                                                    "image_value": {
                                                        "height": 67,
                                                        "width": 100,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=100x100"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_x_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 800,
                                                        "width": 1200,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=png&name=2048x2048_2_exp"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_original",
                                                "value": {
                                                    "image_value": {
                                                        "height": 800,
                                                        "width": 1200,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=orig"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "vanity_url",
                                                "value": {
                                                    "scribe_key": "vanity_url",
                                                    "string_value": "chainbulletin.com",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size",
                                                "value": {
                                                    "image_value": {
                                                        "height": 314,
                                                        "width": 600,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=600x314"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_color",
                                                "value": {
                                                    "image_color_value": {
                                                        "palette": [
                                                            {
                                                                "rgb": {
                                                                    "blue": 50,
                                                                    "green": 47,
                                                                    "red": 54
                                                                },
                                                                "percentage": 57.1
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 104,
                                                                    "green": 118,
                                                                    "red": 141
                                                                },
                                                                "percentage": 28.3
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 107,
                                                                    "green": 96,
                                                                    "red": 103
                                                                },
                                                                "percentage": 8.72
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 64,
                                                                    "green": 76,
                                                                    "red": 95
                                                                },
                                                                "percentage": 5.4
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 92,
                                                                    "green": 67,
                                                                    "red": 71
                                                                },
                                                                "percentage": 0.28
                                                            }
                                                        ]
                                                    },
                                                    "type": "IMAGE_COLOR"
                                                }
                                            },
                                            {
                                                "key": "title",
                                                "value": {
                                                    "string_value": "Theta Labs Welcomes Google Cloud As Enterprise Validator, Releases Mainnet 2.0 - The Chain Bulletin",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_color",
                                                "value": {
                                                    "image_color_value": {
                                                        "palette": [
                                                            {
                                                                "rgb": {
                                                                    "blue": 50,
                                                                    "green": 47,
                                                                    "red": 54
                                                                },
                                                                "percentage": 57.1
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 104,
                                                                    "green": 118,
                                                                    "red": 141
                                                                },
                                                                "percentage": 28.3
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 107,
                                                                    "green": 96,
                                                                    "red": 103
                                                                },
                                                                "percentage": 8.72
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 64,
                                                                    "green": 76,
                                                                    "red": 95
                                                                },
                                                                "percentage": 5.4
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 92,
                                                                    "green": 67,
                                                                    "red": 71
                                                                },
                                                                "percentage": 0.28
                                                            }
                                                        ]
                                                    },
                                                    "type": "IMAGE_COLOR"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_x_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 800,
                                                        "width": 1200,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=png&name=2048x2048_2_exp"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image",
                                                "value": {
                                                    "image_value": {
                                                        "height": 314,
                                                        "width": 600,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=600x314"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_color",
                                                "value": {
                                                    "image_color_value": {
                                                        "palette": [
                                                            {
                                                                "rgb": {
                                                                    "blue": 50,
                                                                    "green": 47,
                                                                    "red": 54
                                                                },
                                                                "percentage": 57.1
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 104,
                                                                    "green": 118,
                                                                    "red": 141
                                                                },
                                                                "percentage": 28.3
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 107,
                                                                    "green": 96,
                                                                    "red": 103
                                                                },
                                                                "percentage": 8.72
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 64,
                                                                    "green": 76,
                                                                    "red": 95
                                                                },
                                                                "percentage": 5.4
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 92,
                                                                    "green": 67,
                                                                    "red": 71
                                                                },
                                                                "percentage": 0.28
                                                            }
                                                        ]
                                                    },
                                                    "type": "IMAGE_COLOR"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_x_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 800,
                                                        "width": 1200,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=png&name=2048x2048_2_exp"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "card_url",
                                                "value": {
                                                    "scribe_key": "card_url",
                                                    "string_value": "https://t.co/SZG15NCvti",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_original",
                                                "value": {
                                                    "image_value": {
                                                        "height": 800,
                                                        "width": 1200,
                                                        "url": "https://pbs.twimg.com/card_img/1793638762645159936/qL-7D1MV?format=jpg&name=orig"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            }
                                        ],
                                        "card_platform": {
                                            "platform": {
                                                "audience": {
                                                    "name": "production"
                                                },
                                                "device": {
                                                    "name": "Swift",
                                                    "version": "12"
                                                }
                                            }
                                        },
                                        "name": "summary_large_image",
                                        "url": "https://t.co/SZG15NCvti",
                                        "user_refs_results": []
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1266210082506891264"
                                    ],
                                    "editable_until_msecs": "1590724783372",
                                    "is_edit_eligible": true,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "state": "Enabled"
                                },
                                "source": "<a href=\"https://www.sprinklr.com\" rel=\"nofollow\">Sprinklr</a>",
                                "legacy": {
                                    "bookmark_count": 14,
                                    "bookmarked": false,
                                    "created_at": "Fri May 29 03:29:43 +0000 2020",
                                    "conversation_id_str": "1266210082506891264",
                                    "display_text_range": [
                                        0,
                                        285
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [
                                            {
                                                "display_url": "chainbulletin.com/theta-labs-wel…",
                                                "expanded_url": "https://chainbulletin.com/theta-labs-welcomes-google-cloud-as-enterprise-validator-releases-mainnet-2-0/",
                                                "url": "https://t.co/SZG15NCvti",
                                                "indices": [
                                                    262,
                                                    285
                                                ]
                                            }
                                        ],
                                        "user_mentions": [
                                            {
                                                "id_str": "6186992",
                                                "name": "Allen Day",
                                                "screen_name": "allenday",
                                                "indices": [
                                                    250,
                                                    259
                                                ]
                                            }
                                        ]
                                    },
                                    "favorite_count": 590,
                                    "favorited": false,
                                    "full_text": "“We’re impressed by Theta’s achievements in blockchain video &amp; data delivery. We look forward to participating as an enterprise validator, and to providing Google Cloud infrastructure in support of Theta’s long-term mission &amp; future growth.”—@allenday ↓ https://t.co/SZG15NCvti",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 53,
                                    "reply_count": 34,
                                    "retweet_count": 220,
                                    "retweeted": false,
                                    "user_id_str": "15813140",
                                    "id_str": "1266210082506891264"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 3,
                            "bookmarked": false,
                            "created_at": "Sat Mar 23 00:58:13 +0000 2024",
                            "conversation_id_str": "1771340640758137242",
                            "display_text_range": [
                                0,
                                271
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "918994376105197568",
                                        "name": "Theta Network",
                                        "screen_name": "Theta_Network",
                                        "indices": [
                                            66,
                                            80
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 147,
                            "favorited": false,
                            "full_text": "This pic/article was from 2020 when Google became a validator for @Theta_Network  - the THETA blockchain and token are still going strong, now supporting not just streaming video but also edge AI processing and soon 3D rendering using its extensive distributed network of",
                            "is_quote_status": true,
                            "lang": "en",
                            "quote_count": 2,
                            "quoted_status_id_str": "1266210082506891264",
                            "quoted_status_permalink": {
                                "url": "https://t.co/DCO6xEmsck",
                                "expanded": "https://twitter.com/GoogleCloudTech/status/1266210082506891264",
                                "display": "x.com/GoogleCloudTec…"
                            },
                            "reply_count": 3,
                            "retweet_count": 38,
                            "retweeted": false,
                            "user_id_str": "26484919",
                            "id_str": "1771340640758137242"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1686910728358207488",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjQ4NDkxOQ==",
                                    "rest_id": "26484919",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Mar 25 12:26:50 +0000 2009",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "ASU, Play Labs @ MIT, Simulation Hypothesis, Wisdom of a Yogi, Startup Myths & Models, Zen Entrepreneurship; Knights of Badassdom; Griffin Gaming Partners.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "zenentrepreneur.com",
                                                        "expanded_url": "http://www.zenentrepreneur.com",
                                                        "url": "https://t.co/SMbe2dPcIm",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 16755,
                                        "followers_count": 15975,
                                        "friends_count": 7689,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 278,
                                        "location": "Mountain View, CA",
                                        "media_count": 539,
                                        "name": "Riz Virk",
                                        "normal_followers_count": 15975,
                                        "pinned_tweet_ids_str": [
                                            "1779571560275460427"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/26484919/1679940641",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/378800000002668909/f81e3ec8fa3f8c46d11118d558c0da3d_normal.jpeg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Rizstanford",
                                        "statuses_count": 8643,
                                        "translator_type": "none",
                                        "url": "https://t.co/SMbe2dPcIm",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "initial_tweet_id": "1686909880051834880",
                            "edit_control_initial": {
                                "edit_tweet_ids": [
                                    "1686909880051834880",
                                    "1686910728358207488"
                                ],
                                "editable_until_msecs": "1691029231000",
                                "is_edit_eligible": true,
                                "edits_remaining": "4"
                            }
                        },
                        "previous_counts": {
                            "bookmark_count": 0,
                            "favorite_count": 3,
                            "quote_count": 0,
                            "reply_count": 1,
                            "retweet_count": 1
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "50512",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "note_tweet": {
                            "is_expandable": true,
                            "note_tweet_results": {
                                "result": {
                                    "id": "Tm90ZVR3ZWV0OjE2ODY5MTA3MjgyNTM0NDgxOTQ=",
                                    "text": "Oh yeah and forgot to mention, we also heard at the Galileo Project conference that the NASA UAP/UFO report was delayed by (at least?)  two weeks.  I don't know why - whether it has anything to do with the recent hearings or just because of regular run-of- the mill reasons... I didn't hear an exact date, but maybe  @NASA or it's panel members have an update for the public on this eagerly awaited report? @DavidSpergel  @nadiamdrake  #UAP #UFOs",
                                    "entity_set": {
                                        "hashtags": [
                                            {
                                                "indices": [
                                                    436,
                                                    440
                                                ],
                                                "text": "UAP"
                                            },
                                            {
                                                "indices": [
                                                    441,
                                                    446
                                                ],
                                                "text": "UFOs"
                                            }
                                        ],
                                        "symbols": [],
                                        "urls": [],
                                        "user_mentions": [
                                            {
                                                "id_str": "11348282",
                                                "name": "NASA",
                                                "screen_name": "NASA",
                                                "indices": [
                                                    317,
                                                    322
                                                ]
                                            },
                                            {
                                                "id_str": "2294678598",
                                                "name": "David Spergel",
                                                "screen_name": "DavidSpergel",
                                                "indices": [
                                                    407,
                                                    420
                                                ]
                                            },
                                            {
                                                "id_str": "198020721",
                                                "name": "Dr. Nadia Drake",
                                                "screen_name": "nadiamdrake",
                                                "indices": [
                                                    422,
                                                    434
                                                ]
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1686829848545619968",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoyNjQ4NDkxOQ==",
                                            "rest_id": "26484919",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Wed Mar 25 12:26:50 +0000 2009",
                                                "default_profile": true,
                                                "default_profile_image": false,
                                                "description": "ASU, Play Labs @ MIT, Simulation Hypothesis, Wisdom of a Yogi, Startup Myths & Models, Zen Entrepreneurship; Knights of Badassdom; Griffin Gaming Partners.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "zenentrepreneur.com",
                                                                "expanded_url": "http://www.zenentrepreneur.com",
                                                                "url": "https://t.co/SMbe2dPcIm",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 16755,
                                                "followers_count": 15975,
                                                "friends_count": 7689,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 278,
                                                "location": "Mountain View, CA",
                                                "media_count": 539,
                                                "name": "Riz Virk",
                                                "normal_followers_count": 15975,
                                                "pinned_tweet_ids_str": [
                                                    "1779571560275460427"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/26484919/1679940641",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/378800000002668909/f81e3ec8fa3f8c46d11118d558c0da3d_normal.jpeg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "Rizstanford",
                                                "statuses_count": 8643,
                                                "translator_type": "none",
                                                "url": "https://t.co/SMbe2dPcIm",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1686829848545619968"
                                    ],
                                    "editable_until_msecs": "1691010150000",
                                    "is_edit_eligible": false,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "175316",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                                "note_tweet": {
                                    "is_expandable": true,
                                    "note_tweet_results": {
                                        "result": {
                                            "id": "Tm90ZVR3ZWV0OjE2ODY4Mjk4NDg0ODI3NzA5NDU=",
                                            "text": "Guess who showed up to give an impromptu panel at the Galileo project on the recent UFO/UAP news? \nDanny Sheehan (standing with microphone), Stanford's Garry Nolan, former Navy Rear Admiral Tim Gallaudet (occluded), and former Navy fighter pilot Ryan Graves... it was quite the panel with Avi Loeb asking questions.",
                                            "entity_set": {
                                                "hashtags": [],
                                                "symbols": [],
                                                "urls": [],
                                                "user_mentions": []
                                            }
                                        }
                                    }
                                },
                                "legacy": {
                                    "bookmark_count": 70,
                                    "bookmarked": false,
                                    "created_at": "Wed Aug 02 20:02:30 +0000 2023",
                                    "conversation_id_str": "1686829848545619968",
                                    "display_text_range": [
                                        0,
                                        277
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "media": [
                                            {
                                                "display_url": "pic.x.com/4k3db9tdcc",
                                                "expanded_url": "https://twitter.com/Rizstanford/status/1686829848545619968/photo/1",
                                                "id_str": "1686829839460839424",
                                                "indices": [
                                                    278,
                                                    301
                                                ],
                                                "media_key": "3_1686829839460839424",
                                                "media_url_https": "https://pbs.twimg.com/media/F2jSzUGXsAA295T.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/4K3DB9Tdcc",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": []
                                                    },
                                                    "medium": {
                                                        "faces": []
                                                    },
                                                    "small": {
                                                        "faces": []
                                                    },
                                                    "orig": {
                                                        "faces": []
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1536,
                                                        "w": 2048,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 900,
                                                        "w": 1200,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 510,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1536,
                                                    "width": 2048,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 2048,
                                                            "h": 1147
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1536,
                                                            "h": 1536
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1347,
                                                            "h": 1536
                                                        },
                                                        {
                                                            "x": 179,
                                                            "y": 0,
                                                            "w": 768,
                                                            "h": 1536
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 2048,
                                                            "h": 1536
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1686829839460839424"
                                                    }
                                                }
                                            }
                                        ],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": []
                                    },
                                    "extended_entities": {
                                        "media": [
                                            {
                                                "display_url": "pic.twitter.com/4K3DB9Tdcc",
                                                "expanded_url": "https://twitter.com/Rizstanford/status/1686829848545619968/photo/1",
                                                "id_str": "1686829839460839424",
                                                "indices": [
                                                    278,
                                                    301
                                                ],
                                                "media_key": "3_1686829839460839424",
                                                "media_url_https": "https://pbs.twimg.com/media/F2jSzUGXsAA295T.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/4K3DB9Tdcc",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": []
                                                    },
                                                    "medium": {
                                                        "faces": []
                                                    },
                                                    "small": {
                                                        "faces": []
                                                    },
                                                    "orig": {
                                                        "faces": []
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1536,
                                                        "w": 2048,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 900,
                                                        "w": 1200,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 510,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1536,
                                                    "width": 2048,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 2048,
                                                            "h": 1147
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1536,
                                                            "h": 1536
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1347,
                                                            "h": 1536
                                                        },
                                                        {
                                                            "x": 179,
                                                            "y": 0,
                                                            "w": 768,
                                                            "h": 1536
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 2048,
                                                            "h": 1536
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1686829839460839424"
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "favorite_count": 694,
                                    "favorited": false,
                                    "full_text": "Guess who showed up to give an impromptu panel at the Galileo project on the recent UFO/UAP news? \nDanny Sheehan (standing with microphone), Stanford's Garry Nolan, former Navy Rear Admiral Tim Gallaudet (occluded), and former Navy fighter pilot Ryan Graves... it was quite the https://t.co/4K3DB9Tdcc",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 20,
                                    "reply_count": 33,
                                    "retweet_count": 113,
                                    "retweeted": false,
                                    "user_id_str": "26484919",
                                    "id_str": "1686829848545619968"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 12,
                            "bookmarked": false,
                            "created_at": "Thu Aug 03 01:23:53 +0000 2023",
                            "conversation_id_str": "1686910728358207488",
                            "display_text_range": [
                                0,
                                278
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 156,
                            "favorited": false,
                            "full_text": "Oh yeah and forgot to mention, we also heard at the Galileo Project conference that the NASA UAP/UFO report was delayed by (at least?)  two weeks.  I don't know why - whether it has anything to do with the recent hearings or just because of regular run-of- the mill reasons... I",
                            "is_quote_status": true,
                            "lang": "en",
                            "quote_count": 5,
                            "quoted_status_id_str": "1686829848545619968",
                            "quoted_status_permalink": {
                                "url": "https://t.co/22PztICOlw",
                                "expanded": "https://twitter.com/Rizstanford/status/1686829848545619968",
                                "display": "x.com/Rizstanford/st…"
                            },
                            "reply_count": 15,
                            "retweet_count": 24,
                            "retweeted": false,
                            "user_id_str": "26484919",
                            "id_str": "1686910728358207488"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1803877904050221508",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozOTUwOTE3MzU=",
                                    "rest_id": "395091735",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": false,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Fri Oct 21 03:34:52 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "The Kid that brings that REAL Football Analysis. Telling you what you NEED to Know.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "havehopefootballhut.com",
                                                        "expanded_url": "http://havehopefootballhut.com",
                                                        "url": "https://t.co/6AMJjViYfi",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 44795,
                                        "followers_count": 6521,
                                        "friends_count": 422,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 41,
                                        "location": "Earth",
                                        "media_count": 12501,
                                        "name": "Have Hope \uD83C\uDDF3\uD83C\uDDEC",
                                        "normal_followers_count": 6521,
                                        "pinned_tweet_ids_str": [
                                            "1803903533462241638"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/395091735/1697046201",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1558644696997658624/2iUKDHW2_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "havehopehut",
                                        "statuses_count": 140244,
                                        "translator_type": "none",
                                        "url": "https://t.co/6AMJjViYfi",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1577444888433643520",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/4WIIZSFEpA",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "tweet_id",
                                        "value": {
                                            "string_value": "1803877904050221508",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "narrow_cast_space_type",
                                        "value": {
                                            "string_value": "0",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "id",
                                        "value": {
                                            "string_value": "1jMJgmmkjdYKL",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/4WIIZSFEpA",
                                            "type": "STRING"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "3691233323:audiospace",
                                "url": "https://t.co/4WIIZSFEpA",
                                "user_refs_results": []
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1803877904050221508"
                            ],
                            "editable_until_msecs": "1718916581000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1178",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/android\" rel=\"nofollow\">Twitter for Android</a>",
                        "legacy": {
                            "bookmark_count": 0,
                            "bookmarked": false,
                            "created_at": "Thu Jun 20 19:49:41 +0000 2024",
                            "conversation_id_str": "1803877904050221508",
                            "display_text_range": [
                                0,
                                23
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "x.com/i/spaces/1jMJg…",
                                        "expanded_url": "https://x.com/i/spaces/1jMJgmmkjdYKL",
                                        "url": "https://t.co/4WIIZSFEpA",
                                        "indices": [
                                            0,
                                            23
                                        ]
                                    }
                                ],
                                "user_mentions": []
                            },
                            "favorite_count": 0,
                            "favorited": false,
                            "full_text": "https://t.co/4WIIZSFEpA",
                            "is_quote_status": false,
                            "lang": "zxx",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 0,
                            "reply_count": 3,
                            "retweet_count": 0,
                            "retweeted": false,
                            "user_id_str": "395091735",
                            "id_str": "1803877904050221508"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1685764574174236672",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjQ4NDkxOQ==",
                                    "rest_id": "26484919",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Mar 25 12:26:50 +0000 2009",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "ASU, Play Labs @ MIT, Simulation Hypothesis, Wisdom of a Yogi, Startup Myths & Models, Zen Entrepreneurship; Knights of Badassdom; Griffin Gaming Partners.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "zenentrepreneur.com",
                                                        "expanded_url": "http://www.zenentrepreneur.com",
                                                        "url": "https://t.co/SMbe2dPcIm",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 16755,
                                        "followers_count": 15975,
                                        "friends_count": 7689,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 278,
                                        "location": "Mountain View, CA",
                                        "media_count": 539,
                                        "name": "Riz Virk",
                                        "normal_followers_count": 15975,
                                        "pinned_tweet_ids_str": [
                                            "1779571560275460427"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/26484919/1679940641",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/378800000002668909/f81e3ec8fa3f8c46d11118d558c0da3d_normal.jpeg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Rizstanford",
                                        "statuses_count": 8643,
                                        "translator_type": "none",
                                        "url": "https://t.co/SMbe2dPcIm",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1685764574174236672"
                            ],
                            "editable_until_msecs": "1690756169000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "12085",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1677406816500846594",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo0MjA2MjQ3ODA=",
                                            "rest_id": "420624780",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Thu Nov 24 21:46:23 +0000 2011",
                                                "default_profile": true,
                                                "default_profile_image": false,
                                                "description": "UFO experiencer.  Near Death Experience. Remote Viewing.  Simulation theory.  Synchronicities. Owls and UFO's like me. 144,000.  #444.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "instagram.com/lewdawgsr/",
                                                                "expanded_url": "https://www.instagram.com/lewdawgsr/",
                                                                "url": "https://t.co/W6TiRswkSp",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 9597,
                                                "followers_count": 3607,
                                                "friends_count": 1429,
                                                "has_custom_timelines": false,
                                                "is_translator": false,
                                                "listed_count": 24,
                                                "location": "Canada",
                                                "media_count": 807,
                                                "name": "LewDawg",
                                                "normal_followers_count": 3607,
                                                "pinned_tweet_ids_str": [
                                                    "1625154129688694792"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/420624780/1675954711",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1847305508283387905/eMC3_8rg_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "LueDawg1",
                                                "statuses_count": 6498,
                                                "translator_type": "none",
                                                "url": "https://t.co/W6TiRswkSp",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1520862545459892225",
                                                "professional_type": "Creator",
                                                "category": [
                                                    {
                                                        "id": 713,
                                                        "name": "Science & Technology",
                                                        "icon_name": "IconBriefcaseStroke"
                                                    }
                                                ]
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1677406816500846594"
                                    ],
                                    "editable_until_msecs": "1688763524000",
                                    "is_edit_eligible": true,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "15932",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                                "legacy": {
                                    "bookmark_count": 19,
                                    "bookmarked": false,
                                    "created_at": "Fri Jul 07 19:58:44 +0000 2023",
                                    "conversation_id_str": "1677406816500846594",
                                    "display_text_range": [
                                        0,
                                        127
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "media": [
                                            {
                                                "display_url": "pic.x.com/7l1xmo7ekw",
                                                "expanded_url": "https://twitter.com/LueDawg1/status/1677406816500846594/video/1",
                                                "id_str": "1677406732769955842",
                                                "indices": [
                                                    128,
                                                    151
                                                ],
                                                "media_key": "13_1677406732769955842",
                                                "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1677406732769955842/img/nXejWvWRqQVSbTd6.jpg",
                                                "type": "video",
                                                "url": "https://t.co/7l1XmO7ekw",
                                                "additional_media_info": {
                                                    "monetizable": false
                                                },
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1024,
                                                        "w": 576,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 1024,
                                                        "w": 576,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 680,
                                                        "w": 383,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1024,
                                                    "width": 576,
                                                    "focus_rects": []
                                                },
                                                "video_info": {
                                                    "aspect_ratio": [
                                                        9,
                                                        16
                                                    ],
                                                    "duration_millis": 138625,
                                                    "variants": [
                                                        {
                                                            "content_type": "application/x-mpegURL",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/pl/qXWWi8TsKUQ5ZiI2.m3u8?tag=14&v=60a"
                                                        },
                                                        {
                                                            "bitrate": 632000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/vid/320x568/lhA4v4bqfrbObqoP.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 950000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/vid/480x852/pDTfdLw2NcaOAfpS.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 2176000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/vid/576x1024/TLVmKvgnO5FtFig_.mp4?tag=14"
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "13_1677406732769955842"
                                                    }
                                                }
                                            }
                                        ],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": []
                                    },
                                    "extended_entities": {
                                        "media": [
                                            {
                                                "display_url": "pic.twitter.com/7l1XmO7ekw",
                                                "expanded_url": "https://twitter.com/LueDawg1/status/1677406816500846594/video/1",
                                                "id_str": "1677406732769955842",
                                                "indices": [
                                                    128,
                                                    151
                                                ],
                                                "media_key": "13_1677406732769955842",
                                                "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1677406732769955842/img/nXejWvWRqQVSbTd6.jpg",
                                                "type": "video",
                                                "url": "https://t.co/7l1XmO7ekw",
                                                "additional_media_info": {
                                                    "monetizable": false
                                                },
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1024,
                                                        "w": 576,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 1024,
                                                        "w": 576,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 680,
                                                        "w": 383,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1024,
                                                    "width": 576,
                                                    "focus_rects": []
                                                },
                                                "video_info": {
                                                    "aspect_ratio": [
                                                        9,
                                                        16
                                                    ],
                                                    "duration_millis": 138625,
                                                    "variants": [
                                                        {
                                                            "content_type": "application/x-mpegURL",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/pl/qXWWi8TsKUQ5ZiI2.m3u8?tag=14&v=60a"
                                                        },
                                                        {
                                                            "bitrate": 632000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/vid/320x568/lhA4v4bqfrbObqoP.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 950000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/vid/480x852/pDTfdLw2NcaOAfpS.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 2176000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1677406732769955842/vid/576x1024/TLVmKvgnO5FtFig_.mp4?tag=14"
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "13_1677406732769955842"
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "favorite_count": 48,
                                    "favorited": false,
                                    "full_text": "Religions, physicist’s and artificial intelligence experts are all converging to the same explanation of our simulated reality. https://t.co/7l1XmO7ekw",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 4,
                                    "reply_count": 4,
                                    "retweet_count": 14,
                                    "retweeted": false,
                                    "user_id_str": "420624780",
                                    "id_str": "1677406816500846594"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 13,
                            "bookmarked": false,
                            "created_at": "Sun Jul 30 21:29:29 +0000 2023",
                            "conversation_id_str": "1685764574174236672",
                            "display_text_range": [
                                0,
                                201
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 86,
                            "favorited": false,
                            "full_text": "Who knew a clip of me talking about the simulation hypothesis would go viral on TikTok! I don't even use TikTok but at least it's available on Twitter ..err... I mean X ...I mean ... simulated twitterX",
                            "is_quote_status": true,
                            "lang": "en",
                            "quote_count": 1,
                            "quoted_status_id_str": "1677406816500846594",
                            "quoted_status_permalink": {
                                "url": "https://t.co/sO7EMip9wo",
                                "expanded": "https://twitter.com/LueDawg1/status/1677406816500846594",
                                "display": "x.com/LueDawg1/statu…"
                            },
                            "reply_count": 15,
                            "retweet_count": 13,
                            "retweeted": false,
                            "user_id_str": "26484919",
                            "id_str": "1685764574174236672"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1805735115374399836",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo5MjQxNTQ5NjIzMDQ4MTUxMDU=",
                                    "rest_id": "924154962304815105",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sat Oct 28 06:04:47 +0000 2017",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "The Art Of Dialogue is the number one source for celebrity interviews, bringing you top-tier content.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "youtube.com/@TheArtOfDialo…",
                                                        "expanded_url": "https://youtube.com/@TheArtOfDialogue",
                                                        "url": "https://t.co/8onbNRIGLW",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 4289,
                                        "followers_count": 87219,
                                        "friends_count": 56,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 177,
                                        "location": "Las Vegas, NV",
                                        "media_count": 2060,
                                        "name": "The Art Of Dialogue",
                                        "normal_followers_count": 87219,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/924154962304815105/1651687844",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1521915007864295430/DXEnd09Y_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "ArtOfDialogue_",
                                        "statuses_count": 5229,
                                        "translator_type": "none",
                                        "url": "https://t.co/8onbNRIGLW",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1487196017472655366",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1805735115374399836"
                            ],
                            "editable_until_msecs": "1719359375000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "20763",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                        "legacy": {
                            "bookmark_count": 168,
                            "bookmarked": false,
                            "created_at": "Tue Jun 25 22:49:35 +0000 2024",
                            "conversation_id_str": "1805735115374399836",
                            "display_text_range": [
                                0,
                                118
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/uz32vmnjdw",
                                        "expanded_url": "https://twitter.com/ArtOfDialogue_/status/1805735115374399836/video/1",
                                        "id_str": "1805730599841251328",
                                        "indices": [
                                            119,
                                            142
                                        ],
                                        "media_key": "13_1805730599841251328",
                                        "media_url_https": "https://pbs.twimg.com/media/GQ9CflxWEAAwJDg.jpg",
                                        "type": "video",
                                        "url": "https://t.co/uz32VMNJdw",
                                        "additional_media_info": {
                                            "title": "Wack 100 Gets Grilled By Prosecutors Over Posting Tupac Murder Suspect",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 720,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 720,
                                            "width": 1280,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 860970,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/pl/womSmYq2IIGMAcfG.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/vid/avc1/480x270/yFj467sJ5N2wSRdp.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/vid/avc1/640x360/hBgQo9aAprUFJhEc.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/vid/avc1/1280x720/IdeXNAf2-PchFf7z.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1805730599841251328"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/uz32VMNJdw",
                                        "expanded_url": "https://twitter.com/ArtOfDialogue_/status/1805735115374399836/video/1",
                                        "id_str": "1805730599841251328",
                                        "indices": [
                                            119,
                                            142
                                        ],
                                        "media_key": "13_1805730599841251328",
                                        "media_url_https": "https://pbs.twimg.com/media/GQ9CflxWEAAwJDg.jpg",
                                        "type": "video",
                                        "url": "https://t.co/uz32VMNJdw",
                                        "additional_media_info": {
                                            "title": "Wack 100 Gets Grilled By Prosecutors Over Posting Tupac Murder Suspect",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 720,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 720,
                                            "width": 1280,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 860970,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/pl/womSmYq2IIGMAcfG.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/vid/avc1/480x270/yFj467sJ5N2wSRdp.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/vid/avc1/640x360/hBgQo9aAprUFJhEc.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1805730599841251328/vid/avc1/1280x720/IdeXNAf2-PchFf7z.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1805730599841251328"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 218,
                            "favorited": false,
                            "full_text": "Wack 100 Gets Grilled By Prosecutors Over Posting Tupac Murder Suspect Keefe D $750K Bail.\n\n(@LawCrimeNetwork/YouTube) https://t.co/uz32VMNJdw",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 35,
                            "reply_count": 25,
                            "retweet_count": 75,
                            "retweeted": false,
                            "user_id_str": "924154962304815105",
                            "id_str": "1805735115374399836"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1811882750317855136",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com \uD83D\uDCE9",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11650,
                                        "followers_count": 21305113,
                                        "friends_count": 2569,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27257,
                                        "location": "Milano, Italia",
                                        "media_count": 22791,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21305113,
                                        "pinned_tweet_ids_str": [
                                            "1811410781927342328"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 44788,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1811882750317855136"
                            ],
                            "editable_until_msecs": "1720825085000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1948625",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1806094258736148533",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjozMzAyNjI3NDg=",
                                            "rest_id": "330262748",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Here we go! © fabrizio.romano93@gmail.com \uD83D\uDCE9",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "m.youtube.com/@FabrizioRoman…",
                                                                "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                                "url": "https://t.co/btxI8gbc2z",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 11650,
                                                "followers_count": 21305113,
                                                "friends_count": 2569,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 27257,
                                                "location": "Milano, Italia",
                                                "media_count": 22791,
                                                "name": "Fabrizio Romano",
                                                "normal_followers_count": 21305113,
                                                "pinned_tweet_ids_str": [
                                                    "1811410781927342328"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "FabrizioRomano",
                                                "statuses_count": 44788,
                                                "translator_type": "none",
                                                "url": "https://t.co/btxI8gbc2z",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1806094258736148533"
                                    ],
                                    "editable_until_msecs": "1719445001000",
                                    "is_edit_eligible": true,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "15466273",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                                "legacy": {
                                    "bookmark_count": 261,
                                    "bookmarked": false,
                                    "created_at": "Wed Jun 26 22:36:41 +0000 2024",
                                    "conversation_id_str": "1806094258736148533",
                                    "display_text_range": [
                                        0,
                                        276
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "media": [
                                            {
                                                "display_url": "pic.x.com/ozog4qoj6l",
                                                "expanded_url": "https://twitter.com/FabrizioRomano/status/1806094258736148533/photo/1",
                                                "id_str": "1806094232429494272",
                                                "indices": [
                                                    277,
                                                    300
                                                ],
                                                "media_key": "3_1806094232429494272",
                                                "media_url_https": "https://pbs.twimg.com/media/GRCJIqLXgAABPwM.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/OZOG4QOJ6L",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": []
                                                    },
                                                    "medium": {
                                                        "faces": []
                                                    },
                                                    "small": {
                                                        "faces": []
                                                    },
                                                    "orig": {
                                                        "faces": []
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1418,
                                                        "w": 1179,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 1200,
                                                        "w": 998,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 680,
                                                        "w": 565,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1418,
                                                    "width": 1179,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 698,
                                                            "w": 1179,
                                                            "h": 660
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 239,
                                                            "w": 1179,
                                                            "h": 1179
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 74,
                                                            "w": 1179,
                                                            "h": 1344
                                                        },
                                                        {
                                                            "x": 470,
                                                            "y": 0,
                                                            "w": 709,
                                                            "h": 1418
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1179,
                                                            "h": 1418
                                                        }
                                                    ]
                                                },
                                                "allow_download_status": {
                                                    "allow_download": true
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1806094232429494272"
                                                    }
                                                }
                                            }
                                        ],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": []
                                    },
                                    "extended_entities": {
                                        "media": [
                                            {
                                                "display_url": "pic.twitter.com/OZOG4QOJ6L",
                                                "expanded_url": "https://twitter.com/FabrizioRomano/status/1806094258736148533/photo/1",
                                                "id_str": "1806094232429494272",
                                                "indices": [
                                                    277,
                                                    300
                                                ],
                                                "media_key": "3_1806094232429494272",
                                                "media_url_https": "https://pbs.twimg.com/media/GRCJIqLXgAABPwM.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/OZOG4QOJ6L",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": []
                                                    },
                                                    "medium": {
                                                        "faces": []
                                                    },
                                                    "small": {
                                                        "faces": []
                                                    },
                                                    "orig": {
                                                        "faces": []
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1418,
                                                        "w": 1179,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 1200,
                                                        "w": 998,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 680,
                                                        "w": 565,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1418,
                                                    "width": 1179,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 698,
                                                            "w": 1179,
                                                            "h": 660
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 239,
                                                            "w": 1179,
                                                            "h": 1179
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 74,
                                                            "w": 1179,
                                                            "h": 1344
                                                        },
                                                        {
                                                            "x": 470,
                                                            "y": 0,
                                                            "w": 709,
                                                            "h": 1418
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1179,
                                                            "h": 1418
                                                        }
                                                    ]
                                                },
                                                "allow_download_status": {
                                                    "allow_download": true
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1806094232429494272"
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "favorite_count": 32155,
                                    "favorited": false,
                                    "full_text": "\uD83D\uDEA8\uD83D\uDD35 EXCLUSIVE: Como’s dream target for the centre back position is Raphael Varane as free agent.\n\nCesc Fabregas wants Varane and they will try to make it happen, but there are several clubs interested in Europe and abroad — not an easy one.\n\nVarane will decide his future soon. https://t.co/OZOG4QOJ6L",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 356,
                                    "reply_count": 312,
                                    "retweet_count": 1865,
                                    "retweeted": false,
                                    "user_id_str": "330262748",
                                    "id_str": "1806094258736148533"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 39,
                            "bookmarked": false,
                            "created_at": "Fri Jul 12 21:58:05 +0000 2024",
                            "conversation_id_str": "1811882750317855136",
                            "display_text_range": [
                                0,
                                11
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            6,
                                            11
                                        ],
                                        "text": "Como"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 7629,
                            "favorited": false,
                            "full_text": "\uD83D\uDD35\uD83D\uDC40⏳\uD83C\uDDEB\uD83C\uDDF7 #Como",
                            "is_quote_status": true,
                            "lang": "qme",
                            "quote_count": 20,
                            "quoted_status_id_str": "1806094258736148533",
                            "quoted_status_permalink": {
                                "url": "https://t.co/g3pTIFMVEd",
                                "expanded": "https://twitter.com/fabrizioromano/status/1806094258736148533",
                                "display": "x.com/fabrizioromano…"
                            },
                            "reply_count": 137,
                            "retweet_count": 386,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1811882750317855136"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1816564075280715871",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMzIzNzMwMjI1MDY3MzM5Nzg0",
                                    "rest_id": "1323730225067339784",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Tue Nov 03 20:55:58 +0000 2020",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Welcome to the Biden-Harris White House! Tweets may be archived: https://t.co/UbZQo0sWVf",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "whitehouse.gov/privacy",
                                                        "expanded_url": "http://whitehouse.gov/privacy",
                                                        "url": "https://t.co/UbZQo0sWVf",
                                                        "indices": [
                                                            65,
                                                            88
                                                        ]
                                                    }
                                                ]
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "wh.gov/resources",
                                                        "expanded_url": "http://wh.gov/resources",
                                                        "url": "https://t.co/2UJSiJ3BR5",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 44,
                                        "followers_count": 8923541,
                                        "friends_count": 6,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 14063,
                                        "location": "United States of America",
                                        "media_count": 4170,
                                        "name": "The White House",
                                        "normal_followers_count": 8923541,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1323730225067339784/1722002531",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1351938473142448133/JQT93Cjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "WhiteHouse",
                                        "statuses_count": 9800,
                                        "translator_type": "none",
                                        "url": "https://t.co/2UJSiJ3BR5",
                                        "verified": false,
                                        "verified_type": "Government",
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1816564075280715871"
                            ],
                            "editable_until_msecs": "1721941200000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "97422",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://www.sprinklr.com\" rel=\"nofollow\">The White House</a>",
                        "legacy": {
                            "bookmark_count": 18,
                            "bookmarked": false,
                            "created_at": "Thu Jul 25 20:00:00 +0000 2024",
                            "conversation_id_str": "1816564075280715871",
                            "display_text_range": [
                                0,
                                174
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/fqbsguqxuq",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady delivers remarks on UNESCO.",
                                        "id_str": "1816544725224034304",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544725224034304",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpzZmWkAAG8R2.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 160,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 62,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 124,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 312,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544725224034304"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/fqbsguqxuq",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady delivers remarks on UNESCO.",
                                        "id_str": "1816544728726290433",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544728726290433",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpzmpWwAEbl35.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 160,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 212,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 274,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 462,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544728726290433"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/fqbsguqxuq",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady attends a UNESCO event.",
                                        "id_str": "1816544731922378752",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544731922378752",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpzyjXMAATvra.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1067,
                                                        "y": 366,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 853,
                                                        "y": 292,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 483,
                                                        "y": 165,
                                                        "h": 22,
                                                        "w": 22
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1067,
                                                        "y": 366,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 500,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 623,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 987,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544731922378752"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/fqbsguqxuq",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady delivers remarks on UNESCO.",
                                        "id_str": "1816544735294570496",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544735294570496",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpz_HWwAAz8Xb.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 67,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 362,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 424,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 612,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544735294570496"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "20646711",
                                        "name": "UNESCO \uD83C\uDFDB️ #Education #Sciences #Culture \uD83C\uDDFA\uD83C\uDDF3",
                                        "screen_name": "UNESCO",
                                        "indices": [
                                            49,
                                            56
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/fQBSGUQXUQ",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady delivers remarks on UNESCO.",
                                        "id_str": "1816544725224034304",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544725224034304",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpzZmWkAAG8R2.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 160,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 62,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 124,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 312,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544725224034304"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/fQBSGUQXUQ",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady delivers remarks on UNESCO.",
                                        "id_str": "1816544728726290433",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544728726290433",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpzmpWwAEbl35.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 160,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 212,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 274,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 462,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544728726290433"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/fQBSGUQXUQ",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady attends a UNESCO event.",
                                        "id_str": "1816544731922378752",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544731922378752",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpzyjXMAATvra.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1067,
                                                        "y": 366,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 853,
                                                        "y": 292,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 483,
                                                        "y": 165,
                                                        "h": 22,
                                                        "w": 22
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1067,
                                                        "y": 366,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 500,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 623,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 987,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544731922378752"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/fQBSGUQXUQ",
                                        "expanded_url": "https://twitter.com/WhiteHouse/status/1816564075280715871/photo/1",
                                        "ext_alt_text": "The First Lady delivers remarks on UNESCO.",
                                        "id_str": "1816544735294570496",
                                        "indices": [
                                            175,
                                            198
                                        ],
                                        "media_key": "3_1816544735294570496",
                                        "media_url_https": "https://pbs.twimg.com/media/GTWpz_HWwAAz8Xb.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/fQBSGUQXUQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1000,
                                                "w": 1500,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1000,
                                            "width": 1500,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 67,
                                                    "w": 1500,
                                                    "h": 840
                                                },
                                                {
                                                    "x": 362,
                                                    "y": 0,
                                                    "w": 1000,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 424,
                                                    "y": 0,
                                                    "w": 877,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 612,
                                                    "y": 0,
                                                    "w": 500,
                                                    "h": 1000
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1500,
                                                    "h": 1000
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1816544735294570496"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 1422,
                            "favorited": false,
                            "full_text": "One year ago, the United States proudly rejoined @UNESCO – because the Biden-Harris Administration understands that if we hope to create a better world, we can’t go it alone. https://t.co/fQBSGUQXUQ",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 13,
                            "reply_count": 201,
                            "retweet_count": 350,
                            "retweeted": false,
                            "user_id_str": "1323730225067339784",
                            "id_str": "1816564075280715871"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1552015619251634176",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com \uD83D\uDCE9",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11650,
                                        "followers_count": 21304908,
                                        "friends_count": 2569,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27257,
                                        "location": "Milano, Italia",
                                        "media_count": 22791,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21304908,
                                        "pinned_tweet_ids_str": [
                                            "1811410781927342328"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 44788,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1552015619251634176"
                            ],
                            "editable_until_msecs": "1658866133000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 2559,
                            "bookmarked": false,
                            "created_at": "Tue Jul 26 19:38:53 +0000 2022",
                            "conversation_id_str": "1552015619251634176",
                            "display_text_range": [
                                0,
                                148
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            97,
                                            104
                                        ],
                                        "text": "ASRoma"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/tnel3l6vdy",
                                        "expanded_url": "https://twitter.com/Zey4d0/status/1552015157827715072/video/1",
                                        "id_str": "1552015081512341505",
                                        "indices": [
                                            125,
                                            148
                                        ],
                                        "media_key": "7_1552015081512341505",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1552015081512341505/pu/img/rbvIUWJBMtcD-Ccp.jpg",
                                        "source_status_id_str": "1552015157827715072",
                                        "source_user_id_str": "354045381",
                                        "type": "video",
                                        "url": "https://t.co/TnEl3l6VDy",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjozNTQwNDUzODE=",
                                                        "rest_id": "354045381",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": false,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Sat Aug 13 01:49:00 +0000 2011",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "equine vet-طبيب بيطري @officialasroma",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "letterboxd.com/zeyad/",
                                                                            "expanded_url": "https://letterboxd.com/zeyad/",
                                                                            "url": "https://t.co/FLZOzPBfaL",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 2474,
                                                            "followers_count": 936,
                                                            "friends_count": 697,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 2,
                                                            "location": "Curva sud",
                                                            "media_count": 1929,
                                                            "name": "Zeyad.",
                                                            "normal_followers_count": 936,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/354045381/1703370024",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1656329541424492545/7gWghjVN_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "Zey4d0",
                                                            "statuses_count": 16619,
                                                            "translator_type": "none",
                                                            "url": "https://t.co/FLZOzPBfaL",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        },
                                                        "tipjar_settings": {
                                                            "is_enabled": false,
                                                            "bandcamp_handle": "",
                                                            "bitcoin_handle": "",
                                                            "cash_app_handle": "",
                                                            "ethereum_handle": "",
                                                            "gofundme_handle": "",
                                                            "patreon_handle": "",
                                                            "pay_pal_handle": "",
                                                            "venmo_handle": ""
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "reason": "Dmcaed",
                                            "status": "Unavailable"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 712,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 668,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 378,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 712,
                                            "width": 1280,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                160,
                                                89
                                            ],
                                            "duration_millis": 25448,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/pl/KlQ1otO4yL0VZO-Y.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 256000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/vid/484x270/h03uDXJy6dJx7JR5.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/vid/646x360/R7korIUELOq71s-5.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/vid/1280x712/ES8J08BSEY8vf5mZ.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1552015081512341505"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "380570951",
                                        "name": "AS Roma",
                                        "screen_name": "OfficialASRoma",
                                        "indices": [
                                            106,
                                            121
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/TnEl3l6VDy",
                                        "expanded_url": "https://twitter.com/Zey4d0/status/1552015157827715072/video/1",
                                        "id_str": "1552015081512341505",
                                        "indices": [
                                            125,
                                            148
                                        ],
                                        "media_key": "7_1552015081512341505",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1552015081512341505/pu/img/rbvIUWJBMtcD-Ccp.jpg",
                                        "source_status_id_str": "1552015157827715072",
                                        "source_user_id_str": "354045381",
                                        "type": "video",
                                        "url": "https://t.co/TnEl3l6VDy",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjozNTQwNDUzODE=",
                                                        "rest_id": "354045381",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": false,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Sat Aug 13 01:49:00 +0000 2011",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "equine vet-طبيب بيطري @officialasroma",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "letterboxd.com/zeyad/",
                                                                            "expanded_url": "https://letterboxd.com/zeyad/",
                                                                            "url": "https://t.co/FLZOzPBfaL",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 2474,
                                                            "followers_count": 936,
                                                            "friends_count": 697,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 2,
                                                            "location": "Curva sud",
                                                            "media_count": 1929,
                                                            "name": "Zeyad.",
                                                            "normal_followers_count": 936,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/354045381/1703370024",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1656329541424492545/7gWghjVN_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "Zey4d0",
                                                            "statuses_count": 16619,
                                                            "translator_type": "none",
                                                            "url": "https://t.co/FLZOzPBfaL",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        },
                                                        "tipjar_settings": {
                                                            "is_enabled": false,
                                                            "bandcamp_handle": "",
                                                            "bitcoin_handle": "",
                                                            "cash_app_handle": "",
                                                            "ethereum_handle": "",
                                                            "gofundme_handle": "",
                                                            "patreon_handle": "",
                                                            "pay_pal_handle": "",
                                                            "venmo_handle": ""
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "reason": "Dmcaed",
                                            "status": "Unavailable"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 712,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 668,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 378,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 712,
                                            "width": 1280,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                160,
                                                89
                                            ],
                                            "duration_millis": 25448,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/pl/KlQ1otO4yL0VZO-Y.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 256000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/vid/484x270/h03uDXJy6dJx7JR5.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/vid/646x360/R7korIUELOq71s-5.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1552015081512341505/pu/vid/1280x712/ES8J08BSEY8vf5mZ.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1552015081512341505"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 268453,
                            "favorited": false,
                            "full_text": "…and this is how AS Roma unveiled Paulo Dybala as new signing tonight, in front of their fans \uD83D\uDFE1\uD83D\uDD34 #ASRoma\n\n@OfficialASRoma \uD83C\uDDE6\uD83C\uDDF7\nhttps://t.co/TnEl3l6VDy",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 11328,
                            "reply_count": 3944,
                            "retweet_count": 30083,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1552015619251634176"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1809644889212105040",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNTYxMTIzNjYz",
                                    "rest_id": "1561123663",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/BleacherReport",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1711004584104038400/lAPnpF7v_bigger.jpg"
                                            },
                                            "description": "Bleacher Report",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Mon Jul 01 17:51:17 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Get the free B/R App ⬇️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "br.app.link/get-the-BR-app",
                                                        "expanded_url": "https://br.app.link/get-the-BR-app",
                                                        "url": "https://t.co/Ry63mhhsjm",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 2865,
                                        "followers_count": 7339908,
                                        "friends_count": 1105,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 13104,
                                        "location": "",
                                        "media_count": 116853,
                                        "name": "B/R Football",
                                        "normal_followers_count": 7339908,
                                        "pinned_tweet_ids_str": [
                                            "1812952321015341392"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1561123663/1685997823",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710859925293760512/MLeyvq0O_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "brfootball",
                                        "statuses_count": 132612,
                                        "translator_type": "regular",
                                        "url": "https://t.co/Ry63mhhsjm",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1602636242457432065",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1809644889212105040"
                            ],
                            "editable_until_msecs": "1720291537000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1080313",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                        "legacy": {
                            "bookmark_count": 411,
                            "bookmarked": false,
                            "created_at": "Sat Jul 06 17:45:37 +0000 2024",
                            "conversation_id_str": "1809644889212105040",
                            "display_text_range": [
                                0,
                                70
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725768712192",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725768712192",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkkacAA5sq-.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 425,
                                                        "y": 493,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 409,
                                                        "y": 488,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 100,
                                                        "h": 50,
                                                        "w": 50
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 475,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725768712192"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725772906498",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725772906498",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSklacAIRn_F.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 246,
                                                        "y": 33,
                                                        "h": 39,
                                                        "w": 39
                                                    },
                                                    {
                                                        "x": 378,
                                                        "y": 166,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725772906498"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725638496256",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725638496256",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkFXgAANM5H.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 103,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 27,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725638496256"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725617537025",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725617537025",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkAXsAE5w93.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 421,
                                                        "y": 111,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 377,
                                                        "y": 34,
                                                        "h": 40,
                                                        "w": 40
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 49,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725617537025"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725768712192",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725768712192",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkkacAA5sq-.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 425,
                                                        "y": 493,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 409,
                                                        "y": 488,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 100,
                                                        "h": 50,
                                                        "w": 50
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 475,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725768712192"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725772906498",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725772906498",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSklacAIRn_F.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 246,
                                                        "y": 33,
                                                        "h": 39,
                                                        "w": 39
                                                    },
                                                    {
                                                        "x": 378,
                                                        "y": 166,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725772906498"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725638496256",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725638496256",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkFXgAANM5H.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 103,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 27,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725638496256"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725617537025",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725617537025",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkAXsAE5w93.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 421,
                                                        "y": 111,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 377,
                                                        "y": 34,
                                                        "h": 40,
                                                        "w": 40
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 49,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725617537025"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 45094,
                            "favorited": false,
                            "full_text": "Bukayo Saka celebrated his goal with Arsenal teammate Aaron Ramsdale \uD83E\uDD17 https://t.co/h0tBPiGXTN",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 257,
                            "reply_count": 203,
                            "retweet_count": 3747,
                            "retweeted": false,
                            "user_id_str": "1561123663",
                            "id_str": "1809644889212105040"
                        }
                    }
                }
            }
        },
    ],
    bukayoSaka: [
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1699347492423311700",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1699347492423311700"
                            ],
                            "editable_until_msecs": "1693994589000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1116758",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 58,
                            "bookmarked": false,
                            "created_at": "Wed Sep 06 09:03:09 +0000 2023",
                            "conversation_id_str": "1699347492423311700",
                            "display_text_range": [
                                0,
                                134
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            124,
                                            134
                                        ],
                                        "text": "GodsChild"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/kgrkq5gpjj",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1699347492423311700/photo/1",
                                        "id_str": "1699347480645652480",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1699347480645652480",
                                        "media_url_https": "https://pbs.twimg.com/media/F5VLh7XW0AADNuz.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/kGRkQ5gPJj",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 446,
                                                        "y": 242,
                                                        "h": 344,
                                                        "w": 344
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 261,
                                                        "y": 141,
                                                        "h": 201,
                                                        "w": 201
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 148,
                                                        "y": 80,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 446,
                                                        "y": 242,
                                                        "h": 344,
                                                        "w": 344
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1366,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 800,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 454,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1366,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 78,
                                                    "w": 1366,
                                                    "h": 765
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1557
                                                },
                                                {
                                                    "x": 153,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1699347480645652480"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/kGRkQ5gPJj",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1699347492423311700/photo/1",
                                        "id_str": "1699347480645652480",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1699347480645652480",
                                        "media_url_https": "https://pbs.twimg.com/media/F5VLh7XW0AADNuz.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/kGRkQ5gPJj",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 446,
                                                        "y": 242,
                                                        "h": 344,
                                                        "w": 344
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 261,
                                                        "y": 141,
                                                        "h": 201,
                                                        "w": 201
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 148,
                                                        "y": 80,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 446,
                                                        "y": 242,
                                                        "h": 344,
                                                        "w": 344
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1366,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 800,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 454,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1366,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 78,
                                                    "w": 1366,
                                                    "h": 765
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1557
                                                },
                                                {
                                                    "x": 153,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1699347480645652480"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 51744,
                            "favorited": false,
                            "full_text": "Back to back, what an honour 🏆 Thank you to everybody who voted me England's Men's Player of the year I’m very grateful 🙏🏿 \n#GodsChild https://t.co/kGRkQ5gPJj",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 323,
                            "reply_count": 1265,
                            "retweet_count": 5899,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1699347492423311700"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1791421597963670010",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo4OTQ1Mjk2Mg==",
                                    "rest_id": "89452962",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/espn",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1170690523201527808/FriNRiir_bigger.png"
                                            },
                                            "description": "ESPN",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Nov 12 14:07:24 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Serving sports fans. Anytime. Anywhere.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "youtube.com/watch?v=1mIwAl…",
                                                        "expanded_url": "https://www.youtube.com/watch?v=1mIwAle4Gzk",
                                                        "url": "https://t.co/ynqp8jDNmx",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 1180,
                                        "followers_count": 1377591,
                                        "friends_count": 1079,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1850,
                                        "location": "",
                                        "media_count": 52813,
                                        "name": "ESPN UK",
                                        "normal_followers_count": 1377591,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/89452962/1674120201",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/693731557299720193/z0EeBAZE_normal.png",
                                        "profile_interstitial_type": "",
                                        "screen_name": "ESPNUK",
                                        "statuses_count": 119453,
                                        "translator_type": "none",
                                        "url": "https://t.co/ynqp8jDNmx",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1791421597963670010"
                            ],
                            "editable_until_msecs": "1715946766000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1041157",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "note_tweet": {
                            "is_expandable": true,
                            "note_tweet_results": {
                                "result": {
                                    "id": "Tm90ZVR3ZWV0OjE3OTE0MjE1OTc4NzU2MTM2OTY=",
                                    "text": "Bukayo Saka has been ranked the most impactful winger across 54 different leagues in world football this season 🌶️\n\nThe ranking is calculated by taking into account performances in six different areas: ground defence, finishing, chance creation, take ons, distribution and aerial play.\n\n(h/t @CIES_Football)",
                                    "entity_set": {
                                        "hashtags": [],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": [
                                            {
                                                "id_str": "791214610288353281",
                                                "name": "CIES Football Obs",
                                                "screen_name": "CIES_Football",
                                                "indices": [
                                                    292,
                                                    306
                                                ]
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 858,
                            "bookmarked": false,
                            "created_at": "Fri May 17 10:52:46 +0000 2024",
                            "conversation_id_str": "1791421597963670010",
                            "display_text_range": [
                                0,
                                279
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/zomgitlpgx",
                                        "expanded_url": "https://twitter.com/ESPNUK/status/1791421597963670010/photo/1",
                                        "id_str": "1791421591999369216",
                                        "indices": [
                                            280,
                                            303
                                        ],
                                        "media_key": "3_1791421591999369216",
                                        "media_url_https": "https://pbs.twimg.com/media/GNxoclIWUAAdRrM.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/zOMGiTLpgx",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 587,
                                                        "y": 1259,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 685,
                                                        "y": 163,
                                                        "h": 312,
                                                        "w": 312
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 521,
                                                        "y": 1119,
                                                        "h": 44,
                                                        "w": 44
                                                    },
                                                    {
                                                        "x": 608,
                                                        "y": 144,
                                                        "h": 277,
                                                        "w": 277
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 295,
                                                        "y": 634,
                                                        "h": 25,
                                                        "w": 25
                                                    },
                                                    {
                                                        "x": 345,
                                                        "y": 82,
                                                        "h": 157,
                                                        "w": 157
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 587,
                                                        "y": 1259,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 685,
                                                        "y": 163,
                                                        "h": 312,
                                                        "w": 312
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1791421591999369216"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/zOMGiTLpgx",
                                        "expanded_url": "https://twitter.com/ESPNUK/status/1791421597963670010/photo/1",
                                        "id_str": "1791421591999369216",
                                        "indices": [
                                            280,
                                            303
                                        ],
                                        "media_key": "3_1791421591999369216",
                                        "media_url_https": "https://pbs.twimg.com/media/GNxoclIWUAAdRrM.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/zOMGiTLpgx",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 587,
                                                        "y": 1259,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 685,
                                                        "y": 163,
                                                        "h": 312,
                                                        "w": 312
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 521,
                                                        "y": 1119,
                                                        "h": 44,
                                                        "w": 44
                                                    },
                                                    {
                                                        "x": 608,
                                                        "y": 144,
                                                        "h": 277,
                                                        "w": 277
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 295,
                                                        "y": 634,
                                                        "h": 25,
                                                        "w": 25
                                                    },
                                                    {
                                                        "x": 345,
                                                        "y": 82,
                                                        "h": 157,
                                                        "w": 157
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 587,
                                                        "y": 1259,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 685,
                                                        "y": 163,
                                                        "h": 312,
                                                        "w": 312
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1791421591999369216"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 18838,
                            "favorited": false,
                            "full_text": "Bukayo Saka has been ranked the most impactful winger across 54 different leagues in world football this season 🌶️\n\nThe ranking is calculated by taking into account performances in six different areas: ground defence, finishing, chance creation, take ons, distribution and aerial https://t.co/zOMGiTLpgx",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1099,
                            "reply_count": 592,
                            "retweet_count": 4428,
                            "retweeted": false,
                            "user_id_str": "89452962",
                            "id_str": "1791421597963670010"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1809704470499991852",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjgwOTAwNQ==",
                                    "rest_id": "26809005",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 26 18:14:06 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "This Is Everything.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "goal.com/en-us",
                                                        "expanded_url": "http://www.goal.com/en-us",
                                                        "url": "https://t.co/70u2qS9AOV",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6639,
                                        "followers_count": 9605732,
                                        "friends_count": 468,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 10409,
                                        "location": "Everywhere",
                                        "media_count": 148282,
                                        "name": "GOAL",
                                        "normal_followers_count": 9605732,
                                        "pinned_tweet_ids_str": [
                                            "1762130397419507933"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/26809005/1692881358",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1457725055178260480/_GOnheh__normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "goal",
                                        "statuses_count": 317372,
                                        "translator_type": "none",
                                        "url": "https://t.co/70u2qS9AOV",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1536375767117996034",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1809704470499991852"
                            ],
                            "editable_until_msecs": "1720305743000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "970598",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 1629,
                            "bookmarked": false,
                            "created_at": "Sat Jul 06 21:42:23 +0000 2024",
                            "conversation_id_str": "1809704470499991852",
                            "display_text_range": [
                                0,
                                77
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ip821fohtx",
                                        "expanded_url": "https://twitter.com/goal/status/1809704470499991852/video/1",
                                        "id_str": "1809704250395549696",
                                        "indices": [
                                            78,
                                            101
                                        ],
                                        "media_key": "7_1809704250395549696",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1809704250395549696/pu/img/_KIKSNBivDwnC5V7.jpg",
                                        "type": "video",
                                        "url": "https://t.co/IP821FOHtX",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1920,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1920,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 24240,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/pl/WCP0_qmOs5hwuFr9.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/vid/avc1/320x568/izPJAT7QvEPpXj8K.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/vid/avc1/480x852/r199yAtnSC4rUKX3.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/vid/avc1/720x1280/cyCCEshO6a7grgwt.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1809704250395549696"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/IP821FOHtX",
                                        "expanded_url": "https://twitter.com/goal/status/1809704470499991852/video/1",
                                        "id_str": "1809704250395549696",
                                        "indices": [
                                            78,
                                            101
                                        ],
                                        "media_key": "7_1809704250395549696",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1809704250395549696/pu/img/_KIKSNBivDwnC5V7.jpg",
                                        "type": "video",
                                        "url": "https://t.co/IP821FOHtX",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1920,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1920,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 24240,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/pl/WCP0_qmOs5hwuFr9.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/vid/avc1/320x568/izPJAT7QvEPpXj8K.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/vid/avc1/480x852/r199yAtnSC4rUKX3.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1809704250395549696/pu/vid/avc1/720x1280/cyCCEshO6a7grgwt.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1809704250395549696"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 25891,
                            "favorited": false,
                            "full_text": "This England fan got emotional after watching Bukayo Saka score his penalty 🥺 https://t.co/IP821FOHtX",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 284,
                            "reply_count": 173,
                            "retweet_count": 2879,
                            "retweeted": false,
                            "user_id_str": "26809005",
                            "id_str": "1809704470499991852"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1770875623738687569",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxOTAzMzgyMDU0",
                                    "rest_id": "1903382054",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Wed Sep 25 08:23:07 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "See you in Berlin.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "englandfootball.com",
                                                        "expanded_url": "https://www.englandfootball.com",
                                                        "url": "https://t.co/eULxdoltKL",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 15277,
                                        "followers_count": 6319842,
                                        "friends_count": 409,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 7520,
                                        "location": "Germany",
                                        "media_count": 23386,
                                        "name": "England",
                                        "normal_followers_count": 6319842,
                                        "pinned_tweet_ids_str": [
                                            "1812366667592470719"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1903382054/1720894722",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1724212442077478912/v_kJPhyb_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "England",
                                        "statuses_count": 53140,
                                        "translator_type": "regular",
                                        "url": "https://t.co/eULxdoltKL",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1481260802090938369",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "card://1770875621419241472",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "unified_card",
                                        "value": {
                                            "string_value": "{\"type\":\"image_website\",\"component_objects\":{\"details_1\":{\"type\":\"details\",\"data\":{\"title\":{\"content\":\"Squad update from St. George's Park\",\"is_rtl\":false},\"subtitle\":{\"content\":\"eng.football\",\"is_rtl\":false},\"destination\":\"browser_1\"}},\"media_1\":{\"type\":\"media\",\"data\":{\"id\":\"3_1770872923055591424\",\"destination\":\"browser_1\"}}},\"destination_objects\":{\"browser_1\":{\"type\":\"browser\",\"data\":{\"url_data\":{\"url\":\"https://eng.football/ODMNlN\",\"vanity\":\"eng.football\"}}}},\"components\":[\"media_1\",\"details_1\"],\"media_entities\":{\"3_1770872923055591424\":{\"id\":1770872923055591424,\"id_str\":\"1770872923055591424\",\"indices\":[0,0],\"media_url\":\"\",\"media_url_https\":\"https://pbs.twimg.com/media/GJNnioEWEAAQn7z.jpg\",\"url\":\"\",\"display_url\":\"\",\"expanded_url\":\"\",\"type\":\"photo\",\"original_info\":{\"width\":1080,\"height\":1080,\"focus_rects\":[{\"x\":0,\"y\":475,\"h\":605,\"w\":1080},{\"x\":0,\"y\":0,\"h\":1080,\"w\":1080},{\"x\":0,\"y\":0,\"h\":1080,\"w\":947},{\"x\":27,\"y\":0,\"h\":1080,\"w\":540},{\"x\":0,\"y\":0,\"h\":1080,\"w\":1080}]},\"sizes\":{\"small\":{\"w\":680,\"h\":680,\"resize\":\"fit\"},\"large\":{\"w\":1080,\"h\":1080,\"resize\":\"fit\"},\"thumb\":{\"w\":150,\"h\":150,\"resize\":\"crop\"},\"medium\":{\"w\":1080,\"h\":1080,\"resize\":\"fit\"}},\"source_user_id\":1903382054,\"source_user_id_str\":\"1903382054\",\"media_key\":\"3_1770872923055591424\",\"ext\":{\"mediaColor\":{\"r\":{\"ok\":{\"palette\":[{\"rgb\":{\"red\":125,\"green\":132,\"blue\":54},\"percentage\":28.64},{\"rgb\":{\"red\":43,\"green\":36,\"blue\":31},\"percentage\":18.97},{\"rgb\":{\"red\":246,\"green\":221,\"blue\":225},\"percentage\":15.45},{\"rgb\":{\"red\":197,\"green\":3,\"blue\":37},\"percentage\":8.02},{\"rgb\":{\"red\":19,\"green\":23,\"blue\":60},\"percentage\":6.57}]}},\"ttl\":-1}}}}}",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://twitter.com",
                                            "type": "STRING"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "unified_card",
                                "url": "card://1770875621419241472",
                                "user_refs_results": []
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1770875623738687569"
                            ],
                            "editable_until_msecs": "1711048224000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "2181327",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">Twitter for Advertisers</a>",
                        "legacy": {
                            "bookmark_count": 78,
                            "bookmarked": false,
                            "created_at": "Thu Mar 21 18:10:24 +0000 2024",
                            "conversation_id_str": "1770875623738687569",
                            "display_text_range": [
                                0,
                                182
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            25,
                                            36
                                        ],
                                        "text": "ThreeLions"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "1038874580956442625",
                                        "name": "Bukayo Saka",
                                        "screen_name": "BukayoSaka87",
                                        "indices": [
                                            166,
                                            179
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 7058,
                            "favorited": false,
                            "full_text": "Bukayo Saka has left the #ThreeLions camp and returned to his club for continued rehabilitation on an injury he reported to St. George's Park with.\n\nSpeedy recovery, @BukayoSaka87! 👊",
                            "is_quote_status": false,
                            "lang": "en",
                            "quote_count": 740,
                            "reply_count": 428,
                            "retweet_count": 648,
                            "retweeted": false,
                            "user_id_str": "1903382054",
                            "id_str": "1770875623738687569"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1696618262404976936",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1696618262404976936"
                            ],
                            "editable_until_msecs": "1693343890000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1782473",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 110,
                            "bookmarked": false,
                            "created_at": "Tue Aug 29 20:18:10 +0000 2023",
                            "conversation_id_str": "1696618262404976936",
                            "display_text_range": [
                                0,
                                277
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            268,
                                            277
                                        ],
                                        "text": "GodsPlan"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/zbwbalyph0",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1696618262404976936/photo/1",
                                        "id_str": "1696618254075154433",
                                        "indices": [
                                            278,
                                            301
                                        ],
                                        "media_key": "3_1696618254075154433",
                                        "media_url_https": "https://pbs.twimg.com/media/F4uZUCGX0AExWiB.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ZbWbAlYPh0",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 621,
                                                        "h": 163,
                                                        "w": 163
                                                    },
                                                    {
                                                        "x": 74,
                                                        "y": 477,
                                                        "h": 269,
                                                        "w": 269
                                                    },
                                                    {
                                                        "x": 292,
                                                        "y": 106,
                                                        "h": 257,
                                                        "w": 257
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 621,
                                                        "h": 163,
                                                        "w": 163
                                                    },
                                                    {
                                                        "x": 74,
                                                        "y": 477,
                                                        "h": 269,
                                                        "w": 269
                                                    },
                                                    {
                                                        "x": 292,
                                                        "y": 106,
                                                        "h": 257,
                                                        "w": 257
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 277,
                                                        "y": 412,
                                                        "h": 108,
                                                        "w": 108
                                                    },
                                                    {
                                                        "x": 49,
                                                        "y": 316,
                                                        "h": 178,
                                                        "w": 178
                                                    },
                                                    {
                                                        "x": 193,
                                                        "y": 70,
                                                        "h": 170,
                                                        "w": 170
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 621,
                                                        "h": 163,
                                                        "w": 163
                                                    },
                                                    {
                                                        "x": 74,
                                                        "y": 477,
                                                        "h": 269,
                                                        "w": 269
                                                    },
                                                    {
                                                        "x": 292,
                                                        "y": 106,
                                                        "h": 257,
                                                        "w": 257
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1024,
                                                "w": 818,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1024,
                                                "w": 818,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 543,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1024,
                                            "width": 818,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 1,
                                                    "w": 818,
                                                    "h": 458
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 818
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 933
                                                },
                                                {
                                                    "x": 178,
                                                    "y": 0,
                                                    "w": 512,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 1024
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1696618254075154433"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/ZbWbAlYPh0",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1696618262404976936/photo/1",
                                        "id_str": "1696618254075154433",
                                        "indices": [
                                            278,
                                            301
                                        ],
                                        "media_key": "3_1696618254075154433",
                                        "media_url_https": "https://pbs.twimg.com/media/F4uZUCGX0AExWiB.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ZbWbAlYPh0",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 621,
                                                        "h": 163,
                                                        "w": 163
                                                    },
                                                    {
                                                        "x": 74,
                                                        "y": 477,
                                                        "h": 269,
                                                        "w": 269
                                                    },
                                                    {
                                                        "x": 292,
                                                        "y": 106,
                                                        "h": 257,
                                                        "w": 257
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 621,
                                                        "h": 163,
                                                        "w": 163
                                                    },
                                                    {
                                                        "x": 74,
                                                        "y": 477,
                                                        "h": 269,
                                                        "w": 269
                                                    },
                                                    {
                                                        "x": 292,
                                                        "y": 106,
                                                        "h": 257,
                                                        "w": 257
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 277,
                                                        "y": 412,
                                                        "h": 108,
                                                        "w": 108
                                                    },
                                                    {
                                                        "x": 49,
                                                        "y": 316,
                                                        "h": 178,
                                                        "w": 178
                                                    },
                                                    {
                                                        "x": 193,
                                                        "y": 70,
                                                        "h": 170,
                                                        "w": 170
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 621,
                                                        "h": 163,
                                                        "w": 163
                                                    },
                                                    {
                                                        "x": 74,
                                                        "y": 477,
                                                        "h": 269,
                                                        "w": 269
                                                    },
                                                    {
                                                        "x": 292,
                                                        "y": 106,
                                                        "h": 257,
                                                        "w": 257
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1024,
                                                "w": 818,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1024,
                                                "w": 818,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 543,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1024,
                                            "width": 818,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 1,
                                                    "w": 818,
                                                    "h": 458
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 818
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 933
                                                },
                                                {
                                                    "x": 178,
                                                    "y": 0,
                                                    "w": 512,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 1024
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1696618254075154433"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 60675,
                            "favorited": false,
                            "full_text": "PFA Young Player 🏆 It's an honour for me to accept this award and have my name alongside the previous winners. To have your peers acknowledge you is a very special feeling! Thank you to the PFA and congratulations to all the other winners and nominees this evening 👏🏿 #GodsPlan https://t.co/ZbWbAlYPh0",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 825,
                            "reply_count": 2194,
                            "retweet_count": 9336,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1696618262404976936"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1667201926620934145",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1667201926620934145"
                            ],
                            "editable_until_msecs": "1686330489000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "565004",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 182,
                            "bookmarked": false,
                            "created_at": "Fri Jun 09 16:08:09 +0000 2023",
                            "conversation_id_str": "1667201926620934145",
                            "display_text_range": [
                                0,
                                111
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            84,
                                            97
                                        ],
                                        "text": "ThierryHenry"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/hvdek8ie68",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1667201926620934145/video/1",
                                        "id_str": "1667201753077391361",
                                        "indices": [
                                            112,
                                            135
                                        ],
                                        "media_key": "13_1667201753077391361",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1667201753077391361/img/pW2TgiF602T4Oesw.jpg",
                                        "type": "video",
                                        "url": "https://t.co/HVDEk8iE68",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 864,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 864,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 864,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                4,
                                                5
                                            ],
                                            "duration_millis": 109240,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/pl/BqRX7eCrBj9M4kt0.m3u8?tag=14&v=2ae"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/vid/320x400/AcYD_gF7YNOjwqIp.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/vid/480x600/J8FNxZZdpskPmQLA.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/vid/720x900/yMvDBH_sKkn_hUVT.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1667201753077391361"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "14423603",
                                        "name": "Beats by Dre",
                                        "screen_name": "beatsbydre",
                                        "indices": [
                                            72,
                                            83
                                        ]
                                    },
                                    {
                                        "id_str": "139343123",
                                        "name": "Dotty",
                                        "screen_name": "TheDottyShow",
                                        "indices": [
                                            98,
                                            111
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/HVDEk8iE68",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1667201926620934145/video/1",
                                        "id_str": "1667201753077391361",
                                        "indices": [
                                            112,
                                            135
                                        ],
                                        "media_key": "13_1667201753077391361",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1667201753077391361/img/pW2TgiF602T4Oesw.jpg",
                                        "type": "video",
                                        "url": "https://t.co/HVDEk8iE68",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 864,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 864,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 864,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                4,
                                                5
                                            ],
                                            "duration_millis": 109240,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/pl/BqRX7eCrBj9M4kt0.m3u8?tag=14&v=2ae"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/vid/320x400/AcYD_gF7YNOjwqIp.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/vid/480x600/J8FNxZZdpskPmQLA.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1667201753077391361/vid/720x900/yMvDBH_sKkn_hUVT.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1667201753077391361"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 9349,
                            "favorited": false,
                            "full_text": "Ever wonder what I’m thinking about? The great man is always in there 🧠 @beatsbydre #ThierryHenry @TheDottyShow https://t.co/HVDEk8iE68",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 325,
                            "reply_count": 280,
                            "retweet_count": 1737,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1667201926620934145"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1670902435232067587",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1670902435232067587"
                            ],
                            "editable_until_msecs": "1687212759000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "3125672",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 94,
                            "bookmarked": false,
                            "created_at": "Mon Jun 19 21:12:39 +0000 2023",
                            "conversation_id_str": "1670902435232067587",
                            "display_text_range": [
                                0,
                                122
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            112,
                                            122
                                        ],
                                        "text": "GodsChild"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/djbgtogxvd",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1670902435232067587/photo/1",
                                        "id_str": "1670902431989870593",
                                        "indices": [
                                            123,
                                            146
                                        ],
                                        "media_key": "3_1670902431989870593",
                                        "media_url_https": "https://pbs.twimg.com/media/FzA86LkXsAES5_3.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/DjBgToGXvd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 334,
                                                        "y": 69,
                                                        "h": 155,
                                                        "w": 155
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 334,
                                                        "y": 69,
                                                        "h": 155,
                                                        "w": 155
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 244,
                                                        "y": 50,
                                                        "h": 113,
                                                        "w": 113
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 334,
                                                        "y": 69,
                                                        "h": 155,
                                                        "w": 155
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 931,
                                                "w": 750,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 931,
                                                "w": 750,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 548,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 931,
                                            "width": 750,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 420
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 750
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 855
                                                },
                                                {
                                                    "x": 162,
                                                    "y": 0,
                                                    "w": 466,
                                                    "h": 931
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 931
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1670902431989870593"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/DjBgToGXvd",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1670902435232067587/photo/1",
                                        "id_str": "1670902431989870593",
                                        "indices": [
                                            123,
                                            146
                                        ],
                                        "media_key": "3_1670902431989870593",
                                        "media_url_https": "https://pbs.twimg.com/media/FzA86LkXsAES5_3.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/DjBgToGXvd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 334,
                                                        "y": 69,
                                                        "h": 155,
                                                        "w": 155
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 334,
                                                        "y": 69,
                                                        "h": 155,
                                                        "w": 155
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 244,
                                                        "y": 50,
                                                        "h": 113,
                                                        "w": 113
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 334,
                                                        "y": 69,
                                                        "h": 155,
                                                        "w": 155
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 931,
                                                "w": 750,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 931,
                                                "w": 750,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 548,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 931,
                                            "width": 750,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 420
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 750
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 855
                                                },
                                                {
                                                    "x": 162,
                                                    "y": 0,
                                                    "w": 466,
                                                    "h": 931
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 931
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1670902431989870593"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 94685,
                            "favorited": false,
                            "full_text": "Honoured to have scored the first hat-trick of my career! Important steps taken towards qualification 🙏🏿🏴󠁧󠁢󠁥󠁮󠁧󠁿 #GodsChild https://t.co/DjBgToGXvd",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1111,
                            "reply_count": 2223,
                            "retweet_count": 11131,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1670902435232067587"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1642228804033576961",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1642228804033576961"
                            ],
                            "editable_until_msecs": "1680374632000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1872875",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 83,
                            "bookmarked": false,
                            "created_at": "Sat Apr 01 18:13:52 +0000 2023",
                            "conversation_id_str": "1642228804033576961",
                            "display_text_range": [
                                0,
                                239
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ze9zburouf",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1642228804033576961/photo/1",
                                        "id_str": "1642228794340569091",
                                        "indices": [
                                            240,
                                            263
                                        ],
                                        "media_key": "3_1642228794340569091",
                                        "media_url_https": "https://pbs.twimg.com/media/FspeYzaWcAMnxi1.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ze9ZbURoUF",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 738,
                                                        "y": 370,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 585,
                                                        "y": 108,
                                                        "h": 149,
                                                        "w": 149
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 725,
                                                        "y": 363,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 574,
                                                        "y": 106,
                                                        "h": 146,
                                                        "w": 146
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 411,
                                                        "y": 206,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 325,
                                                        "y": 60,
                                                        "h": 82,
                                                        "w": 82
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 738,
                                                        "y": 370,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 585,
                                                        "y": 108,
                                                        "h": 149,
                                                        "w": 149
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 932,
                                                "w": 1221,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 916,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 519,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 932,
                                            "width": 1221,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 115,
                                                    "w": 1221,
                                                    "h": 684
                                                },
                                                {
                                                    "x": 289,
                                                    "y": 0,
                                                    "w": 932,
                                                    "h": 932
                                                },
                                                {
                                                    "x": 403,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 932
                                                },
                                                {
                                                    "x": 591,
                                                    "y": 0,
                                                    "w": 466,
                                                    "h": 932
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1221,
                                                    "h": 932
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1642228794340569091"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/ze9zburouf",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1642228804033576961/photo/1",
                                        "id_str": "1642228794323763205",
                                        "indices": [
                                            240,
                                            263
                                        ],
                                        "media_key": "3_1642228794323763205",
                                        "media_url_https": "https://pbs.twimg.com/media/FspeYzWWAAUnpDZ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ze9ZbURoUF",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 534,
                                                        "y": 114,
                                                        "h": 170,
                                                        "w": 170
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 524,
                                                        "y": 111,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 297,
                                                        "y": 63,
                                                        "h": 94,
                                                        "w": 94
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 534,
                                                        "y": 114,
                                                        "h": 170,
                                                        "w": 170
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 934,
                                                "w": 1222,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 917,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 520,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 934,
                                            "width": 1222,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 176,
                                                    "w": 1222,
                                                    "h": 684
                                                },
                                                {
                                                    "x": 288,
                                                    "y": 0,
                                                    "w": 934,
                                                    "h": 934
                                                },
                                                {
                                                    "x": 353,
                                                    "y": 0,
                                                    "w": 819,
                                                    "h": 934
                                                },
                                                {
                                                    "x": 529,
                                                    "y": 0,
                                                    "w": 467,
                                                    "h": 934
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1222,
                                                    "h": 934
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1642228794323763205"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/ze9ZbURoUF",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1642228804033576961/photo/1",
                                        "id_str": "1642228794340569091",
                                        "indices": [
                                            240,
                                            263
                                        ],
                                        "media_key": "3_1642228794340569091",
                                        "media_url_https": "https://pbs.twimg.com/media/FspeYzaWcAMnxi1.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ze9ZbURoUF",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 738,
                                                        "y": 370,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 585,
                                                        "y": 108,
                                                        "h": 149,
                                                        "w": 149
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 725,
                                                        "y": 363,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 574,
                                                        "y": 106,
                                                        "h": 146,
                                                        "w": 146
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 411,
                                                        "y": 206,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 325,
                                                        "y": 60,
                                                        "h": 82,
                                                        "w": 82
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 738,
                                                        "y": 370,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 585,
                                                        "y": 108,
                                                        "h": 149,
                                                        "w": 149
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 932,
                                                "w": 1221,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 916,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 519,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 932,
                                            "width": 1221,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 115,
                                                    "w": 1221,
                                                    "h": 684
                                                },
                                                {
                                                    "x": 289,
                                                    "y": 0,
                                                    "w": 932,
                                                    "h": 932
                                                },
                                                {
                                                    "x": 403,
                                                    "y": 0,
                                                    "w": 818,
                                                    "h": 932
                                                },
                                                {
                                                    "x": 591,
                                                    "y": 0,
                                                    "w": 466,
                                                    "h": 932
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1221,
                                                    "h": 932
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1642228794340569091"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/ze9ZbURoUF",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1642228804033576961/photo/1",
                                        "id_str": "1642228794323763205",
                                        "indices": [
                                            240,
                                            263
                                        ],
                                        "media_key": "3_1642228794323763205",
                                        "media_url_https": "https://pbs.twimg.com/media/FspeYzWWAAUnpDZ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ze9ZbURoUF",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 534,
                                                        "y": 114,
                                                        "h": 170,
                                                        "w": 170
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 524,
                                                        "y": 111,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 297,
                                                        "y": 63,
                                                        "h": 94,
                                                        "w": 94
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 534,
                                                        "y": 114,
                                                        "h": 170,
                                                        "w": 170
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 934,
                                                "w": 1222,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 917,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 520,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 934,
                                            "width": 1222,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 176,
                                                    "w": 1222,
                                                    "h": 684
                                                },
                                                {
                                                    "x": 288,
                                                    "y": 0,
                                                    "w": 934,
                                                    "h": 934
                                                },
                                                {
                                                    "x": 353,
                                                    "y": 0,
                                                    "w": 819,
                                                    "h": 934
                                                },
                                                {
                                                    "x": 529,
                                                    "y": 0,
                                                    "w": 467,
                                                    "h": 934
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1222,
                                                    "h": 934
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1642228794323763205"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 82651,
                            "favorited": false,
                            "full_text": "Happy to have won March’s Premier League Player of the Month award. Even though I’m the one receiving it, I couldn't have done it without all the hard work from my teammates and everybody at the club. Thank you again and let's keep going 🏆 https://t.co/ze9ZbURoUF",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 458,
                            "reply_count": 1396,
                            "retweet_count": 8691,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1642228804033576961"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1809644889212105040",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNTYxMTIzNjYz",
                                    "rest_id": "1561123663",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/BleacherReport",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1711004584104038400/lAPnpF7v_bigger.jpg"
                                            },
                                            "description": "Bleacher Report",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Mon Jul 01 17:51:17 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Get the free B/R App ⬇️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "br.app.link/get-the-BR-app",
                                                        "expanded_url": "https://br.app.link/get-the-BR-app",
                                                        "url": "https://t.co/Ry63mhhsjm",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 2864,
                                        "followers_count": 7328915,
                                        "friends_count": 1103,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 13096,
                                        "location": "",
                                        "media_count": 116716,
                                        "name": "B/R Football",
                                        "normal_followers_count": 7328915,
                                        "pinned_tweet_ids_str": [
                                            "1801592701919306163"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1561123663/1685997823",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710859925293760512/MLeyvq0O_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "brfootball",
                                        "statuses_count": 132475,
                                        "translator_type": "regular",
                                        "url": "https://t.co/Ry63mhhsjm",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1602636242457432065",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1809644889212105040"
                            ],
                            "editable_until_msecs": "1720291537000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1073753",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                        "legacy": {
                            "bookmark_count": 413,
                            "bookmarked": false,
                            "created_at": "Sat Jul 06 17:45:37 +0000 2024",
                            "conversation_id_str": "1809644889212105040",
                            "display_text_range": [
                                0,
                                70
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725768712192",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725768712192",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkkacAA5sq-.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 425,
                                                        "y": 493,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 409,
                                                        "y": 488,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 100,
                                                        "h": 50,
                                                        "w": 50
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 475,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725768712192"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725772906498",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725772906498",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSklacAIRn_F.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 246,
                                                        "y": 33,
                                                        "h": 39,
                                                        "w": 39
                                                    },
                                                    {
                                                        "x": 378,
                                                        "y": 166,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725772906498"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725638496256",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725638496256",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkFXgAANM5H.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 103,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 27,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725638496256"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/h0tbpigxtn",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725617537025",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725617537025",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkAXsAE5w93.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 421,
                                                        "y": 111,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 377,
                                                        "y": 34,
                                                        "h": 40,
                                                        "w": 40
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 49,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725617537025"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725768712192",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725768712192",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkkacAA5sq-.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 425,
                                                        "y": 493,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 409,
                                                        "y": 488,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 100,
                                                        "h": 50,
                                                        "w": 50
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 675,
                                                        "y": 784,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 651,
                                                        "y": 776,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 163,
                                                        "y": 159,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 475,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725768712192"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725772906498",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725772906498",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSklacAIRn_F.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 246,
                                                        "y": 33,
                                                        "h": 39,
                                                        "w": 39
                                                    },
                                                    {
                                                        "x": 378,
                                                        "y": 166,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 391,
                                                        "y": 53,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 601,
                                                        "y": 264,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725772906498"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725638496256",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725638496256",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkFXgAANM5H.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 103,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 27,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725638496256"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/h0tBPiGXTN",
                                        "expanded_url": "https://twitter.com/brfootball/status/1809644889212105040/photo/1",
                                        "id_str": "1809644725617537025",
                                        "indices": [
                                            71,
                                            94
                                        ],
                                        "media_key": "3_1809644725617537025",
                                        "media_url_https": "https://pbs.twimg.com/media/GR0mSkAXsAE5w93.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/h0tBPiGXTN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 421,
                                                        "y": 111,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 377,
                                                        "y": 34,
                                                        "h": 40,
                                                        "w": 40
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 670,
                                                        "y": 177,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 600,
                                                        "y": 55,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 49,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 189,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1809644725617537025"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 45141,
                            "favorited": false,
                            "full_text": "Bukayo Saka celebrated his goal with Arsenal teammate Aaron Ramsdale 🤗 https://t.co/h0tBPiGXTN",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 257,
                            "reply_count": 203,
                            "retweet_count": 3753,
                            "retweeted": false,
                            "user_id_str": "1561123663",
                            "id_str": "1809644889212105040"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1809659773496786955",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxOTAzMzgyMDU0",
                                    "rest_id": "1903382054",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Wed Sep 25 08:23:07 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "See you in Berlin.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "englandfootball.com",
                                                        "expanded_url": "https://www.englandfootball.com",
                                                        "url": "https://t.co/eULxdoltKL",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 15277,
                                        "followers_count": 6319842,
                                        "friends_count": 409,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 7520,
                                        "location": "Germany",
                                        "media_count": 23386,
                                        "name": "England",
                                        "normal_followers_count": 6319842,
                                        "pinned_tweet_ids_str": [
                                            "1812366667592470719"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1903382054/1720894722",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1724212442077478912/v_kJPhyb_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "England",
                                        "statuses_count": 53140,
                                        "translator_type": "regular",
                                        "url": "https://t.co/eULxdoltKL",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1481260802090938369",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1809659773496786955"
                            ],
                            "editable_until_msecs": "1720295086000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1527366",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 269,
                            "bookmarked": false,
                            "created_at": "Sat Jul 06 18:44:46 +0000 2024",
                            "conversation_id_str": "1809659773496786955",
                            "display_text_range": [
                                0,
                                130
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 38764,
                            "favorited": false,
                            "full_text": "Cole Palmer ✅\nJude Bellingham ✅\nBukayo Saka ✅\nIvan Toney ✅\nTrent Alexander-Arnold ✅\n\nFive perfect penalties. GET IN THERE! 🏴󠁧󠁢󠁥󠁮󠁧󠁿",
                            "is_quote_status": false,
                            "lang": "en",
                            "quote_count": 460,
                            "reply_count": 457,
                            "retweet_count": 3879,
                            "retweeted": false,
                            "user_id_str": "1903382054",
                            "id_str": "1809659773496786955"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1599510675004325888",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1599510675004325888"
                            ],
                            "editable_until_msecs": "1670189837000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 60,
                            "bookmarked": false,
                            "created_at": "Sun Dec 04 21:07:17 +0000 2022",
                            "conversation_id_str": "1599510675004325888",
                            "display_text_range": [
                                0,
                                27
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ypsbj1wwhb",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1599510675004325888/photo/1",
                                        "id_str": "1599510665932185602",
                                        "indices": [
                                            28,
                                            51
                                        ],
                                        "media_key": "3_1599510665932185602",
                                        "media_url_https": "https://pbs.twimg.com/media/FjKaeeFWIAIzx0a.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ypsbJ1wwHb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 1670,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 407,
                                                        "y": 978,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 230,
                                                        "y": 554,
                                                        "h": 37,
                                                        "w": 37
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 1670,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1462,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 857,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 485,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1462,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 819
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 1462
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 1667
                                                },
                                                {
                                                    "x": 153,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1599510665932185602"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/ypsbj1wwhb",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1599510675004325888/photo/1",
                                        "id_str": "1599510665932292097",
                                        "indices": [
                                            28,
                                            51
                                        ],
                                        "media_key": "3_1599510665932292097",
                                        "media_url_https": "https://pbs.twimg.com/media/FjKaeeFXwAEDSYj.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ypsbJ1wwHb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 994,
                                                        "y": 172,
                                                        "h": 210,
                                                        "w": 210
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 582,
                                                        "y": 100,
                                                        "h": 123,
                                                        "w": 123
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 330,
                                                        "y": 57,
                                                        "h": 69,
                                                        "w": 69
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 994,
                                                        "y": 172,
                                                        "h": 210,
                                                        "w": 210
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 494,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 578,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 836,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1599510665932292097"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/ypsbJ1wwHb",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1599510675004325888/photo/1",
                                        "id_str": "1599510665932185602",
                                        "indices": [
                                            28,
                                            51
                                        ],
                                        "media_key": "3_1599510665932185602",
                                        "media_url_https": "https://pbs.twimg.com/media/FjKaeeFWIAIzx0a.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ypsbJ1wwHb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 1670,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 407,
                                                        "y": 978,
                                                        "h": 65,
                                                        "w": 65
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 230,
                                                        "y": 554,
                                                        "h": 37,
                                                        "w": 37
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 1670,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1462,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 857,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 485,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1462,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 819
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 1462
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 1667
                                                },
                                                {
                                                    "x": 153,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1462,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1599510665932185602"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/ypsbJ1wwHb",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1599510675004325888/photo/1",
                                        "id_str": "1599510665932292097",
                                        "indices": [
                                            28,
                                            51
                                        ],
                                        "media_key": "3_1599510665932292097",
                                        "media_url_https": "https://pbs.twimg.com/media/FjKaeeFXwAEDSYj.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ypsbJ1wwHb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 994,
                                                        "y": 172,
                                                        "h": 210,
                                                        "w": 210
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 582,
                                                        "y": 100,
                                                        "h": 123,
                                                        "w": 123
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 330,
                                                        "y": 57,
                                                        "h": 69,
                                                        "w": 69
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 994,
                                                        "y": 172,
                                                        "h": 210,
                                                        "w": 210
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 494,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 578,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 836,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1599510665932292097"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 80630,
                            "favorited": false,
                            "full_text": "COME ON ENGLAND !! 🏴󠁧󠁢󠁥󠁮󠁧󠁿😝 https://t.co/ypsbJ1wwHb",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 466,
                            "reply_count": 1047,
                            "retweet_count": 6029,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1599510675004325888"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1627337111366934529",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1627337111366934529"
                            ],
                            "editable_until_msecs": "1676824176000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "6812493",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 442,
                            "bookmarked": false,
                            "created_at": "Sun Feb 19 15:59:36 +0000 2023",
                            "conversation_id_str": "1627337111366934529",
                            "display_text_range": [
                                0,
                                20
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/3cbh6qpdww",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1627337111366934529/photo/1",
                                        "id_str": "1627337107629809664",
                                        "indices": [
                                            21,
                                            44
                                        ],
                                        "media_key": "3_1627337107629809664",
                                        "media_url_https": "https://pbs.twimg.com/media/FpV2ejYWIAABafJ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3cbH6qpDww",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 42,
                                                        "y": 157,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 97,
                                                        "y": 158,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 221,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 769,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 114,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 94,
                                                        "y": 279,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 432,
                                                        "y": 379,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 422,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 473,
                                                        "h": 47,
                                                        "w": 47
                                                    },
                                                    {
                                                        "x": 165,
                                                        "y": 161,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 765,
                                                        "y": 124,
                                                        "h": 90,
                                                        "w": 90
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 42,
                                                        "y": 157,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 97,
                                                        "y": 158,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 221,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 769,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 114,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 94,
                                                        "y": 279,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 432,
                                                        "y": 379,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 422,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 473,
                                                        "h": 47,
                                                        "w": 47
                                                    },
                                                    {
                                                        "x": 165,
                                                        "y": 161,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 765,
                                                        "y": 124,
                                                        "h": 90,
                                                        "w": 90
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 27,
                                                        "y": 104,
                                                        "h": 22,
                                                        "w": 22
                                                    },
                                                    {
                                                        "x": 64,
                                                        "y": 104,
                                                        "h": 24,
                                                        "w": 24
                                                    },
                                                    {
                                                        "x": 134,
                                                        "y": 146,
                                                        "h": 24,
                                                        "w": 24
                                                    },
                                                    {
                                                        "x": 537,
                                                        "y": 510,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 67,
                                                        "y": 75,
                                                        "h": 23,
                                                        "w": 23
                                                    },
                                                    {
                                                        "x": 62,
                                                        "y": 185,
                                                        "h": 26,
                                                        "w": 26
                                                    },
                                                    {
                                                        "x": 286,
                                                        "y": 251,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 142,
                                                        "y": 280,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 277,
                                                        "y": 314,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 109,
                                                        "y": 106,
                                                        "h": 26,
                                                        "w": 26
                                                    },
                                                    {
                                                        "x": 508,
                                                        "y": 82,
                                                        "h": 59,
                                                        "w": 59
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 42,
                                                        "y": 157,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 97,
                                                        "y": 158,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 221,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 769,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 114,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 94,
                                                        "y": 279,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 432,
                                                        "y": 379,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 422,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 473,
                                                        "h": 47,
                                                        "w": 47
                                                    },
                                                    {
                                                        "x": 165,
                                                        "y": 161,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 765,
                                                        "y": 124,
                                                        "h": 90,
                                                        "w": 90
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1024,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1024,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1024,
                                            "width": 1024,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 573
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 126,
                                                    "y": 0,
                                                    "w": 898,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 512,
                                                    "y": 0,
                                                    "w": 512,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 1024
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1627337107629809664"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/3cbH6qpDww",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1627337111366934529/photo/1",
                                        "id_str": "1627337107629809664",
                                        "indices": [
                                            21,
                                            44
                                        ],
                                        "media_key": "3_1627337107629809664",
                                        "media_url_https": "https://pbs.twimg.com/media/FpV2ejYWIAABafJ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3cbH6qpDww",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 42,
                                                        "y": 157,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 97,
                                                        "y": 158,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 221,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 769,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 114,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 94,
                                                        "y": 279,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 432,
                                                        "y": 379,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 422,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 473,
                                                        "h": 47,
                                                        "w": 47
                                                    },
                                                    {
                                                        "x": 165,
                                                        "y": 161,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 765,
                                                        "y": 124,
                                                        "h": 90,
                                                        "w": 90
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 42,
                                                        "y": 157,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 97,
                                                        "y": 158,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 221,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 769,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 114,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 94,
                                                        "y": 279,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 432,
                                                        "y": 379,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 422,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 473,
                                                        "h": 47,
                                                        "w": 47
                                                    },
                                                    {
                                                        "x": 165,
                                                        "y": 161,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 765,
                                                        "y": 124,
                                                        "h": 90,
                                                        "w": 90
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 27,
                                                        "y": 104,
                                                        "h": 22,
                                                        "w": 22
                                                    },
                                                    {
                                                        "x": 64,
                                                        "y": 104,
                                                        "h": 24,
                                                        "w": 24
                                                    },
                                                    {
                                                        "x": 134,
                                                        "y": 146,
                                                        "h": 24,
                                                        "w": 24
                                                    },
                                                    {
                                                        "x": 537,
                                                        "y": 510,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 67,
                                                        "y": 75,
                                                        "h": 23,
                                                        "w": 23
                                                    },
                                                    {
                                                        "x": 62,
                                                        "y": 185,
                                                        "h": 26,
                                                        "w": 26
                                                    },
                                                    {
                                                        "x": 286,
                                                        "y": 251,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 142,
                                                        "y": 280,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 277,
                                                        "y": 314,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 109,
                                                        "y": 106,
                                                        "h": 26,
                                                        "w": 26
                                                    },
                                                    {
                                                        "x": 508,
                                                        "y": 82,
                                                        "h": 59,
                                                        "w": 59
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 42,
                                                        "y": 157,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 97,
                                                        "y": 158,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 221,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 769,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 102,
                                                        "y": 114,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 94,
                                                        "y": 279,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 432,
                                                        "y": 379,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 422,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 473,
                                                        "h": 47,
                                                        "w": 47
                                                    },
                                                    {
                                                        "x": 165,
                                                        "y": 161,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 765,
                                                        "y": 124,
                                                        "h": 90,
                                                        "w": 90
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1024,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1024,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1024,
                                            "width": 1024,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 573
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 126,
                                                    "y": 0,
                                                    "w": 898,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 512,
                                                    "y": 0,
                                                    "w": 512,
                                                    "h": 1024
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 1024
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1627337107629809664"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 215871,
                            "favorited": false,
                            "full_text": "Honouring the King 👑 https://t.co/3cbH6qpDww",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 933,
                            "reply_count": 1687,
                            "retweet_count": 21549,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1627337111366934529"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1581687360139689986",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1581687360139689986"
                            ],
                            "editable_until_msecs": "1665940427000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 25,
                            "bookmarked": false,
                            "created_at": "Sun Oct 16 16:43:47 +0000 2022",
                            "conversation_id_str": "1581687360139689986",
                            "display_text_range": [
                                0,
                                46
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/hh3yfztdv2",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1581687360139689986/photo/1",
                                        "id_str": "1581687346315026432",
                                        "indices": [
                                            47,
                                            70
                                        ],
                                        "media_key": "3_1581687346315026432",
                                        "media_url_https": "https://pbs.twimg.com/media/FfNIQubWYAApwdD.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Hh3yFZtDV2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 973,
                                                        "y": 373,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 645,
                                                        "y": 148,
                                                        "h": 100,
                                                        "w": 100
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 729,
                                                        "y": 279,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 483,
                                                        "y": 111,
                                                        "h": 75,
                                                        "w": 75
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 413,
                                                        "y": 158,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 274,
                                                        "y": 62,
                                                        "h": 42,
                                                        "w": 42
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 973,
                                                        "y": 373,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 645,
                                                        "y": 148,
                                                        "h": 100,
                                                        "w": 100
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1170,
                                                "w": 1600,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 878,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 497,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1170,
                                            "width": 1600,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1600,
                                                    "h": 896
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1170,
                                                    "h": 1170
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1026,
                                                    "h": 1170
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 585,
                                                    "h": 1170
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1600,
                                                    "h": 1170
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1581687346315026432"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/Hh3yFZtDV2",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1581687360139689986/photo/1",
                                        "id_str": "1581687346315026432",
                                        "indices": [
                                            47,
                                            70
                                        ],
                                        "media_key": "3_1581687346315026432",
                                        "media_url_https": "https://pbs.twimg.com/media/FfNIQubWYAApwdD.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Hh3yFZtDV2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 973,
                                                        "y": 373,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 645,
                                                        "y": 148,
                                                        "h": 100,
                                                        "w": 100
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 729,
                                                        "y": 279,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 483,
                                                        "y": 111,
                                                        "h": 75,
                                                        "w": 75
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 413,
                                                        "y": 158,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 274,
                                                        "y": 62,
                                                        "h": 42,
                                                        "w": 42
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 973,
                                                        "y": 373,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 645,
                                                        "y": 148,
                                                        "h": 100,
                                                        "w": 100
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1170,
                                                "w": 1600,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 878,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 497,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1170,
                                            "width": 1600,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1600,
                                                    "h": 896
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1170,
                                                    "h": 1170
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1026,
                                                    "h": 1170
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 585,
                                                    "h": 1170
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1600,
                                                    "h": 1170
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1581687346315026432"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 81701,
                            "favorited": false,
                            "full_text": "Another win and another goal 😝\nGod is great 🙌🏿 https://t.co/Hh3yFZtDV2",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 402,
                            "reply_count": 1309,
                            "retweet_count": 6820,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1581687360139689986"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1339301917776818177",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1339301917776818177"
                            ],
                            "editable_until_msecs": "1608151234881",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 5506,
                            "bookmarked": false,
                            "created_at": "Wed Dec 16 20:10:34 +0000 2020",
                            "conversation_id_str": "1339301917776818177",
                            "display_text_range": [
                                0,
                                31
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/owrcjchizd",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1339301917776818177/photo/1",
                                        "id_str": "1339301914543009792",
                                        "indices": [
                                            32,
                                            55
                                        ],
                                        "media_key": "3_1339301914543009792",
                                        "media_url_https": "https://pbs.twimg.com/media/EpYn_s9WMAANvMk.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/oWrcjchIZd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 861,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 807,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 457,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 861,
                                            "width": 1280,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1280,
                                                    "h": 717
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 861,
                                                    "h": 861
                                                },
                                                {
                                                    "x": 39,
                                                    "y": 0,
                                                    "w": 755,
                                                    "h": 861
                                                },
                                                {
                                                    "x": 201,
                                                    "y": 0,
                                                    "w": 431,
                                                    "h": 861
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1280,
                                                    "h": 861
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1339301914543009792"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/oWrcjchIZd",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1339301917776818177/photo/1",
                                        "id_str": "1339301914543009792",
                                        "indices": [
                                            32,
                                            55
                                        ],
                                        "media_key": "3_1339301914543009792",
                                        "media_url_https": "https://pbs.twimg.com/media/EpYn_s9WMAANvMk.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/oWrcjchIZd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 861,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 807,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 457,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 861,
                                            "width": 1280,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1280,
                                                    "h": 717
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 861,
                                                    "h": 861
                                                },
                                                {
                                                    "x": 39,
                                                    "y": 0,
                                                    "w": 755,
                                                    "h": 861
                                                },
                                                {
                                                    "x": 201,
                                                    "y": 0,
                                                    "w": 431,
                                                    "h": 861
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1280,
                                                    "h": 861
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1339301914543009792"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 160271,
                            "favorited": false,
                            "full_text": "You deserve more Arsenal fans 💔 https://t.co/oWrcjchIZd",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 9744,
                            "reply_count": 6251,
                            "retweet_count": 20787,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1339301917776818177"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1573287692254724096",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1573287692254724096"
                            ],
                            "editable_until_msecs": "1663937790000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 60,
                            "bookmarked": false,
                            "created_at": "Fri Sep 23 12:26:30 +0000 2022",
                            "conversation_id_str": "1573287692254724096",
                            "display_text_range": [
                                0,
                                134
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/5t6kpcqpmp",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1573287692254724096/photo/1",
                                        "id_str": "1573287687720779776",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1573287687720779776",
                                        "media_url_https": "https://pbs.twimg.com/media/FdVw0PwXwAAW5-w.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5T6kPCQPmp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 516,
                                                        "y": 210,
                                                        "h": 402,
                                                        "w": 402
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 344,
                                                        "y": 140,
                                                        "h": 268,
                                                        "w": 268
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 194,
                                                        "y": 79,
                                                        "h": 151,
                                                        "w": 151
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 516,
                                                        "y": 210,
                                                        "h": 402,
                                                        "w": 402
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1800,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1800,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 362,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 45,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1642
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 900,
                                                    "h": 1800
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1800
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1573287687720779776"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/5t6kpcqpmp",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1573287692254724096/photo/1",
                                        "id_str": "1573287687733248000",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1573287687733248000",
                                        "media_url_https": "https://pbs.twimg.com/media/FdVw0PzWAAAml9E.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5T6kPCQPmp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 914,
                                                        "y": 1023,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 799,
                                                        "h": 181,
                                                        "w": 181
                                                    },
                                                    {
                                                        "x": 202,
                                                        "y": 718,
                                                        "h": 247,
                                                        "w": 247
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 609,
                                                        "y": 682,
                                                        "h": 57,
                                                        "w": 57
                                                    },
                                                    {
                                                        "x": 542,
                                                        "y": 532,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 134,
                                                        "y": 478,
                                                        "h": 164,
                                                        "w": 164
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 345,
                                                        "y": 386,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 307,
                                                        "y": 301,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 76,
                                                        "y": 271,
                                                        "h": 93,
                                                        "w": 93
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 914,
                                                        "y": 1023,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 799,
                                                        "h": 181,
                                                        "w": 181
                                                    },
                                                    {
                                                        "x": 202,
                                                        "y": 718,
                                                        "h": 247,
                                                        "w": 247
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1800,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1800,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 2,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1642
                                                },
                                                {
                                                    "x": 135,
                                                    "y": 0,
                                                    "w": 900,
                                                    "h": 1800
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1800
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1573287687733248000"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/5t6kpcqpmp",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1573287692254724096/photo/1",
                                        "id_str": "1573287687741644802",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1573287687741644802",
                                        "media_url_https": "https://pbs.twimg.com/media/FdVw0P1WIAIOCdV.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5T6kPCQPmp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1309,
                                                        "y": 673,
                                                        "h": 79,
                                                        "w": 79
                                                    },
                                                    {
                                                        "x": 576,
                                                        "y": 356,
                                                        "h": 84,
                                                        "w": 84
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 673,
                                                        "h": 93,
                                                        "w": 93
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 1469,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 872,
                                                        "y": 448,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 384,
                                                        "y": 237,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 542,
                                                        "y": 448,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 147,
                                                        "y": 979,
                                                        "h": 74,
                                                        "w": 74
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 494,
                                                        "y": 254,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 217,
                                                        "y": 134,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 307,
                                                        "y": 254,
                                                        "h": 35,
                                                        "w": 35
                                                    },
                                                    {
                                                        "x": 83,
                                                        "y": 554,
                                                        "h": 42,
                                                        "w": 42
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1309,
                                                        "y": 673,
                                                        "h": 79,
                                                        "w": 79
                                                    },
                                                    {
                                                        "x": 576,
                                                        "y": 356,
                                                        "h": 84,
                                                        "w": 84
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 673,
                                                        "h": 93,
                                                        "w": 93
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 1469,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1800,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1800,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 2,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1642
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 900,
                                                    "h": 1800
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1800
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1573287687741644802"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/5T6kPCQPmp",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1573287692254724096/photo/1",
                                        "id_str": "1573287687720779776",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1573287687720779776",
                                        "media_url_https": "https://pbs.twimg.com/media/FdVw0PwXwAAW5-w.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5T6kPCQPmp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 516,
                                                        "y": 210,
                                                        "h": 402,
                                                        "w": 402
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 344,
                                                        "y": 140,
                                                        "h": 268,
                                                        "w": 268
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 194,
                                                        "y": 79,
                                                        "h": 151,
                                                        "w": 151
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 516,
                                                        "y": 210,
                                                        "h": 402,
                                                        "w": 402
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1800,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1800,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 362,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 45,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1642
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 900,
                                                    "h": 1800
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1800
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1573287687720779776"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/5T6kPCQPmp",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1573287692254724096/photo/1",
                                        "id_str": "1573287687733248000",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1573287687733248000",
                                        "media_url_https": "https://pbs.twimg.com/media/FdVw0PzWAAAml9E.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5T6kPCQPmp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 914,
                                                        "y": 1023,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 799,
                                                        "h": 181,
                                                        "w": 181
                                                    },
                                                    {
                                                        "x": 202,
                                                        "y": 718,
                                                        "h": 247,
                                                        "w": 247
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 609,
                                                        "y": 682,
                                                        "h": 57,
                                                        "w": 57
                                                    },
                                                    {
                                                        "x": 542,
                                                        "y": 532,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 134,
                                                        "y": 478,
                                                        "h": 164,
                                                        "w": 164
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 345,
                                                        "y": 386,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 307,
                                                        "y": 301,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 76,
                                                        "y": 271,
                                                        "h": 93,
                                                        "w": 93
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 914,
                                                        "y": 1023,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 799,
                                                        "h": 181,
                                                        "w": 181
                                                    },
                                                    {
                                                        "x": 202,
                                                        "y": 718,
                                                        "h": 247,
                                                        "w": 247
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1800,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1800,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 2,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1642
                                                },
                                                {
                                                    "x": 135,
                                                    "y": 0,
                                                    "w": 900,
                                                    "h": 1800
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1800
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1573287687733248000"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/5T6kPCQPmp",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1573287692254724096/photo/1",
                                        "id_str": "1573287687741644802",
                                        "indices": [
                                            135,
                                            158
                                        ],
                                        "media_key": "3_1573287687741644802",
                                        "media_url_https": "https://pbs.twimg.com/media/FdVw0P1WIAIOCdV.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5T6kPCQPmp",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1309,
                                                        "y": 673,
                                                        "h": 79,
                                                        "w": 79
                                                    },
                                                    {
                                                        "x": 576,
                                                        "y": 356,
                                                        "h": 84,
                                                        "w": 84
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 673,
                                                        "h": 93,
                                                        "w": 93
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 1469,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 872,
                                                        "y": 448,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 384,
                                                        "y": 237,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 542,
                                                        "y": 448,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 147,
                                                        "y": 979,
                                                        "h": 74,
                                                        "w": 74
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 494,
                                                        "y": 254,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 217,
                                                        "y": 134,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 307,
                                                        "y": 254,
                                                        "h": 35,
                                                        "w": 35
                                                    },
                                                    {
                                                        "x": 83,
                                                        "y": 554,
                                                        "h": 42,
                                                        "w": 42
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1309,
                                                        "y": 673,
                                                        "h": 79,
                                                        "w": 79
                                                    },
                                                    {
                                                        "x": 576,
                                                        "y": 356,
                                                        "h": 84,
                                                        "w": 84
                                                    },
                                                    {
                                                        "x": 813,
                                                        "y": 673,
                                                        "h": 93,
                                                        "w": 93
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 1469,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1800,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1800,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 2,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1642
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 900,
                                                    "h": 1800
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1800
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1573287687741644802"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 49874,
                            "favorited": false,
                            "full_text": "England Men’s Player of the Year 🤩🏆\nThis is a such a special honour for me and I’m very grateful to everyone who voted.\nGod is Great ! https://t.co/5T6kPCQPmp",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 626,
                            "reply_count": 1317,
                            "retweet_count": 6208,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1573287692254724096"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1278298080362840066",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDM4ODc0NTgwOTU2NDQyNjI1",
                                    "rest_id": "1038874580956442625",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Sep 09 19:39:36 +0000 2018",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Football for Arsenal & England. New Balance Athlete #GodsChild😇",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/bukayosaka87",
                                                        "expanded_url": "http://instagram.com/bukayosaka87",
                                                        "url": "https://t.co/gJxa3EotoJ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 181,
                                        "followers_count": 1288655,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1330,
                                        "location": "London, England",
                                        "media_count": 157,
                                        "name": "Bukayo Saka",
                                        "normal_followers_count": 1288655,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1038874580956442625/1603838064",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1286767288859992067/P-xmi5go_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BukayoSaka87",
                                        "statuses_count": 229,
                                        "translator_type": "none",
                                        "url": "https://t.co/gJxa3EotoJ",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1278298080362840066"
                            ],
                            "editable_until_msecs": "1593606786645",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "state": "Enabled"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 119,
                            "bookmarked": false,
                            "created_at": "Wed Jul 01 12:03:06 +0000 2020",
                            "conversation_id_str": "1278298080362840066",
                            "display_text_range": [
                                0,
                                250
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ns7g5ne9pc",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1278298080362840066/photo/1",
                                        "id_str": "1278298073110843392",
                                        "indices": [
                                            251,
                                            274
                                        ],
                                        "media_key": "3_1278298073110843392",
                                        "media_url_https": "https://pbs.twimg.com/media/Eb1tUyTWkAAHB91.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/nS7G5nE9Pc",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 198,
                                                        "y": 70,
                                                        "h": 210,
                                                        "w": 210
                                                    },
                                                    {
                                                        "x": 521,
                                                        "y": 201,
                                                        "h": 243,
                                                        "w": 243
                                                    },
                                                    {
                                                        "x": 907,
                                                        "y": 554,
                                                        "h": 271,
                                                        "w": 271
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 148,
                                                        "y": 52,
                                                        "h": 157,
                                                        "w": 157
                                                    },
                                                    {
                                                        "x": 390,
                                                        "y": 150,
                                                        "h": 182,
                                                        "w": 182
                                                    },
                                                    {
                                                        "x": 680,
                                                        "y": 415,
                                                        "h": 203,
                                                        "w": 203
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 84,
                                                        "y": 29,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 85,
                                                        "h": 103,
                                                        "w": 103
                                                    },
                                                    {
                                                        "x": 385,
                                                        "y": 235,
                                                        "h": 115,
                                                        "w": 115
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 198,
                                                        "y": 70,
                                                        "h": 210,
                                                        "w": 210
                                                    },
                                                    {
                                                        "x": 521,
                                                        "y": 201,
                                                        "h": 243,
                                                        "w": 243
                                                    },
                                                    {
                                                        "x": 907,
                                                        "y": 554,
                                                        "h": 271,
                                                        "w": 271
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1219,
                                                "w": 1600,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 914,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 518,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1219,
                                            "width": 1600,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 311,
                                                    "w": 1600,
                                                    "h": 896
                                                },
                                                {
                                                    "x": 381,
                                                    "y": 0,
                                                    "w": 1219,
                                                    "h": 1219
                                                },
                                                {
                                                    "x": 531,
                                                    "y": 0,
                                                    "w": 1069,
                                                    "h": 1219
                                                },
                                                {
                                                    "x": 774,
                                                    "y": 0,
                                                    "w": 610,
                                                    "h": 1219
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1600,
                                                    "h": 1219
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1278298073110843392"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/nS7G5nE9Pc",
                                        "expanded_url": "https://twitter.com/BukayoSaka87/status/1278298080362840066/photo/1",
                                        "id_str": "1278298073110843392",
                                        "indices": [
                                            251,
                                            274
                                        ],
                                        "media_key": "3_1278298073110843392",
                                        "media_url_https": "https://pbs.twimg.com/media/Eb1tUyTWkAAHB91.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/nS7G5nE9Pc",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 198,
                                                        "y": 70,
                                                        "h": 210,
                                                        "w": 210
                                                    },
                                                    {
                                                        "x": 521,
                                                        "y": 201,
                                                        "h": 243,
                                                        "w": 243
                                                    },
                                                    {
                                                        "x": 907,
                                                        "y": 554,
                                                        "h": 271,
                                                        "w": 271
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 148,
                                                        "y": 52,
                                                        "h": 157,
                                                        "w": 157
                                                    },
                                                    {
                                                        "x": 390,
                                                        "y": 150,
                                                        "h": 182,
                                                        "w": 182
                                                    },
                                                    {
                                                        "x": 680,
                                                        "y": 415,
                                                        "h": 203,
                                                        "w": 203
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 84,
                                                        "y": 29,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 85,
                                                        "h": 103,
                                                        "w": 103
                                                    },
                                                    {
                                                        "x": 385,
                                                        "y": 235,
                                                        "h": 115,
                                                        "w": 115
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 198,
                                                        "y": 70,
                                                        "h": 210,
                                                        "w": 210
                                                    },
                                                    {
                                                        "x": 521,
                                                        "y": 201,
                                                        "h": 243,
                                                        "w": 243
                                                    },
                                                    {
                                                        "x": 907,
                                                        "y": 554,
                                                        "h": 271,
                                                        "w": 271
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1219,
                                                "w": 1600,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 914,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 518,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1219,
                                            "width": 1600,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 311,
                                                    "w": 1600,
                                                    "h": 896
                                                },
                                                {
                                                    "x": 381,
                                                    "y": 0,
                                                    "w": 1219,
                                                    "h": 1219
                                                },
                                                {
                                                    "x": 531,
                                                    "y": 0,
                                                    "w": 1069,
                                                    "h": 1219
                                                },
                                                {
                                                    "x": 774,
                                                    "y": 0,
                                                    "w": 610,
                                                    "h": 1219
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1600,
                                                    "h": 1219
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1278298073110843392"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 130899,
                            "favorited": false,
                            "full_text": "London is my home. Arsenal my team. I’m so happy to finally announce my contract extension😄📝 I love playing for this club and I’m looking forward to what the future holds.. The hard work continues so I can continue living my dream🙏🏿❤️ God is Great !! https://t.co/nS7G5nE9Pc",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 5070,
                            "reply_count": 4491,
                            "retweet_count": 22562,
                            "retweeted": false,
                            "user_id_str": "1038874580956442625",
                            "id_str": "1278298080362840066"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1809659654915649982",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxODM3NzAzNg==",
                                    "rest_id": "18377036",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Thu Dec 25 17:43:42 +0000 2008",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Professor @StanfordEcon. Incoming Director @SIEPR. Former @WhiteHouse National Economic Council.  Watches soccer, reads history, listens to all types of music.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "nmahoney.people.stanford.edu",
                                                        "expanded_url": "https://nmahoney.people.stanford.edu/",
                                                        "url": "https://t.co/Tjys7tfv8V",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 4494,
                                        "followers_count": 8049,
                                        "friends_count": 708,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 125,
                                        "location": "Stanford, CA",
                                        "media_count": 343,
                                        "name": "Neale Mahoney",
                                        "normal_followers_count": 8049,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/18377036/1692465774",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/540706989626511360/l2j0Nsge_normal.jpeg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "nealemahoney",
                                        "statuses_count": 3003,
                                        "translator_type": "none",
                                        "url": "https://t.co/Tjys7tfv8V",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1809659654915649982"
                            ],
                            "editable_until_msecs": "1720295058000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1526",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 0,
                            "bookmarked": false,
                            "created_at": "Sat Jul 06 18:44:18 +0000 2024",
                            "conversation_id_str": "1809659654915649982",
                            "display_text_range": [
                                0,
                                22
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 7,
                            "favorited": false,
                            "full_text": "Bukayo Saka had a game",
                            "is_quote_status": false,
                            "lang": "tl",
                            "quote_count": 0,
                            "reply_count": 1,
                            "retweet_count": 1,
                            "retweeted": false,
                            "user_id_str": "18377036",
                            "id_str": "1809659654915649982"
                        }
                    }
                }
            }
        }
    ],
    lenyYoro: [
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814021150369869870",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNTU5Mjc5NzY=",
                                    "rest_id": "155927976",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Tue Jun 15 14:47:40 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Official Twitter Account of Rio Ferdinand / Management Enquiries - Jakemallen@neweraltd.co.uk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "Rioferdinandpresents.com",
                                                        "expanded_url": "http://Rioferdinandpresents.com",
                                                        "url": "https://t.co/mpGUfTwbw3",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 5106,
                                        "followers_count": 11668419,
                                        "friends_count": 756,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 19997,
                                        "location": "",
                                        "media_count": 3409,
                                        "name": "Rio Ferdinand",
                                        "normal_followers_count": 11668419,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/155927976/1723447736",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1836880197896859648/DIHa3Lm5_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "rioferdy5",
                                        "statuses_count": 23827,
                                        "translator_type": "none",
                                        "url": "https://t.co/mpGUfTwbw3",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814021150369869870"
                            ],
                            "editable_until_msecs": "1721334919000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1388332",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 387,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 19:35:19 +0000 2024",
                            "conversation_id_str": "1814021150369869870",
                            "display_text_range": [
                                0,
                                117
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            87,
                                            92
                                        ],
                                        "text": "MUFC"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/mCfPH5pDHv",
                                        "expanded_url": "https://x.com/ManUtd/status/1814017924081795072/video/1",
                                        "id_str": "1814017733064806400",
                                        "indices": [
                                            94,
                                            117
                                        ],
                                        "media_key": "13_1814017733064806400",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyvq2cWoAEWFek.jpg",
                                        "source_status_id_str": "1814017924081795072",
                                        "source_user_id_str": "558797310",
                                        "type": "video",
                                        "url": "https://t.co/mCfPH5pDHv",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjo1NTg3OTczMTA=",
                                                        "rest_id": "558797310",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Square",
                                                        "legacy": {
                                                            "created_at": "Fri Apr 20 15:17:43 +0000 2012",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "The home of Manchester United.",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "bit.ly/3YYcXho",
                                                                            "expanded_url": "https://bit.ly/3YYcXho",
                                                                            "url": "https://t.co/0epF8s3mZQ",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 6682,
                                                            "followers_count": 38500476,
                                                            "friends_count": 143,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 29179,
                                                            "location": "United Store ➡",
                                                            "media_count": 45866,
                                                            "name": "Manchester United",
                                                            "normal_followers_count": 38500476,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/558797310/1734290033",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1856418426496880640/iIvJaO5T_normal.png",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "ManUtd",
                                                            "statuses_count": 92737,
                                                            "translator_type": "regular",
                                                            "url": "https://t.co/0epF8s3mZQ",
                                                            "verified": false,
                                                            "verified_type": "Business",
                                                            "withheld_in_countries": []
                                                        },
                                                        "tipjar_settings": {
                                                            "is_enabled": false,
                                                            "bandcamp_handle": "",
                                                            "bitcoin_handle": "",
                                                            "cash_app_handle": "",
                                                            "ethereum_handle": "",
                                                            "gofundme_handle": "",
                                                            "patreon_handle": "",
                                                            "pay_pal_handle": "",
                                                            "venmo_handle": ""
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                4,
                                                5
                                            ],
                                            "duration_millis": 54400,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/pl/P_wN2UHeY4khIy3i.m3u8?tag=16&v=9ba"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/320x400/Bi9ECZSNQuOQmiFs.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/480x600/w3Nbug5EbCyJG742.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/720x900/TK_K-rlEWtRQEB_H.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/1080x1350/7i1915EvKT9kKHIU.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1814017733064806400"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "1438496548493606917",
                                        "name": "Leny Yoro",
                                        "screen_name": "leny_yoro",
                                        "indices": [
                                            63,
                                            73
                                        ]
                                    },
                                    {
                                        "id_str": "558797310",
                                        "name": "Manchester United",
                                        "screen_name": "ManUtd",
                                        "indices": [
                                            77,
                                            84
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.x.com/mCfPH5pDHv",
                                        "expanded_url": "https://x.com/ManUtd/status/1814017924081795072/video/1",
                                        "id_str": "1814017733064806400",
                                        "indices": [
                                            94,
                                            117
                                        ],
                                        "media_key": "13_1814017733064806400",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyvq2cWoAEWFek.jpg",
                                        "source_status_id_str": "1814017924081795072",
                                        "source_user_id_str": "558797310",
                                        "type": "video",
                                        "url": "https://t.co/mCfPH5pDHv",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjo1NTg3OTczMTA=",
                                                        "rest_id": "558797310",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Square",
                                                        "legacy": {
                                                            "created_at": "Fri Apr 20 15:17:43 +0000 2012",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "The home of Manchester United.",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "bit.ly/3YYcXho",
                                                                            "expanded_url": "https://bit.ly/3YYcXho",
                                                                            "url": "https://t.co/0epF8s3mZQ",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 6682,
                                                            "followers_count": 38500476,
                                                            "friends_count": 143,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 29179,
                                                            "location": "United Store ➡",
                                                            "media_count": 45866,
                                                            "name": "Manchester United",
                                                            "normal_followers_count": 38500476,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/558797310/1734290033",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1856418426496880640/iIvJaO5T_normal.png",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "ManUtd",
                                                            "statuses_count": 92737,
                                                            "translator_type": "regular",
                                                            "url": "https://t.co/0epF8s3mZQ",
                                                            "verified": false,
                                                            "verified_type": "Business",
                                                            "withheld_in_countries": []
                                                        },
                                                        "tipjar_settings": {
                                                            "is_enabled": false,
                                                            "bandcamp_handle": "",
                                                            "bitcoin_handle": "",
                                                            "cash_app_handle": "",
                                                            "ethereum_handle": "",
                                                            "gofundme_handle": "",
                                                            "patreon_handle": "",
                                                            "pay_pal_handle": "",
                                                            "venmo_handle": ""
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                4,
                                                5
                                            ],
                                            "duration_millis": 54400,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/pl/P_wN2UHeY4khIy3i.m3u8?tag=16&v=9ba"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/320x400/Bi9ECZSNQuOQmiFs.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/480x600/w3Nbug5EbCyJG742.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/720x900/TK_K-rlEWtRQEB_H.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814017733064806400/vid/avc1/1080x1350/7i1915EvKT9kKHIU.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1814017733064806400"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 37853,
                            "favorited": false,
                            "full_text": "Leny Yoro is a red, is a red, is a red,\nLeny Yoro is a red…… \n\n@leny_yoro \uD83E\uDD1D\uD83C\uDFFD @ManUtd \n\n#MUFC \nhttps://t.co/mCfPH5pDHv",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 192,
                            "reply_count": 815,
                            "retweet_count": 4035,
                            "retweeted": false,
                            "user_id_str": "155927976",
                            "id_str": "1814021150369869870"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813934368953627036",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com 📩",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11664,
                                        "followers_count": 21432130,
                                        "friends_count": 2573,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27347,
                                        "location": "Milano, Italia",
                                        "media_count": 23085,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21432130,
                                        "pinned_tweet_ids_str": [
                                            "1814036386552451367"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 45184,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813934368953627036"
                            ],
                            "editable_until_msecs": "1721314229000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "4904920",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 684,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 13:50:29 +0000 2024",
                            "conversation_id_str": "1813934368953627036",
                            "display_text_range": [
                                0,
                                267
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/pokve2cpfc",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1813934368953627036/photo/1",
                                        "id_str": "1813934363127476224",
                                        "indices": [
                                            268,
                                            291
                                        ],
                                        "media_key": "3_1813934363127476224",
                                        "media_url_https": "https://pbs.twimg.com/media/GSxjsVAWcAApF0Z.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/pOKvE2cPfC",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 662,
                                                        "y": 290,
                                                        "h": 316,
                                                        "w": 316
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 387,
                                                        "y": 169,
                                                        "h": 185,
                                                        "w": 185
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 219,
                                                        "y": 96,
                                                        "h": 104,
                                                        "w": 104
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 662,
                                                        "y": 290,
                                                        "h": 316,
                                                        "w": 316
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1638,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1638,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 924,
                                                    "w": 1638,
                                                    "h": 917
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 410,
                                                    "w": 1638,
                                                    "h": 1638
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 181,
                                                    "w": 1638,
                                                    "h": 1867
                                                },
                                                {
                                                    "x": 255,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813934363127476224"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/pOKvE2cPfC",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1813934368953627036/photo/1",
                                        "id_str": "1813934363127476224",
                                        "indices": [
                                            268,
                                            291
                                        ],
                                        "media_key": "3_1813934363127476224",
                                        "media_url_https": "https://pbs.twimg.com/media/GSxjsVAWcAApF0Z.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/pOKvE2cPfC",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 662,
                                                        "y": 290,
                                                        "h": 316,
                                                        "w": 316
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 387,
                                                        "y": 169,
                                                        "h": 185,
                                                        "w": 185
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 219,
                                                        "y": 96,
                                                        "h": 104,
                                                        "w": 104
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 662,
                                                        "y": 290,
                                                        "h": 316,
                                                        "w": 316
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1638,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1638,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 924,
                                                    "w": 1638,
                                                    "h": 917
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 410,
                                                    "w": 1638,
                                                    "h": 1638
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 181,
                                                    "w": 1638,
                                                    "h": 1867
                                                },
                                                {
                                                    "x": 255,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813934363127476224"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 113786,
                            "favorited": false,
                            "full_text": "🚨✍🏻 Leny Yoro has just signed his contract as new Manchester United player.\n\nDeal completed on both clubs and player side as Man Utd and Lille are exchanging all documents today.\n\nYoro signs in at Manchester United until June 2029, medical tests also done. Saga over. https://t.co/pOKvE2cPfC",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1880,
                            "reply_count": 2317,
                            "retweet_count": 14869,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1813934368953627036"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814005116023996886",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com 📩",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11664,
                                        "followers_count": 21432133,
                                        "friends_count": 2573,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27347,
                                        "location": "Milano, Italia",
                                        "media_count": 23085,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21432133,
                                        "pinned_tweet_ids_str": [
                                            "1814036386552451367"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 45184,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814005116023996886"
                            ],
                            "editable_until_msecs": "1721331096000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "2211587",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 476,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 18:31:36 +0000 2024",
                            "conversation_id_str": "1814005116023996886",
                            "display_text_range": [
                                0,
                                82
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ya5gr2ludv",
                                        "expanded_url": "https://twitter.com/ManUtd/status/1814004803975971285/video/1",
                                        "id_str": "1814004737487904768",
                                        "indices": [
                                            59,
                                            82
                                        ],
                                        "media_key": "13_1814004737487904768",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyjvGLWYAAl47D.jpg",
                                        "source_status_id_str": "1814004803975971285",
                                        "source_user_id_str": "558797310",
                                        "type": "video",
                                        "url": "https://t.co/yA5GR2ludV",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjo1NTg3OTczMTA=",
                                                        "rest_id": "558797310",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Square",
                                                        "legacy": {
                                                            "created_at": "Fri Apr 20 15:17:43 +0000 2012",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "Watch every United pre-season game this summer LIVE on MUTV by subscribing today 📱⬇️",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "bit.ly/3WwP0Ol",
                                                                            "expanded_url": "https://bit.ly/3WwP0Ol",
                                                                            "url": "https://t.co/uZbUaNhbRo",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 6536,
                                                            "followers_count": 37958843,
                                                            "friends_count": 149,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 29218,
                                                            "location": "Worldwide 🌎",
                                                            "media_count": 44544,
                                                            "name": "Manchester United",
                                                            "normal_followers_count": 37958843,
                                                            "pinned_tweet_ids_str": [
                                                                "1814012288854339622"
                                                            ],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/558797310/1719819539",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1755882741176913920/3l3AFLq2_normal.png",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "ManUtd",
                                                            "statuses_count": 89762,
                                                            "translator_type": "regular",
                                                            "url": "https://t.co/uZbUaNhbRo",
                                                            "verified": false,
                                                            "verified_type": "Business",
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                4,
                                                5
                                            ],
                                            "duration_millis": 7120,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/pl/jKLkvvhcvX3lJgvY.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/320x400/-unJCnZDoxqb6oFB.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/480x600/K-BBbBfC-GDf8Ct2.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/720x900/WrtD6gAVul6Xyxa9.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/1080x1350/bIl8zuLQG9mZwvIw.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1814004737487904768"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/yA5GR2ludV",
                                        "expanded_url": "https://twitter.com/ManUtd/status/1814004803975971285/video/1",
                                        "id_str": "1814004737487904768",
                                        "indices": [
                                            59,
                                            82
                                        ],
                                        "media_key": "13_1814004737487904768",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyjvGLWYAAl47D.jpg",
                                        "source_status_id_str": "1814004803975971285",
                                        "source_user_id_str": "558797310",
                                        "type": "video",
                                        "url": "https://t.co/yA5GR2ludV",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjo1NTg3OTczMTA=",
                                                        "rest_id": "558797310",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Square",
                                                        "legacy": {
                                                            "created_at": "Fri Apr 20 15:17:43 +0000 2012",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "Watch every United pre-season game this summer LIVE on MUTV by subscribing today 📱⬇️",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "bit.ly/3WwP0Ol",
                                                                            "expanded_url": "https://bit.ly/3WwP0Ol",
                                                                            "url": "https://t.co/uZbUaNhbRo",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 6536,
                                                            "followers_count": 37958843,
                                                            "friends_count": 149,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 29218,
                                                            "location": "Worldwide 🌎",
                                                            "media_count": 44544,
                                                            "name": "Manchester United",
                                                            "normal_followers_count": 37958843,
                                                            "pinned_tweet_ids_str": [
                                                                "1814012288854339622"
                                                            ],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/558797310/1719819539",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1755882741176913920/3l3AFLq2_normal.png",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "ManUtd",
                                                            "statuses_count": 89762,
                                                            "translator_type": "regular",
                                                            "url": "https://t.co/uZbUaNhbRo",
                                                            "verified": false,
                                                            "verified_type": "Business",
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                4,
                                                5
                                            ],
                                            "duration_millis": 7120,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/pl/jKLkvvhcvX3lJgvY.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/320x400/-unJCnZDoxqb6oFB.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/480x600/K-BBbBfC-GDf8Ct2.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/720x900/WrtD6gAVul6Xyxa9.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814004737487904768/vid/avc1/1080x1350/bIl8zuLQG9mZwvIw.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1814004737487904768"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 52241,
                            "favorited": false,
                            "full_text": "Leny Yoro to Manchester United, official in 29 minutes. 🔴🔜 https://t.co/yA5GR2ludV",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 268,
                            "reply_count": 768,
                            "retweet_count": 4150,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1814005116023996886"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813921889443811384",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MTM5OTM0MTM=",
                                    "rest_id": "713993413",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Tue Jul 24 09:18:08 +0000 2012",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "The official account for the Sky Sports Premier League channel",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "shop.skysports.com/football-clubs/",
                                                        "expanded_url": "https://shop.skysports.com/football-clubs/",
                                                        "url": "https://t.co/0XTVPZ8lP0",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 336,
                                        "followers_count": 12334455,
                                        "friends_count": 39,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 17317,
                                        "location": "London",
                                        "media_count": 107113,
                                        "name": "Sky Sports Premier League",
                                        "normal_followers_count": 12334455,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/713993413/1699464013",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1605131756310614017/05qwHae-_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "SkySportsPL",
                                        "statuses_count": 222871,
                                        "translator_type": "none",
                                        "url": "https://t.co/0XTVPZ8lP0",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1443897323508183042",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813921889443811384"
                            ],
                            "editable_until_msecs": "1721311254000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "432784",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 95,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 13:00:54 +0000 2024",
                            "conversation_id_str": "1813921889443811384",
                            "display_text_range": [
                                0,
                                64
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/nxsbjivhij",
                                        "expanded_url": "https://twitter.com/SkySportsPL/status/1813921889443811384/photo/1",
                                        "id_str": "1813921215305641985",
                                        "indices": [
                                            65,
                                            88
                                        ],
                                        "media_key": "3_1813921215305641985",
                                        "media_url_https": "https://pbs.twimg.com/media/GSxXvBjWcAEQp1E.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NXSBjivHiJ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 784,
                                                        "y": 730,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 461,
                                                        "y": 391,
                                                        "h": 224,
                                                        "w": 224
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 648,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 409,
                                                        "y": 347,
                                                        "h": 199,
                                                        "w": 199
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 394,
                                                        "y": 367,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 232,
                                                        "y": 196,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 784,
                                                        "y": 730,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 461,
                                                        "y": 391,
                                                        "h": 224,
                                                        "w": 224
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 676,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 270,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 119,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813921215305641985"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/NXSBjivHiJ",
                                        "expanded_url": "https://twitter.com/SkySportsPL/status/1813921889443811384/photo/1",
                                        "id_str": "1813921215305641985",
                                        "indices": [
                                            65,
                                            88
                                        ],
                                        "media_key": "3_1813921215305641985",
                                        "media_url_https": "https://pbs.twimg.com/media/GSxXvBjWcAEQp1E.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NXSBjivHiJ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 784,
                                                        "y": 730,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 461,
                                                        "y": 391,
                                                        "h": 224,
                                                        "w": 224
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 648,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 409,
                                                        "y": 347,
                                                        "h": 199,
                                                        "w": 199
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 394,
                                                        "y": 367,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 232,
                                                        "y": 196,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 784,
                                                        "y": 730,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 461,
                                                        "y": 391,
                                                        "h": 224,
                                                        "w": 224
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 676,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 270,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 119,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813921215305641985"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 17686,
                            "favorited": false,
                            "full_text": "Will Leny Yoro's move to Man United be the deal of the summer? 👀 https://t.co/NXSBjivHiJ",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 62,
                            "reply_count": 380,
                            "retweet_count": 1013,
                            "retweeted": false,
                            "user_id_str": "713993413",
                            "id_str": "1813921889443811384"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814012902015439090",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com 📩",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11664,
                                        "followers_count": 21432130,
                                        "friends_count": 2573,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27347,
                                        "location": "Milano, Italia",
                                        "media_count": 23085,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21432130,
                                        "pinned_tweet_ids_str": [
                                            "1814036386552451367"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 45184,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814012902015439090"
                            ],
                            "editable_until_msecs": "1721332953000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "2763928",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 478,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 19:02:33 +0000 2024",
                            "conversation_id_str": "1814012902015439090",
                            "display_text_range": [
                                0,
                                277
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/7ucjmsw4wp",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1814012902015439090/photo/1",
                                        "id_str": "1814012896264757248",
                                        "indices": [
                                            278,
                                            301
                                        ],
                                        "media_key": "3_1814012896264757248",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyrHjvWoAAm1N8.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/7UcJMSW4WP",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1214,
                                                        "y": 138,
                                                        "h": 152,
                                                        "w": 152
                                                    },
                                                    {
                                                        "x": 844,
                                                        "y": 122,
                                                        "h": 150,
                                                        "w": 150
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 711,
                                                        "y": 80,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 494,
                                                        "y": 71,
                                                        "h": 87,
                                                        "w": 87
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 403,
                                                        "y": 45,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 280,
                                                        "y": 40,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1214,
                                                        "y": 138,
                                                        "h": 152,
                                                        "w": 152
                                                    },
                                                    {
                                                        "x": 844,
                                                        "y": 122,
                                                        "h": 150,
                                                        "w": 150
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1365,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1365,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 218,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 393,
                                                    "y": 0,
                                                    "w": 1365,
                                                    "h": 1365
                                                },
                                                {
                                                    "x": 477,
                                                    "y": 0,
                                                    "w": 1197,
                                                    "h": 1365
                                                },
                                                {
                                                    "x": 734,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1365
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1365
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814012896264757248"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/7UcJMSW4WP",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1814012902015439090/photo/1",
                                        "id_str": "1814012896264757248",
                                        "indices": [
                                            278,
                                            301
                                        ],
                                        "media_key": "3_1814012896264757248",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyrHjvWoAAm1N8.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/7UcJMSW4WP",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1214,
                                                        "y": 138,
                                                        "h": 152,
                                                        "w": 152
                                                    },
                                                    {
                                                        "x": 844,
                                                        "y": 122,
                                                        "h": 150,
                                                        "w": 150
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 711,
                                                        "y": 80,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 494,
                                                        "y": 71,
                                                        "h": 87,
                                                        "w": 87
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 403,
                                                        "y": 45,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 280,
                                                        "y": 40,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1214,
                                                        "y": 138,
                                                        "h": 152,
                                                        "w": 152
                                                    },
                                                    {
                                                        "x": 844,
                                                        "y": 122,
                                                        "h": 150,
                                                        "w": 150
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1365,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1365,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 218,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 393,
                                                    "y": 0,
                                                    "w": 1365,
                                                    "h": 1365
                                                },
                                                {
                                                    "x": 477,
                                                    "y": 0,
                                                    "w": 1197,
                                                    "h": 1365
                                                },
                                                {
                                                    "x": 734,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1365
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1365
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814012896264757248"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 67644,
                            "favorited": false,
                            "full_text": "🔴 Leny Yoro on why he accepted Man United: “Since my first conversations with the club, they set out a clear plan for how I can develop as part of this exciting project, showing a lot of care for me and my family”.\n\n“It’s incredible honour to sign for club of Man Utd stature”. https://t.co/7UcJMSW4WP",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 509,
                            "reply_count": 943,
                            "retweet_count": 6668,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1814012902015439090"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814019820523757772",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMjc2MjY3MTc2NzkwNDk5MzI4",
                                    "rest_id": "1276267176790499328",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/CBSSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1730281935014895616/VebpL81c_bigger.jpg"
                                            },
                                            "description": "CBS Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Jun 25 21:33:25 +0000 2020",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Welcome to the home of...\n\n⚽️ The World's Game 🌎\n📺 CBS Sports Golazo Network. 24/7 and FREE 👉 Link in bio\n🎶 And... THE CHAAAMPIONS 🎶",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "linktr.ee/cbssportsgolazo",
                                                        "expanded_url": "https://linktr.ee/cbssportsgolazo",
                                                        "url": "https://t.co/OAxBmhlRQ7",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 3512,
                                        "followers_count": 324130,
                                        "friends_count": 1172,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1711,
                                        "location": "United States",
                                        "media_count": 31381,
                                        "name": "CBS Sports Golazo ⚽️",
                                        "normal_followers_count": 324130,
                                        "pinned_tweet_ids_str": [
                                            "1813927167819981310"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1276267176790499328/1717278413",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1399729918548889600/EXKZ4qak_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "CBSSportsGolazo",
                                        "statuses_count": 39789,
                                        "translator_type": "none",
                                        "url": "https://t.co/OAxBmhlRQ7",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1591574227228020736",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814019820523757772"
                            ],
                            "editable_until_msecs": "1721334602000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "20380",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 1,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 19:30:02 +0000 2024",
                            "conversation_id_str": "1814019820523757772",
                            "display_text_range": [
                                0,
                                190
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/6m2db8o9wl",
                                        "expanded_url": "https://twitter.com/CBSSportsGolazo/status/1814019820523757772/photo/1",
                                        "id_str": "1814019792627531776",
                                        "indices": [
                                            191,
                                            214
                                        ],
                                        "media_key": "3_1814019792627531776",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyxY-sXgAAHKd9.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/6m2dB8O9wL",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 603,
                                                        "y": 280,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 283,
                                                        "y": 25,
                                                        "h": 721,
                                                        "w": 721
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 565,
                                                        "y": 262,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 265,
                                                        "y": 23,
                                                        "h": 675,
                                                        "w": 675
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 320,
                                                        "y": 148,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 150,
                                                        "y": 13,
                                                        "h": 383,
                                                        "w": 383
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 603,
                                                        "y": 280,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 283,
                                                        "y": 25,
                                                        "h": 721,
                                                        "w": 721
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 853,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 853,
                                            "width": 1280,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 58,
                                                    "w": 1280,
                                                    "h": 717
                                                },
                                                {
                                                    "x": 182,
                                                    "y": 0,
                                                    "w": 853,
                                                    "h": 853
                                                },
                                                {
                                                    "x": 234,
                                                    "y": 0,
                                                    "w": 748,
                                                    "h": 853
                                                },
                                                {
                                                    "x": 395,
                                                    "y": 0,
                                                    "w": 427,
                                                    "h": 853
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1280,
                                                    "h": 853
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814019792627531776"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/6m2db8o9wl",
                                        "expanded_url": "https://twitter.com/CBSSportsGolazo/status/1814019820523757772/photo/1",
                                        "id_str": "1814019799292276736",
                                        "indices": [
                                            191,
                                            214
                                        ],
                                        "media_key": "3_1814019799292276736",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyxZXhXcAAVZVo.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/6m2dB8O9wL",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 618,
                                                        "y": 602,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 563,
                                                        "y": 219,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 900,
                                                        "h": 261,
                                                        "w": 261
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 484,
                                                        "y": 472,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 441,
                                                        "y": 171,
                                                        "h": 95,
                                                        "w": 95
                                                    },
                                                    {
                                                        "x": 173,
                                                        "y": 705,
                                                        "h": 204,
                                                        "w": 204
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 274,
                                                        "y": 267,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 250,
                                                        "y": 97,
                                                        "h": 54,
                                                        "w": 54
                                                    },
                                                    {
                                                        "x": 98,
                                                        "y": 400,
                                                        "h": 116,
                                                        "w": 116
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 618,
                                                        "y": 602,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 563,
                                                        "y": 219,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 900,
                                                        "h": 261,
                                                        "w": 261
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1530,
                                                "w": 1224,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1530,
                                            "width": 1224,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 685
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1224
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1395
                                                },
                                                {
                                                    "x": 230,
                                                    "y": 0,
                                                    "w": 765,
                                                    "h": 1530
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1530
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814019799292276736"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/6m2dB8O9wL",
                                        "expanded_url": "https://twitter.com/CBSSportsGolazo/status/1814019820523757772/photo/1",
                                        "id_str": "1814019792627531776",
                                        "indices": [
                                            191,
                                            214
                                        ],
                                        "media_key": "3_1814019792627531776",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyxY-sXgAAHKd9.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/6m2dB8O9wL",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 603,
                                                        "y": 280,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 283,
                                                        "y": 25,
                                                        "h": 721,
                                                        "w": 721
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 565,
                                                        "y": 262,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 265,
                                                        "y": 23,
                                                        "h": 675,
                                                        "w": 675
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 320,
                                                        "y": 148,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 150,
                                                        "y": 13,
                                                        "h": 383,
                                                        "w": 383
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 603,
                                                        "y": 280,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 283,
                                                        "y": 25,
                                                        "h": 721,
                                                        "w": 721
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 853,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 453,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 853,
                                            "width": 1280,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 58,
                                                    "w": 1280,
                                                    "h": 717
                                                },
                                                {
                                                    "x": 182,
                                                    "y": 0,
                                                    "w": 853,
                                                    "h": 853
                                                },
                                                {
                                                    "x": 234,
                                                    "y": 0,
                                                    "w": 748,
                                                    "h": 853
                                                },
                                                {
                                                    "x": 395,
                                                    "y": 0,
                                                    "w": 427,
                                                    "h": 853
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1280,
                                                    "h": 853
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814019792627531776"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/6m2dB8O9wL",
                                        "expanded_url": "https://twitter.com/CBSSportsGolazo/status/1814019820523757772/photo/1",
                                        "id_str": "1814019799292276736",
                                        "indices": [
                                            191,
                                            214
                                        ],
                                        "media_key": "3_1814019799292276736",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyxZXhXcAAVZVo.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/6m2dB8O9wL",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 618,
                                                        "y": 602,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 563,
                                                        "y": 219,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 900,
                                                        "h": 261,
                                                        "w": 261
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 484,
                                                        "y": 472,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 441,
                                                        "y": 171,
                                                        "h": 95,
                                                        "w": 95
                                                    },
                                                    {
                                                        "x": 173,
                                                        "y": 705,
                                                        "h": 204,
                                                        "w": 204
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 274,
                                                        "y": 267,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 250,
                                                        "y": 97,
                                                        "h": 54,
                                                        "w": 54
                                                    },
                                                    {
                                                        "x": 98,
                                                        "y": 400,
                                                        "h": 116,
                                                        "w": 116
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 618,
                                                        "y": 602,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 563,
                                                        "y": 219,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 221,
                                                        "y": 900,
                                                        "h": 261,
                                                        "w": 261
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1530,
                                                "w": 1224,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1530,
                                            "width": 1224,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 685
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1224
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1395
                                                },
                                                {
                                                    "x": 230,
                                                    "y": 0,
                                                    "w": 765,
                                                    "h": 1530
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1530
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814019799292276736"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 128,
                            "favorited": false,
                            "full_text": "Leny Yoro becomes the most expensive defensive transfer in Ligue 1 history as he signs a five-year deal with Man Utd ✍️\n\nThe Red Devils will pay Lille $67.5 million for the 18-year-old CB ⚽️ https://t.co/6m2dB8O9wL",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 6,
                            "reply_count": 4,
                            "retweet_count": 17,
                            "retweeted": false,
                            "user_id_str": "1276267176790499328",
                            "id_str": "1814019820523757772"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814035439231369687",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNDM1NjgzNzYzNzQxMTQ3MTQw",
                                    "rest_id": "1435683763741147140",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": false,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Sep 08 19:17:45 +0000 2021",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "🇮🇹🇺🇲\nFeatured on @FTalentScout\n⚽Transfer News🗞️Comps, Goals & Assists📽Stats📊Talents💎Analysis✍ @onbunches partner\n🐐 Messi #SSCBari #BVB #AVFC #NETS",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "my-store-c2f94b.creator-spring.com",
                                                        "expanded_url": "https://my-store-c2f94b.creator-spring.com",
                                                        "url": "https://t.co/F9i4ruCiZC",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 514916,
                                        "followers_count": 84552,
                                        "friends_count": 4490,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 261,
                                        "location": "Backup: @FootballReprt2",
                                        "media_count": 70493,
                                        "name": "Football Report",
                                        "normal_followers_count": 84552,
                                        "pinned_tweet_ids_str": [
                                            "1795631209802043443"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1435683763741147140/1686509949",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1813940903205015552/wFMupu7g_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FootballReprt",
                                        "statuses_count": 391121,
                                        "translator_type": "none",
                                        "url": "https://t.co/F9i4ruCiZC",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1604940522363166720",
                                        "professional_type": "Creator",
                                        "category": [
                                            {
                                                "id": 934,
                                                "name": "Social Media Influencer",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814035439231369687"
                            ],
                            "editable_until_msecs": "1721338326000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "2860",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/android\" rel=\"nofollow\">Twitter for Android</a>",
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1813660631733539321",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo3NDgwMjE0MjE1ODI5NzQ5NzY=",
                                            "rest_id": "748021421582974976",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Wed Jun 29 05:12:59 +0000 2016",
                                                "default_profile": true,
                                                "default_profile_image": false,
                                                "description": "First Team Analyst in the EFL, 1.1 MSc in performance analysis, 2.1 BA in psychology, EBL2017.media@gmail.com for 💼 queries. EXCLUSIVE Patreon linked below 👇",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "patreon.com/ebl2017",
                                                                "expanded_url": "http://patreon.com/ebl2017",
                                                                "url": "https://t.co/HR91A52Jq7",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 20573,
                                                "followers_count": 168100,
                                                "friends_count": 140,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 1398,
                                                "location": "United Kingdom",
                                                "media_count": 5325,
                                                "name": "EBL",
                                                "normal_followers_count": 168100,
                                                "pinned_tweet_ids_str": [
                                                    "1813660612104425903"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/748021421582974976/1630781500",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1439654389476638728/SxFCVsm0_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "EBL2017",
                                                "statuses_count": 57017,
                                                "translator_type": "none",
                                                "url": "https://t.co/HR91A52Jq7",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            }
                                        }
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1813660631733539321"
                                    ],
                                    "editable_until_msecs": "1721248965000",
                                    "is_edit_eligible": false,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "1860224",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                                "note_tweet": {
                                    "is_expandable": false,
                                    "note_tweet_results": {
                                        "result": {
                                            "id": "Tm90ZVR3ZWV0OjE4MTM2NjA2MzE2NjIzMDExODQ=",
                                            "text": "Look at how he nonchalantly puts his stud on the ball here to assess the picture.\n\nCall it over-analysis, call it pseudo-intellectualism, call it what you like.\n\nThose with an experienced eye can tell that this type of subtlety (in tandem with other qualities) screams QUALITY.",
                                            "entity_set": {
                                                "hashtags": [],
                                                "symbols": [],
                                                "urls": [],
                                                "user_mentions": []
                                            },
                                            "richtext": {
                                                "richtext_tags": [
                                                    {
                                                        "from_index": 269,
                                                        "to_index": 276,
                                                        "richtext_types": [
                                                            "Bold"
                                                        ]
                                                    }
                                                ]
                                            },
                                            "media": {
                                                "inline_media": []
                                            }
                                        }
                                    }
                                },
                                "legacy": {
                                    "bookmark_count": 68,
                                    "bookmarked": false,
                                    "created_at": "Wed Jul 17 19:42:45 +0000 2024",
                                    "conversation_id_str": "1813660612104425903",
                                    "display_text_range": [
                                        0,
                                        277
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "media": [
                                            {
                                                "display_url": "pic.x.com/7lvhwc7o8a",
                                                "expanded_url": "https://twitter.com/EBL2017/status/1813660631733539321/photo/1",
                                                "id_str": "1813636502678544384",
                                                "indices": [
                                                    278,
                                                    301
                                                ],
                                                "media_key": "3_1813636502678544384",
                                                "media_url_https": "https://pbs.twimg.com/media/GStUykXWIAA67iR.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/7lvHwC7o8a",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": [
                                                            {
                                                                "x": 52,
                                                                "y": 609,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    },
                                                    "medium": {
                                                        "faces": [
                                                            {
                                                                "x": 32,
                                                                "y": 380,
                                                                "h": 51,
                                                                "w": 51
                                                            }
                                                        ]
                                                    },
                                                    "small": {
                                                        "faces": [
                                                            {
                                                                "x": 18,
                                                                "y": 215,
                                                                "h": 29,
                                                                "w": 29
                                                            }
                                                        ]
                                                    },
                                                    "orig": {
                                                        "faces": [
                                                            {
                                                                "x": 52,
                                                                "y": 609,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1080,
                                                        "w": 1920,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 675,
                                                        "w": 1200,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 383,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1080,
                                                    "width": 1920,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1920,
                                                            "h": 1075
                                                        },
                                                        {
                                                            "x": 372,
                                                            "y": 0,
                                                            "w": 1080,
                                                            "h": 1080
                                                        },
                                                        {
                                                            "x": 439,
                                                            "y": 0,
                                                            "w": 947,
                                                            "h": 1080
                                                        },
                                                        {
                                                            "x": 642,
                                                            "y": 0,
                                                            "w": 540,
                                                            "h": 1080
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1920,
                                                            "h": 1080
                                                        }
                                                    ]
                                                },
                                                "allow_download_status": {
                                                    "allow_download": true
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1813636502678544384"
                                                    }
                                                }
                                            }
                                        ],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": []
                                    },
                                    "extended_entities": {
                                        "media": [
                                            {
                                                "display_url": "pic.twitter.com/7lvHwC7o8a",
                                                "expanded_url": "https://twitter.com/EBL2017/status/1813660631733539321/photo/1",
                                                "id_str": "1813636502678544384",
                                                "indices": [
                                                    278,
                                                    301
                                                ],
                                                "media_key": "3_1813636502678544384",
                                                "media_url_https": "https://pbs.twimg.com/media/GStUykXWIAA67iR.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/7lvHwC7o8a",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": [
                                                            {
                                                                "x": 52,
                                                                "y": 609,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    },
                                                    "medium": {
                                                        "faces": [
                                                            {
                                                                "x": 32,
                                                                "y": 380,
                                                                "h": 51,
                                                                "w": 51
                                                            }
                                                        ]
                                                    },
                                                    "small": {
                                                        "faces": [
                                                            {
                                                                "x": 18,
                                                                "y": 215,
                                                                "h": 29,
                                                                "w": 29
                                                            }
                                                        ]
                                                    },
                                                    "orig": {
                                                        "faces": [
                                                            {
                                                                "x": 52,
                                                                "y": 609,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 1080,
                                                        "w": 1920,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 675,
                                                        "w": 1200,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 383,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 1080,
                                                    "width": 1920,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1920,
                                                            "h": 1075
                                                        },
                                                        {
                                                            "x": 372,
                                                            "y": 0,
                                                            "w": 1080,
                                                            "h": 1080
                                                        },
                                                        {
                                                            "x": 439,
                                                            "y": 0,
                                                            "w": 947,
                                                            "h": 1080
                                                        },
                                                        {
                                                            "x": 642,
                                                            "y": 0,
                                                            "w": 540,
                                                            "h": 1080
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1920,
                                                            "h": 1080
                                                        }
                                                    ]
                                                },
                                                "allow_download_status": {
                                                    "allow_download": true
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1813636502678544384"
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "favorite_count": 482,
                                    "favorited": false,
                                    "full_text": "Look at how he nonchalantly puts his stud on the ball here to assess the picture.\n\nCall it over-analysis, call it pseudo-intellectualism, call it what you like.\n\nThose with an experienced eye can tell that this type of subtlety (in tandem with other qualities) screams QUALITY. https://t.co/7lvHwC7o8a",
                                    "in_reply_to_screen_name": "EBL2017",
                                    "in_reply_to_status_id_str": "1813660626956533879",
                                    "in_reply_to_user_id_str": "748021421582974976",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 209,
                                    "reply_count": 50,
                                    "retweet_count": 20,
                                    "retweeted": false,
                                    "user_id_str": "748021421582974976",
                                    "id_str": "1813660631733539321"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 1,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 20:32:06 +0000 2024",
                            "conversation_id_str": "1814035439231369687",
                            "display_text_range": [
                                0,
                                121
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 17,
                            "favorited": false,
                            "full_text": "Leny Yoro is quality, but this nonsense is pure waffle.\nI hate Tactico Twitter with a passion, they're a bunch of freaks!",
                            "is_quote_status": true,
                            "lang": "en",
                            "quote_count": 0,
                            "quoted_status_id_str": "1813660631733539321",
                            "quoted_status_permalink": {
                                "url": "https://t.co/wyP2UGgA9u",
                                "expanded": "https://twitter.com/EBL2017/status/1813660631733539321",
                                "display": "x.com/EBL2017/status…"
                            },
                            "reply_count": 3,
                            "retweet_count": 0,
                            "retweeted": false,
                            "user_id_str": "1435683763741147140",
                            "id_str": "1814035439231369687"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814014002365677681",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMDg1NjgzNzM=",
                                    "rest_id": "108568373",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Tue Jan 26 10:22:29 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "The official X account for Sky Sports News. \nYour home of sports news on channel 409.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "skysports.com",
                                                        "expanded_url": "http://www.skysports.com",
                                                        "url": "https://t.co/wqJpd2ze5k",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 437,
                                        "followers_count": 12719708,
                                        "friends_count": 22,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 20520,
                                        "location": "England",
                                        "media_count": 53065,
                                        "name": "Sky Sports News",
                                        "normal_followers_count": 12719708,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/108568373/1699464038",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1605131333772234752/O2P81gwm_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "SkySportsNews",
                                        "statuses_count": 115140,
                                        "translator_type": "none",
                                        "url": "https://t.co/wqJpd2ze5k",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814014002365677681"
                            ],
                            "editable_until_msecs": "1721333215000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1035319",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://wildmoka.com\" rel=\"nofollow\">Wildmoka</a>",
                        "legacy": {
                            "bookmark_count": 354,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 19:06:55 +0000 2024",
                            "conversation_id_str": "1814014002365677681",
                            "display_text_range": [
                                0,
                                80
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/7wqjnpruyd",
                                        "expanded_url": "https://twitter.com/SkySportsNews/status/1814014002365677681/video/1",
                                        "id_str": "1814013395080749056",
                                        "indices": [
                                            81,
                                            104
                                        ],
                                        "media_key": "13_1814013395080749056",
                                        "media_url_https": "https://pbs.twimg.com/media/GSysHjXW0AA7EfL.jpg",
                                        "type": "video",
                                        "url": "https://t.co/7WqJnprUyD",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": true
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 173080,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/pl/hOE3RlUgTrw3xIdY.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/480x270/RRQ2EevlC5gD83wW.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/640x360/wA5dcX4qmiLEGAbR.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/1280x720/ptJeB50EaImDXADZ.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/1920x1080/Tz_AK_BmmaWEEWmn.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1814013395080749056"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/7WqJnprUyD",
                                        "expanded_url": "https://twitter.com/SkySportsNews/status/1814014002365677681/video/1",
                                        "id_str": "1814013395080749056",
                                        "indices": [
                                            81,
                                            104
                                        ],
                                        "media_key": "13_1814013395080749056",
                                        "media_url_https": "https://pbs.twimg.com/media/GSysHjXW0AA7EfL.jpg",
                                        "type": "video",
                                        "url": "https://t.co/7WqJnprUyD",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": true
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 173080,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/pl/hOE3RlUgTrw3xIdY.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/480x270/RRQ2EevlC5gD83wW.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/640x360/wA5dcX4qmiLEGAbR.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/1280x720/ptJeB50EaImDXADZ.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1814013395080749056/vid/avc1/1920x1080/Tz_AK_BmmaWEEWmn.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1814013395080749056"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 15693,
                            "favorited": false,
                            "full_text": "BREAKING: Manchester United have signed Leny Yoro from Lille for €70m (£58.9m) 🚨 https://t.co/7WqJnprUyD",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 261,
                            "reply_count": 611,
                            "retweet_count": 1733,
                            "retweeted": false,
                            "user_id_str": "108568373",
                            "id_str": "1814014002365677681"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813502801764385092",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo0Njg3NTEyNA==",
                                    "rest_id": "46875124",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sat Jun 13 12:09:04 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Football Correspondent, @TheAthleticFC",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "nytimes.com/athletic/autho…",
                                                        "expanded_url": "https://www.nytimes.com/athletic/author/david-ornstein/",
                                                        "url": "https://t.co/efp3FmH2Bh",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 1707,
                                        "followers_count": 3154143,
                                        "friends_count": 2390,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 13581,
                                        "location": "UK",
                                        "media_count": 787,
                                        "name": "David Ornstein",
                                        "normal_followers_count": 3154143,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/46875124/1715632626",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1178558529105530880/Qvy-hv3O_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "David_Ornstein",
                                        "statuses_count": 8190,
                                        "translator_type": "none",
                                        "url": "https://t.co/efp3FmH2Bh",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/Vz5gTFH2Xx",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "photo_image_full_size_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image",
                                        "value": {
                                            "image_value": {
                                                "height": 150,
                                                "width": 225,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=280x150"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "description",
                                        "value": {
                                            "string_value": "Lille centre-back Leny Yoro is undergoing a medical at Manchester United ahead of signing a five-year contract, with the option of an additional year, at the Premier League club. The 18-year-old...",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "domain",
                                        "value": {
                                            "string_value": "www.nytimes.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 320,
                                                "width": 481,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=800x320_1"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "site",
                                        "value": {
                                            "scribe_key": "publisher_id",
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "809532994444591104",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 67,
                                                "width": 100,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=100x100"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "creator",
                                        "value": {
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "809532994444591104",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_original",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "vanity_url",
                                        "value": {
                                            "scribe_key": "vanity_url",
                                            "string_value": "nytimes.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 27,
                                                            "green": 12,
                                                            "red": 11
                                                        },
                                                        "percentage": 85.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 59,
                                                            "green": 32,
                                                            "red": 241
                                                        },
                                                        "percentage": 3.83
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 92,
                                                            "green": 74,
                                                            "red": 212
                                                        },
                                                        "percentage": 1.94
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 175,
                                                            "green": 164,
                                                            "red": 217
                                                        },
                                                        "percentage": 1.71
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 79,
                                                            "green": 122,
                                                            "red": 185
                                                        },
                                                        "percentage": 1.66
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "title",
                                        "value": {
                                            "string_value": "Leny Yoro undergoing Manchester United medical ahead of signing five-year contract",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 27,
                                                            "green": 12,
                                                            "red": 11
                                                        },
                                                        "percentage": 85.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 59,
                                                            "green": 32,
                                                            "red": 241
                                                        },
                                                        "percentage": 3.83
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 92,
                                                            "green": 74,
                                                            "red": 212
                                                        },
                                                        "percentage": 1.94
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 175,
                                                            "green": 164,
                                                            "red": 217
                                                        },
                                                        "percentage": 1.71
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 79,
                                                            "green": 122,
                                                            "red": 185
                                                        },
                                                        "percentage": 1.66
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 27,
                                                            "green": 12,
                                                            "red": 11
                                                        },
                                                        "percentage": 85.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 59,
                                                            "green": 32,
                                                            "red": 241
                                                        },
                                                        "percentage": 3.83
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 92,
                                                            "green": 74,
                                                            "red": 212
                                                        },
                                                        "percentage": 1.94
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 175,
                                                            "green": 164,
                                                            "red": 217
                                                        },
                                                        "percentage": 1.71
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 79,
                                                            "green": 122,
                                                            "red": 185
                                                        },
                                                        "percentage": 1.66
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/Vz5gTFH2Xx",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "summary_large_image",
                                "url": "https://t.co/Vz5gTFH2Xx",
                                "user_refs_results": [
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo4MDk1MzI5OTQ0NDQ1OTExMDQ=",
                                            "rest_id": "809532994444591104",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Dec 15 22:58:01 +0000 2016",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Get every sports story that matters.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "nytimes.com/athletic/",
                                                                "expanded_url": "https://www.nytimes.com/athletic/",
                                                                "url": "https://t.co/IqAvrbxlyG",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 17501,
                                                "followers_count": 577878,
                                                "friends_count": 1021,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 3144,
                                                "location": "",
                                                "media_count": 35823,
                                                "name": "The Athletic",
                                                "normal_followers_count": 577878,
                                                "pinned_tweet_ids_str": [
                                                    "1876289952637722798"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/809532994444591104/1696624392",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710392781502599168/30B7uQGJ_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TheAthletic",
                                                "statuses_count": 85322,
                                                "translator_type": "none",
                                                "url": "https://t.co/IqAvrbxlyG",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481701729729085440",
                                                "professional_type": "Business",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    },
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo4MDk1MzI5OTQ0NDQ1OTExMDQ=",
                                            "rest_id": "809532994444591104",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Dec 15 22:58:01 +0000 2016",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Get every sports story that matters.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "nytimes.com/athletic/",
                                                                "expanded_url": "https://www.nytimes.com/athletic/",
                                                                "url": "https://t.co/IqAvrbxlyG",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 17501,
                                                "followers_count": 577878,
                                                "friends_count": 1021,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 3144,
                                                "location": "",
                                                "media_count": 35823,
                                                "name": "The Athletic",
                                                "normal_followers_count": 577878,
                                                "pinned_tweet_ids_str": [
                                                    "1876289952637722798"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/809532994444591104/1696624392",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710392781502599168/30B7uQGJ_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TheAthletic",
                                                "statuses_count": 85322,
                                                "translator_type": "none",
                                                "url": "https://t.co/IqAvrbxlyG",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481701729729085440",
                                                "professional_type": "Business",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813502801764385092"
                            ],
                            "editable_until_msecs": "1721211335000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "4560877",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 775,
                            "bookmarked": false,
                            "created_at": "Wed Jul 17 09:15:35 +0000 2024",
                            "conversation_id_str": "1813502801764385092",
                            "display_text_range": [
                                0,
                                278
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            159,
                                            164
                                        ],
                                        "text": "RMFC"
                                    },
                                    {
                                        "indices": [
                                            169,
                                            174
                                        ],
                                        "text": "LOSC"
                                    },
                                    {
                                        "indices": [
                                            197,
                                            202
                                        ],
                                        "text": "MUFC"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "nytimes.com/athletic/56264…",
                                        "expanded_url": "https://www.nytimes.com/athletic/5626457/2024/07/17/leny-yoro-manchester-united-transfer/",
                                        "url": "https://t.co/Vz5gTFH2Xx",
                                        "indices": [
                                            255,
                                            278
                                        ]
                                    }
                                ],
                                "user_mentions": [
                                    {
                                        "id_str": "970939705629069312",
                                        "name": "The Athletic | Football",
                                        "screen_name": "TheAthleticFC",
                                        "indices": [
                                            240,
                                            254
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 45300,
                            "favorited": false,
                            "full_text": "\uD83D\uDEA8 EXCLUSIVE: Leny Yoro flying to UK to take medical + finalise personal terms as Man Utd push to complete signing from Lille. 18yo defender initially favoured #RMFC but #LOSC accepted initial €62m #MUFC bid - still work to do but now close @TheAthleticFC https://t.co/Vz5gTFH2Xx",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 9761,
                            "reply_count": 3663,
                            "retweet_count": 11226,
                            "retweeted": false,
                            "user_id_str": "46875124",
                            "id_str": "1813502801764385092"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814012988434829657",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyMzAzNzY1OTQ4",
                                    "rest_id": "2303765948",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Tue Jan 21 21:53:20 +0000 2014",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Sky Reporter/Moderator▫️Transfer Update - die Show ⚽️ FC Bayern▫️DFB▫️Transfer News🚨Instagram & Tiktok: Plettigoal 🤳",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/plettigoal?igs…",
                                                        "expanded_url": "https://www.instagram.com/plettigoal?igsh=MWN6NWx1ZWs1dWh5Zg%3D%3D&utm_source=qr",
                                                        "url": "https://t.co/j7OU8lpie6",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6621,
                                        "followers_count": 336512,
                                        "friends_count": 754,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1732,
                                        "location": "München, Bayern",
                                        "media_count": 4868,
                                        "name": "Florian Plettenberg",
                                        "normal_followers_count": 336512,
                                        "pinned_tweet_ids_str": [
                                            "1813916077342032374"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/2303765948/1692715660",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1525214569450426372/pZEW9tDo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Plettigoal",
                                        "statuses_count": 12934,
                                        "translator_type": "none",
                                        "url": "https://t.co/j7OU8lpie6",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1587215873865031681",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814012988434829657"
                            ],
                            "editable_until_msecs": "1721332973000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "98114",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 13,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 19:02:53 +0000 2024",
                            "conversation_id_str": "1814012988434829657",
                            "display_text_range": [
                                0,
                                153
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            20,
                                            25
                                        ],
                                        "text": "Yoro"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ehoyyzmeit",
                                        "expanded_url": "https://twitter.com/Plettigoal/status/1814012988434829657/photo/1",
                                        "id_str": "1814012982440968193",
                                        "indices": [
                                            154,
                                            177
                                        ],
                                        "media_key": "3_1814012982440968193",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyrMkxXQAEuPhx.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/EHoYyZmEit",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "all": {
                                                "tags": [
                                                    {
                                                        "user_id": "558797310",
                                                        "name": "Manchester United",
                                                        "screen_name": "ManUtd",
                                                        "type": "user"
                                                    }
                                                ]
                                            },
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 875,
                                                "w": 1091,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 875,
                                                "w": 1091,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 545,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 875,
                                            "width": 1091,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 264,
                                                    "w": 1091,
                                                    "h": 611
                                                },
                                                {
                                                    "x": 80,
                                                    "y": 0,
                                                    "w": 875,
                                                    "h": 875
                                                },
                                                {
                                                    "x": 133,
                                                    "y": 0,
                                                    "w": 768,
                                                    "h": 875
                                                },
                                                {
                                                    "x": 298,
                                                    "y": 0,
                                                    "w": 438,
                                                    "h": 875
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1091,
                                                    "h": 875
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814012982440968193"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "558797310",
                                        "name": "Manchester United",
                                        "screen_name": "ManUtd",
                                        "indices": [
                                            43,
                                            50
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/EHoYyZmEit",
                                        "expanded_url": "https://twitter.com/Plettigoal/status/1814012988434829657/photo/1",
                                        "id_str": "1814012982440968193",
                                        "indices": [
                                            154,
                                            177
                                        ],
                                        "media_key": "3_1814012982440968193",
                                        "media_url_https": "https://pbs.twimg.com/media/GSyrMkxXQAEuPhx.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/EHoYyZmEit",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "all": {
                                                "tags": [
                                                    {
                                                        "user_id": "558797310",
                                                        "name": "Manchester United",
                                                        "screen_name": "ManUtd",
                                                        "type": "user"
                                                    }
                                                ]
                                            },
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 875,
                                                "w": 1091,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 875,
                                                "w": 1091,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 545,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 875,
                                            "width": 1091,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 264,
                                                    "w": 1091,
                                                    "h": 611
                                                },
                                                {
                                                    "x": 80,
                                                    "y": 0,
                                                    "w": 875,
                                                    "h": 875
                                                },
                                                {
                                                    "x": 133,
                                                    "y": 0,
                                                    "w": 768,
                                                    "h": 875
                                                },
                                                {
                                                    "x": 298,
                                                    "y": 0,
                                                    "w": 438,
                                                    "h": 875
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1091,
                                                    "h": 875
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814012982440968193"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 4503,
                            "favorited": false,
                            "full_text": "🚨Now official: Leny #Yoro, new defender of @ManUtd! \n\n… with a contract signed until 2029, with the option to extend for a further year as revealed ✔️🏁🇫🇷 https://t.co/EHoYyZmEit",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 5,
                            "reply_count": 27,
                            "retweet_count": 373,
                            "retweeted": false,
                            "user_id_str": "2303765948",
                            "id_str": "1814012988434829657"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814055161909608768",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNDUzMzYwNTU2MDk4OTI0NTQ3",
                                    "rest_id": "1453360556098924547",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Oct 27 13:59:05 +0000 2021",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "She/Her | Video Scout / Opposition Analyst. Football writer & History student.\n\nDM for enquiries.\n\nhttps://t.co/AJTksZO6zj",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "linktr.ee/bethlimb",
                                                        "expanded_url": "https://linktr.ee/bethlimb",
                                                        "url": "https://t.co/AJTksZO6zj",
                                                        "indices": [
                                                            99,
                                                            122
                                                        ]
                                                    }
                                                ]
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "bethlimb.substack.com",
                                                        "expanded_url": "https://bethlimb.substack.com",
                                                        "url": "https://t.co/wa8AjorxP1",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 4171,
                                        "followers_count": 1363,
                                        "friends_count": 1816,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 15,
                                        "location": "United Kingdom",
                                        "media_count": 186,
                                        "name": "Beth",
                                        "normal_followers_count": 1363,
                                        "pinned_tweet_ids_str": [
                                            "1809255473549393985"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1453360556098924547/1659020019",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1676157076064595968/RYXnI9hj_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "bethlimb",
                                        "statuses_count": 1964,
                                        "translator_type": "none",
                                        "url": "https://t.co/wa8AjorxP1",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1768954922307829876",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814055161909608768"
                            ],
                            "editable_until_msecs": "1721343028000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "535",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1811663416940953977",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxNDUzMzYwNTU2MDk4OTI0NTQ3",
                                            "rest_id": "1453360556098924547",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Wed Oct 27 13:59:05 +0000 2021",
                                                "default_profile": true,
                                                "default_profile_image": false,
                                                "description": "She/Her | Video Scout / Opposition Analyst. Football writer & History student.\n\nDM for enquiries.\n\nhttps://t.co/AJTksZO6zj",
                                                "entities": {
                                                    "description": {
                                                        "urls": [
                                                            {
                                                                "display_url": "linktr.ee/bethlimb",
                                                                "expanded_url": "https://linktr.ee/bethlimb",
                                                                "url": "https://t.co/AJTksZO6zj",
                                                                "indices": [
                                                                    99,
                                                                    122
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "bethlimb.substack.com",
                                                                "expanded_url": "https://bethlimb.substack.com",
                                                                "url": "https://t.co/wa8AjorxP1",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 4171,
                                                "followers_count": 1363,
                                                "friends_count": 1816,
                                                "has_custom_timelines": false,
                                                "is_translator": false,
                                                "listed_count": 15,
                                                "location": "United Kingdom",
                                                "media_count": 186,
                                                "name": "Beth",
                                                "normal_followers_count": 1363,
                                                "pinned_tweet_ids_str": [
                                                    "1809255473549393985"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/1453360556098924547/1659020019",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1676157076064595968/RYXnI9hj_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "bethlimb",
                                                "statuses_count": 1964,
                                                "translator_type": "none",
                                                "url": "https://t.co/wa8AjorxP1",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1768954922307829876",
                                                "professional_type": "Creator",
                                                "category": []
                                            }
                                        }
                                    }
                                },
                                "card": {
                                    "rest_id": "https://t.co/dyJE0L0zGO",
                                    "legacy": {
                                        "binding_values": [
                                            {
                                                "key": "photo_image_full_size_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 393,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=800x419"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "app_star_rating",
                                                "value": {
                                                    "string_value": "4.82115",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image",
                                                "value": {
                                                    "image_value": {
                                                        "height": 150,
                                                        "width": 267,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=280x150"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "description",
                                                "value": {
                                                    "string_value": "17-year-old Leny Yoro is establishing himself as an important player for Lille this season. The young defender is an extremely confident…",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "domain",
                                                "value": {
                                                    "string_value": "bethlimb.medium.com",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "app_is_free",
                                                "value": {
                                                    "string_value": "true",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 320,
                                                        "width": 569,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=800x320_1"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_small",
                                                "value": {
                                                    "image_value": {
                                                        "height": 202,
                                                        "width": 386,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=386x202"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_original",
                                                "value": {
                                                    "image_value": {
                                                        "height": 422,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=orig"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "site",
                                                "value": {
                                                    "scribe_key": "publisher_id",
                                                    "type": "USER",
                                                    "user_value": {
                                                        "id_str": "571202103",
                                                        "path": []
                                                    }
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_small",
                                                "value": {
                                                    "image_value": {
                                                        "height": 202,
                                                        "width": 386,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=386x202"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 393,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=800x419"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_small",
                                                "value": {
                                                    "image_value": {
                                                        "height": 81,
                                                        "width": 144,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=144x144"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "creator",
                                                "value": {
                                                    "type": "USER",
                                                    "user_value": {
                                                        "id_str": "1453360556098924547",
                                                        "path": []
                                                    }
                                                }
                                            },
                                            {
                                                "key": "app_num_ratings",
                                                "value": {
                                                    "string_value": "137,537",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "app_price_amount",
                                                "value": {
                                                    "string_value": "0.0",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_x_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 422,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=png&name=2048x2048_2_exp"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_original",
                                                "value": {
                                                    "image_value": {
                                                        "height": 422,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=orig"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "vanity_url",
                                                "value": {
                                                    "scribe_key": "vanity_url",
                                                    "string_value": "bethlimb.medium.com",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size",
                                                "value": {
                                                    "image_value": {
                                                        "height": 314,
                                                        "width": 600,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=600x314"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "app_name",
                                                "value": {
                                                    "string_value": "Medium: Read & Write Stories",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "thumbnail_image_color",
                                                "value": {
                                                    "image_color_value": {
                                                        "palette": [
                                                            {
                                                                "rgb": {
                                                                    "blue": 204,
                                                                    "green": 207,
                                                                    "red": 213
                                                                },
                                                                "percentage": 58.71
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 37,
                                                                    "green": 13,
                                                                    "red": 192
                                                                },
                                                                "percentage": 30.24
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 83,
                                                                    "green": 62,
                                                                    "red": 176
                                                                },
                                                                "percentage": 3.79
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 10,
                                                                    "green": 11,
                                                                    "red": 20
                                                                },
                                                                "percentage": 1.1
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 27,
                                                                    "green": 6,
                                                                    "red": 136
                                                                },
                                                                "percentage": 1.03
                                                            }
                                                        ]
                                                    },
                                                    "type": "IMAGE_COLOR"
                                                }
                                            },
                                            {
                                                "key": "title",
                                                "value": {
                                                    "string_value": "Leny Yoro — Scout Report 2023/24",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "app_price_currency",
                                                "value": {
                                                    "string_value": "USD",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_color",
                                                "value": {
                                                    "image_color_value": {
                                                        "palette": [
                                                            {
                                                                "rgb": {
                                                                    "blue": 204,
                                                                    "green": 207,
                                                                    "red": 213
                                                                },
                                                                "percentage": 58.71
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 37,
                                                                    "green": 13,
                                                                    "red": 192
                                                                },
                                                                "percentage": 30.24
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 83,
                                                                    "green": 62,
                                                                    "red": 176
                                                                },
                                                                "percentage": 3.79
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 10,
                                                                    "green": 11,
                                                                    "red": 20
                                                                },
                                                                "percentage": 1.1
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 27,
                                                                    "green": 6,
                                                                    "red": 136
                                                                },
                                                                "percentage": 1.03
                                                            }
                                                        ]
                                                    },
                                                    "type": "IMAGE_COLOR"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_x_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 422,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=png&name=2048x2048_2_exp"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image",
                                                "value": {
                                                    "image_value": {
                                                        "height": 314,
                                                        "width": 600,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=600x314"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_color",
                                                "value": {
                                                    "image_color_value": {
                                                        "palette": [
                                                            {
                                                                "rgb": {
                                                                    "blue": 204,
                                                                    "green": 207,
                                                                    "red": 213
                                                                },
                                                                "percentage": 58.71
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 37,
                                                                    "green": 13,
                                                                    "red": 192
                                                                },
                                                                "percentage": 30.24
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 83,
                                                                    "green": 62,
                                                                    "red": 176
                                                                },
                                                                "percentage": 3.79
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 10,
                                                                    "green": 11,
                                                                    "red": 20
                                                                },
                                                                "percentage": 1.1
                                                            },
                                                            {
                                                                "rgb": {
                                                                    "blue": 27,
                                                                    "green": 6,
                                                                    "red": 136
                                                                },
                                                                "percentage": 1.03
                                                            }
                                                        ]
                                                    },
                                                    "type": "IMAGE_COLOR"
                                                }
                                            },
                                            {
                                                "key": "photo_image_full_size_x_large",
                                                "value": {
                                                    "image_value": {
                                                        "height": 422,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=png&name=2048x2048_2_exp"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            },
                                            {
                                                "key": "card_url",
                                                "value": {
                                                    "scribe_key": "card_url",
                                                    "string_value": "https://t.co/dyJE0L0zGO",
                                                    "type": "STRING"
                                                }
                                            },
                                            {
                                                "key": "summary_photo_image_original",
                                                "value": {
                                                    "image_value": {
                                                        "height": 422,
                                                        "width": 750,
                                                        "url": "https://pbs.twimg.com/card_img/1813197745882005504/0TNwXsul?format=jpg&name=orig"
                                                    },
                                                    "type": "IMAGE"
                                                }
                                            }
                                        ],
                                        "card_platform": {
                                            "platform": {
                                                "audience": {
                                                    "name": "production"
                                                },
                                                "device": {
                                                    "name": "Swift",
                                                    "version": "12"
                                                }
                                            }
                                        },
                                        "name": "summary_large_image",
                                        "url": "https://t.co/dyJE0L0zGO",
                                        "user_refs_results": [
                                            {
                                                "result": {
                                                    "__typename": "User",
                                                    "id": "VXNlcjoxNDUzMzYwNTU2MDk4OTI0NTQ3",
                                                    "rest_id": "1453360556098924547",
                                                    "affiliates_highlighted_label": {},
                                                    "is_blue_verified": true,
                                                    "profile_image_shape": "Circle",
                                                    "legacy": {
                                                        "created_at": "Wed Oct 27 13:59:05 +0000 2021",
                                                        "default_profile": true,
                                                        "default_profile_image": false,
                                                        "description": "She/Her | Video Scout / Opposition Analyst. Football writer & History student.\n\nDM for enquiries.\n\nhttps://t.co/AJTksZO6zj",
                                                        "entities": {
                                                            "description": {
                                                                "urls": [
                                                                    {
                                                                        "display_url": "linktr.ee/bethlimb",
                                                                        "expanded_url": "https://linktr.ee/bethlimb",
                                                                        "url": "https://t.co/AJTksZO6zj",
                                                                        "indices": [
                                                                            99,
                                                                            122
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "url": {
                                                                "urls": [
                                                                    {
                                                                        "display_url": "bethlimb.substack.com",
                                                                        "expanded_url": "https://bethlimb.substack.com",
                                                                        "url": "https://t.co/wa8AjorxP1",
                                                                        "indices": [
                                                                            0,
                                                                            23
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        "fast_followers_count": 0,
                                                        "favourites_count": 4171,
                                                        "followers_count": 1363,
                                                        "friends_count": 1816,
                                                        "has_custom_timelines": false,
                                                        "is_translator": false,
                                                        "listed_count": 15,
                                                        "location": "United Kingdom",
                                                        "media_count": 186,
                                                        "name": "Beth",
                                                        "normal_followers_count": 1363,
                                                        "pinned_tweet_ids_str": [
                                                            "1809255473549393985"
                                                        ],
                                                        "possibly_sensitive": false,
                                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1453360556098924547/1659020019",
                                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1676157076064595968/RYXnI9hj_normal.jpg",
                                                        "profile_interstitial_type": "",
                                                        "screen_name": "bethlimb",
                                                        "statuses_count": 1964,
                                                        "translator_type": "none",
                                                        "url": "https://t.co/wa8AjorxP1",
                                                        "verified": false,
                                                        "withheld_in_countries": []
                                                    },
                                                    "professional": {
                                                        "rest_id": "1768954922307829876",
                                                        "professional_type": "Creator",
                                                        "category": []
                                                    }
                                                }
                                            },
                                            {
                                                "result": {
                                                    "__typename": "User",
                                                    "id": "VXNlcjo1NzEyMDIxMDM=",
                                                    "rest_id": "571202103",
                                                    "affiliates_highlighted_label": {},
                                                    "is_blue_verified": true,
                                                    "profile_image_shape": "Circle",
                                                    "legacy": {
                                                        "created_at": "Fri May 04 20:16:39 +0000 2012",
                                                        "default_profile": false,
                                                        "default_profile_image": false,
                                                        "description": "Everyone has a story to tell; find ours on https://t.co/3cf4z3Kf7e, Instagram/Threads (@medium), LinkedIn and https://t.co/zVH9KVi7kZ",
                                                        "entities": {
                                                            "description": {
                                                                "urls": [
                                                                    {
                                                                        "display_url": "me.dm",
                                                                        "expanded_url": "http://me.dm",
                                                                        "url": "https://t.co/3cf4z3Kf7e",
                                                                        "indices": [
                                                                            43,
                                                                            66
                                                                        ]
                                                                    },
                                                                    {
                                                                        "display_url": "medium.com/blog/newslette…",
                                                                        "expanded_url": "https://medium.com/blog/newsletters/medium-daily-edition",
                                                                        "url": "https://t.co/zVH9KVi7kZ",
                                                                        "indices": [
                                                                            110,
                                                                            133
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "url": {
                                                                "urls": [
                                                                    {
                                                                        "display_url": "medium.com",
                                                                        "expanded_url": "http://medium.com",
                                                                        "url": "https://t.co/SbA6IT7HKV",
                                                                        "indices": [
                                                                            0,
                                                                            23
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        "fast_followers_count": 0,
                                                        "favourites_count": 6140,
                                                        "followers_count": 2137961,
                                                        "friends_count": 406,
                                                        "has_custom_timelines": true,
                                                        "is_translator": false,
                                                        "listed_count": 12061,
                                                        "location": "Not updating this account ",
                                                        "media_count": 1040,
                                                        "name": "Medium",
                                                        "normal_followers_count": 2137961,
                                                        "pinned_tweet_ids_str": [
                                                            "1730329661450715157"
                                                        ],
                                                        "possibly_sensitive": false,
                                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/571202103/1691886422",
                                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1316412044959252482/3EZR8AKp_normal.jpg",
                                                        "profile_interstitial_type": "",
                                                        "screen_name": "Medium",
                                                        "statuses_count": 48861,
                                                        "translator_type": "regular",
                                                        "url": "https://t.co/SbA6IT7HKV",
                                                        "verified": false,
                                                        "withheld_in_countries": []
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1811663416940953977"
                                    ],
                                    "editable_until_msecs": "1720772792000",
                                    "is_edit_eligible": true,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "1055",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                                "legacy": {
                                    "bookmark_count": 1,
                                    "bookmarked": false,
                                    "created_at": "Fri Jul 12 07:26:32 +0000 2024",
                                    "conversation_id_str": "1811663416940953977",
                                    "display_text_range": [
                                        0,
                                        76
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [
                                            {
                                                "display_url": "medium.com/p/c21fcf854987",
                                                "expanded_url": "https://medium.com/p/c21fcf854987",
                                                "url": "https://t.co/dyJE0L0zGO",
                                                "indices": [
                                                    53,
                                                    76
                                                ]
                                            }
                                        ],
                                        "user_mentions": [
                                            {
                                                "id_str": "288804720",
                                                "name": "LOSC",
                                                "screen_name": "losclive",
                                                "indices": [
                                                    12,
                                                    21
                                                ]
                                            }
                                        ]
                                    },
                                    "favorite_count": 6,
                                    "favorited": false,
                                    "full_text": "Leny Yoro - @losclive Scout Report (from Oct. 2023)\n\nhttps://t.co/dyJE0L0zGO",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 1,
                                    "reply_count": 0,
                                    "retweet_count": 3,
                                    "retweeted": false,
                                    "user_id_str": "1453360556098924547",
                                    "id_str": "1811663416940953977"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 1,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 21:50:28 +0000 2024",
                            "conversation_id_str": "1814055161909608768",
                            "display_text_range": [
                                0,
                                80
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            39,
                                            44
                                        ],
                                        "text": "mufc"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 5,
                            "favorited": false,
                            "full_text": "Leny Yoro is an incredible signing for #mufc \n\nI profiled him back in October ⬇️",
                            "is_quote_status": true,
                            "lang": "en",
                            "quote_count": 0,
                            "quoted_status_id_str": "1811663416940953977",
                            "quoted_status_permalink": {
                                "url": "https://t.co/AL1GOMHjRD",
                                "expanded": "https://twitter.com/bethlimb/status/1811663416940953977",
                                "display": "x.com/bethlimb/statu…"
                            },
                            "reply_count": 0,
                            "retweet_count": 1,
                            "retweeted": false,
                            "user_id_str": "1453360556098924547",
                            "id_str": "1814055161909608768"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813610005310165002",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com 📩",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11664,
                                        "followers_count": 21432134,
                                        "friends_count": 2573,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27347,
                                        "location": "Milano, Italia",
                                        "media_count": 23085,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21432134,
                                        "pinned_tweet_ids_str": [
                                            "1814036386552451367"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 45184,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813610005310165002"
                            ],
                            "editable_until_msecs": "1721236895000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "18683965",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 2698,
                            "bookmarked": false,
                            "created_at": "Wed Jul 17 16:21:35 +0000 2024",
                            "conversation_id_str": "1813610005310165002",
                            "display_text_range": [
                                0,
                                270
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/8ziwb2jknj",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1813610005310165002/photo/1",
                                        "id_str": "1813609999282671616",
                                        "indices": [
                                            271,
                                            294
                                        ],
                                        "media_key": "3_1813609999282671616",
                                        "media_url_https": "https://pbs.twimg.com/media/GSs8r3hXEAAr8Y5.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/8Ziwb2JKNj",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 750,
                                                        "y": 364,
                                                        "h": 336,
                                                        "w": 336
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 439,
                                                        "y": 213,
                                                        "h": 196,
                                                        "w": 196
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 249,
                                                        "y": 120,
                                                        "h": 111,
                                                        "w": 111
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 750,
                                                        "y": 364,
                                                        "h": 336,
                                                        "w": 336
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1638,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1638,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 105,
                                                    "w": 1638,
                                                    "h": 917
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 1638
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 1867
                                                },
                                                {
                                                    "x": 358,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813609999282671616"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/8Ziwb2JKNj",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1813610005310165002/photo/1",
                                        "id_str": "1813609999282671616",
                                        "indices": [
                                            271,
                                            294
                                        ],
                                        "media_key": "3_1813609999282671616",
                                        "media_url_https": "https://pbs.twimg.com/media/GSs8r3hXEAAr8Y5.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/8Ziwb2JKNj",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 750,
                                                        "y": 364,
                                                        "h": 336,
                                                        "w": 336
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 439,
                                                        "y": 213,
                                                        "h": 196,
                                                        "w": 196
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 249,
                                                        "y": 120,
                                                        "h": 111,
                                                        "w": 111
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 750,
                                                        "y": 364,
                                                        "h": 336,
                                                        "w": 336
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1638,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1638,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 105,
                                                    "w": 1638,
                                                    "h": 917
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 1638
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 1867
                                                },
                                                {
                                                    "x": 358,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1638,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813609999282671616"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 221451,
                            "favorited": false,
                            "full_text": "🚨🔴 Leny Yoro to Manchester United, here we go! Deal in place after first part of medical completed.\n\nMore tests to follow then he’s ready to sign five year deal valid until June 2029.\n\nLille and Man United have all documents set for deal worth €50m plus several add-ons. https://t.co/8Ziwb2JKNj",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 11231,
                            "reply_count": 6915,
                            "retweet_count": 37875,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1813610005310165002"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813956005438628344",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyMzAzNzY1OTQ4",
                                    "rest_id": "2303765948",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Tue Jan 21 21:53:20 +0000 2014",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Sky Reporter/Moderator▫️Transfer Update - die Show ⚽️ FC Bayern▫️DFB▫️Transfer News🚨Instagram & Tiktok: Plettigoal 🤳",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/plettigoal?igs…",
                                                        "expanded_url": "https://www.instagram.com/plettigoal?igsh=MWN6NWx1ZWs1dWh5Zg%3D%3D&utm_source=qr",
                                                        "url": "https://t.co/j7OU8lpie6",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6621,
                                        "followers_count": 336512,
                                        "friends_count": 754,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1732,
                                        "location": "München, Bayern",
                                        "media_count": 4868,
                                        "name": "Florian Plettenberg",
                                        "normal_followers_count": 336512,
                                        "pinned_tweet_ids_str": [
                                            "1813916077342032374"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/2303765948/1692715660",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1525214569450426372/pZEW9tDo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Plettigoal",
                                        "statuses_count": 12934,
                                        "translator_type": "none",
                                        "url": "https://t.co/j7OU8lpie6",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1587215873865031681",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813956005438628344"
                            ],
                            "editable_until_msecs": "1721319388000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "256051",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 41,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 15:16:28 +0000 2024",
                            "conversation_id_str": "1813956005438628344",
                            "display_text_range": [
                                0,
                                196
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            8,
                                            13
                                        ],
                                        "text": "Yoro"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/rmncdzlcc5",
                                        "expanded_url": "https://twitter.com/Plettigoal/status/1813956005438628344/photo/1",
                                        "id_str": "1813955998387781632",
                                        "indices": [
                                            197,
                                            220
                                        ],
                                        "media_key": "3_1813955998387781632",
                                        "media_url_https": "https://pbs.twimg.com/media/GSx3XqoXwAAxZqK.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/rmnCDZLcc5",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "all": {
                                                "tags": [
                                                    {
                                                        "user_id": "2303765948",
                                                        "name": "Florian Plettenberg",
                                                        "screen_name": "Plettigoal",
                                                        "type": "user"
                                                    }
                                                ]
                                            },
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 551,
                                                        "y": 1112,
                                                        "h": 135,
                                                        "w": 135
                                                    },
                                                    {
                                                        "x": 341,
                                                        "y": 106,
                                                        "h": 429,
                                                        "w": 429
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 489,
                                                        "y": 988,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 303,
                                                        "y": 94,
                                                        "h": 381,
                                                        "w": 381
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 277,
                                                        "y": 560,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 171,
                                                        "y": 53,
                                                        "h": 216,
                                                        "w": 216
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 551,
                                                        "y": 1112,
                                                        "h": 135,
                                                        "w": 135
                                                    },
                                                    {
                                                        "x": 341,
                                                        "y": 106,
                                                        "h": 429,
                                                        "w": 429
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 69,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813955998387781632"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "558797310",
                                        "name": "Manchester United",
                                        "screen_name": "ManUtd",
                                        "indices": [
                                            171,
                                            178
                                        ]
                                    },
                                    {
                                        "id_str": "323222806",
                                        "name": "Sky Sport",
                                        "screen_name": "SkySportDE",
                                        "indices": [
                                            182,
                                            193
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/rmnCDZLcc5",
                                        "expanded_url": "https://twitter.com/Plettigoal/status/1813956005438628344/photo/1",
                                        "id_str": "1813955998387781632",
                                        "indices": [
                                            197,
                                            220
                                        ],
                                        "media_key": "3_1813955998387781632",
                                        "media_url_https": "https://pbs.twimg.com/media/GSx3XqoXwAAxZqK.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/rmnCDZLcc5",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "all": {
                                                "tags": [
                                                    {
                                                        "user_id": "2303765948",
                                                        "name": "Florian Plettenberg",
                                                        "screen_name": "Plettigoal",
                                                        "type": "user"
                                                    }
                                                ]
                                            },
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 551,
                                                        "y": 1112,
                                                        "h": 135,
                                                        "w": 135
                                                    },
                                                    {
                                                        "x": 341,
                                                        "y": 106,
                                                        "h": 429,
                                                        "w": 429
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 489,
                                                        "y": 988,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 303,
                                                        "y": 94,
                                                        "h": 381,
                                                        "w": 381
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 277,
                                                        "y": 560,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 171,
                                                        "y": 53,
                                                        "h": 216,
                                                        "w": 216
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 551,
                                                        "y": 1112,
                                                        "h": 135,
                                                        "w": 135
                                                    },
                                                    {
                                                        "x": 341,
                                                        "y": 106,
                                                        "h": 429,
                                                        "w": 429
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 69,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813955998387781632"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 8987,
                            "favorited": false,
                            "full_text": "🚨🔴 Leny #Yoro deal with Manchester United will be announced very soon! Probably today …\n\nAll done and sealed. Contract signed until 2029 + 1 … ✍️\n\nYoro, a new defender of @ManUtd! \n\n@SkySportDE 🇫🇷 https://t.co/rmnCDZLcc5",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 20,
                            "reply_count": 62,
                            "retweet_count": 851,
                            "retweeted": false,
                            "user_id_str": "2303765948",
                            "id_str": "1813956005438628344"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814019876538794110",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo0Njg3NTEyNA==",
                                    "rest_id": "46875124",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sat Jun 13 12:09:04 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Football Correspondent, @TheAthleticFC",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "nytimes.com/athletic/autho…",
                                                        "expanded_url": "https://www.nytimes.com/athletic/author/david-ornstein/",
                                                        "url": "https://t.co/efp3FmH2Bh",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 1707,
                                        "followers_count": 3154144,
                                        "friends_count": 2390,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 13582,
                                        "location": "UK",
                                        "media_count": 787,
                                        "name": "David Ornstein",
                                        "normal_followers_count": 3154144,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/46875124/1715632626",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1178558529105530880/Qvy-hv3O_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "David_Ornstein",
                                        "statuses_count": 8190,
                                        "translator_type": "none",
                                        "url": "https://t.co/efp3FmH2Bh",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/Pp6ahLHN05",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "photo_image_full_size_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image",
                                        "value": {
                                            "image_value": {
                                                "height": 200,
                                                "width": 400,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=400x400"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "description",
                                        "value": {
                                            "string_value": "United have landed Lille defender Yoro, considered a 'generational talent' at age 18 - this is the story of how they did it",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "domain",
                                        "value": {
                                            "string_value": "www.nytimes.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 300,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=600x600"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 675,
                                                "width": 1350,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "site",
                                        "value": {
                                            "scribe_key": "publisher_id",
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "809532994444591104",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 72,
                                                "width": 144,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=144x144"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "creator",
                                        "value": {
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "809532994444591104",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 675,
                                                "width": 1350,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_original",
                                        "value": {
                                            "image_value": {
                                                "height": 675,
                                                "width": 1350,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "vanity_url",
                                        "value": {
                                            "scribe_key": "vanity_url",
                                            "string_value": "nytimes.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 26,
                                                            "green": 21,
                                                            "red": 18
                                                        },
                                                        "percentage": 67.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 44,
                                                            "green": 44,
                                                            "red": 204
                                                        },
                                                        "percentage": 12.28
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 112,
                                                            "green": 156,
                                                            "red": 219
                                                        },
                                                        "percentage": 7.3
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 34,
                                                            "green": 26,
                                                            "red": 144
                                                        },
                                                        "percentage": 3.7
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 45,
                                                            "green": 60,
                                                            "red": 112
                                                        },
                                                        "percentage": 3.49
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "title",
                                        "value": {
                                            "string_value": "How Manchester United beat Real Madrid to the signing of Leny Yoro",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 26,
                                                            "green": 21,
                                                            "red": 18
                                                        },
                                                        "percentage": 67.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 44,
                                                            "green": 44,
                                                            "red": 204
                                                        },
                                                        "percentage": 12.28
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 112,
                                                            "green": 156,
                                                            "red": 219
                                                        },
                                                        "percentage": 7.3
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 34,
                                                            "green": 26,
                                                            "red": 144
                                                        },
                                                        "percentage": 3.7
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 45,
                                                            "green": 60,
                                                            "red": 112
                                                        },
                                                        "percentage": 3.49
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 675,
                                                "width": 1350,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 26,
                                                            "green": 21,
                                                            "red": 18
                                                        },
                                                        "percentage": 67.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 44,
                                                            "green": 44,
                                                            "red": 204
                                                        },
                                                        "percentage": 12.28
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 112,
                                                            "green": 156,
                                                            "red": 219
                                                        },
                                                        "percentage": 7.3
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 34,
                                                            "green": 26,
                                                            "red": 144
                                                        },
                                                        "percentage": 3.7
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 45,
                                                            "green": 60,
                                                            "red": 112
                                                        },
                                                        "percentage": 3.49
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 675,
                                                "width": 1350,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/Pp6ahLHN05",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 675,
                                                "width": 1350,
                                                "url": "https://pbs.twimg.com/card_img/1872928010237612033/I75ghLg3?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "summary_large_image",
                                "url": "https://t.co/Pp6ahLHN05",
                                "user_refs_results": [
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo4MDk1MzI5OTQ0NDQ1OTExMDQ=",
                                            "rest_id": "809532994444591104",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Dec 15 22:58:01 +0000 2016",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Get every sports story that matters.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "nytimes.com/athletic/",
                                                                "expanded_url": "https://www.nytimes.com/athletic/",
                                                                "url": "https://t.co/IqAvrbxlyG",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 17501,
                                                "followers_count": 577879,
                                                "friends_count": 1021,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 3144,
                                                "location": "",
                                                "media_count": 35823,
                                                "name": "The Athletic",
                                                "normal_followers_count": 577879,
                                                "pinned_tweet_ids_str": [
                                                    "1876289952637722798"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/809532994444591104/1696624392",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710392781502599168/30B7uQGJ_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TheAthletic",
                                                "statuses_count": 85322,
                                                "translator_type": "none",
                                                "url": "https://t.co/IqAvrbxlyG",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481701729729085440",
                                                "professional_type": "Business",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    },
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo4MDk1MzI5OTQ0NDQ1OTExMDQ=",
                                            "rest_id": "809532994444591104",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Dec 15 22:58:01 +0000 2016",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Get every sports story that matters.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "nytimes.com/athletic/",
                                                                "expanded_url": "https://www.nytimes.com/athletic/",
                                                                "url": "https://t.co/IqAvrbxlyG",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 17501,
                                                "followers_count": 577879,
                                                "friends_count": 1021,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 3144,
                                                "location": "",
                                                "media_count": 35823,
                                                "name": "The Athletic",
                                                "normal_followers_count": 577879,
                                                "pinned_tweet_ids_str": [
                                                    "1876289952637722798"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/809532994444591104/1696624392",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710392781502599168/30B7uQGJ_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TheAthletic",
                                                "statuses_count": 85322,
                                                "translator_type": "none",
                                                "url": "https://t.co/IqAvrbxlyG",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481701729729085440",
                                                "professional_type": "Business",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814019876538794110"
                            ],
                            "editable_until_msecs": "1721334616000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "757033",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 286,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 19:30:16 +0000 2024",
                            "conversation_id_str": "1814019876538794110",
                            "display_text_range": [
                                0,
                                279
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            154,
                                            159
                                        ],
                                        "text": "MUFC"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "nytimes.com/athletic/56448…",
                                        "expanded_url": "https://www.nytimes.com/athletic/5644891/2024/07/18/leny-yoro-transfer-manchester-united-real-madrid/",
                                        "url": "https://t.co/Pp6ahLHN05",
                                        "indices": [
                                            256,
                                            279
                                        ]
                                    }
                                ],
                                "user_mentions": [
                                    {
                                        "id_str": "970939705629069312",
                                        "name": "The Athletic | Football",
                                        "screen_name": "TheAthleticFC",
                                        "indices": [
                                            241,
                                            255
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 9541,
                            "favorited": false,
                            "full_text": "\uD83D\uDEA8 Manchester United signing Leny Yoro from Lille a massive statement of intent. Real Madrid were firm favourites to land the coveted 18yo centre-back but #MUFC confounded expectations to pull off a massive coup - and this is how they did it @TheAthleticFC https://t.co/Pp6ahLHN05",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 186,
                            "reply_count": 351,
                            "retweet_count": 1284,
                            "retweeted": false,
                            "user_id_str": "46875124",
                            "id_str": "1814019876538794110"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814033303391134128",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo0MzUyMjU5MjI=",
                                    "rest_id": "435225922",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Mon Dec 12 20:29:59 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "At The Heart Of The Action.",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "sportbible.com",
                                                        "expanded_url": "http://sportbible.com",
                                                        "url": "https://t.co/EnbUSqpAex",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10592,
                                        "followers_count": 2219978,
                                        "friends_count": 3279,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 4066,
                                        "location": "contact@sportbible.com",
                                        "media_count": 41417,
                                        "name": "SPORTbible",
                                        "normal_followers_count": 2219978,
                                        "pinned_tweet_ids_str": [
                                            "1811829312439361997"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/435225922/1721143972",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1502336009211686919/6l8yeEw9_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "sportbible",
                                        "statuses_count": 111612,
                                        "translator_type": "regular",
                                        "url": "https://t.co/EnbUSqpAex",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814033303391134128"
                            ],
                            "editable_until_msecs": "1721337817000",
                            "is_edit_eligible": false,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "50853",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 0,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 20:23:37 +0000 2024",
                            "conversation_id_str": "1814033303391134128",
                            "display_text_range": [
                                0,
                                96
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/srubuoljmw",
                                        "expanded_url": "https://twitter.com/sportbible/status/1814033303391134128/photo/1",
                                        "id_str": "1814033244855160833",
                                        "indices": [
                                            97,
                                            120
                                        ],
                                        "media_key": "3_1814033244855160833",
                                        "media_url_https": "https://pbs.twimg.com/media/GSy9oAJXUAEh5Tu.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/sRUbuoljMw",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 523,
                                                        "y": 69,
                                                        "h": 273,
                                                        "w": 273
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 523,
                                                        "y": 69,
                                                        "h": 273,
                                                        "w": 273
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 329,
                                                        "y": 43,
                                                        "h": 171,
                                                        "w": 171
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 523,
                                                        "y": 69,
                                                        "h": 273,
                                                        "w": 273
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 475,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 133,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 513,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814033244855160833"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/sRUbuoljMw",
                                        "expanded_url": "https://twitter.com/sportbible/status/1814033303391134128/photo/1",
                                        "id_str": "1814033244855160833",
                                        "indices": [
                                            97,
                                            120
                                        ],
                                        "media_key": "3_1814033244855160833",
                                        "media_url_https": "https://pbs.twimg.com/media/GSy9oAJXUAEh5Tu.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/sRUbuoljMw",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 523,
                                                        "y": 69,
                                                        "h": 273,
                                                        "w": 273
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 523,
                                                        "y": 69,
                                                        "h": 273,
                                                        "w": 273
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 329,
                                                        "y": 43,
                                                        "h": 171,
                                                        "w": 171
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 523,
                                                        "y": 69,
                                                        "h": 273,
                                                        "w": 273
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 475,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 133,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 513,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814033244855160833"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 395,
                            "favorited": false,
                            "full_text": "🚨Leny Yoro explains why he performed Real Madrid U-turn as key reasons for Man Utd move revealed https://t.co/sRUbuoljMw",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1,
                            "reply_count": 6,
                            "retweet_count": 16,
                            "retweeted": false,
                            "user_id_str": "435225922",
                            "id_str": "1814033303391134128"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1814038901796843916",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo0MzY0MjAzNTc1",
                                    "rest_id": "4364203575",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Thu Dec 03 19:15:09 +0000 2015",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "bookings : crayon@mavinrecords.com",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "crayon.lnk.to/if-i-be-youIB",
                                                        "expanded_url": "https://crayon.lnk.to/if-i-be-youIB",
                                                        "url": "https://t.co/NPfMieaprD",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 71800,
                                        "followers_count": 775409,
                                        "friends_count": 757,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 176,
                                        "location": "Lagos ",
                                        "media_count": 2311,
                                        "name": "CRAYWAY!",
                                        "normal_followers_count": 775409,
                                        "pinned_tweet_ids_str": [
                                            "1798041415215452475"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/4364203575/1714242201",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1792566453868068864/HAS17mZV_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "crayonthis",
                                        "statuses_count": 84331,
                                        "translator_type": "none",
                                        "url": "https://t.co/NPfMieaprD",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1525069021867036672",
                                        "professional_type": "Creator",
                                        "category": [
                                            {
                                                "id": 940,
                                                "name": "Musician",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1814038901796843916"
                            ],
                            "editable_until_msecs": "1721339152000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "201620",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 35,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 20:45:52 +0000 2024",
                            "conversation_id_str": "1814038901796843916",
                            "display_text_range": [
                                0,
                                40
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/lntcaw8oyh",
                                        "expanded_url": "https://twitter.com/crayonthis/status/1814038901796843916/photo/1",
                                        "id_str": "1814038882301714432",
                                        "indices": [
                                            41,
                                            64
                                        ],
                                        "media_key": "3_1814038882301714432",
                                        "media_url_https": "https://pbs.twimg.com/media/GSzCwJRXIAAWiZU.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/lNTcaW8oYh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1034,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 606,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 343,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1034,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 170,
                                                    "w": 1034,
                                                    "h": 579
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1034,
                                                    "h": 1034
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1034,
                                                    "h": 1179
                                                },
                                                {
                                                    "x": 10,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1034,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814038882301714432"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/lNTcaW8oYh",
                                        "expanded_url": "https://twitter.com/crayonthis/status/1814038901796843916/photo/1",
                                        "id_str": "1814038882301714432",
                                        "indices": [
                                            41,
                                            64
                                        ],
                                        "media_key": "3_1814038882301714432",
                                        "media_url_https": "https://pbs.twimg.com/media/GSzCwJRXIAAWiZU.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/lNTcaW8oYh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1034,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 606,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 343,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1034,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 170,
                                                    "w": 1034,
                                                    "h": 579
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1034,
                                                    "h": 1034
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1034,
                                                    "h": 1179
                                                },
                                                {
                                                    "x": 10,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1034,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1814038882301714432"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 6501,
                            "favorited": false,
                            "full_text": "My star boyyyyyyyyy LENY YORO!!! Is RED! https://t.co/lNTcaW8oYh",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 32,
                            "reply_count": 104,
                            "retweet_count": 520,
                            "retweeted": false,
                            "user_id_str": "4364203575",
                            "id_str": "1814038901796843916"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813839384195588124",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMjU5NTA5OTc4MzM3MDg3NDk1",
                                    "rest_id": "1259509978337087495",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 10 15:46:10 +0000 2020",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "Official Utd Faithfuls account #UF • DM for business/enquiries 📥 • https://t.co/yO1IpYsP8P",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "duel.bz/utd",
                                                        "expanded_url": "https://duel.bz/utd",
                                                        "url": "https://t.co/yO1IpYsP8P",
                                                        "indices": [
                                                            67,
                                                            90
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11526,
                                        "followers_count": 410427,
                                        "friends_count": 164,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1187,
                                        "location": "utdfaithfuls@gmail.com",
                                        "media_count": 4414,
                                        "name": "UF",
                                        "normal_followers_count": 410427,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1259509978337087495/1662446426",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1617081344999264320/i2MNx0du_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "UtdFaithfuls",
                                        "statuses_count": 10942,
                                        "translator_type": "none",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813839384195588124"
                            ],
                            "editable_until_msecs": "1721291583000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "280014",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/android\" rel=\"nofollow\">Twitter for Android</a>",
                        "legacy": {
                            "bookmark_count": 125,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 07:33:03 +0000 2024",
                            "conversation_id_str": "1813839384195588124",
                            "display_text_range": [
                                0,
                                210
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/9fy9xjd20y",
                                        "expanded_url": "https://twitter.com/UtdFaithfuls/status/1813839384195588124/photo/1",
                                        "id_str": "1813839372124340224",
                                        "indices": [
                                            211,
                                            234
                                        ],
                                        "media_key": "3_1813839372124340224",
                                        "media_url_https": "https://pbs.twimg.com/media/GSwNTH8WwAAMD4y.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/9fy9xJd20Y",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 266,
                                                        "y": 455,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 46,
                                                        "y": 174,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 266,
                                                        "y": 455,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 46,
                                                        "y": 174,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 154,
                                                        "y": 264,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 26,
                                                        "y": 101,
                                                        "h": 44,
                                                        "w": 44
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 266,
                                                        "y": 455,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 46,
                                                        "y": 174,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1167,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1167,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 559,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1167,
                                            "width": 960,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 460,
                                                    "w": 960,
                                                    "h": 538
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 207,
                                                    "w": 960,
                                                    "h": 960
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 73,
                                                    "w": 960,
                                                    "h": 1094
                                                },
                                                {
                                                    "x": 28,
                                                    "y": 0,
                                                    "w": 584,
                                                    "h": 1167
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 960,
                                                    "h": 1167
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813839372124340224"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/9fy9xJd20Y",
                                        "expanded_url": "https://twitter.com/UtdFaithfuls/status/1813839384195588124/photo/1",
                                        "id_str": "1813839372124340224",
                                        "indices": [
                                            211,
                                            234
                                        ],
                                        "media_key": "3_1813839372124340224",
                                        "media_url_https": "https://pbs.twimg.com/media/GSwNTH8WwAAMD4y.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/9fy9xJd20Y",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 266,
                                                        "y": 455,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 46,
                                                        "y": 174,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 266,
                                                        "y": 455,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 46,
                                                        "y": 174,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 154,
                                                        "y": 264,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 26,
                                                        "y": 101,
                                                        "h": 44,
                                                        "w": 44
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 266,
                                                        "y": 455,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 46,
                                                        "y": 174,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1167,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1167,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 559,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1167,
                                            "width": 960,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 460,
                                                    "w": 960,
                                                    "h": 538
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 207,
                                                    "w": 960,
                                                    "h": 960
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 73,
                                                    "w": 960,
                                                    "h": 1094
                                                },
                                                {
                                                    "x": 28,
                                                    "y": 0,
                                                    "w": 584,
                                                    "h": 1167
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 960,
                                                    "h": 1167
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813839372124340224"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 5303,
                            "favorited": false,
                            "full_text": "🚨 Leny Yoro's imminent signing means Man Utd will now have THREE players in the current Top 10 Golden Boy rankings:\n\n• 3rd - Alejandro Garnacho 🇦🇷\n• 5th - Leny Yoro 🇫🇷\n• 7th - Kobbie Mainoo 🏴󠁧󠁢󠁥󠁮󠁧󠁿\n\nSTARBOYS 🌟🔴 https://t.co/9fy9xJd20Y",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 32,
                            "reply_count": 111,
                            "retweet_count": 573,
                            "retweeted": false,
                            "user_id_str": "1259509978337087495",
                            "id_str": "1813839384195588124"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813575418332738010",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo0Njg3NTEyNA==",
                                    "rest_id": "46875124",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sat Jun 13 12:09:04 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Football Correspondent, @TheAthleticFC",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "nytimes.com/athletic/autho…",
                                                        "expanded_url": "https://www.nytimes.com/athletic/author/david-ornstein/",
                                                        "url": "https://t.co/efp3FmH2Bh",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 1707,
                                        "followers_count": 3154143,
                                        "friends_count": 2390,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 13582,
                                        "location": "UK",
                                        "media_count": 787,
                                        "name": "David Ornstein",
                                        "normal_followers_count": 3154143,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/46875124/1715632626",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1178558529105530880/Qvy-hv3O_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "David_Ornstein",
                                        "statuses_count": 8190,
                                        "translator_type": "none",
                                        "url": "https://t.co/efp3FmH2Bh",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/HlAU2AY2m1",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "photo_image_full_size_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image",
                                        "value": {
                                            "image_value": {
                                                "height": 150,
                                                "width": 225,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=280x150"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "description",
                                        "value": {
                                            "string_value": "Lille centre-back Leny Yoro is undergoing a medical at Manchester United ahead of signing a five-year contract, with the option of an additional year, at the Premier League club. The 18-year-old...",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "domain",
                                        "value": {
                                            "string_value": "www.nytimes.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 320,
                                                "width": 481,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=800x320_1"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "site",
                                        "value": {
                                            "scribe_key": "publisher_id",
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "809532994444591104",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 67,
                                                "width": 100,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=100x100"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "creator",
                                        "value": {
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "809532994444591104",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_original",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "vanity_url",
                                        "value": {
                                            "scribe_key": "vanity_url",
                                            "string_value": "nytimes.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 27,
                                                            "green": 12,
                                                            "red": 11
                                                        },
                                                        "percentage": 85.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 59,
                                                            "green": 32,
                                                            "red": 241
                                                        },
                                                        "percentage": 3.83
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 92,
                                                            "green": 74,
                                                            "red": 212
                                                        },
                                                        "percentage": 1.94
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 175,
                                                            "green": 164,
                                                            "red": 217
                                                        },
                                                        "percentage": 1.71
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 79,
                                                            "green": 122,
                                                            "red": 185
                                                        },
                                                        "percentage": 1.66
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "title",
                                        "value": {
                                            "string_value": "Leny Yoro undergoing Manchester United medical ahead of signing five-year contract",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 27,
                                                            "green": 12,
                                                            "red": 11
                                                        },
                                                        "percentage": 85.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 59,
                                                            "green": 32,
                                                            "red": 241
                                                        },
                                                        "percentage": 3.83
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 92,
                                                            "green": 74,
                                                            "red": 212
                                                        },
                                                        "percentage": 1.94
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 175,
                                                            "green": 164,
                                                            "red": 217
                                                        },
                                                        "percentage": 1.71
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 79,
                                                            "green": 122,
                                                            "red": 185
                                                        },
                                                        "percentage": 1.66
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 27,
                                                            "green": 12,
                                                            "red": 11
                                                        },
                                                        "percentage": 85.77
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 59,
                                                            "green": 32,
                                                            "red": 241
                                                        },
                                                        "percentage": 3.83
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 92,
                                                            "green": 74,
                                                            "red": 212
                                                        },
                                                        "percentage": 1.94
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 175,
                                                            "green": 164,
                                                            "red": 217
                                                        },
                                                        "percentage": 1.71
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 79,
                                                            "green": 122,
                                                            "red": 185
                                                        },
                                                        "percentage": 1.66
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/HlAU2AY2m1",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 799,
                                                "width": 1200,
                                                "url": "https://pbs.twimg.com/card_img/1874425714490933249/9HGbhJxK?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "summary_large_image",
                                "url": "https://t.co/HlAU2AY2m1",
                                "user_refs_results": [
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo4MDk1MzI5OTQ0NDQ1OTExMDQ=",
                                            "rest_id": "809532994444591104",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Dec 15 22:58:01 +0000 2016",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Get every sports story that matters.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "nytimes.com/athletic/",
                                                                "expanded_url": "https://www.nytimes.com/athletic/",
                                                                "url": "https://t.co/IqAvrbxlyG",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 17501,
                                                "followers_count": 577881,
                                                "friends_count": 1021,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 3144,
                                                "location": "",
                                                "media_count": 35823,
                                                "name": "The Athletic",
                                                "normal_followers_count": 577881,
                                                "pinned_tweet_ids_str": [
                                                    "1876289952637722798"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/809532994444591104/1696624392",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710392781502599168/30B7uQGJ_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TheAthletic",
                                                "statuses_count": 85322,
                                                "translator_type": "none",
                                                "url": "https://t.co/IqAvrbxlyG",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481701729729085440",
                                                "professional_type": "Business",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    },
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjo4MDk1MzI5OTQ0NDQ1OTExMDQ=",
                                            "rest_id": "809532994444591104",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Dec 15 22:58:01 +0000 2016",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "Get every sports story that matters.",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "nytimes.com/athletic/",
                                                                "expanded_url": "https://www.nytimes.com/athletic/",
                                                                "url": "https://t.co/IqAvrbxlyG",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 17501,
                                                "followers_count": 577881,
                                                "friends_count": 1021,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 3144,
                                                "location": "",
                                                "media_count": 35823,
                                                "name": "The Athletic",
                                                "normal_followers_count": 577881,
                                                "pinned_tweet_ids_str": [
                                                    "1876289952637722798"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/809532994444591104/1696624392",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710392781502599168/30B7uQGJ_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TheAthletic",
                                                "statuses_count": 85322,
                                                "translator_type": "none",
                                                "url": "https://t.co/IqAvrbxlyG",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481701729729085440",
                                                "professional_type": "Business",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "initial_tweet_id": "1813574926739386599",
                            "edit_control_initial": {
                                "edit_tweet_ids": [
                                    "1813574926739386599",
                                    "1813575418332738010"
                                ],
                                "editable_until_msecs": "1721228531000",
                                "is_edit_eligible": true,
                                "edits_remaining": "4"
                            }
                        },
                        "previous_counts": {
                            "bookmark_count": 33,
                            "favorite_count": 2910,
                            "quote_count": 236,
                            "reply_count": 574,
                            "retweet_count": 429
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1114855",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 209,
                            "bookmarked": false,
                            "created_at": "Wed Jul 17 14:04:08 +0000 2024",
                            "conversation_id_str": "1813575418332738010",
                            "display_text_range": [
                                0,
                                278
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            197,
                                            202
                                        ],
                                        "text": "MUFC"
                                    },
                                    {
                                        "indices": [
                                            249,
                                            254
                                        ],
                                        "text": "LOSC"
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "nytimes.com/athletic/56264…",
                                        "expanded_url": "https://www.nytimes.com/athletic/5626457/2024/07/17/leny-yoro-manchester-united-transfer/?source=emp_shared_article",
                                        "url": "https://t.co/HlAU2AY2m1",
                                        "indices": [
                                            255,
                                            278
                                        ]
                                    }
                                ],
                                "user_mentions": [
                                    {
                                        "id_str": "970939705629069312",
                                        "name": "The Athletic | Football",
                                        "screen_name": "TheAthleticFC",
                                        "indices": [
                                            234,
                                            248
                                        ]
                                    }
                                ]
                            },
                            "favorite_count": 16680,
                            "favorited": false,
                            "full_text": "\uD83D\uDEA8 Leny Yoro medical taking place as we speak - once done today/tomorrow Manchester United contract will be signed. 5yr deal + option to extend by 12mnths. 18yo decided last night to accept move to #MUFC from Lille for maximum of €70m @TheAthleticFC #LOSC https://t.co/HlAU2AY2m1",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1101,
                            "reply_count": 640,
                            "retweet_count": 3044,
                            "retweeted": false,
                            "user_id_str": "46875124",
                            "id_str": "1813575418332738010"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813859001450553612",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMjc3MjM2MTUxMzQzMDg3NjE3",
                                    "rest_id": "1277236151343087617",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Jun 28 13:43:30 +0000 2020",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "📲 Independent hub for all your #RealMadrid, #UCL — updates, news, stats & much more. Email: contact@themadridzone.com",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "linktr.ee/theMadridZone",
                                                        "expanded_url": "https://linktr.ee/theMadridZone",
                                                        "url": "https://t.co/rgUl3201qf",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 7,
                                        "followers_count": 1220888,
                                        "friends_count": 237,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 2027,
                                        "location": "",
                                        "media_count": 45757,
                                        "name": "Madrid Zone",
                                        "normal_followers_count": 1220888,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1277236151343087617/1708591319",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1505281971131400194/qqcqktJV_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "theMadridZone",
                                        "statuses_count": 77779,
                                        "translator_type": "none",
                                        "url": "https://t.co/rgUl3201qf",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1484346201457659904",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "initial_tweet_id": "1813858722474819610",
                            "edit_control_initial": {
                                "edit_tweet_ids": [
                                    "1813858722474819610",
                                    "1813859001450553612"
                                ],
                                "editable_until_msecs": "1721296193000",
                                "is_edit_eligible": true,
                                "edits_remaining": "4"
                            }
                        },
                        "previous_counts": {
                            "bookmark_count": 1,
                            "favorite_count": 46,
                            "quote_count": 6,
                            "reply_count": 10,
                            "retweet_count": 2
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "3694895",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 820,
                            "bookmarked": false,
                            "created_at": "Thu Jul 18 08:51:00 +0000 2024",
                            "conversation_id_str": "1813859001450553612",
                            "display_text_range": [
                                0,
                                123
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/vzfcpq8mjq",
                                        "expanded_url": "https://twitter.com/theMadridZone/status/1813859001450553612/photo/1",
                                        "id_str": "1813858713767129088",
                                        "indices": [
                                            124,
                                            147
                                        ],
                                        "media_key": "3_1813858713767129088",
                                        "media_url_https": "https://pbs.twimg.com/media/GSwe49LWMAA9vxF.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/vzFCpq8mJQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 466,
                                                        "y": 34,
                                                        "h": 269,
                                                        "w": 269
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 466,
                                                        "y": 34,
                                                        "h": 269,
                                                        "w": 269
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 280,
                                                        "y": 20,
                                                        "h": 162,
                                                        "w": 162
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 466,
                                                        "y": 34,
                                                        "h": 269,
                                                        "w": 269
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1129,
                                                "w": 968,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1129,
                                                "w": 968,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 583,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1129,
                                            "width": 968,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 434,
                                                    "w": 968,
                                                    "h": 542
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 161,
                                                    "w": 968,
                                                    "h": 968
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 25,
                                                    "w": 968,
                                                    "h": 1104
                                                },
                                                {
                                                    "x": 254,
                                                    "y": 0,
                                                    "w": 565,
                                                    "h": 1129
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 968,
                                                    "h": 1129
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813858713767129088"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "15095537",
                                        "name": "MARCA",
                                        "screen_name": "marca",
                                        "indices": [
                                            117,
                                            123
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/vzFCpq8mJQ",
                                        "expanded_url": "https://twitter.com/theMadridZone/status/1813859001450553612/photo/1",
                                        "id_str": "1813858713767129088",
                                        "indices": [
                                            124,
                                            147
                                        ],
                                        "media_key": "3_1813858713767129088",
                                        "media_url_https": "https://pbs.twimg.com/media/GSwe49LWMAA9vxF.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/vzFCpq8mJQ",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 466,
                                                        "y": 34,
                                                        "h": 269,
                                                        "w": 269
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 466,
                                                        "y": 34,
                                                        "h": 269,
                                                        "w": 269
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 280,
                                                        "y": 20,
                                                        "h": 162,
                                                        "w": 162
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 466,
                                                        "y": 34,
                                                        "h": 269,
                                                        "w": 269
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1129,
                                                "w": 968,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1129,
                                                "w": 968,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 583,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1129,
                                            "width": 968,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 434,
                                                    "w": 968,
                                                    "h": 542
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 161,
                                                    "w": 968,
                                                    "h": 968
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 25,
                                                    "w": 968,
                                                    "h": 1104
                                                },
                                                {
                                                    "x": 254,
                                                    "y": 0,
                                                    "w": 565,
                                                    "h": 1129
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 968,
                                                    "h": 1129
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813858713767129088"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 24782,
                            "favorited": false,
                            "full_text": "❗️Lille threatened Leny Yoro that they will not play him for a year if he didn't sign with Manchester United, as per @marca https://t.co/vzFCpq8mJQ",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1703,
                            "reply_count": 1983,
                            "retweet_count": 1311,
                            "retweeted": false,
                            "user_id_str": "1277236151343087617",
                            "id_str": "1813859001450553612"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1813510886658830419",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MTM5OTM0MTM=",
                                    "rest_id": "713993413",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Tue Jul 24 09:18:08 +0000 2012",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "The official account for the Sky Sports Premier League channel",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "shop.skysports.com/football-clubs/",
                                                        "expanded_url": "https://shop.skysports.com/football-clubs/",
                                                        "url": "https://t.co/0XTVPZ8lP0",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 336,
                                        "followers_count": 12334455,
                                        "friends_count": 39,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 17317,
                                        "location": "London",
                                        "media_count": 107113,
                                        "name": "Sky Sports Premier League",
                                        "normal_followers_count": 12334455,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/713993413/1699464013",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1605131756310614017/05qwHae-_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "SkySportsPL",
                                        "statuses_count": 222871,
                                        "translator_type": "none",
                                        "url": "https://t.co/0XTVPZ8lP0",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1443897323508183042",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1813510886658830419"
                            ],
                            "editable_until_msecs": "1721213263000",
                            "is_edit_eligible": false,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "552913",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 77,
                            "bookmarked": false,
                            "created_at": "Wed Jul 17 09:47:43 +0000 2024",
                            "conversation_id_str": "1813510886658830419",
                            "display_text_range": [
                                0,
                                168
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/2i3z70jwri",
                                        "expanded_url": "https://twitter.com/SkySportsPL/status/1813510886658830419/photo/1",
                                        "id_str": "1813510798880239616",
                                        "indices": [
                                            169,
                                            192
                                        ],
                                        "media_key": "3_1813510798880239616",
                                        "media_url_https": "https://pbs.twimg.com/media/GSridpOXcAA7zIf.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/2i3Z70JWRi",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 341,
                                                        "y": 72,
                                                        "h": 262,
                                                        "w": 262
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 303,
                                                        "y": 64,
                                                        "h": 232,
                                                        "w": 232
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 171,
                                                        "y": 36,
                                                        "h": 131,
                                                        "w": 131
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 341,
                                                        "y": 72,
                                                        "h": 262,
                                                        "w": 262
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813510798880239616"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/2i3Z70JWRi",
                                        "expanded_url": "https://twitter.com/SkySportsPL/status/1813510886658830419/photo/1",
                                        "id_str": "1813510798880239616",
                                        "indices": [
                                            169,
                                            192
                                        ],
                                        "media_key": "3_1813510798880239616",
                                        "media_url_https": "https://pbs.twimg.com/media/GSridpOXcAA7zIf.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/2i3Z70JWRi",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 341,
                                                        "y": 72,
                                                        "h": 262,
                                                        "w": 262
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 303,
                                                        "y": 64,
                                                        "h": 232,
                                                        "w": 232
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 171,
                                                        "y": 36,
                                                        "h": 131,
                                                        "w": 131
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 341,
                                                        "y": 72,
                                                        "h": 262,
                                                        "w": 262
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1813510798880239616"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 19236,
                            "favorited": false,
                            "full_text": "Lille defender Leny Yoro is flying to the UK for a medical with Manchester United after a deal worth a total of more than £50m was agreed between the clubs last week 🔴🔜 https://t.co/2i3Z70JWRi",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 134,
                            "reply_count": 203,
                            "retweet_count": 1660,
                            "retweeted": false,
                            "user_id_str": "713993413",
                            "id_str": "1813510886658830419"
                        }
                    }
                }
            }
        }
    ],
    lamineYamal: [
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812592004838117689",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNTYxMTIzNjYz",
                                    "rest_id": "1561123663",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/BleacherReport",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1711004584104038400/lAPnpF7v_bigger.jpg"
                                            },
                                            "description": "Bleacher Report",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Mon Jul 01 17:51:17 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Get the free B/R App ⬇️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "br.app.link/get-the-BR-app",
                                                        "expanded_url": "https://br.app.link/get-the-BR-app",
                                                        "url": "https://t.co/Ry63mhhsjm",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 2866,
                                        "followers_count": 7451914,
                                        "friends_count": 1115,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 13139,
                                        "location": "",
                                        "media_count": 120001,
                                        "name": "B/R Football",
                                        "normal_followers_count": 7451914,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1561123663/1729194940",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1710859925293760512/MLeyvq0O_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "brfootball",
                                        "statuses_count": 135771,
                                        "translator_type": "regular",
                                        "url": "https://t.co/Ry63mhhsjm",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1602636242457432065",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812592004838117689"
                            ],
                            "editable_until_msecs": "1720994184000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "8053339",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                        "legacy": {
                            "bookmark_count": 1655,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 20:56:24 +0000 2024",
                            "conversation_id_str": "1812592004838117689",
                            "display_text_range": [
                                0,
                                88
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/TLVFlAH1Mh",
                                        "expanded_url": "https://x.com/brfootball/status/1812592004838117689/photo/1",
                                        "id_str": "1812591960126877696",
                                        "indices": [
                                            89,
                                            112
                                        ],
                                        "media_key": "3_1812591960126877696",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeeyMIXcAAk9zf.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/TLVFlAH1Mh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 771,
                                                        "y": 1108,
                                                        "h": 126,
                                                        "w": 126
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 685,
                                                        "y": 984,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 388,
                                                        "y": 558,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 771,
                                                        "y": 1108,
                                                        "h": 126,
                                                        "w": 126
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 136,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 236,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812591960126877696"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.x.com/TLVFlAH1Mh",
                                        "expanded_url": "https://x.com/brfootball/status/1812592004838117689/photo/1",
                                        "id_str": "1812591960126877696",
                                        "indices": [
                                            89,
                                            112
                                        ],
                                        "media_key": "3_1812591960126877696",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeeyMIXcAAk9zf.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/TLVFlAH1Mh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 771,
                                                        "y": 1108,
                                                        "h": 126,
                                                        "w": 126
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 685,
                                                        "y": 984,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 388,
                                                        "y": 558,
                                                        "h": 63,
                                                        "w": 63
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 771,
                                                        "y": 1108,
                                                        "h": 126,
                                                        "w": 126
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 136,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 236,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812591960126877696"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 118207,
                            "favorited": false,
                            "full_text": "Lamine Yamal leads Spain to the European Championship a day after he turns 17.\n\nMAGIC \uD83D\uDEC1✨ https://t.co/TLVFlAH1Mh",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1117,
                            "reply_count": 560,
                            "retweet_count": 14578,
                            "retweeted": false,
                            "user_id_str": "1561123663",
                            "id_str": "1812592004838117689"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812629733559222477",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490905,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490905,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812629733559222477"
                            ],
                            "editable_until_msecs": "1721003180000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "121021",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 118,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 23:26:20 +0000 2024",
                            "conversation_id_str": "1812629733559222477",
                            "display_text_range": [
                                0,
                                98
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/huchbqv67s",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812629733559222477/video/1",
                                        "id_str": "1812629470953582592",
                                        "indices": [
                                            99,
                                            122
                                        ],
                                        "media_key": "7_1812629470953582592",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1812629470953582592/pu/img/y9yydQhPxdI_eUZR.jpg",
                                        "type": "video",
                                        "url": "https://t.co/huchBqv67S",
                                        "additional_media_info": {
                                            "title": "",
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1920,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1920,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 35583,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/pl/1ue-x7b5VBVpezOS.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/vid/avc1/320x568/dK8MIKM4JaKw9G4h.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/vid/avc1/480x852/6YdG4WqXWU0j3ZfA.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/vid/avc1/720x1280/FhwHw0VnXJkvPV5z.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1812629470953582592"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/huchBqv67S",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812629733559222477/video/1",
                                        "id_str": "1812629470953582592",
                                        "indices": [
                                            99,
                                            122
                                        ],
                                        "media_key": "7_1812629470953582592",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1812629470953582592/pu/img/y9yydQhPxdI_eUZR.jpg",
                                        "type": "video",
                                        "url": "https://t.co/huchBqv67S",
                                        "additional_media_info": {
                                            "title": "",
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1920,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1920,
                                            "width": 1080,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 35583,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/pl/1ue-x7b5VBVpezOS.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/vid/avc1/320x568/dK8MIKM4JaKw9G4h.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/vid/avc1/480x852/6YdG4WqXWU0j3ZfA.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812629470953582592/pu/vid/avc1/720x1280/FhwHw0VnXJkvPV5z.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1812629470953582592"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 1087,
                            "favorited": false,
                            "full_text": "Spain's locker room celebration on Lamine Yamal's IG live was going wild 😅🇪🇸\n\n(via lamineyamal/IG) https://t.co/huchBqv67S",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 6,
                            "reply_count": 26,
                            "retweet_count": 88,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812629733559222477"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812584917928411299",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490906,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490906,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812584917928411299"
                            ],
                            "editable_until_msecs": "1720992495000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "67907",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                        "legacy": {
                            "bookmark_count": 21,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 20:28:15 +0000 2024",
                            "conversation_id_str": "1812584917928411299",
                            "display_text_range": [
                                0,
                                187
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/o1dn0uaunt",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812584917928411299/video/1",
                                        "id_str": "1812584149976535040",
                                        "indices": [
                                            188,
                                            211
                                        ],
                                        "media_key": "13_1812584149976535040",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeXzp6bMAA-uWg.jpg",
                                        "type": "video",
                                        "url": "https://t.co/o1dN0uaUNT",
                                        "additional_media_info": {
                                            "title": "",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1280,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1280,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 33333,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/pl/Wz6UdnL0Ri52dh-o.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/vid/avc1/320x568/g2-jty-NRoVBUEeb.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/vid/avc1/480x852/YFcJcnEPQx0ZCQCD.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/vid/avc1/720x1280/o7KiigZMp-x2UVV9.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812584149976535040"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/o1dN0uaUNT",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812584917928411299/video/1",
                                        "id_str": "1812584149976535040",
                                        "indices": [
                                            188,
                                            211
                                        ],
                                        "media_key": "13_1812584149976535040",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeXzp6bMAA-uWg.jpg",
                                        "type": "video",
                                        "url": "https://t.co/o1dN0uaUNT",
                                        "additional_media_info": {
                                            "title": "",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1280,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1280,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 33333,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/pl/Wz6UdnL0Ri52dh-o.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/vid/avc1/320x568/g2-jty-NRoVBUEeb.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/vid/avc1/480x852/YFcJcnEPQx0ZCQCD.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812584149976535040/vid/avc1/720x1280/o7KiigZMp-x2UVV9.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812584149976535040"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 285,
                            "favorited": false,
                            "full_text": "Lamine Yamal has now tied the record for the most assists by a player at the single edition of the EUROs 🎯🇪🇸\n\nRelive his setup on Nico Williams' goal through the eyes of the Yamal Cam 🎥⬇️ https://t.co/o1dN0uaUNT",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 2,
                            "reply_count": 6,
                            "retweet_count": 42,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812584917928411299"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812554709326352417",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490909,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490909,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812554709326352417"
                            ],
                            "editable_until_msecs": "1720985292000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "38680",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                        "legacy": {
                            "bookmark_count": 6,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 18:28:12 +0000 2024",
                            "conversation_id_str": "1812554709326352417",
                            "display_text_range": [
                                0,
                                87
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/n0hksg31qp",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812554709326352417/video/1",
                                        "id_str": "1812554399040086016",
                                        "indices": [
                                            88,
                                            111
                                        ],
                                        "media_key": "13_1812554399040086016",
                                        "media_url_https": "https://pbs.twimg.com/media/GSd84yHaIAAFcU-.jpg",
                                        "type": "video",
                                        "url": "https://t.co/N0hkSG31Qp",
                                        "additional_media_info": {
                                            "title": "",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 360,
                                                "w": 640,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 360,
                                                "w": 640,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 360,
                                                "w": 640,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 360,
                                            "width": 640,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 16816,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/pl/Aqj5iJ8sP66KFAMK.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/vid/avc1/480x270/pPVQd0mHphIq1lvs.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/vid/avc1/640x360/Q1rga0sDuKsn8HLo.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/vid/avc1/1280x720/_4yuDaREyrJkvOlj.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812554399040086016"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/N0hkSG31Qp",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812554709326352417/video/1",
                                        "id_str": "1812554399040086016",
                                        "indices": [
                                            88,
                                            111
                                        ],
                                        "media_key": "13_1812554399040086016",
                                        "media_url_https": "https://pbs.twimg.com/media/GSd84yHaIAAFcU-.jpg",
                                        "type": "video",
                                        "url": "https://t.co/N0hkSG31Qp",
                                        "additional_media_info": {
                                            "title": "",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 360,
                                                "w": 640,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 360,
                                                "w": 640,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 360,
                                                "w": 640,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 360,
                                            "width": 640,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 16816,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/pl/Aqj5iJ8sP66KFAMK.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/vid/avc1/480x270/pPVQd0mHphIq1lvs.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/vid/avc1/640x360/Q1rga0sDuKsn8HLo.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812554399040086016/vid/avc1/1280x720/_4yuDaREyrJkvOlj.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812554399040086016"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 268,
                            "favorited": false,
                            "full_text": "What a moment for Lamine Yamal as he takes the pitch ahead of the EURO  2024 final ❤️🇪🇸 https://t.co/N0hkSG31Qp",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 0,
                            "reply_count": 9,
                            "retweet_count": 31,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812554709326352417"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812566725814071363",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490905,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490905,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812566725814071363"
                            ],
                            "editable_until_msecs": "1720988157000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "75910",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://wildmoka.com\" rel=\"nofollow\">Wildmoka</a>",
                        "legacy": {
                            "bookmark_count": 17,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 19:15:57 +0000 2024",
                            "conversation_id_str": "1812566725814071363",
                            "display_text_range": [
                                0,
                                40
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/gak7pgki78",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812566725814071363/video/1",
                                        "id_str": "1812566672844161024",
                                        "indices": [
                                            41,
                                            64
                                        ],
                                        "media_key": "13_1812566672844161024",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeH1BqWAAARmlv.jpg",
                                        "type": "video",
                                        "url": "https://t.co/gAk7pGKI78",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": true
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 20587,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/pl/bEnnXrXtfkHObsje.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/480x270/BK4Wk5R-6ol1gFUo.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/640x360/SQGZJvrsQvhUnhKj.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/1280x720/SSqVXIEhIhsLmhQf.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/1920x1080/lK6AJTIQLvR6CwW8.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812566672844161024"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/gAk7pGKI78",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812566725814071363/video/1",
                                        "id_str": "1812566672844161024",
                                        "indices": [
                                            41,
                                            64
                                        ],
                                        "media_key": "13_1812566672844161024",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeH1BqWAAARmlv.jpg",
                                        "type": "video",
                                        "url": "https://t.co/gAk7pGKI78",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": true
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 20587,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/pl/bEnnXrXtfkHObsje.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/480x270/BK4Wk5R-6ol1gFUo.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/640x360/SQGZJvrsQvhUnhKj.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/1280x720/SSqVXIEhIhsLmhQf.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812566672844161024/vid/avc1/1920x1080/lK6AJTIQLvR6CwW8.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812566672844161024"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 165,
                            "favorited": false,
                            "full_text": "Lamine Yamal runs down Jude Bellingham 😤 https://t.co/gAk7pGKI78",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 8,
                            "reply_count": 16,
                            "retweet_count": 21,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812566725814071363"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812602055757861344",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo5Njk1MTgwMA==",
                                    "rest_id": "96951800",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Tue Dec 15 09:53:50 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "\uD83D\uDC99 1899–2024: 125TH ANNIVERSARY ❤️ FC Barcelona official account",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "barca.link/qsa050UAIWR",
                                                        "expanded_url": "http://barca.link/qsa050UAIWR",
                                                        "url": "https://t.co/7NXU6ZqyNl",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 5185,
                                        "followers_count": 49482488,
                                        "friends_count": 119,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 34868,
                                        "location": "POLSERES BLAUGRANES \uD83D\uDC99❤",
                                        "media_count": 95210,
                                        "name": "FC Barcelona",
                                        "normal_followers_count": 49482488,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/96951800/1731072309",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1834115251274452992/7m_GC0Wu_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FCBarcelona",
                                        "statuses_count": 146710,
                                        "translator_type": "regular",
                                        "url": "https://t.co/7NXU6ZqyNl",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812602055757861344"
                            ],
                            "editable_until_msecs": "1720996581000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "909475",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 230,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 21:36:21 +0000 2024",
                            "conversation_id_str": "1812602055757861344",
                            "display_text_range": [
                                0,
                                114
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            35,
                                            44
                                        ],
                                        "text": "EURO2024"
                                    },
                                    {
                                        "indices": [
                                            100,
                                            114
                                        ],
                                        "text": "MadeInLaMasia"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/qFc02jHVQS",
                                        "expanded_url": "https://x.com/FCBarcelona/status/1812602055757861344/photo/1",
                                        "id_str": "1812602051072831488",
                                        "indices": [
                                            115,
                                            138
                                        ],
                                        "media_key": "3_1812602051072831488",
                                        "media_url_https": "https://pbs.twimg.com/media/GSen9j1XMAAZgqC.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/qFc02jHVQS",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 286,
                                                        "y": 206,
                                                        "h": 270,
                                                        "w": 270
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 271,
                                                        "y": 195,
                                                        "h": 256,
                                                        "w": 256
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 153,
                                                        "y": 110,
                                                        "h": 145,
                                                        "w": 145
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 286,
                                                        "y": 206,
                                                        "h": 270,
                                                        "w": 270
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1264,
                                                "w": 1011,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1264,
                                            "width": 1011,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 64,
                                                    "w": 1011,
                                                    "h": 566
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1011,
                                                    "h": 1011
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1011,
                                                    "h": 1153
                                                },
                                                {
                                                    "x": 94,
                                                    "y": 0,
                                                    "w": 632,
                                                    "h": 1264
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1011,
                                                    "h": 1264
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812602051072831488"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.x.com/qFc02jHVQS",
                                        "expanded_url": "https://x.com/FCBarcelona/status/1812602055757861344/photo/1",
                                        "id_str": "1812602051072831488",
                                        "indices": [
                                            115,
                                            138
                                        ],
                                        "media_key": "3_1812602051072831488",
                                        "media_url_https": "https://pbs.twimg.com/media/GSen9j1XMAAZgqC.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/qFc02jHVQS",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 286,
                                                        "y": 206,
                                                        "h": 270,
                                                        "w": 270
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 271,
                                                        "y": 195,
                                                        "h": 256,
                                                        "w": 256
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 153,
                                                        "y": 110,
                                                        "h": 145,
                                                        "w": 145
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 286,
                                                        "y": 206,
                                                        "h": 270,
                                                        "w": 270
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1264,
                                                "w": 1011,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1264,
                                            "width": 1011,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 64,
                                                    "w": 1011,
                                                    "h": 566
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1011,
                                                    "h": 1011
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1011,
                                                    "h": 1153
                                                },
                                                {
                                                    "x": 94,
                                                    "y": 0,
                                                    "w": 632,
                                                    "h": 1264
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1011,
                                                    "h": 1264
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812602051072831488"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 47862,
                            "favorited": false,
                            "full_text": "Lamine Yamal, Best Young Player of #EURO2024!\n\nCongratulations, Lamine! \n\n\uD83D\uDCF8 UEFA via Getty Images | #MadeInLaMasia https://t.co/qFc02jHVQS",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 240,
                            "reply_count": 311,
                            "retweet_count": 6156,
                            "retweeted": false,
                            "user_id_str": "96951800",
                            "id_str": "1812602055757861344"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812595712489648383",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490908,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490908,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812595712489648383"
                            ],
                            "editable_until_msecs": "1720995068000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "57871",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://wildmoka.com\" rel=\"nofollow\">Wildmoka</a>",
                        "legacy": {
                            "bookmark_count": 14,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 21:11:08 +0000 2024",
                            "conversation_id_str": "1812595712489648383",
                            "display_text_range": [
                                0,
                                52
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/x4z9hl60oa",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812595712489648383/video/1",
                                        "id_str": "1812595663009402880",
                                        "indices": [
                                            53,
                                            76
                                        ],
                                        "media_key": "13_1812595663009402880",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeiMLnW0AA3JNp.jpg",
                                        "type": "video",
                                        "url": "https://t.co/x4Z9Hl60oa",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 16362,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/pl/GigAnEeB3ueZuV3l.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/480x270/yQ9EePYCEI6YYdzF.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/640x360/bgCTkMURggNuH7FT.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/1280x720/tQH5UMMXMcCHX4D6.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/1920x1080/zruXNKVDGyt7zlpb.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812595663009402880"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/x4Z9Hl60oa",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812595712489648383/video/1",
                                        "id_str": "1812595663009402880",
                                        "indices": [
                                            53,
                                            76
                                        ],
                                        "media_key": "13_1812595663009402880",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeiMLnW0AA3JNp.jpg",
                                        "type": "video",
                                        "url": "https://t.co/x4Z9Hl60oa",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 16362,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/pl/GigAnEeB3ueZuV3l.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/480x270/yQ9EePYCEI6YYdzF.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/640x360/bgCTkMURggNuH7FT.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/1280x720/tQH5UMMXMcCHX4D6.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595663009402880/vid/avc1/1920x1080/zruXNKVDGyt7zlpb.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812595663009402880"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 348,
                            "favorited": false,
                            "full_text": "Lamine Yamal wins Best Young Player of EURO 2024 👏🇪🇸 https://t.co/x4Z9Hl60oa",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 7,
                            "reply_count": 16,
                            "retweet_count": 62,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812595712489648383"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812619943638343903",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490909,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490909,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812619943638343903"
                            ],
                            "editable_until_msecs": "1721000846000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "63104",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                        "legacy": {
                            "bookmark_count": 7,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 22:47:26 +0000 2024",
                            "conversation_id_str": "1812619943638343903",
                            "display_text_range": [
                                0,
                                68
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/8eqh4isss5",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812619943638343903/video/1",
                                        "id_str": "1812619235560218624",
                                        "indices": [
                                            69,
                                            92
                                        ],
                                        "media_key": "13_1812619235560218624",
                                        "media_url_https": "https://pbs.twimg.com/media/GSe3zVmagAA9GU4.jpg",
                                        "type": "video",
                                        "url": "https://t.co/8EQH4iSsS5",
                                        "additional_media_info": {
                                            "title": "",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1280,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1280,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 22966,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/pl/4SwlbV1k9gFEwSLN.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/vid/avc1/320x568/W93MbviuZlk_8We8.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/vid/avc1/480x852/OFI4Z5BO6Os_sZ5X.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/vid/avc1/720x1280/3Tdb6vavWW7k84Aj.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812619235560218624"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/8EQH4iSsS5",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812619943638343903/video/1",
                                        "id_str": "1812619235560218624",
                                        "indices": [
                                            69,
                                            92
                                        ],
                                        "media_key": "13_1812619235560218624",
                                        "media_url_https": "https://pbs.twimg.com/media/GSe3zVmagAA9GU4.jpg",
                                        "type": "video",
                                        "url": "https://t.co/8EQH4iSsS5",
                                        "additional_media_info": {
                                            "title": "",
                                            "description": "",
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1280,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1280,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 22966,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/pl/4SwlbV1k9gFEwSLN.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/vid/avc1/320x568/W93MbviuZlk_8We8.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/vid/avc1/480x852/OFI4Z5BO6Os_sZ5X.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812619235560218624/vid/avc1/720x1280/3Tdb6vavWW7k84Aj.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812619235560218624"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 330,
                            "favorited": false,
                            "full_text": "Lamine Yamal was a little too eager to get on stage for the trophy 🤣 https://t.co/8EQH4iSsS5",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1,
                            "reply_count": 3,
                            "retweet_count": 19,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812619943638343903"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812556638207057957",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNjU5MDI3Mjk=",
                                    "rest_id": "265902729",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Mon Mar 14 09:44:40 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Official https://t.co/UU1K81mMof account. Also follow @bbcmotd and @bbctms.",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "bbc.co.uk/sport",
                                                        "expanded_url": "http://bbc.co.uk/sport",
                                                        "url": "https://t.co/UU1K81mMof",
                                                        "indices": [
                                                            9,
                                                            32
                                                        ]
                                                    }
                                                ]
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "bbc.co.uk/sport",
                                                        "expanded_url": "http://www.bbc.co.uk/sport",
                                                        "url": "https://t.co/LmA8PNogaZ",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 3018,
                                        "followers_count": 10738613,
                                        "friends_count": 710,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 23594,
                                        "location": "MediaCityUK, Salford",
                                        "media_count": 319150,
                                        "name": "BBC Sport",
                                        "normal_followers_count": 10738613,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/265902729/1717668051",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1486488950680215553/Rc0iOmOY_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BBCSport",
                                        "statuses_count": 616952,
                                        "translator_type": "none",
                                        "url": "https://t.co/LmA8PNogaZ",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1486877124971712512",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812556638207057957"
                            ],
                            "editable_until_msecs": "1720985752000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "164268",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                        "legacy": {
                            "bookmark_count": 15,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 18:35:52 +0000 2024",
                            "conversation_id_str": "1812556638207057957",
                            "display_text_range": [
                                0,
                                163
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            146,
                                            155
                                        ],
                                        "text": "Euro2024"
                                    },
                                    {
                                        "indices": [
                                            156,
                                            163
                                        ],
                                        "text": "ESPENG"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/l6iwux7udm",
                                        "expanded_url": "https://twitter.com/BBCSport/status/1812556638207057957/photo/1",
                                        "id_str": "1812556403128586240",
                                        "indices": [
                                            164,
                                            187
                                        ],
                                        "media_key": "3_1812556403128586240",
                                        "media_url_https": "https://pbs.twimg.com/media/GSd-cf_W0AAGzhd.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/L6Iwux7UdM",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 782,
                                                        "y": 370,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 857,
                                                        "h": 185,
                                                        "w": 185
                                                    },
                                                    {
                                                        "x": 531,
                                                        "y": 615,
                                                        "h": 264,
                                                        "w": 264
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 613,
                                                        "y": 290,
                                                        "h": 69,
                                                        "w": 69
                                                    },
                                                    {
                                                        "x": 6,
                                                        "y": 672,
                                                        "h": 145,
                                                        "w": 145
                                                    },
                                                    {
                                                        "x": 416,
                                                        "y": 482,
                                                        "h": 207,
                                                        "w": 207
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 347,
                                                        "y": 164,
                                                        "h": 39,
                                                        "w": 39
                                                    },
                                                    {
                                                        "x": 3,
                                                        "y": 380,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 273,
                                                        "h": 117,
                                                        "w": 117
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 782,
                                                        "y": 370,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 857,
                                                        "h": 185,
                                                        "w": 185
                                                    },
                                                    {
                                                        "x": 531,
                                                        "y": 615,
                                                        "h": 264,
                                                        "w": 264
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1530,
                                                "w": 1224,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1530,
                                            "width": 1224,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 461,
                                                    "w": 1224,
                                                    "h": 685
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 191,
                                                    "w": 1224,
                                                    "h": 1224
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 106,
                                                    "w": 1224,
                                                    "h": 1395
                                                },
                                                {
                                                    "x": 268,
                                                    "y": 0,
                                                    "w": 765,
                                                    "h": 1530
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1530
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812556403128586240"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/L6Iwux7UdM",
                                        "expanded_url": "https://twitter.com/BBCSport/status/1812556638207057957/photo/1",
                                        "id_str": "1812556403128586240",
                                        "indices": [
                                            164,
                                            187
                                        ],
                                        "media_key": "3_1812556403128586240",
                                        "media_url_https": "https://pbs.twimg.com/media/GSd-cf_W0AAGzhd.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/L6Iwux7UdM",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 782,
                                                        "y": 370,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 857,
                                                        "h": 185,
                                                        "w": 185
                                                    },
                                                    {
                                                        "x": 531,
                                                        "y": 615,
                                                        "h": 264,
                                                        "w": 264
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 613,
                                                        "y": 290,
                                                        "h": 69,
                                                        "w": 69
                                                    },
                                                    {
                                                        "x": 6,
                                                        "y": 672,
                                                        "h": 145,
                                                        "w": 145
                                                    },
                                                    {
                                                        "x": 416,
                                                        "y": 482,
                                                        "h": 207,
                                                        "w": 207
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 347,
                                                        "y": 164,
                                                        "h": 39,
                                                        "w": 39
                                                    },
                                                    {
                                                        "x": 3,
                                                        "y": 380,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 273,
                                                        "h": 117,
                                                        "w": 117
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 782,
                                                        "y": 370,
                                                        "h": 89,
                                                        "w": 89
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 857,
                                                        "h": 185,
                                                        "w": 185
                                                    },
                                                    {
                                                        "x": 531,
                                                        "y": 615,
                                                        "h": 264,
                                                        "w": 264
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1530,
                                                "w": 1224,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1530,
                                            "width": 1224,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 461,
                                                    "w": 1224,
                                                    "h": 685
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 191,
                                                    "w": 1224,
                                                    "h": 1224
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 106,
                                                    "w": 1224,
                                                    "h": 1395
                                                },
                                                {
                                                    "x": 268,
                                                    "y": 0,
                                                    "w": 765,
                                                    "h": 1530
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1224,
                                                    "h": 1530
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812556403128586240"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 643,
                            "favorited": false,
                            "full_text": "Lamine Yamal is the youngest ever male player to feature in a World Cup or Euros final ✨\n\nHe's surpassed Pele’s record from the 1958 World Cup 👏\n\n#Euro2024 #ESPENG https://t.co/L6Iwux7UdM",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 18,
                            "reply_count": 45,
                            "retweet_count": 90,
                            "retweeted": false,
                            "user_id_str": "265902729",
                            "id_str": "1812556638207057957"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812595387624042900",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMTk1OTMwODI=",
                                    "rest_id": "119593082",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/FOXSports",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1645557541609373707/v7MM_VT__bigger.jpg"
                                            },
                                            "description": "FOX Sports",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Mar 04 02:57:00 +0000 2010",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Home of 2024 Copa América, 2024 EUROS on FOX and so much more 🏆🌎",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "foxsports.com",
                                                        "expanded_url": "http://www.foxsports.com",
                                                        "url": "https://t.co/LgF8vIvyXR",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 10122,
                                        "followers_count": 1490902,
                                        "friends_count": 1485,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 6950,
                                        "location": "Los Angeles, CA",
                                        "media_count": 67250,
                                        "name": "FOX Soccer",
                                        "normal_followers_count": 1490902,
                                        "pinned_tweet_ids_str": [
                                            "1812687012979433506"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/119593082/1718048690",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1800266146119335936/eASNQqjo_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FOXSoccer",
                                        "statuses_count": 160783,
                                        "translator_type": "none",
                                        "url": "https://t.co/LgF8vIvyXR",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1601291265651318784",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812595387624042900"
                            ],
                            "editable_until_msecs": "1720994991000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "115781",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://wildmoka.com\" rel=\"nofollow\">Wildmoka</a>",
                        "legacy": {
                            "bookmark_count": 54,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 21:09:51 +0000 2024",
                            "conversation_id_str": "1812595387624042900",
                            "display_text_range": [
                                0,
                                66
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/q1doynqtli",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812595387624042900/video/1",
                                        "id_str": "1812595346930794496",
                                        "indices": [
                                            67,
                                            90
                                        ],
                                        "media_key": "13_1812595346930794496",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeh5S_WMAAq_C_.jpg",
                                        "type": "video",
                                        "url": "https://t.co/Q1DOYNQTLi",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 12159,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/pl/CNqiL-gju3zStlEd.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/480x270/7-ZgIzPx5i2kTQY4.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/640x360/pQaBcYrRkWiRzWTU.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/1280x720/QKQoZFbiyAnCIcBP.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/1920x1080/jQtUll7-9I7Ayg5X.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812595346930794496"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/Q1DOYNQTLi",
                                        "expanded_url": "https://twitter.com/FOXSoccer/status/1812595387624042900/video/1",
                                        "id_str": "1812595346930794496",
                                        "indices": [
                                            67,
                                            90
                                        ],
                                        "media_key": "13_1812595346930794496",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeh5S_WMAAq_C_.jpg",
                                        "type": "video",
                                        "url": "https://t.co/Q1DOYNQTLi",
                                        "additional_media_info": {
                                            "embeddable": true,
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 12159,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/pl/CNqiL-gju3zStlEd.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/480x270/7-ZgIzPx5i2kTQY4.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/640x360/pQaBcYrRkWiRzWTU.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/1280x720/QKQoZFbiyAnCIcBP.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812595346930794496/vid/avc1/1920x1080/jQtUll7-9I7Ayg5X.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812595346930794496"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 1168,
                            "favorited": false,
                            "full_text": "Lamine Yamal's teammates as he walks up to win Best Young Player 🤣 https://t.co/Q1DOYNQTLi",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 5,
                            "reply_count": 12,
                            "retweet_count": 104,
                            "retweeted": false,
                            "user_id_str": "119593082",
                            "id_str": "1812595387624042900"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812562962718011833",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNDI5MzMxMA==",
                                    "rest_id": "14293310",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Apr 03 13:54:30 +0000 2008",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "News and current events from around the globe. Since 1923. \nSubscribe: https://t.co/yT0dueLEm0",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "ti.me/subscribe",
                                                        "expanded_url": "http://ti.me/subscribe",
                                                        "url": "https://t.co/yT0dueLEm0",
                                                        "indices": [
                                                            71,
                                                            94
                                                        ]
                                                    }
                                                ]
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "time.com",
                                                        "expanded_url": "https://www.time.com",
                                                        "url": "https://t.co/vl89LXOvyB",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 570,
                                        "followers_count": 19230008,
                                        "friends_count": 482,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 102651,
                                        "location": "",
                                        "media_count": 31263,
                                        "name": "TIME",
                                        "normal_followers_count": 19230008,
                                        "pinned_tweet_ids_str": [
                                            "1873497455054016671"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/14293310/1722449916",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1821984581915987968/cv44xY5x_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "TIME",
                                        "statuses_count": 432397,
                                        "translator_type": "regular",
                                        "url": "https://t.co/vl89LXOvyB",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "card": {
                            "rest_id": "https://t.co/AVMYHz4ftu",
                            "legacy": {
                                "binding_values": [
                                    {
                                        "key": "photo_image_full_size_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image",
                                        "value": {
                                            "image_value": {
                                                "height": 147,
                                                "width": 240,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=240x240"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "description",
                                        "value": {
                                            "string_value": "Spain's Lamine Yamal is the youngest person to ever score a goal in the UEFA European Football Championship.",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "domain",
                                        "value": {
                                            "string_value": "time.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 320,
                                                "width": 522,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=800x320_1"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 628,
                                                "width": 1024,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "site",
                                        "value": {
                                            "scribe_key": "publisher_id",
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "14293310",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_small",
                                        "value": {
                                            "image_value": {
                                                "height": 202,
                                                "width": 386,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=386x202"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_large",
                                        "value": {
                                            "image_value": {
                                                "height": 419,
                                                "width": 800,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=800x419"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_small",
                                        "value": {
                                            "image_value": {
                                                "height": 61,
                                                "width": 100,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=100x100"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "creator",
                                        "value": {
                                            "type": "USER",
                                            "user_value": {
                                                "id_str": "1164388962401521666",
                                                "path": []
                                            }
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 628,
                                                "width": 1024,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_original",
                                        "value": {
                                            "image_value": {
                                                "height": 628,
                                                "width": 1024,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "vanity_url",
                                        "value": {
                                            "scribe_key": "vanity_url",
                                            "string_value": "time.com",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "thumbnail_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 40,
                                                            "green": 36,
                                                            "red": 42
                                                        },
                                                        "percentage": 58.93
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 24,
                                                            "green": 3,
                                                            "red": 156
                                                        },
                                                        "percentage": 13.23
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 86,
                                                            "green": 48,
                                                            "red": 36
                                                        },
                                                        "percentage": 8.74
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 47,
                                                            "green": 70,
                                                            "red": 102
                                                        },
                                                        "percentage": 6.93
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 7,
                                                            "green": 0,
                                                            "red": 99
                                                        },
                                                        "percentage": 3.48
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "title",
                                        "value": {
                                            "string_value": "Meet Lamine Yamal, the Spanish Teenager Dominating EURO 2024",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 40,
                                                            "green": 36,
                                                            "red": 42
                                                        },
                                                        "percentage": 58.93
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 24,
                                                            "green": 3,
                                                            "red": 156
                                                        },
                                                        "percentage": 13.23
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 86,
                                                            "green": 48,
                                                            "red": 36
                                                        },
                                                        "percentage": 8.74
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 47,
                                                            "green": 70,
                                                            "red": 102
                                                        },
                                                        "percentage": 6.93
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 7,
                                                            "green": 0,
                                                            "red": 99
                                                        },
                                                        "percentage": 3.48
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 628,
                                                "width": 1024,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image",
                                        "value": {
                                            "image_value": {
                                                "height": 314,
                                                "width": 600,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=600x314"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_color",
                                        "value": {
                                            "image_color_value": {
                                                "palette": [
                                                    {
                                                        "rgb": {
                                                            "blue": 40,
                                                            "green": 36,
                                                            "red": 42
                                                        },
                                                        "percentage": 58.93
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 24,
                                                            "green": 3,
                                                            "red": 156
                                                        },
                                                        "percentage": 13.23
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 86,
                                                            "green": 48,
                                                            "red": 36
                                                        },
                                                        "percentage": 8.74
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 47,
                                                            "green": 70,
                                                            "red": 102
                                                        },
                                                        "percentage": 6.93
                                                    },
                                                    {
                                                        "rgb": {
                                                            "blue": 7,
                                                            "green": 0,
                                                            "red": 99
                                                        },
                                                        "percentage": 3.48
                                                    }
                                                ]
                                            },
                                            "type": "IMAGE_COLOR"
                                        }
                                    },
                                    {
                                        "key": "photo_image_full_size_x_large",
                                        "value": {
                                            "image_value": {
                                                "height": 628,
                                                "width": 1024,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=png&name=2048x2048_2_exp"
                                            },
                                            "type": "IMAGE"
                                        }
                                    },
                                    {
                                        "key": "card_url",
                                        "value": {
                                            "scribe_key": "card_url",
                                            "string_value": "https://t.co/AVMYHz4ftu",
                                            "type": "STRING"
                                        }
                                    },
                                    {
                                        "key": "summary_photo_image_original",
                                        "value": {
                                            "image_value": {
                                                "height": 628,
                                                "width": 1024,
                                                "url": "https://pbs.twimg.com/card_img/1872780957373075456/WYLtqEuv?format=jpg&name=orig"
                                            },
                                            "type": "IMAGE"
                                        }
                                    }
                                ],
                                "card_platform": {
                                    "platform": {
                                        "audience": {
                                            "name": "production"
                                        },
                                        "device": {
                                            "name": "Swift",
                                            "version": "12"
                                        }
                                    }
                                },
                                "name": "summary_large_image",
                                "url": "https://t.co/AVMYHz4ftu",
                                "user_refs_results": [
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxMTY0Mzg4OTYyNDAxNTIxNjY2",
                                            "rest_id": "1164388962401521666",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Thu Aug 22 04:09:14 +0000 2019",
                                                "default_profile": true,
                                                "default_profile_image": false,
                                                "description": "Freelance journalist covering Israel-Hamas war. Prev: Reporter @TIME, words in @AJEnglish and @TheEconomist. Email: ag4343@columbia.edu",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 2320,
                                                "followers_count": 605,
                                                "friends_count": 2142,
                                                "has_custom_timelines": false,
                                                "is_translator": false,
                                                "listed_count": 4,
                                                "location": "Arizona, USA ",
                                                "media_count": 0,
                                                "name": "Anna Gordon",
                                                "normal_followers_count": 605,
                                                "pinned_tweet_ids_str": [
                                                    "1845913109128532379"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/1164388962401521666/1699888741",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1724084593383428096/419TXiTv_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "AnnaGordon0111",
                                                "statuses_count": 201,
                                                "translator_type": "none",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1685957935942254593",
                                                "professional_type": "Creator",
                                                "category": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    },
                                    {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxNDI5MzMxMA==",
                                            "rest_id": "14293310",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Thu Apr 03 13:54:30 +0000 2008",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "News and current events from around the globe. Since 1923. \nSubscribe: https://t.co/yT0dueLEm0",
                                                "entities": {
                                                    "description": {
                                                        "urls": [
                                                            {
                                                                "display_url": "ti.me/subscribe",
                                                                "expanded_url": "http://ti.me/subscribe",
                                                                "url": "https://t.co/yT0dueLEm0",
                                                                "indices": [
                                                                    71,
                                                                    94
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "time.com",
                                                                "expanded_url": "https://www.time.com",
                                                                "url": "https://t.co/vl89LXOvyB",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 570,
                                                "followers_count": 19230008,
                                                "friends_count": 482,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 102651,
                                                "location": "",
                                                "media_count": 31263,
                                                "name": "TIME",
                                                "normal_followers_count": 19230008,
                                                "pinned_tweet_ids_str": [
                                                    "1873497455054016671"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/14293310/1722449916",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1821984581915987968/cv44xY5x_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "TIME",
                                                "statuses_count": 432397,
                                                "translator_type": "regular",
                                                "url": "https://t.co/vl89LXOvyB",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "tipjar_settings": {
                                                "is_enabled": false,
                                                "bandcamp_handle": "",
                                                "bitcoin_handle": "",
                                                "cash_app_handle": "",
                                                "ethereum_handle": "",
                                                "gofundme_handle": "",
                                                "patreon_handle": "",
                                                "pay_pal_handle": "",
                                                "venmo_handle": ""
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812562962718011833"
                            ],
                            "editable_until_msecs": "1720987260000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "58293",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://www.sprinklr.com\" rel=\"nofollow\">Sprinklr</a>",
                        "legacy": {
                            "bookmark_count": 3,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 19:01:00 +0000 2024",
                            "conversation_id_str": "1812562962718011833",
                            "display_text_range": [
                                0,
                                104
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "ti.me/4f3LbY8",
                                        "expanded_url": "https://ti.me/4f3LbY8",
                                        "url": "https://t.co/AVMYHz4ftu",
                                        "indices": [
                                            81,
                                            104
                                        ]
                                    }
                                ],
                                "user_mentions": []
                            },
                            "favorite_count": 96,
                            "favorited": false,
                            "full_text": "Everything to know about Lamine Yamal, the Spanish teenager dominating EURO 2024\nhttps://t.co/AVMYHz4ftu",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 1,
                            "reply_count": 13,
                            "retweet_count": 23,
                            "retweeted": false,
                            "user_id_str": "14293310",
                            "id_str": "1812562962718011833"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812526406904979682",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo2MTM0ODgy",
                                    "rest_id": "6134882",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/DeutscheWelle",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/900269457976823808/nkod9w_m_bigger.jpg"
                                            },
                                            "description": "DW Deutsche Welle",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Fri May 18 11:00:50 +0000 2007",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "We really know Germany. Follow us for trustworthy news and analysis from our reporters around the world, also on WhatsApp: https://t.co/YgpwoHoLF7",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "tinyurl.com/3w935pc7",
                                                        "expanded_url": "https://tinyurl.com/3w935pc7",
                                                        "url": "https://t.co/YgpwoHoLF7",
                                                        "indices": [
                                                            123,
                                                            146
                                                        ]
                                                    }
                                                ]
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "dw.com",
                                                        "expanded_url": "http://www.dw.com",
                                                        "url": "https://t.co/FCJh9TCD8V",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 4499,
                                        "followers_count": 731249,
                                        "friends_count": 600,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 9368,
                                        "location": "Germany",
                                        "media_count": 131180,
                                        "name": "DW News",
                                        "normal_followers_count": 731249,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/6134882/1717498010",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1796098295812567041/Pe_t5loe_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "dwnews",
                                        "statuses_count": 345891,
                                        "translator_type": "none",
                                        "url": "https://t.co/FCJh9TCD8V",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1457115893671108611",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 580,
                                                "name": "Media & News Company",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812526406904979682"
                            ],
                            "editable_until_msecs": "1720978545000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "7640",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                        "legacy": {
                            "bookmark_count": 0,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 16:35:45 +0000 2024",
                            "conversation_id_str": "1812526406904979682",
                            "display_text_range": [
                                0,
                                276
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            82,
                                            91
                                        ],
                                        "text": "EURO2024"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/cazcpd7djx",
                                        "expanded_url": "https://twitter.com/dw_sports/status/1812151238592463121/video/1",
                                        "id_str": "1810818451591909376",
                                        "indices": [
                                            253,
                                            276
                                        ],
                                        "media_key": "7_1810818451591909376",
                                        "media_url_https": "https://pbs.twimg.com/media/GSFSZYTW0AAkqwQ.jpg",
                                        "source_status_id_str": "1812151238592463121",
                                        "source_user_id_str": "31697485",
                                        "type": "video",
                                        "url": "https://t.co/CAZcPD7dJx",
                                        "additional_media_info": {
                                            "title": "Lamine Yamal wants to win the Euros for his 17th birthday",
                                            "description": "Spain's young teenage prodigy Lamine Yamal turns 17 one day before the final of the European Championship. He might yet become the youngest ever player to win the trophy.",
                                            "embeddable": true,
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjozMTY5NzQ4NQ==",
                                                        "rest_id": "31697485",
                                                        "affiliates_highlighted_label": {
                                                            "label": {
                                                                "url": {
                                                                    "url": "https://twitter.com/DeutscheWelle",
                                                                    "urlType": "DeepLink"
                                                                },
                                                                "badge": {
                                                                    "url": "https://pbs.twimg.com/profile_images/900269457976823808/nkod9w_m_bigger.jpg"
                                                                },
                                                                "description": "DW Deutsche Welle",
                                                                "userLabelType": "BusinessLabel",
                                                                "userLabelDisplayType": "Badge"
                                                            }
                                                        },
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Square",
                                                        "legacy": {
                                                            "created_at": "Thu Apr 16 08:49:45 +0000 2009",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "News and background stories from football and the world of sports | Germany's international broadcaster.",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "dw.com/sports",
                                                                            "expanded_url": "http://www.dw.com/sports",
                                                                            "url": "https://t.co/XiqExbYECd",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 3490,
                                                            "followers_count": 103835,
                                                            "friends_count": 1101,
                                                            "has_custom_timelines": false,
                                                            "is_translator": false,
                                                            "listed_count": 1123,
                                                            "location": "Germany",
                                                            "media_count": 40615,
                                                            "name": "DW Sports",
                                                            "normal_followers_count": 103835,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/31697485/1718443064",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1799017738398298113/U3hntoN5_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "dw_sports",
                                                            "statuses_count": 149693,
                                                            "translator_type": "none",
                                                            "url": "https://t.co/XiqExbYECd",
                                                            "verified": false,
                                                            "verified_type": "Business",
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1280,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1280,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 25000,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/pl/82T_7RKqjmIufY9p.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/320x568/URXQkUO4hT9DAmjr.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/480x852/ehKgdsZCoyCtE0hK.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/720x1280/HqyflS1NbpJAHZop.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/1080x1920/O8v0eTboq0TgbaN1.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1810818451591909376"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/CAZcPD7dJx",
                                        "expanded_url": "https://twitter.com/dw_sports/status/1812151238592463121/video/1",
                                        "id_str": "1810818451591909376",
                                        "indices": [
                                            253,
                                            276
                                        ],
                                        "media_key": "7_1810818451591909376",
                                        "media_url_https": "https://pbs.twimg.com/media/GSFSZYTW0AAkqwQ.jpg",
                                        "source_status_id_str": "1812151238592463121",
                                        "source_user_id_str": "31697485",
                                        "type": "video",
                                        "url": "https://t.co/CAZcPD7dJx",
                                        "additional_media_info": {
                                            "title": "Lamine Yamal wants to win the Euros for his 17th birthday",
                                            "description": "Spain's young teenage prodigy Lamine Yamal turns 17 one day before the final of the European Championship. He might yet become the youngest ever player to win the trophy.",
                                            "embeddable": true,
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjozMTY5NzQ4NQ==",
                                                        "rest_id": "31697485",
                                                        "affiliates_highlighted_label": {
                                                            "label": {
                                                                "url": {
                                                                    "url": "https://twitter.com/DeutscheWelle",
                                                                    "urlType": "DeepLink"
                                                                },
                                                                "badge": {
                                                                    "url": "https://pbs.twimg.com/profile_images/900269457976823808/nkod9w_m_bigger.jpg"
                                                                },
                                                                "description": "DW Deutsche Welle",
                                                                "userLabelType": "BusinessLabel",
                                                                "userLabelDisplayType": "Badge"
                                                            }
                                                        },
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Square",
                                                        "legacy": {
                                                            "created_at": "Thu Apr 16 08:49:45 +0000 2009",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "News and background stories from football and the world of sports | Germany's international broadcaster.",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "dw.com/sports",
                                                                            "expanded_url": "http://www.dw.com/sports",
                                                                            "url": "https://t.co/XiqExbYECd",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 3490,
                                                            "followers_count": 103835,
                                                            "friends_count": 1101,
                                                            "has_custom_timelines": false,
                                                            "is_translator": false,
                                                            "listed_count": 1123,
                                                            "location": "Germany",
                                                            "media_count": 40615,
                                                            "name": "DW Sports",
                                                            "normal_followers_count": 103835,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/31697485/1718443064",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1799017738398298113/U3hntoN5_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "dw_sports",
                                                            "statuses_count": 149693,
                                                            "translator_type": "none",
                                                            "url": "https://t.co/XiqExbYECd",
                                                            "verified": false,
                                                            "verified_type": "Business",
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1280,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 675,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 383,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1280,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": false
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                9,
                                                16
                                            ],
                                            "duration_millis": 25000,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/pl/82T_7RKqjmIufY9p.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/320x568/URXQkUO4hT9DAmjr.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/480x852/ehKgdsZCoyCtE0hK.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/720x1280/HqyflS1NbpJAHZop.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 10368000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810818451591909376/pu/vid/avc1/1080x1920/O8v0eTboq0TgbaN1.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1810818451591909376"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 35,
                            "favorited": false,
                            "full_text": "Spain's young football star Lamine Yamal turned 17 just a day before the final of #EURO2024 against England, which is due to start in Berlin shortly: \"I told my mom she doesn't need to get me anything, winning the final with Spain is more than enough!\" https://t.co/CAZcPD7dJx",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 0,
                            "reply_count": 2,
                            "retweet_count": 5,
                            "retweeted": false,
                            "user_id_str": "6134882",
                            "id_str": "1812526406904979682"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812108727220052393",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo5Njk1MTgwMA==",
                                    "rest_id": "96951800",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Tue Dec 15 09:53:50 +0000 2009",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "\uD83D\uDC99 1899–2024: 125TH ANNIVERSARY ❤️ FC Barcelona official account",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "barca.link/qsa050UAIWR",
                                                        "expanded_url": "http://barca.link/qsa050UAIWR",
                                                        "url": "https://t.co/7NXU6ZqyNl",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 5185,
                                        "followers_count": 49482505,
                                        "friends_count": 119,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 34868,
                                        "location": "POLSERES BLAUGRANES \uD83D\uDC99❤",
                                        "media_count": 95210,
                                        "name": "FC Barcelona",
                                        "normal_followers_count": 49482505,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/96951800/1731072309",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1834115251274452992/7m_GC0Wu_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FCBarcelona",
                                        "statuses_count": 146710,
                                        "translator_type": "regular",
                                        "url": "https://t.co/7NXU6ZqyNl",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812108727220052393"
                            ],
                            "editable_until_msecs": "1720878962000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "155561",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 81,
                            "bookmarked": false,
                            "created_at": "Sat Jul 13 12:56:02 +0000 2024",
                            "conversation_id_str": "1812108727220052393",
                            "display_text_range": [
                                0,
                                47
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            30,
                                            47
                                        ],
                                        "text": "LaLigaHighlights"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/N1SmMrB1UQ",
                                        "expanded_url": "https://x.com/FCBarcelona/status/1812108727220052393/video/1",
                                        "id_str": "1812108609376882688",
                                        "indices": [
                                            48,
                                            71
                                        ],
                                        "media_key": "13_1812108609376882688",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1812108609376882688/img/3w7R6OUgRouAkqK0.jpg",
                                        "type": "video",
                                        "url": "https://t.co/N1SmMrB1UQ",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 720,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 720,
                                            "width": 1280,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 204040,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/pl/f51HQseXR0I6MaDA.m3u8?tag=16&v=368"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/vid/avc1/480x270/iVIPCJ1yHUAT9-Zi.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/vid/avc1/640x360/4isuH9Fa3d0v4C-v.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/vid/avc1/1280x720/c8lZYjL8vTeTRR4_.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812108609376882688"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.x.com/N1SmMrB1UQ",
                                        "expanded_url": "https://x.com/FCBarcelona/status/1812108727220052393/video/1",
                                        "id_str": "1812108609376882688",
                                        "indices": [
                                            48,
                                            71
                                        ],
                                        "media_key": "13_1812108609376882688",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1812108609376882688/img/3w7R6OUgRouAkqK0.jpg",
                                        "type": "video",
                                        "url": "https://t.co/N1SmMrB1UQ",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 720,
                                                "w": 1280,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 720,
                                            "width": 1280,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 204040,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/pl/f51HQseXR0I6MaDA.m3u8?tag=16&v=368"
                                                },
                                                {
                                                    "bitrate": 288000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/vid/avc1/480x270/iVIPCJ1yHUAT9-Zi.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/vid/avc1/640x360/4isuH9Fa3d0v4C-v.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1812108609376882688/vid/avc1/1280x720/c8lZYjL8vTeTRR4_.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1812108609376882688"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 4966,
                            "favorited": false,
                            "full_text": "Reminder. Lamine Yamal is 17.\n#LaLigaHighlights https://t.co/N1SmMrB1UQ",
                            "is_quote_status": false,
                            "lang": "tr",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 22,
                            "reply_count": 59,
                            "retweet_count": 484,
                            "retweeted": false,
                            "user_id_str": "96951800",
                            "id_str": "1812108727220052393"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812579937662242964",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxMzc2MjY4MTk4NDU5NDE2NTg0",
                                    "rest_id": "1376268198459416584",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": false,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun Mar 28 20:21:31 +0000 2021",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "🐍🐢 🤖 🔜📃✍️ Self-Taught Journalist\n(Tutor: @jfelixdiaz)",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "twitter.com/realmadrid/sta…",
                                                        "expanded_url": "https://twitter.com/realmadrid/status/470302366919839744?s=19",
                                                        "url": "https://t.co/Uu1OL6J23B",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 69041,
                                        "followers_count": 5296,
                                        "friends_count": 652,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 24,
                                        "location": "🌍",
                                        "media_count": 4809,
                                        "name": "Gina",
                                        "normal_followers_count": 5296,
                                        "pinned_tweet_ids_str": [
                                            "1533802234147917824"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1376268198459416584/1649805330",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1719408121083301888/bre00Q7z_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Serginaoo",
                                        "statuses_count": 38889,
                                        "translator_type": "none",
                                        "url": "https://t.co/Uu1OL6J23B",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812579937662242964"
                            ],
                            "editable_until_msecs": "1720991307000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "671",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/android\" rel=\"nofollow\">Twitter for Android</a>",
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1810812474259652688",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxMzc2MjY4MTk4NDU5NDE2NTg0",
                                            "rest_id": "1376268198459416584",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": false,
                                            "profile_image_shape": "Circle",
                                            "legacy": {
                                                "created_at": "Sun Mar 28 20:21:31 +0000 2021",
                                                "default_profile": true,
                                                "default_profile_image": false,
                                                "description": "🐍🐢 🤖 🔜📃✍️ Self-Taught Journalist\n(Tutor: @jfelixdiaz)",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "twitter.com/realmadrid/sta…",
                                                                "expanded_url": "https://twitter.com/realmadrid/status/470302366919839744?s=19",
                                                                "url": "https://t.co/Uu1OL6J23B",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 69041,
                                                "followers_count": 5296,
                                                "friends_count": 652,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 24,
                                                "location": "🌍",
                                                "media_count": 4809,
                                                "name": "Gina",
                                                "normal_followers_count": 5296,
                                                "pinned_tweet_ids_str": [
                                                    "1533802234147917824"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/1376268198459416584/1649805330",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1719408121083301888/bre00Q7z_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "Serginaoo",
                                                "statuses_count": 38889,
                                                "translator_type": "none",
                                                "url": "https://t.co/Uu1OL6J23B",
                                                "verified": false,
                                                "withheld_in_countries": []
                                            }
                                        }
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1810812474259652688"
                                    ],
                                    "editable_until_msecs": "1720569911000",
                                    "is_edit_eligible": true,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "1121",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"http://twitter.com/download/android\" rel=\"nofollow\">Twitter for Android</a>",
                                "legacy": {
                                    "bookmark_count": 0,
                                    "bookmarked": false,
                                    "created_at": "Tue Jul 09 23:05:11 +0000 2024",
                                    "conversation_id_str": "1810812474259652688",
                                    "display_text_range": [
                                        0,
                                        164
                                    ],
                                    "entities": {
                                        "hashtags": [],
                                        "media": [
                                            {
                                                "display_url": "pic.x.com/dtdyixwblh",
                                                "expanded_url": "https://twitter.com/Serginaoo/status/1810812474259652688/photo/1",
                                                "id_str": "1810802013061664770",
                                                "indices": [
                                                    165,
                                                    188
                                                ],
                                                "media_key": "3_1810802013061664770",
                                                "media_url_https": "https://pbs.twimg.com/media/GSFC1jsaUAI5fF2.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/DTdyIXwBLH",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": [
                                                            {
                                                                "x": 479,
                                                                "y": 90,
                                                                "h": 71,
                                                                "w": 71
                                                            },
                                                            {
                                                                "x": 762,
                                                                "y": 59,
                                                                "h": 78,
                                                                "w": 78
                                                            },
                                                            {
                                                                "x": 686,
                                                                "y": 515,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    },
                                                    "medium": {
                                                        "faces": [
                                                            {
                                                                "x": 442,
                                                                "y": 83,
                                                                "h": 65,
                                                                "w": 65
                                                            },
                                                            {
                                                                "x": 703,
                                                                "y": 54,
                                                                "h": 72,
                                                                "w": 72
                                                            },
                                                            {
                                                                "x": 633,
                                                                "y": 475,
                                                                "h": 75,
                                                                "w": 75
                                                            }
                                                        ]
                                                    },
                                                    "small": {
                                                        "faces": [
                                                            {
                                                                "x": 250,
                                                                "y": 47,
                                                                "h": 37,
                                                                "w": 37
                                                            },
                                                            {
                                                                "x": 398,
                                                                "y": 30,
                                                                "h": 40,
                                                                "w": 40
                                                            },
                                                            {
                                                                "x": 358,
                                                                "y": 269,
                                                                "h": 42,
                                                                "w": 42
                                                            }
                                                        ]
                                                    },
                                                    "orig": {
                                                        "faces": [
                                                            {
                                                                "x": 479,
                                                                "y": 90,
                                                                "h": 71,
                                                                "w": 71
                                                            },
                                                            {
                                                                "x": 762,
                                                                "y": 59,
                                                                "h": 78,
                                                                "w": 78
                                                            },
                                                            {
                                                                "x": 686,
                                                                "y": 515,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 735,
                                                        "w": 1300,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 678,
                                                        "w": 1200,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 384,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 735,
                                                    "width": 1300,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1300,
                                                            "h": 728
                                                        },
                                                        {
                                                            "x": 510,
                                                            "y": 0,
                                                            "w": 735,
                                                            "h": 735
                                                        },
                                                        {
                                                            "x": 555,
                                                            "y": 0,
                                                            "w": 645,
                                                            "h": 735
                                                        },
                                                        {
                                                            "x": 693,
                                                            "y": 0,
                                                            "w": 368,
                                                            "h": 735
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1300,
                                                            "h": 735
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1810802013061664770"
                                                    }
                                                }
                                            }
                                        ],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": []
                                    },
                                    "extended_entities": {
                                        "media": [
                                            {
                                                "display_url": "pic.twitter.com/DTdyIXwBLH",
                                                "expanded_url": "https://twitter.com/Serginaoo/status/1810812474259652688/photo/1",
                                                "id_str": "1810802013061664770",
                                                "indices": [
                                                    165,
                                                    188
                                                ],
                                                "media_key": "3_1810802013061664770",
                                                "media_url_https": "https://pbs.twimg.com/media/GSFC1jsaUAI5fF2.jpg",
                                                "type": "photo",
                                                "url": "https://t.co/DTdyIXwBLH",
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "features": {
                                                    "large": {
                                                        "faces": [
                                                            {
                                                                "x": 479,
                                                                "y": 90,
                                                                "h": 71,
                                                                "w": 71
                                                            },
                                                            {
                                                                "x": 762,
                                                                "y": 59,
                                                                "h": 78,
                                                                "w": 78
                                                            },
                                                            {
                                                                "x": 686,
                                                                "y": 515,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    },
                                                    "medium": {
                                                        "faces": [
                                                            {
                                                                "x": 442,
                                                                "y": 83,
                                                                "h": 65,
                                                                "w": 65
                                                            },
                                                            {
                                                                "x": 703,
                                                                "y": 54,
                                                                "h": 72,
                                                                "w": 72
                                                            },
                                                            {
                                                                "x": 633,
                                                                "y": 475,
                                                                "h": 75,
                                                                "w": 75
                                                            }
                                                        ]
                                                    },
                                                    "small": {
                                                        "faces": [
                                                            {
                                                                "x": 250,
                                                                "y": 47,
                                                                "h": 37,
                                                                "w": 37
                                                            },
                                                            {
                                                                "x": 398,
                                                                "y": 30,
                                                                "h": 40,
                                                                "w": 40
                                                            },
                                                            {
                                                                "x": 358,
                                                                "y": 269,
                                                                "h": 42,
                                                                "w": 42
                                                            }
                                                        ]
                                                    },
                                                    "orig": {
                                                        "faces": [
                                                            {
                                                                "x": 479,
                                                                "y": 90,
                                                                "h": 71,
                                                                "w": 71
                                                            },
                                                            {
                                                                "x": 762,
                                                                "y": 59,
                                                                "h": 78,
                                                                "w": 78
                                                            },
                                                            {
                                                                "x": 686,
                                                                "y": 515,
                                                                "h": 82,
                                                                "w": 82
                                                            }
                                                        ]
                                                    }
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 735,
                                                        "w": 1300,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 678,
                                                        "w": 1200,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 384,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 735,
                                                    "width": 1300,
                                                    "focus_rects": [
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1300,
                                                            "h": 728
                                                        },
                                                        {
                                                            "x": 510,
                                                            "y": 0,
                                                            "w": 735,
                                                            "h": 735
                                                        },
                                                        {
                                                            "x": 555,
                                                            "y": 0,
                                                            "w": 645,
                                                            "h": 735
                                                        },
                                                        {
                                                            "x": 693,
                                                            "y": 0,
                                                            "w": 368,
                                                            "h": 735
                                                        },
                                                        {
                                                            "x": 0,
                                                            "y": 0,
                                                            "w": 1300,
                                                            "h": 735
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "3_1810802013061664770"
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "favorite_count": 8,
                                    "favorited": false,
                                    "full_text": "A 21 yr old and a 16 yr old are leading Spain in European tournament. \n\nThe level of talent and maturity Nico Williams and Lamine Yamal possess is truly remarkable. https://t.co/DTdyIXwBLH",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 1,
                                    "reply_count": 0,
                                    "retweet_count": 1,
                                    "retweeted": false,
                                    "user_id_str": "1376268198459416584",
                                    "id_str": "1810812474259652688"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 0,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 20:08:27 +0000 2024",
                            "conversation_id_str": "1812579937662242964",
                            "display_text_range": [
                                0,
                                105
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/donqymi0by",
                                        "expanded_url": "https://twitter.com/DivinaFaus68446/status/1812579239159619891/video/1",
                                        "id_str": "1812579207580467200",
                                        "indices": [
                                            82,
                                            105
                                        ],
                                        "media_key": "7_1812579207580467200",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1812579207580467200/pu/img/_tNx-Vk0PoSzyCKP.jpg",
                                        "source_status_id_str": "1812579239159619891",
                                        "source_user_id_str": "1791601027046584320",
                                        "type": "video",
                                        "url": "https://t.co/DoNQymI0bY",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjoxNzkxNjAxMDI3MDQ2NTg0MzIw",
                                                        "rest_id": "1791601027046584320",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": false,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Fri May 17 22:45:47 +0000 2024",
                                                            "default_profile": true,
                                                            "default_profile_image": false,
                                                            "description": "",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 20,
                                                            "followers_count": 143,
                                                            "friends_count": 7,
                                                            "has_custom_timelines": false,
                                                            "is_translator": false,
                                                            "listed_count": 2,
                                                            "location": "",
                                                            "media_count": 23,
                                                            "name": ".",
                                                            "normal_followers_count": 143,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1812576683376975872/JLGf29aG_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "DivinaFaus68446",
                                                            "statuses_count": 23,
                                                            "translator_type": "none",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "reason": "Dmcaed",
                                            "status": "Unavailable"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 10150,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/pl/E7yQTIvoX2LDPygn.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 256000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/vid/avc1/480x270/UNDmJzFkjXgX3aoH.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/vid/avc1/640x360/u0_UaQo-KShpE9IT.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/vid/avc1/1280x720/l9kDx5sfE9ATHZ8l.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1812579207580467200"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/DoNQymI0bY",
                                        "expanded_url": "https://twitter.com/DivinaFaus68446/status/1812579239159619891/video/1",
                                        "id_str": "1812579207580467200",
                                        "indices": [
                                            82,
                                            105
                                        ],
                                        "media_key": "7_1812579207580467200",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1812579207580467200/pu/img/_tNx-Vk0PoSzyCKP.jpg",
                                        "source_status_id_str": "1812579239159619891",
                                        "source_user_id_str": "1791601027046584320",
                                        "type": "video",
                                        "url": "https://t.co/DoNQymI0bY",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjoxNzkxNjAxMDI3MDQ2NTg0MzIw",
                                                        "rest_id": "1791601027046584320",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": false,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Fri May 17 22:45:47 +0000 2024",
                                                            "default_profile": true,
                                                            "default_profile_image": false,
                                                            "description": "",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 20,
                                                            "followers_count": 143,
                                                            "friends_count": 7,
                                                            "has_custom_timelines": false,
                                                            "is_translator": false,
                                                            "listed_count": 2,
                                                            "location": "",
                                                            "media_count": 23,
                                                            "name": ".",
                                                            "normal_followers_count": 143,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1812576683376975872/JLGf29aG_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "DivinaFaus68446",
                                                            "statuses_count": 23,
                                                            "translator_type": "none",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "reason": "Dmcaed",
                                            "status": "Unavailable"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 10150,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/pl/E7yQTIvoX2LDPygn.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 256000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/vid/avc1/480x270/UNDmJzFkjXgX3aoH.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/vid/avc1/640x360/u0_UaQo-KShpE9IT.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1812579207580467200/pu/vid/avc1/1280x720/l9kDx5sfE9ATHZ8l.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1812579207580467200"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 2,
                            "favorited": false,
                            "full_text": "Lamine Yamal to Nico Williams and it's a goal. Incredible story for both of them.\nhttps://t.co/DoNQymI0bY",
                            "is_quote_status": true,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 0,
                            "quoted_status_id_str": "1810812474259652688",
                            "quoted_status_permalink": {
                                "url": "https://t.co/iGg2rlSnYy",
                                "expanded": "https://twitter.com/Serginaoo/status/1810812474259652688",
                                "display": "x.com/Serginaoo/stat…"
                            },
                            "reply_count": 0,
                            "retweet_count": 0,
                            "retweeted": false,
                            "user_id_str": "1376268198459416584",
                            "id_str": "1812579937662242964"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812592001877221438",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxNDk3NTcwMDIzOTI1MTE2OTI5",
                                    "rest_id": "1497570023925116929",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": false,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sat Feb 26 13:54:15 +0000 2022",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "\uD83D\uDC99❤️ Welcome to | \uD835\uDE3D\uD835\uDE56\uD835\uDE67\uD835\uDE58\uD835\uDE56 \uD835\uDE53\uD835\uDE44 | A page for all things Barça such as News \uD83D\uDDDE • Quotes \uD83D\uDDE3 • Stats \uD83D\uDCCA • Threads \uD83E\uDDF5• Game highlights \uD83C\uDFA5 • Memes \uD83D\uDE02• Messi \uD83D\uDC10⭐️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6782,
                                        "followers_count": 15276,
                                        "friends_count": 408,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 0,
                                        "location": "Spotify Camp Nou \uD83C\uDFDF",
                                        "media_count": 5830,
                                        "name": "Barça Eleven \uD83D\uDC94",
                                        "normal_followers_count": 15276,
                                        "pinned_tweet_ids_str": [
                                            "1676880350314909696"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1497570023925116929/1725431836",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1831219912003502080/KGDHGcHW_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "BarcaEleven_",
                                        "statuses_count": 10714,
                                        "translator_type": "none",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1498286082290446344",
                                        "professional_type": "Creator",
                                        "category": [
                                            {
                                                "id": 579,
                                                "name": "Media & News",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812592001877221438"
                            ],
                            "editable_until_msecs": "1720994184000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "553",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 1,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 20:56:24 +0000 2024",
                            "conversation_id_str": "1812592001877221438",
                            "display_text_range": [
                                0,
                                88
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 19,
                            "favorited": false,
                            "full_text": "Lamine Yamal deadass won the Euros at 16 while being the best player. WHAT THE FARKKKKKK",
                            "is_quote_status": false,
                            "lang": "en",
                            "quote_count": 0,
                            "reply_count": 0,
                            "retweet_count": 1,
                            "retweeted": false,
                            "user_id_str": "1497570023925116929",
                            "id_str": "1812592001877221438"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812594806415331460",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo5NDU4MTcxMzU4MTY2NTQ4NDg=",
                                    "rest_id": "945817135816654848",
                                    "affiliates_highlighted_label": {
                                        "label": {
                                            "url": {
                                                "url": "https://twitter.com/workweekinc",
                                                "urlType": "DeepLink"
                                            },
                                            "badge": {
                                                "url": "https://pbs.twimg.com/profile_images/1451596150482604042/JYP1L5G6_bigger.jpg"
                                            },
                                            "description": "Workweek 🤝",
                                            "userLabelType": "BusinessLabel",
                                            "userLabelDisplayType": "Badge"
                                        }
                                    },
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Dec 27 00:42:32 +0000 2017",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Write on business with @workweekinc. Co-host @niapodcast. Building an AI research app: https://t.co/fZ5ObIyBGI",
                                        "entities": {
                                            "description": {
                                                "urls": [
                                                    {
                                                        "display_url": "Bearly.AI",
                                                        "expanded_url": "http://Bearly.AI",
                                                        "url": "https://t.co/fZ5ObIyBGI",
                                                        "indices": [
                                                            87,
                                                            110
                                                        ]
                                                    }
                                                ]
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "readtrung.com",
                                                        "expanded_url": "https://www.readtrung.com",
                                                        "url": "https://t.co/QXcmEZDThE",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 155482,
                                        "followers_count": 705302,
                                        "friends_count": 4195,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 5858,
                                        "location": "My Saturday newsletter ➡️",
                                        "media_count": 12152,
                                        "name": "Trung Phan",
                                        "normal_followers_count": 705302,
                                        "pinned_tweet_ids_str": [
                                            "1779155645880553603"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/945817135816654848/1670800079",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1506362585448296448/LJg8kVSD_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "TrungTPhan",
                                        "statuses_count": 64976,
                                        "translator_type": "none",
                                        "url": "https://t.co/QXcmEZDThE",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1466620402755522571",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812594806415331460"
                            ],
                            "editable_until_msecs": "1720994852000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "193067",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 38,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 21:07:32 +0000 2024",
                            "conversation_id_str": "1812594806415331460",
                            "display_text_range": [
                                0,
                                280
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/i2tqbcbgno",
                                        "expanded_url": "https://twitter.com/TrungTPhan/status/1790154665147220430/video/1",
                                        "id_str": "1790154520737325056",
                                        "indices": [
                                            257,
                                            280
                                        ],
                                        "media_key": "13_1790154520737325056",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1790154520737325056/img/xj_H8FDuu_NmznmZ.jpg",
                                        "source_status_id_str": "1790154665147220430",
                                        "source_user_id_str": "945817135816654848",
                                        "type": "video",
                                        "url": "https://t.co/i2tqbcBGNO",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjo5NDU4MTcxMzU4MTY2NTQ4NDg=",
                                                        "rest_id": "945817135816654848",
                                                        "affiliates_highlighted_label": {
                                                            "label": {
                                                                "url": {
                                                                    "url": "https://twitter.com/workweekinc",
                                                                    "urlType": "DeepLink"
                                                                },
                                                                "badge": {
                                                                    "url": "https://pbs.twimg.com/profile_images/1451596150482604042/JYP1L5G6_bigger.jpg"
                                                                },
                                                                "description": "Workweek 🤝",
                                                                "userLabelType": "BusinessLabel",
                                                                "userLabelDisplayType": "Badge"
                                                            }
                                                        },
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Wed Dec 27 00:42:32 +0000 2017",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "Write on business with @workweekinc. Co-host @niapodcast. Building an AI research app: https://t.co/fZ5ObIyBGI",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "Bearly.AI",
                                                                            "expanded_url": "http://Bearly.AI",
                                                                            "url": "https://t.co/fZ5ObIyBGI",
                                                                            "indices": [
                                                                                87,
                                                                                110
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "readtrung.com",
                                                                            "expanded_url": "https://www.readtrung.com",
                                                                            "url": "https://t.co/QXcmEZDThE",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 155482,
                                                            "followers_count": 705302,
                                                            "friends_count": 4195,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 5858,
                                                            "location": "My Saturday newsletter ➡️",
                                                            "media_count": 12152,
                                                            "name": "Trung Phan",
                                                            "normal_followers_count": 705302,
                                                            "pinned_tweet_ids_str": [
                                                                "1779155645880553603"
                                                            ],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/945817135816654848/1670800079",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1506362585448296448/LJg8kVSD_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "TrungTPhan",
                                                            "statuses_count": 64976,
                                                            "translator_type": "none",
                                                            "url": "https://t.co/QXcmEZDThE",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        },
                                                        "professional": {
                                                            "rest_id": "1466620402755522571",
                                                            "professional_type": "Creator",
                                                            "category": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1354,
                                                "w": 888,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 787,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 446,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1354,
                                            "width": 888,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                444,
                                                677
                                            ],
                                            "duration_millis": 70856,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/pl/CBaxVZyn9mIWxoOx.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/vid/avc1/320x486/G_knrsyxVVPyEzx4.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/vid/avc1/480x730/C_mBCwcqvyLwbH1w.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/vid/avc1/720x1096/b_jUEnlAC_xFB_OP.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1790154520737325056"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/i2tqbcBGNO",
                                        "expanded_url": "https://twitter.com/TrungTPhan/status/1790154665147220430/video/1",
                                        "id_str": "1790154520737325056",
                                        "indices": [
                                            257,
                                            280
                                        ],
                                        "media_key": "13_1790154520737325056",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1790154520737325056/img/xj_H8FDuu_NmznmZ.jpg",
                                        "source_status_id_str": "1790154665147220430",
                                        "source_user_id_str": "945817135816654848",
                                        "type": "video",
                                        "url": "https://t.co/i2tqbcBGNO",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjo5NDU4MTcxMzU4MTY2NTQ4NDg=",
                                                        "rest_id": "945817135816654848",
                                                        "affiliates_highlighted_label": {
                                                            "label": {
                                                                "url": {
                                                                    "url": "https://twitter.com/workweekinc",
                                                                    "urlType": "DeepLink"
                                                                },
                                                                "badge": {
                                                                    "url": "https://pbs.twimg.com/profile_images/1451596150482604042/JYP1L5G6_bigger.jpg"
                                                                },
                                                                "description": "Workweek 🤝",
                                                                "userLabelType": "BusinessLabel",
                                                                "userLabelDisplayType": "Badge"
                                                            }
                                                        },
                                                        "is_blue_verified": true,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Wed Dec 27 00:42:32 +0000 2017",
                                                            "default_profile": false,
                                                            "default_profile_image": false,
                                                            "description": "Write on business with @workweekinc. Co-host @niapodcast. Building an AI research app: https://t.co/fZ5ObIyBGI",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "Bearly.AI",
                                                                            "expanded_url": "http://Bearly.AI",
                                                                            "url": "https://t.co/fZ5ObIyBGI",
                                                                            "indices": [
                                                                                87,
                                                                                110
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                "url": {
                                                                    "urls": [
                                                                        {
                                                                            "display_url": "readtrung.com",
                                                                            "expanded_url": "https://www.readtrung.com",
                                                                            "url": "https://t.co/QXcmEZDThE",
                                                                            "indices": [
                                                                                0,
                                                                                23
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 155482,
                                                            "followers_count": 705302,
                                                            "friends_count": 4195,
                                                            "has_custom_timelines": true,
                                                            "is_translator": false,
                                                            "listed_count": 5858,
                                                            "location": "My Saturday newsletter ➡️",
                                                            "media_count": 12152,
                                                            "name": "Trung Phan",
                                                            "normal_followers_count": 705302,
                                                            "pinned_tweet_ids_str": [
                                                                "1779155645880553603"
                                                            ],
                                                            "possibly_sensitive": false,
                                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/945817135816654848/1670800079",
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1506362585448296448/LJg8kVSD_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "TrungTPhan",
                                                            "statuses_count": 64976,
                                                            "translator_type": "none",
                                                            "url": "https://t.co/QXcmEZDThE",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        },
                                                        "professional": {
                                                            "rest_id": "1466620402755522571",
                                                            "professional_type": "Creator",
                                                            "category": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1354,
                                                "w": 888,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 787,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 446,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1354,
                                            "width": 888,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                444,
                                                677
                                            ],
                                            "duration_millis": 70856,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/pl/CBaxVZyn9mIWxoOx.m3u8?tag=14"
                                                },
                                                {
                                                    "bitrate": 632000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/vid/avc1/320x486/G_knrsyxVVPyEzx4.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 950000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/vid/avc1/480x730/C_mBCwcqvyLwbH1w.mp4?tag=14"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1790154520737325056/vid/avc1/720x1096/b_jUEnlAC_xFB_OP.mp4?tag=14"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1790154520737325056"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 162,
                            "favorited": false,
                            "full_text": "Lamine Yamal: 16-year old starter on Spanish Team that just won Eurocup. \n\nCarlos Alcaraz: 21-year old Spanish superstar that just beat Novak Djokovic at Wimbledon for the 2nd straight year. \n\nMy Spanish language skills is after 10,000 hours with Duolingo: https://t.co/i2tqbcBGNO",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 3,
                            "reply_count": 6,
                            "retweet_count": 18,
                            "retweeted": false,
                            "user_id_str": "945817135816654848",
                            "id_str": "1812594806415331460"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1812581104815075596",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozODU0NzM4MjU=",
                                    "rest_id": "385473825",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Wed Oct 05 15:25:19 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "⚽️ More than the Score\n\n@Squawka: Stats and Stories\n@Squawka_Live: Match Coverage\n@SquawkaBet: Tips and Info\n\n(Opta Data)",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "linkin.bio/squawkafootball",
                                                        "expanded_url": "https://linkin.bio/squawkafootball",
                                                        "url": "https://t.co/C2KKrmDLg2",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 14254,
                                        "followers_count": 1277114,
                                        "friends_count": 1093,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 8034,
                                        "location": "Comparison Matrix",
                                        "media_count": 125480,
                                        "name": "Squawka",
                                        "normal_followers_count": 1277114,
                                        "pinned_tweet_ids_str": [
                                            "1812597182509572254"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/385473825/1720995915",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1550503609829318656/uiKVOLVh_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "Squawka",
                                        "statuses_count": 238098,
                                        "translator_type": "none",
                                        "url": "https://t.co/C2KKrmDLg2",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1497002518387298304",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1812581104815075596"
                            ],
                            "editable_until_msecs": "1720991586000",
                            "is_edit_eligible": false,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "116233",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 46,
                            "bookmarked": false,
                            "created_at": "Sun Jul 14 20:13:06 +0000 2024",
                            "conversation_id_str": "1812581104815075596",
                            "display_text_range": [
                                0,
                                156
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            147,
                                            156
                                        ],
                                        "text": "EURO2024"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/5cu67dyh2f",
                                        "expanded_url": "https://twitter.com/Squawka/status/1812581104815075596/photo/1",
                                        "id_str": "1812581067410362368",
                                        "indices": [
                                            157,
                                            180
                                        ],
                                        "media_key": "3_1812581067410362368",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeU4JmX0AA7Wlm.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5cU67DYH2f",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 308,
                                                        "y": 204,
                                                        "h": 529,
                                                        "w": 529
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 273,
                                                        "y": 181,
                                                        "h": 470,
                                                        "w": 470
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 155,
                                                        "y": 102,
                                                        "h": 266,
                                                        "w": 266
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 308,
                                                        "y": 204,
                                                        "h": 529,
                                                        "w": 529
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 204,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 236,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812581067410362368"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/5cU67DYH2f",
                                        "expanded_url": "https://twitter.com/Squawka/status/1812581104815075596/photo/1",
                                        "id_str": "1812581067410362368",
                                        "indices": [
                                            157,
                                            180
                                        ],
                                        "media_key": "3_1812581067410362368",
                                        "media_url_https": "https://pbs.twimg.com/media/GSeU4JmX0AA7Wlm.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5cU67DYH2f",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 308,
                                                        "y": 204,
                                                        "h": 529,
                                                        "w": 529
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 273,
                                                        "y": 181,
                                                        "h": 470,
                                                        "w": 470
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 155,
                                                        "y": 102,
                                                        "h": 266,
                                                        "w": 266
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 308,
                                                        "y": 204,
                                                        "h": 529,
                                                        "w": 529
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1350,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1350,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 204,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1231
                                                },
                                                {
                                                    "x": 236,
                                                    "y": 0,
                                                    "w": 675,
                                                    "h": 1350
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1350
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1812581067410362368"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 1931,
                            "favorited": false,
                            "full_text": "Lamine Yamal is the first player to provide 4+ assists for Spain at a single edition of any major men’s tournament.\n\nAnd this is his first one. 🤯\n\n#EURO2024 https://t.co/5cU67DYH2f",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 18,
                            "reply_count": 21,
                            "retweet_count": 483,
                            "retweeted": false,
                            "user_id_str": "385473825",
                            "id_str": "1812581104815075596"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1810756280799146423",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyNzQwMTE3MDI5",
                                    "rest_id": "2740117029",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Mon Aug 11 18:59:38 +0000 2014",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "We celebrate all parts of football here - DM requests. ⚽️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 4,
                                        "followers_count": 452949,
                                        "friends_count": 0,
                                        "has_custom_timelines": false,
                                        "is_translator": false,
                                        "listed_count": 1002,
                                        "location": "stoptfooty@gmail.com",
                                        "media_count": 1083,
                                        "name": "Stop That Football",
                                        "normal_followers_count": 452949,
                                        "pinned_tweet_ids_str": [
                                            "1134532753217773568"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/2740117029/1635930773",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1454917595560304641/1UJ_zkZv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "stopthatfooty",
                                        "statuses_count": 929,
                                        "translator_type": "none",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1810756280799146423"
                            ],
                            "editable_until_msecs": "1720556514000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "7129267",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 3509,
                            "bookmarked": false,
                            "created_at": "Tue Jul 09 19:21:54 +0000 2024",
                            "conversation_id_str": "1810756280799146423",
                            "display_text_range": [
                                0,
                                48
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/wnuax2d0ff",
                                        "expanded_url": "https://twitter.com/Kassand41966507/status/1810756031187673551/video/1",
                                        "id_str": "1810755998161735680",
                                        "indices": [
                                            25,
                                            48
                                        ],
                                        "media_key": "7_1810755998161735680",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1810755998161735680/pu/img/j14RpYbAiRmrdRwV.jpg",
                                        "source_status_id_str": "1810756031187673551",
                                        "source_user_id_str": "1791601020922900480",
                                        "type": "video",
                                        "url": "https://t.co/WNuax2D0FF",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjoxNzkxNjAxMDIwOTIyOTAwNDgw",
                                                        "rest_id": "1791601020922900480",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": false,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Fri May 17 22:45:45 +0000 2024",
                                                            "default_profile": true,
                                                            "default_profile_image": false,
                                                            "description": "",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 17,
                                                            "followers_count": 409,
                                                            "friends_count": 8,
                                                            "has_custom_timelines": false,
                                                            "is_translator": false,
                                                            "listed_count": 2,
                                                            "location": "",
                                                            "media_count": 73,
                                                            "name": ".",
                                                            "normal_followers_count": 409,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1809333284696125442/SclsFC5n_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "Kassand41966507",
                                                            "statuses_count": 74,
                                                            "translator_type": "none",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "reason": "Dmcaed",
                                            "status": "Unavailable"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 11300,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/pl/Ab5Blel2-rFX5iid.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 256000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/vid/avc1/480x270/LGNY2IW1Jx3bgS4N.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/vid/avc1/640x360/TeCu-y1s3zLTLDxh.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/vid/avc1/1280x720/st0mfL7_C59XOlOA.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1810755998161735680"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/WNuax2D0FF",
                                        "expanded_url": "https://twitter.com/Kassand41966507/status/1810756031187673551/video/1",
                                        "id_str": "1810755998161735680",
                                        "indices": [
                                            25,
                                            48
                                        ],
                                        "media_key": "7_1810755998161735680",
                                        "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1810755998161735680/pu/img/j14RpYbAiRmrdRwV.jpg",
                                        "source_status_id_str": "1810756031187673551",
                                        "source_user_id_str": "1791601020922900480",
                                        "type": "video",
                                        "url": "https://t.co/WNuax2D0FF",
                                        "additional_media_info": {
                                            "monetizable": false,
                                            "source_user": {
                                                "user_results": {
                                                    "result": {
                                                        "__typename": "User",
                                                        "id": "VXNlcjoxNzkxNjAxMDIwOTIyOTAwNDgw",
                                                        "rest_id": "1791601020922900480",
                                                        "affiliates_highlighted_label": {},
                                                        "is_blue_verified": false,
                                                        "profile_image_shape": "Circle",
                                                        "legacy": {
                                                            "created_at": "Fri May 17 22:45:45 +0000 2024",
                                                            "default_profile": true,
                                                            "default_profile_image": false,
                                                            "description": "",
                                                            "entities": {
                                                                "description": {
                                                                    "urls": []
                                                                }
                                                            },
                                                            "fast_followers_count": 0,
                                                            "favourites_count": 17,
                                                            "followers_count": 409,
                                                            "friends_count": 8,
                                                            "has_custom_timelines": false,
                                                            "is_translator": false,
                                                            "listed_count": 2,
                                                            "location": "",
                                                            "media_count": 73,
                                                            "name": ".",
                                                            "normal_followers_count": 409,
                                                            "pinned_tweet_ids_str": [],
                                                            "possibly_sensitive": false,
                                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1809333284696125442/SclsFC5n_normal.jpg",
                                                            "profile_interstitial_type": "",
                                                            "screen_name": "Kassand41966507",
                                                            "statuses_count": 74,
                                                            "translator_type": "none",
                                                            "verified": false,
                                                            "withheld_in_countries": []
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ext_media_availability": {
                                            "reason": "Dmcaed",
                                            "status": "Unavailable"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1920,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 675,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 383,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1920,
                                            "focus_rects": []
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                16,
                                                9
                                            ],
                                            "duration_millis": 11300,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/pl/Ab5Blel2-rFX5iid.m3u8?tag=12"
                                                },
                                                {
                                                    "bitrate": 256000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/vid/avc1/480x270/LGNY2IW1Jx3bgS4N.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/vid/avc1/640x360/TeCu-y1s3zLTLDxh.mp4?tag=12"
                                                },
                                                {
                                                    "bitrate": 2176000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/ext_tw_video/1810755998161735680/pu/vid/avc1/1280x720/st0mfL7_C59XOlOA.mp4?tag=12"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "7_1810755998161735680"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 90385,
                            "favorited": false,
                            "full_text": "Stop that Lamine Yamal.  https://t.co/WNuax2D0FF",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 4013,
                            "reply_count": 598,
                            "retweet_count": 14554,
                            "retweeted": false,
                            "user_id_str": "2740117029",
                            "id_str": "1810756280799146423"
                        }
                    }
                }
            }
        }
    ],
    philFoden: [
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1797682724062532012",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1797682724062532012"
                            ],
                            "editable_until_msecs": "1717439535000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "434205",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 129,
                            "bookmarked": false,
                            "created_at": "Mon Jun 03 17:32:15 +0000 2024",
                            "conversation_id_str": "1797682724062532012",
                            "display_text_range": [
                                0,
                                75
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/fxoqitxzur",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1797682724062532012/photo/1",
                                        "id_str": "1797682716785160192",
                                        "indices": [
                                            76,
                                            99
                                        ],
                                        "media_key": "3_1797682716785160192",
                                        "media_url_https": "https://pbs.twimg.com/media/GPKm6AjWsAA7iMx.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/FXOQitxZuR",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 596,
                                                        "y": 400,
                                                        "h": 132,
                                                        "w": 132
                                                    },
                                                    {
                                                        "x": 762,
                                                        "y": 455,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 496,
                                                        "y": 333,
                                                        "h": 110,
                                                        "w": 110
                                                    },
                                                    {
                                                        "x": 635,
                                                        "y": 379,
                                                        "h": 93,
                                                        "w": 93
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 281,
                                                        "y": 188,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 359,
                                                        "y": 214,
                                                        "h": 52,
                                                        "w": 52
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 596,
                                                        "y": 400,
                                                        "h": 132,
                                                        "w": 132
                                                    },
                                                    {
                                                        "x": 762,
                                                        "y": 455,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1439,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1199,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1439,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 64,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1439,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 52,
                                                    "y": 0,
                                                    "w": 1262,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 323,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1439
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1797682716785160192"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/fxoqitxzur",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1797682724062532012/photo/1",
                                        "id_str": "1797682716772573185",
                                        "indices": [
                                            76,
                                            99
                                        ],
                                        "media_key": "3_1797682716772573185",
                                        "media_url_https": "https://pbs.twimg.com/media/GPKm6AgWoAE58SX.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/FXOQitxZuR",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1005,
                                                        "y": 1320,
                                                        "h": 54,
                                                        "w": 54
                                                    },
                                                    {
                                                        "x": 455,
                                                        "y": 774,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 786,
                                                        "y": 239,
                                                        "h": 105,
                                                        "w": 105
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 837,
                                                        "y": 1100,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 379,
                                                        "y": 645,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 655,
                                                        "y": 199,
                                                        "h": 87,
                                                        "w": 87
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 474,
                                                        "y": 623,
                                                        "h": 25,
                                                        "w": 25
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 365,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 371,
                                                        "y": 112,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1005,
                                                        "y": 1320,
                                                        "h": 54,
                                                        "w": 54
                                                    },
                                                    {
                                                        "x": 455,
                                                        "y": 774,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 786,
                                                        "y": 239,
                                                        "h": 105,
                                                        "w": 105
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 425,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 108,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1797682716772573185"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/fxoqitxzur",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1797682724062532012/photo/1",
                                        "id_str": "1797682716801916928",
                                        "indices": [
                                            76,
                                            99
                                        ],
                                        "media_key": "3_1797682716801916928",
                                        "media_url_https": "https://pbs.twimg.com/media/GPKm6AnWYAAS5yj.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/FXOQitxZuR",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 470,
                                                        "y": 477,
                                                        "h": 96,
                                                        "w": 96
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 392,
                                                        "y": 398,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 222,
                                                        "y": 225,
                                                        "h": 45,
                                                        "w": 45
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 470,
                                                        "y": 477,
                                                        "h": 96,
                                                        "w": 96
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1436,
                                                "w": 1438,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1198,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 679,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1436,
                                            "width": 1438,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 631,
                                                    "w": 1438,
                                                    "h": 805
                                                },
                                                {
                                                    "x": 2,
                                                    "y": 0,
                                                    "w": 1436,
                                                    "h": 1436
                                                },
                                                {
                                                    "x": 123,
                                                    "y": 0,
                                                    "w": 1260,
                                                    "h": 1436
                                                },
                                                {
                                                    "x": 394,
                                                    "y": 0,
                                                    "w": 718,
                                                    "h": 1436
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1438,
                                                    "h": 1436
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1797682716801916928"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/FXOQitxZuR",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1797682724062532012/photo/1",
                                        "id_str": "1797682716785160192",
                                        "indices": [
                                            76,
                                            99
                                        ],
                                        "media_key": "3_1797682716785160192",
                                        "media_url_https": "https://pbs.twimg.com/media/GPKm6AjWsAA7iMx.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/FXOQitxZuR",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 596,
                                                        "y": 400,
                                                        "h": 132,
                                                        "w": 132
                                                    },
                                                    {
                                                        "x": 762,
                                                        "y": 455,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 496,
                                                        "y": 333,
                                                        "h": 110,
                                                        "w": 110
                                                    },
                                                    {
                                                        "x": 635,
                                                        "y": 379,
                                                        "h": 93,
                                                        "w": 93
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 281,
                                                        "y": 188,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 359,
                                                        "y": 214,
                                                        "h": 52,
                                                        "w": 52
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 596,
                                                        "y": 400,
                                                        "h": 132,
                                                        "w": 132
                                                    },
                                                    {
                                                        "x": 762,
                                                        "y": 455,
                                                        "h": 112,
                                                        "w": 112
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1439,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1199,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1439,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 64,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1439,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 52,
                                                    "y": 0,
                                                    "w": 1262,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 323,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1439
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1797682716785160192"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/FXOQitxZuR",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1797682724062532012/photo/1",
                                        "id_str": "1797682716772573185",
                                        "indices": [
                                            76,
                                            99
                                        ],
                                        "media_key": "3_1797682716772573185",
                                        "media_url_https": "https://pbs.twimg.com/media/GPKm6AgWoAE58SX.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/FXOQitxZuR",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 1005,
                                                        "y": 1320,
                                                        "h": 54,
                                                        "w": 54
                                                    },
                                                    {
                                                        "x": 455,
                                                        "y": 774,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 786,
                                                        "y": 239,
                                                        "h": 105,
                                                        "w": 105
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 837,
                                                        "y": 1100,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 379,
                                                        "y": 645,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 655,
                                                        "y": 199,
                                                        "h": 87,
                                                        "w": 87
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 474,
                                                        "y": 623,
                                                        "h": 25,
                                                        "w": 25
                                                    },
                                                    {
                                                        "x": 214,
                                                        "y": 365,
                                                        "h": 37,
                                                        "w": 37
                                                    },
                                                    {
                                                        "x": 371,
                                                        "y": 112,
                                                        "h": 49,
                                                        "w": 49
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 1005,
                                                        "y": 1320,
                                                        "h": 54,
                                                        "w": 54
                                                    },
                                                    {
                                                        "x": 455,
                                                        "y": 774,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 786,
                                                        "y": 239,
                                                        "h": 105,
                                                        "w": 105
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 425,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 108,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1797682716772573185"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/FXOQitxZuR",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1797682724062532012/photo/1",
                                        "id_str": "1797682716801916928",
                                        "indices": [
                                            76,
                                            99
                                        ],
                                        "media_key": "3_1797682716801916928",
                                        "media_url_https": "https://pbs.twimg.com/media/GPKm6AnWYAAS5yj.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/FXOQitxZuR",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 470,
                                                        "y": 477,
                                                        "h": 96,
                                                        "w": 96
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 392,
                                                        "y": 398,
                                                        "h": 80,
                                                        "w": 80
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 222,
                                                        "y": 225,
                                                        "h": 45,
                                                        "w": 45
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 470,
                                                        "y": 477,
                                                        "h": 96,
                                                        "w": 96
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1436,
                                                "w": 1438,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1198,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 679,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1436,
                                            "width": 1438,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 631,
                                                    "w": 1438,
                                                    "h": 805
                                                },
                                                {
                                                    "x": 2,
                                                    "y": 0,
                                                    "w": 1436,
                                                    "h": 1436
                                                },
                                                {
                                                    "x": 123,
                                                    "y": 0,
                                                    "w": 1260,
                                                    "h": 1436
                                                },
                                                {
                                                    "x": 394,
                                                    "y": 0,
                                                    "w": 718,
                                                    "h": 1436
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1438,
                                                    "h": 1436
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1797682716801916928"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 21886,
                            "favorited": false,
                            "full_text": "Marbella was a bit sunnier than Stockport 😅 \n\nRecharged and ready to go 💪🏻🔋 https://t.co/FXOQitxZuR",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 118,
                            "reply_count": 200,
                            "retweet_count": 1120,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1797682724062532012"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1811176118180794457",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1811176118180794457"
                            ],
                            "editable_until_msecs": "1720656611000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1112023",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 210,
                            "bookmarked": false,
                            "created_at": "Wed Jul 10 23:10:11 +0000 2024",
                            "conversation_id_str": "1811176118180794457",
                            "display_text_range": [
                                0,
                                61
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/v39lptnxup",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1811176118180794457/photo/1",
                                        "id_str": "1811176106034073600",
                                        "indices": [
                                            62,
                                            85
                                        ],
                                        "media_key": "3_1811176106034073600",
                                        "media_url_https": "https://pbs.twimg.com/media/GSKXEonWEAAgZLk.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/V39LPtNXup",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 714,
                                                        "y": 470,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 532,
                                                        "y": 484,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 560,
                                                        "y": 816,
                                                        "h": 124,
                                                        "w": 124
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 275,
                                                        "h": 71,
                                                        "w": 71
                                                    },
                                                    {
                                                        "x": 311,
                                                        "y": 283,
                                                        "h": 79,
                                                        "w": 79
                                                    },
                                                    {
                                                        "x": 327,
                                                        "y": 477,
                                                        "h": 72,
                                                        "w": 72
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 237,
                                                        "y": 156,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 176,
                                                        "y": 160,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 186,
                                                        "y": 271,
                                                        "h": 41,
                                                        "w": 41
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 714,
                                                        "y": 470,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 532,
                                                        "y": 484,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 560,
                                                        "y": 816,
                                                        "h": 124,
                                                        "w": 124
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1366,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 800,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 454,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1366,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 283,
                                                    "w": 1366,
                                                    "h": 765
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1557
                                                },
                                                {
                                                    "x": 153,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811176106034073600"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/v39lptnxup",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1811176118180794457/photo/1",
                                        "id_str": "1811176106218881024",
                                        "indices": [
                                            62,
                                            85
                                        ],
                                        "media_key": "3_1811176106218881024",
                                        "media_url_https": "https://pbs.twimg.com/media/GSKXEpTaAAAkiXp.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/V39LPtNXup",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 776,
                                                        "y": 706,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 756,
                                                        "y": 348,
                                                        "h": 182,
                                                        "w": 182
                                                    },
                                                    {
                                                        "x": 950,
                                                        "y": 212,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 454,
                                                        "y": 413,
                                                        "h": 57,
                                                        "w": 57
                                                    },
                                                    {
                                                        "x": 442,
                                                        "y": 203,
                                                        "h": 106,
                                                        "w": 106
                                                    },
                                                    {
                                                        "x": 556,
                                                        "y": 124,
                                                        "h": 125,
                                                        "w": 125
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 257,
                                                        "y": 234,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 251,
                                                        "y": 115,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 315,
                                                        "y": 70,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 776,
                                                        "y": 706,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 756,
                                                        "y": 348,
                                                        "h": 182,
                                                        "w": 182
                                                    },
                                                    {
                                                        "x": 950,
                                                        "y": 212,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 289,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 373,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 631,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811176106218881024"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/v39lptnxup",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1811176118180794457/photo/1",
                                        "id_str": "1811176106034085888",
                                        "indices": [
                                            62,
                                            85
                                        ],
                                        "media_key": "3_1811176106034085888",
                                        "media_url_https": "https://pbs.twimg.com/media/GSKXEonWQAAFeEP.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/V39LPtNXup",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 590,
                                                        "y": 382,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 120,
                                                        "y": 482,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 790,
                                                        "y": 216,
                                                        "h": 88,
                                                        "w": 88
                                                    },
                                                    {
                                                        "x": 1470,
                                                        "y": 420,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 992,
                                                        "y": 332,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 345,
                                                        "y": 223,
                                                        "h": 48,
                                                        "w": 48
                                                    },
                                                    {
                                                        "x": 70,
                                                        "y": 282,
                                                        "h": 43,
                                                        "w": 43
                                                    },
                                                    {
                                                        "x": 462,
                                                        "y": 126,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 861,
                                                        "y": 246,
                                                        "h": 46,
                                                        "w": 46
                                                    },
                                                    {
                                                        "x": 581,
                                                        "y": 194,
                                                        "h": 51,
                                                        "w": 51
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 195,
                                                        "y": 126,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 39,
                                                        "y": 160,
                                                        "h": 24,
                                                        "w": 24
                                                    },
                                                    {
                                                        "x": 262,
                                                        "y": 71,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 488,
                                                        "y": 139,
                                                        "h": 26,
                                                        "w": 26
                                                    },
                                                    {
                                                        "x": 329,
                                                        "y": 110,
                                                        "h": 29,
                                                        "w": 29
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 590,
                                                        "y": 382,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 120,
                                                        "y": 482,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 790,
                                                        "y": 216,
                                                        "h": 88,
                                                        "w": 88
                                                    },
                                                    {
                                                        "x": 1470,
                                                        "y": 420,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 992,
                                                        "y": 332,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 187,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 271,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 529,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811176106034085888"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/V39LPtNXup",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1811176118180794457/photo/1",
                                        "id_str": "1811176106034073600",
                                        "indices": [
                                            62,
                                            85
                                        ],
                                        "media_key": "3_1811176106034073600",
                                        "media_url_https": "https://pbs.twimg.com/media/GSKXEonWEAAgZLk.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/V39LPtNXup",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 714,
                                                        "y": 470,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 532,
                                                        "y": 484,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 560,
                                                        "y": 816,
                                                        "h": 124,
                                                        "w": 124
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 418,
                                                        "y": 275,
                                                        "h": 71,
                                                        "w": 71
                                                    },
                                                    {
                                                        "x": 311,
                                                        "y": 283,
                                                        "h": 79,
                                                        "w": 79
                                                    },
                                                    {
                                                        "x": 327,
                                                        "y": 477,
                                                        "h": 72,
                                                        "w": 72
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 237,
                                                        "y": 156,
                                                        "h": 40,
                                                        "w": 40
                                                    },
                                                    {
                                                        "x": 176,
                                                        "y": 160,
                                                        "h": 45,
                                                        "w": 45
                                                    },
                                                    {
                                                        "x": 186,
                                                        "y": 271,
                                                        "h": 41,
                                                        "w": 41
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 714,
                                                        "y": 470,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 532,
                                                        "y": 484,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 560,
                                                        "y": 816,
                                                        "h": 124,
                                                        "w": 124
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1366,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 800,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 454,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1366,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 283,
                                                    "w": 1366,
                                                    "h": 765
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1557
                                                },
                                                {
                                                    "x": 153,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811176106034073600"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/V39LPtNXup",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1811176118180794457/photo/1",
                                        "id_str": "1811176106218881024",
                                        "indices": [
                                            62,
                                            85
                                        ],
                                        "media_key": "3_1811176106218881024",
                                        "media_url_https": "https://pbs.twimg.com/media/GSKXEpTaAAAkiXp.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/V39LPtNXup",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 776,
                                                        "y": 706,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 756,
                                                        "y": 348,
                                                        "h": 182,
                                                        "w": 182
                                                    },
                                                    {
                                                        "x": 950,
                                                        "y": 212,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 454,
                                                        "y": 413,
                                                        "h": 57,
                                                        "w": 57
                                                    },
                                                    {
                                                        "x": 442,
                                                        "y": 203,
                                                        "h": 106,
                                                        "w": 106
                                                    },
                                                    {
                                                        "x": 556,
                                                        "y": 124,
                                                        "h": 125,
                                                        "w": 125
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 257,
                                                        "y": 234,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 251,
                                                        "y": 115,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 315,
                                                        "y": 70,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 776,
                                                        "y": 706,
                                                        "h": 98,
                                                        "w": 98
                                                    },
                                                    {
                                                        "x": 756,
                                                        "y": 348,
                                                        "h": 182,
                                                        "w": 182
                                                    },
                                                    {
                                                        "x": 950,
                                                        "y": 212,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 289,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 373,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 631,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811176106218881024"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/V39LPtNXup",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1811176118180794457/photo/1",
                                        "id_str": "1811176106034085888",
                                        "indices": [
                                            62,
                                            85
                                        ],
                                        "media_key": "3_1811176106034085888",
                                        "media_url_https": "https://pbs.twimg.com/media/GSKXEonWQAAFeEP.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/V39LPtNXup",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 590,
                                                        "y": 382,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 120,
                                                        "y": 482,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 790,
                                                        "y": 216,
                                                        "h": 88,
                                                        "w": 88
                                                    },
                                                    {
                                                        "x": 1470,
                                                        "y": 420,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 992,
                                                        "y": 332,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 345,
                                                        "y": 223,
                                                        "h": 48,
                                                        "w": 48
                                                    },
                                                    {
                                                        "x": 70,
                                                        "y": 282,
                                                        "h": 43,
                                                        "w": 43
                                                    },
                                                    {
                                                        "x": 462,
                                                        "y": 126,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 861,
                                                        "y": 246,
                                                        "h": 46,
                                                        "w": 46
                                                    },
                                                    {
                                                        "x": 581,
                                                        "y": 194,
                                                        "h": 51,
                                                        "w": 51
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 195,
                                                        "y": 126,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 39,
                                                        "y": 160,
                                                        "h": 24,
                                                        "w": 24
                                                    },
                                                    {
                                                        "x": 262,
                                                        "y": 71,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 488,
                                                        "y": 139,
                                                        "h": 26,
                                                        "w": 26
                                                    },
                                                    {
                                                        "x": 329,
                                                        "y": 110,
                                                        "h": 29,
                                                        "w": 29
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 590,
                                                        "y": 382,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 120,
                                                        "y": 482,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 790,
                                                        "y": 216,
                                                        "h": 88,
                                                        "w": 88
                                                    },
                                                    {
                                                        "x": 1470,
                                                        "y": 420,
                                                        "h": 80,
                                                        "w": 80
                                                    },
                                                    {
                                                        "x": 992,
                                                        "y": 332,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 187,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 271,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 529,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811176106034085888"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 75792,
                            "favorited": false,
                            "full_text": "One more to go 🫡 \n\nFans were class! Bring on Sunday 💪🏻🏴󠁧󠁢󠁥󠁮󠁧󠁿 https://t.co/V39LPtNXup",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 136,
                            "reply_count": 575,
                            "retweet_count": 2950,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1811176118180794457"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1807509474359328876",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1807509474359328876"
                            ],
                            "editable_until_msecs": "1719782415000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "618738",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 82,
                            "bookmarked": false,
                            "created_at": "Sun Jun 30 20:20:15 +0000 2024",
                            "conversation_id_str": "1807509474359328876",
                            "display_text_range": [
                                0,
                                46
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/glauivlskb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1807509474359328876/photo/1",
                                        "id_str": "1807509467313176576",
                                        "indices": [
                                            47,
                                            70
                                        ],
                                        "media_key": "3_1807509467313176576",
                                        "media_url_https": "https://pbs.twimg.com/media/GRWQSK9bgAAp13Y.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/GlAUIvLskB",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 493,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 742,
                                            "width": 1024,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 573
                                                },
                                                {
                                                    "x": 115,
                                                    "y": 0,
                                                    "w": 742,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 161,
                                                    "y": 0,
                                                    "w": 651,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 301,
                                                    "y": 0,
                                                    "w": 371,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 742
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1807509467313176576"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/glauivlskb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1807509474359328876/photo/1",
                                        "id_str": "1807509467506135040",
                                        "indices": [
                                            47,
                                            70
                                        ],
                                        "media_key": "3_1807509467506135040",
                                        "media_url_https": "https://pbs.twimg.com/media/GRWQSLrb0AAupaq.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/GlAUIvLskB",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 822,
                                                        "y": 192,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 822,
                                                        "y": 192,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 545,
                                                        "y": 127,
                                                        "h": 31,
                                                        "w": 31
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 822,
                                                        "y": 192,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 493,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 742,
                                            "width": 1024,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 573
                                                },
                                                {
                                                    "x": 63,
                                                    "y": 0,
                                                    "w": 742,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 109,
                                                    "y": 0,
                                                    "w": 651,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 249,
                                                    "y": 0,
                                                    "w": 371,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 742
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1807509467506135040"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/GlAUIvLskB",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1807509474359328876/photo/1",
                                        "id_str": "1807509467313176576",
                                        "indices": [
                                            47,
                                            70
                                        ],
                                        "media_key": "3_1807509467313176576",
                                        "media_url_https": "https://pbs.twimg.com/media/GRWQSK9bgAAp13Y.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/GlAUIvLskB",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 493,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 742,
                                            "width": 1024,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 573
                                                },
                                                {
                                                    "x": 115,
                                                    "y": 0,
                                                    "w": 742,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 161,
                                                    "y": 0,
                                                    "w": 651,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 301,
                                                    "y": 0,
                                                    "w": 371,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 742
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1807509467313176576"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/GlAUIvLskB",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1807509474359328876/photo/1",
                                        "id_str": "1807509467506135040",
                                        "indices": [
                                            47,
                                            70
                                        ],
                                        "media_key": "3_1807509467506135040",
                                        "media_url_https": "https://pbs.twimg.com/media/GRWQSLrb0AAupaq.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/GlAUIvLskB",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 822,
                                                        "y": 192,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 822,
                                                        "y": 192,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 545,
                                                        "y": 127,
                                                        "h": 31,
                                                        "w": 31
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 822,
                                                        "y": 192,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 742,
                                                "w": 1024,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 493,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 742,
                                            "width": 1024,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 573
                                                },
                                                {
                                                    "x": 63,
                                                    "y": 0,
                                                    "w": 742,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 109,
                                                    "y": 0,
                                                    "w": 651,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 249,
                                                    "y": 0,
                                                    "w": 371,
                                                    "h": 742
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 742
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1807509467506135040"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 33398,
                            "favorited": false,
                            "full_text": "Quarter-finals coming up 🔜🦁 \n\nNever give in 💪🏻 https://t.co/GlAUIvLskB",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 113,
                            "reply_count": 514,
                            "retweet_count": 1364,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1807509474359328876"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1795109811480113575",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1795109811480113575"
                            ],
                            "editable_until_msecs": "1716826105000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "359564",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 141,
                            "bookmarked": false,
                            "created_at": "Mon May 27 15:08:25 +0000 2024",
                            "conversation_id_str": "1795109811480113575",
                            "display_text_range": [
                                0,
                                133
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/nrve8eurrd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1795109811480113575/photo/1",
                                        "id_str": "1795109804475600896",
                                        "indices": [
                                            134,
                                            157
                                        ],
                                        "media_key": "3_1795109804475600896",
                                        "media_url_https": "https://pbs.twimg.com/media/GOmC2zSW0AAFTPh.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Nrve8eUrrd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 292,
                                                        "y": 1130,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 243,
                                                        "y": 941,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 137,
                                                        "y": 533,
                                                        "h": 22,
                                                        "w": 22
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 292,
                                                        "y": 1130,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1439,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1199,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1439,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 633,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 1,
                                                    "y": 0,
                                                    "w": 1439,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 124,
                                                    "y": 0,
                                                    "w": 1262,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 395,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1439
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1795109804475600896"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/nrve8eurrd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1795109811480113575/photo/1",
                                        "id_str": "1795109804458876928",
                                        "indices": [
                                            134,
                                            157
                                        ],
                                        "media_key": "3_1795109804458876928",
                                        "media_url_https": "https://pbs.twimg.com/media/GOmC2zOXoAAhClh.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Nrve8eUrrd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 777,
                                                        "y": 985,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 129,
                                                        "y": 208,
                                                        "h": 99,
                                                        "w": 99
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 647,
                                                        "y": 820,
                                                        "h": 72,
                                                        "w": 72
                                                    },
                                                    {
                                                        "x": 107,
                                                        "y": 173,
                                                        "h": 82,
                                                        "w": 82
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 366,
                                                        "y": 465,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 60,
                                                        "y": 98,
                                                        "h": 46,
                                                        "w": 46
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 777,
                                                        "y": 985,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 129,
                                                        "y": 208,
                                                        "h": 99,
                                                        "w": 99
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1435,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1196,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 678,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1435,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 629,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1435,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1259,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 718,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1435
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1795109804458876928"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/nrve8eurrd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1795109811480113575/photo/1",
                                        "id_str": "1795109804475551744",
                                        "indices": [
                                            134,
                                            157
                                        ],
                                        "media_key": "3_1795109804475551744",
                                        "media_url_https": "https://pbs.twimg.com/media/GOmC2zSWEAAaYtA.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Nrve8eUrrd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 279,
                                                        "y": 382,
                                                        "h": 227,
                                                        "w": 227
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 476,
                                                        "h": 248,
                                                        "w": 248
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 232,
                                                        "y": 318,
                                                        "h": 189,
                                                        "w": 189
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 396,
                                                        "h": 206,
                                                        "w": 206
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 131,
                                                        "y": 180,
                                                        "h": 107,
                                                        "w": 107
                                                    },
                                                    {
                                                        "x": 229,
                                                        "y": 224,
                                                        "h": 117,
                                                        "w": 117
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 279,
                                                        "y": 382,
                                                        "h": 227,
                                                        "w": 227
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 476,
                                                        "h": 248,
                                                        "w": 248
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1435,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1196,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 678,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1435,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 136,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1435,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1259,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 36,
                                                    "y": 0,
                                                    "w": 718,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1435
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1795109804475551744"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/Nrve8eUrrd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1795109811480113575/photo/1",
                                        "id_str": "1795109804475600896",
                                        "indices": [
                                            134,
                                            157
                                        ],
                                        "media_key": "3_1795109804475600896",
                                        "media_url_https": "https://pbs.twimg.com/media/GOmC2zSW0AAFTPh.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Nrve8eUrrd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 292,
                                                        "y": 1130,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 243,
                                                        "y": 941,
                                                        "h": 39,
                                                        "w": 39
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 137,
                                                        "y": 533,
                                                        "h": 22,
                                                        "w": 22
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 292,
                                                        "y": 1130,
                                                        "h": 47,
                                                        "w": 47
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1439,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1199,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1439,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 633,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 1,
                                                    "y": 0,
                                                    "w": 1439,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 124,
                                                    "y": 0,
                                                    "w": 1262,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 395,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1439
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1439
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1795109804475600896"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/Nrve8eUrrd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1795109811480113575/photo/1",
                                        "id_str": "1795109804458876928",
                                        "indices": [
                                            134,
                                            157
                                        ],
                                        "media_key": "3_1795109804458876928",
                                        "media_url_https": "https://pbs.twimg.com/media/GOmC2zOXoAAhClh.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Nrve8eUrrd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 777,
                                                        "y": 985,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 129,
                                                        "y": 208,
                                                        "h": 99,
                                                        "w": 99
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 647,
                                                        "y": 820,
                                                        "h": 72,
                                                        "w": 72
                                                    },
                                                    {
                                                        "x": 107,
                                                        "y": 173,
                                                        "h": 82,
                                                        "w": 82
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 366,
                                                        "y": 465,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 60,
                                                        "y": 98,
                                                        "h": 46,
                                                        "w": 46
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 777,
                                                        "y": 985,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 129,
                                                        "y": 208,
                                                        "h": 99,
                                                        "w": 99
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1435,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1196,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 678,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1435,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 629,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1435,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1259,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 718,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1435
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1795109804458876928"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/Nrve8eUrrd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1795109811480113575/photo/1",
                                        "id_str": "1795109804475551744",
                                        "indices": [
                                            134,
                                            157
                                        ],
                                        "media_key": "3_1795109804475551744",
                                        "media_url_https": "https://pbs.twimg.com/media/GOmC2zSWEAAaYtA.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/Nrve8eUrrd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 279,
                                                        "y": 382,
                                                        "h": 227,
                                                        "w": 227
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 476,
                                                        "h": 248,
                                                        "w": 248
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 232,
                                                        "y": 318,
                                                        "h": 189,
                                                        "w": 189
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 396,
                                                        "h": 206,
                                                        "w": 206
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 131,
                                                        "y": 180,
                                                        "h": 107,
                                                        "w": 107
                                                    },
                                                    {
                                                        "x": 229,
                                                        "y": 224,
                                                        "h": 117,
                                                        "w": 117
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 279,
                                                        "y": 382,
                                                        "h": 227,
                                                        "w": 227
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 476,
                                                        "h": 248,
                                                        "w": 248
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1435,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1196,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 678,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1435,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 136,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1435,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1259,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 36,
                                                    "y": 0,
                                                    "w": 718,
                                                    "h": 1435
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1435
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1795109804475551744"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 24255,
                            "favorited": false,
                            "full_text": "HISTORY MAKERS 🏆🏆🏆🏆 \n\nAn incredible season comes to an end. Thank you to all the fans for supporting us along the way! See you soon 🩵 https://t.co/Nrve8eUrrd",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 51,
                            "reply_count": 266,
                            "retweet_count": 2450,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1795109811480113575"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1811121771761868891",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoxOTAzMzgyMDU0",
                                    "rest_id": "1903382054",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Wed Sep 25 08:23:07 +0000 2013",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "🏴󠁧󠁢󠁥󠁮󠁧󠁿❤️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "englandfootball.com",
                                                        "expanded_url": "https://www.englandfootball.com",
                                                        "url": "https://t.co/eULxdoltKL",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 15277,
                                        "followers_count": 6328325,
                                        "friends_count": 409,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 7532,
                                        "location": "Germany",
                                        "media_count": 23425,
                                        "name": "England",
                                        "normal_followers_count": 6328325,
                                        "pinned_tweet_ids_str": [
                                            "1812606390361342334"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/1903382054/1720982875",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1724212442077478912/v_kJPhyb_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "England",
                                        "statuses_count": 53192,
                                        "translator_type": "regular",
                                        "url": "https://t.co/eULxdoltKL",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1481260802090938369",
                                        "professional_type": "Business",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1811121771761868891"
                            ],
                            "editable_until_msecs": "1720643654000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "832088",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 66,
                            "bookmarked": false,
                            "created_at": "Wed Jul 10 19:34:14 +0000 2024",
                            "conversation_id_str": "1811121771761868891",
                            "display_text_range": [
                                0,
                                26
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 10216,
                            "favorited": false,
                            "full_text": "Phil Foden's on fire... 🎶🔥",
                            "is_quote_status": false,
                            "lang": "en",
                            "quote_count": 220,
                            "reply_count": 377,
                            "retweet_count": 743,
                            "retweeted": false,
                            "user_id_str": "1903382054",
                            "id_str": "1811121771761868891"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1792279206732148927",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1792279206732148927"
                            ],
                            "editable_until_msecs": "1716151236000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1185870",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 414,
                            "bookmarked": false,
                            "created_at": "Sun May 19 19:40:36 +0000 2024",
                            "conversation_id_str": "1792279206732148927",
                            "display_text_range": [
                                0,
                                38
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/3gobtrdjy2",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1792279206732148927/photo/1",
                                        "id_str": "1792279199090098176",
                                        "indices": [
                                            39,
                                            62
                                        ],
                                        "media_key": "3_1792279199090098176",
                                        "media_url_https": "https://pbs.twimg.com/media/GN90b4gWQAAmhYc.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3GOBTRDjY2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 601,
                                                        "y": 648,
                                                        "h": 236,
                                                        "w": 236
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 447,
                                                        "y": 482,
                                                        "h": 175,
                                                        "w": 175
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 253,
                                                        "y": 273,
                                                        "h": 99,
                                                        "w": 99
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 601,
                                                        "y": 648,
                                                        "h": 236,
                                                        "w": 236
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1612,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1072,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 607,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1612,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 362,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 45,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 26,
                                                    "y": 0,
                                                    "w": 1414,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 362,
                                                    "y": 0,
                                                    "w": 806,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1612
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1792279199090098176"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/3gobtrdjy2",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1792279206732148927/photo/1",
                                        "id_str": "1792279199090139136",
                                        "indices": [
                                            39,
                                            62
                                        ],
                                        "media_key": "3_1792279199090139136",
                                        "media_url_https": "https://pbs.twimg.com/media/GN90b4gW4AAHNwZ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3GOBTRDjY2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 620,
                                                        "y": 65,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 712,
                                                        "y": 426,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 355,
                                                        "y": 203,
                                                        "h": 147,
                                                        "w": 147
                                                    },
                                                    {
                                                        "x": 1234,
                                                        "y": 336,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 1199,
                                                        "y": 878,
                                                        "h": 133,
                                                        "w": 133
                                                    },
                                                    {
                                                        "x": 1101,
                                                        "y": 570,
                                                        "h": 139,
                                                        "w": 139
                                                    },
                                                    {
                                                        "x": 411,
                                                        "y": 839,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 363,
                                                        "y": 974,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 917,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 438,
                                                        "y": 588,
                                                        "h": 153,
                                                        "w": 153
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 463,
                                                        "y": 48,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 532,
                                                        "y": 318,
                                                        "h": 91,
                                                        "w": 91
                                                    },
                                                    {
                                                        "x": 265,
                                                        "y": 151,
                                                        "h": 109,
                                                        "w": 109
                                                    },
                                                    {
                                                        "x": 922,
                                                        "y": 251,
                                                        "h": 101,
                                                        "w": 101
                                                    },
                                                    {
                                                        "x": 896,
                                                        "y": 656,
                                                        "h": 99,
                                                        "w": 99
                                                    },
                                                    {
                                                        "x": 823,
                                                        "y": 426,
                                                        "h": 103,
                                                        "w": 103
                                                    },
                                                    {
                                                        "x": 307,
                                                        "y": 627,
                                                        "h": 91,
                                                        "w": 91
                                                    },
                                                    {
                                                        "x": 271,
                                                        "y": 728,
                                                        "h": 115,
                                                        "w": 115
                                                    },
                                                    {
                                                        "x": 747,
                                                        "y": 685,
                                                        "h": 115,
                                                        "w": 115
                                                    },
                                                    {
                                                        "x": 327,
                                                        "y": 439,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 262,
                                                        "y": 27,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 301,
                                                        "y": 180,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 150,
                                                        "y": 85,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 522,
                                                        "y": 142,
                                                        "h": 57,
                                                        "w": 57
                                                    },
                                                    {
                                                        "x": 507,
                                                        "y": 371,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 466,
                                                        "y": 241,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 174,
                                                        "y": 355,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 153,
                                                        "y": 412,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 423,
                                                        "y": 388,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 185,
                                                        "y": 249,
                                                        "h": 64,
                                                        "w": 64
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 620,
                                                        "y": 65,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 712,
                                                        "y": 426,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 355,
                                                        "y": 203,
                                                        "h": 147,
                                                        "w": 147
                                                    },
                                                    {
                                                        "x": 1234,
                                                        "y": 336,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 1199,
                                                        "y": 878,
                                                        "h": 133,
                                                        "w": 133
                                                    },
                                                    {
                                                        "x": 1101,
                                                        "y": 570,
                                                        "h": 139,
                                                        "w": 139
                                                    },
                                                    {
                                                        "x": 411,
                                                        "y": 839,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 363,
                                                        "y": 974,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 917,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 438,
                                                        "y": 588,
                                                        "h": 153,
                                                        "w": 153
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1604,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1077,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 610,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1604,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 599,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 164,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 33,
                                                    "y": 0,
                                                    "w": 1407,
                                                    "h": 1604
                                                },
                                                {
                                                    "x": 638,
                                                    "y": 0,
                                                    "w": 802,
                                                    "h": 1604
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1604
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1792279199090139136"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/3gobtrdjy2",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1792279206732148927/photo/1",
                                        "id_str": "1792279199090106368",
                                        "indices": [
                                            39,
                                            62
                                        ],
                                        "media_key": "3_1792279199090106368",
                                        "media_url_https": "https://pbs.twimg.com/media/GN90b4gWYAA0711.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3GOBTRDjY2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 739,
                                                        "y": 358,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 425,
                                                        "y": 182,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 550,
                                                        "y": 266,
                                                        "h": 90,
                                                        "w": 90
                                                    },
                                                    {
                                                        "x": 316,
                                                        "y": 135,
                                                        "h": 94,
                                                        "w": 94
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 311,
                                                        "y": 150,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 179,
                                                        "y": 76,
                                                        "h": 53,
                                                        "w": 53
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 739,
                                                        "y": 358,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 425,
                                                        "y": 182,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1612,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1072,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 607,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1612,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1414,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 120,
                                                    "y": 0,
                                                    "w": 806,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1612
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1792279199090106368"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/3GOBTRDjY2",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1792279206732148927/photo/1",
                                        "id_str": "1792279199090098176",
                                        "indices": [
                                            39,
                                            62
                                        ],
                                        "media_key": "3_1792279199090098176",
                                        "media_url_https": "https://pbs.twimg.com/media/GN90b4gWQAAmhYc.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3GOBTRDjY2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 601,
                                                        "y": 648,
                                                        "h": 236,
                                                        "w": 236
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 447,
                                                        "y": 482,
                                                        "h": 175,
                                                        "w": 175
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 253,
                                                        "y": 273,
                                                        "h": 99,
                                                        "w": 99
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 601,
                                                        "y": 648,
                                                        "h": 236,
                                                        "w": 236
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1612,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1072,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 607,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1612,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 362,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 45,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 26,
                                                    "y": 0,
                                                    "w": 1414,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 362,
                                                    "y": 0,
                                                    "w": 806,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1612
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1792279199090098176"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/3GOBTRDjY2",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1792279206732148927/photo/1",
                                        "id_str": "1792279199090139136",
                                        "indices": [
                                            39,
                                            62
                                        ],
                                        "media_key": "3_1792279199090139136",
                                        "media_url_https": "https://pbs.twimg.com/media/GN90b4gW4AAHNwZ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3GOBTRDjY2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 620,
                                                        "y": 65,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 712,
                                                        "y": 426,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 355,
                                                        "y": 203,
                                                        "h": 147,
                                                        "w": 147
                                                    },
                                                    {
                                                        "x": 1234,
                                                        "y": 336,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 1199,
                                                        "y": 878,
                                                        "h": 133,
                                                        "w": 133
                                                    },
                                                    {
                                                        "x": 1101,
                                                        "y": 570,
                                                        "h": 139,
                                                        "w": 139
                                                    },
                                                    {
                                                        "x": 411,
                                                        "y": 839,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 363,
                                                        "y": 974,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 917,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 438,
                                                        "y": 588,
                                                        "h": 153,
                                                        "w": 153
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 463,
                                                        "y": 48,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 532,
                                                        "y": 318,
                                                        "h": 91,
                                                        "w": 91
                                                    },
                                                    {
                                                        "x": 265,
                                                        "y": 151,
                                                        "h": 109,
                                                        "w": 109
                                                    },
                                                    {
                                                        "x": 922,
                                                        "y": 251,
                                                        "h": 101,
                                                        "w": 101
                                                    },
                                                    {
                                                        "x": 896,
                                                        "y": 656,
                                                        "h": 99,
                                                        "w": 99
                                                    },
                                                    {
                                                        "x": 823,
                                                        "y": 426,
                                                        "h": 103,
                                                        "w": 103
                                                    },
                                                    {
                                                        "x": 307,
                                                        "y": 627,
                                                        "h": 91,
                                                        "w": 91
                                                    },
                                                    {
                                                        "x": 271,
                                                        "y": 728,
                                                        "h": 115,
                                                        "w": 115
                                                    },
                                                    {
                                                        "x": 747,
                                                        "y": 685,
                                                        "h": 115,
                                                        "w": 115
                                                    },
                                                    {
                                                        "x": 327,
                                                        "y": 439,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 262,
                                                        "y": 27,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 301,
                                                        "y": 180,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 150,
                                                        "y": 85,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 522,
                                                        "y": 142,
                                                        "h": 57,
                                                        "w": 57
                                                    },
                                                    {
                                                        "x": 507,
                                                        "y": 371,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 466,
                                                        "y": 241,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 174,
                                                        "y": 355,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 153,
                                                        "y": 412,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 423,
                                                        "y": 388,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 185,
                                                        "y": 249,
                                                        "h": 64,
                                                        "w": 64
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 620,
                                                        "y": 65,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 712,
                                                        "y": 426,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 355,
                                                        "y": 203,
                                                        "h": 147,
                                                        "w": 147
                                                    },
                                                    {
                                                        "x": 1234,
                                                        "y": 336,
                                                        "h": 136,
                                                        "w": 136
                                                    },
                                                    {
                                                        "x": 1199,
                                                        "y": 878,
                                                        "h": 133,
                                                        "w": 133
                                                    },
                                                    {
                                                        "x": 1101,
                                                        "y": 570,
                                                        "h": 139,
                                                        "w": 139
                                                    },
                                                    {
                                                        "x": 411,
                                                        "y": 839,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 363,
                                                        "y": 974,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 917,
                                                        "h": 155,
                                                        "w": 155
                                                    },
                                                    {
                                                        "x": 438,
                                                        "y": 588,
                                                        "h": 153,
                                                        "w": 153
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1604,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1077,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 610,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1604,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 599,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 164,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 33,
                                                    "y": 0,
                                                    "w": 1407,
                                                    "h": 1604
                                                },
                                                {
                                                    "x": 638,
                                                    "y": 0,
                                                    "w": 802,
                                                    "h": 1604
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1604
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1792279199090139136"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/3GOBTRDjY2",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1792279206732148927/photo/1",
                                        "id_str": "1792279199090106368",
                                        "indices": [
                                            39,
                                            62
                                        ],
                                        "media_key": "3_1792279199090106368",
                                        "media_url_https": "https://pbs.twimg.com/media/GN90b4gWYAA0711.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/3GOBTRDjY2",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 739,
                                                        "y": 358,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 425,
                                                        "y": 182,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 550,
                                                        "y": 266,
                                                        "h": 90,
                                                        "w": 90
                                                    },
                                                    {
                                                        "x": 316,
                                                        "y": 135,
                                                        "h": 94,
                                                        "w": 94
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 311,
                                                        "y": 150,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 179,
                                                        "y": 76,
                                                        "h": 53,
                                                        "w": 53
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 739,
                                                        "y": 358,
                                                        "h": 122,
                                                        "w": 122
                                                    },
                                                    {
                                                        "x": 425,
                                                        "y": 182,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1612,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1072,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 607,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1612,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1414,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 120,
                                                    "y": 0,
                                                    "w": 806,
                                                    "h": 1612
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1612
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1792279199090106368"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 82594,
                            "favorited": false,
                            "full_text": "Champions again ole ole! 🏆 \n\nMy club 🩵 https://t.co/3GOBTRDjY2",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 393,
                            "reply_count": 1165,
                            "retweet_count": 9211,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1792279206732148927"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1802479883320242317",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1802479883320242317"
                            ],
                            "editable_until_msecs": "1718583267000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "2731041",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 162,
                            "bookmarked": false,
                            "created_at": "Sun Jun 16 23:14:27 +0000 2024",
                            "conversation_id_str": "1802479883320242317",
                            "display_text_range": [
                                0,
                                36
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/nkpvu81vun",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1802479883320242317/photo/1",
                                        "id_str": "1802479877813063680",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1802479877813063680",
                                        "media_url_https": "https://pbs.twimg.com/media/GQOx5h_WUAAj-Ud.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NkpVU81vUN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 642,
                                                        "y": 289,
                                                        "h": 108,
                                                        "w": 108
                                                    },
                                                    {
                                                        "x": 935,
                                                        "y": 599,
                                                        "h": 123,
                                                        "w": 123
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 535,
                                                        "y": 240,
                                                        "h": 90,
                                                        "w": 90
                                                    },
                                                    {
                                                        "x": 779,
                                                        "y": 499,
                                                        "h": 102,
                                                        "w": 102
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 303,
                                                        "y": 136,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 441,
                                                        "y": 282,
                                                        "h": 58,
                                                        "w": 58
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 642,
                                                        "y": 289,
                                                        "h": 108,
                                                        "w": 108
                                                    },
                                                    {
                                                        "x": 935,
                                                        "y": 599,
                                                        "h": 123,
                                                        "w": 123
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1085,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 904,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 512,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1085,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 65,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 142,
                                                    "y": 0,
                                                    "w": 1085,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 208,
                                                    "y": 0,
                                                    "w": 952,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 413,
                                                    "y": 0,
                                                    "w": 543,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1085
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1802479877813063680"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/nkpvu81vun",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1802479883320242317/photo/1",
                                        "id_str": "1802479877720829953",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1802479877720829953",
                                        "media_url_https": "https://pbs.twimg.com/media/GQOx5hpW8AE1x4W.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NkpVU81vUN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1106,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 922,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 522,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1106,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 136,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 58,
                                                    "y": 0,
                                                    "w": 1106,
                                                    "h": 1106
                                                },
                                                {
                                                    "x": 126,
                                                    "y": 0,
                                                    "w": 970,
                                                    "h": 1106
                                                },
                                                {
                                                    "x": 335,
                                                    "y": 0,
                                                    "w": 553,
                                                    "h": 1106
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1106
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1802479877720829953"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/nkpvu81vun",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1802479883320242317/photo/1",
                                        "id_str": "1802479877720883200",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1802479877720883200",
                                        "media_url_https": "https://pbs.twimg.com/media/GQOx5hpXwAAbXOo.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NkpVU81vUN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 464,
                                                        "y": 106,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 670,
                                                        "y": 253,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 253,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 133,
                                                        "y": 251,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 268,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 832,
                                                        "y": 285,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1036,
                                                        "y": 585,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 284,
                                                        "y": 243,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 793,
                                                        "y": 552,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 1240,
                                                        "y": 516,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 493,
                                                        "y": 516,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 239,
                                                        "y": 535,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 386,
                                                        "y": 88,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 558,
                                                        "y": 210,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 832,
                                                        "y": 210,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 110,
                                                        "y": 209,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 223,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 693,
                                                        "y": 237,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 863,
                                                        "y": 487,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 202,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 660,
                                                        "y": 460,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 1033,
                                                        "y": 430,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 410,
                                                        "y": 430,
                                                        "h": 72,
                                                        "w": 72
                                                    },
                                                    {
                                                        "x": 199,
                                                        "y": 445,
                                                        "h": 73,
                                                        "w": 73
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 219,
                                                        "y": 50,
                                                        "h": 23,
                                                        "w": 23
                                                    },
                                                    {
                                                        "x": 316,
                                                        "y": 119,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 471,
                                                        "y": 119,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 62,
                                                        "y": 118,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 229,
                                                        "y": 126,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 392,
                                                        "y": 134,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 489,
                                                        "y": 276,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 134,
                                                        "y": 114,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 374,
                                                        "y": 260,
                                                        "h": 35,
                                                        "w": 35
                                                    },
                                                    {
                                                        "x": 585,
                                                        "y": 243,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 232,
                                                        "y": 243,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 112,
                                                        "y": 252,
                                                        "h": 41,
                                                        "w": 41
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 464,
                                                        "y": 106,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 670,
                                                        "y": 253,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 253,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 133,
                                                        "y": 251,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 268,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 832,
                                                        "y": 285,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1036,
                                                        "y": 585,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 284,
                                                        "y": 243,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 793,
                                                        "y": 552,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 1240,
                                                        "y": 516,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 493,
                                                        "y": 516,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 239,
                                                        "y": 535,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1085,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 904,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 512,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1085,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 137,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1085,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 64,
                                                    "y": 0,
                                                    "w": 952,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 269,
                                                    "y": 0,
                                                    "w": 543,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1085
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1802479877720883200"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/NkpVU81vUN",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1802479883320242317/photo/1",
                                        "id_str": "1802479877813063680",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1802479877813063680",
                                        "media_url_https": "https://pbs.twimg.com/media/GQOx5h_WUAAj-Ud.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NkpVU81vUN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 642,
                                                        "y": 289,
                                                        "h": 108,
                                                        "w": 108
                                                    },
                                                    {
                                                        "x": 935,
                                                        "y": 599,
                                                        "h": 123,
                                                        "w": 123
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 535,
                                                        "y": 240,
                                                        "h": 90,
                                                        "w": 90
                                                    },
                                                    {
                                                        "x": 779,
                                                        "y": 499,
                                                        "h": 102,
                                                        "w": 102
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 303,
                                                        "y": 136,
                                                        "h": 51,
                                                        "w": 51
                                                    },
                                                    {
                                                        "x": 441,
                                                        "y": 282,
                                                        "h": 58,
                                                        "w": 58
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 642,
                                                        "y": 289,
                                                        "h": 108,
                                                        "w": 108
                                                    },
                                                    {
                                                        "x": 935,
                                                        "y": 599,
                                                        "h": 123,
                                                        "w": 123
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1085,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 904,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 512,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1085,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 65,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 142,
                                                    "y": 0,
                                                    "w": 1085,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 208,
                                                    "y": 0,
                                                    "w": 952,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 413,
                                                    "y": 0,
                                                    "w": 543,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1085
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1802479877813063680"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/NkpVU81vUN",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1802479883320242317/photo/1",
                                        "id_str": "1802479877720829953",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1802479877720829953",
                                        "media_url_https": "https://pbs.twimg.com/media/GQOx5hpW8AE1x4W.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NkpVU81vUN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1106,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 922,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 522,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1106,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 136,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 58,
                                                    "y": 0,
                                                    "w": 1106,
                                                    "h": 1106
                                                },
                                                {
                                                    "x": 126,
                                                    "y": 0,
                                                    "w": 970,
                                                    "h": 1106
                                                },
                                                {
                                                    "x": 335,
                                                    "y": 0,
                                                    "w": 553,
                                                    "h": 1106
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1106
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1802479877720829953"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/NkpVU81vUN",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1802479883320242317/photo/1",
                                        "id_str": "1802479877720883200",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1802479877720883200",
                                        "media_url_https": "https://pbs.twimg.com/media/GQOx5hpXwAAbXOo.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/NkpVU81vUN",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 464,
                                                        "y": 106,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 670,
                                                        "y": 253,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 253,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 133,
                                                        "y": 251,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 268,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 832,
                                                        "y": 285,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1036,
                                                        "y": 585,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 284,
                                                        "y": 243,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 793,
                                                        "y": 552,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 1240,
                                                        "y": 516,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 493,
                                                        "y": 516,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 239,
                                                        "y": 535,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 386,
                                                        "y": 88,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 558,
                                                        "y": 210,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 832,
                                                        "y": 210,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 110,
                                                        "y": 209,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 223,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 693,
                                                        "y": 237,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 863,
                                                        "y": 487,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 202,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 660,
                                                        "y": 460,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 1033,
                                                        "y": 430,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 410,
                                                        "y": 430,
                                                        "h": 72,
                                                        "w": 72
                                                    },
                                                    {
                                                        "x": 199,
                                                        "y": 445,
                                                        "h": 73,
                                                        "w": 73
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 219,
                                                        "y": 50,
                                                        "h": 23,
                                                        "w": 23
                                                    },
                                                    {
                                                        "x": 316,
                                                        "y": 119,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 471,
                                                        "y": 119,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 62,
                                                        "y": 118,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 229,
                                                        "y": 126,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 392,
                                                        "y": 134,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 489,
                                                        "y": 276,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 134,
                                                        "y": 114,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 374,
                                                        "y": 260,
                                                        "h": 35,
                                                        "w": 35
                                                    },
                                                    {
                                                        "x": 585,
                                                        "y": 243,
                                                        "h": 38,
                                                        "w": 38
                                                    },
                                                    {
                                                        "x": 232,
                                                        "y": 243,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 112,
                                                        "y": 252,
                                                        "h": 41,
                                                        "w": 41
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 464,
                                                        "y": 106,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 670,
                                                        "y": 253,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 999,
                                                        "y": 253,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 133,
                                                        "y": 251,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 486,
                                                        "y": 268,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 832,
                                                        "y": 285,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1036,
                                                        "y": 585,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 284,
                                                        "y": 243,
                                                        "h": 74,
                                                        "w": 74
                                                    },
                                                    {
                                                        "x": 793,
                                                        "y": 552,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 1240,
                                                        "y": 516,
                                                        "h": 82,
                                                        "w": 82
                                                    },
                                                    {
                                                        "x": 493,
                                                        "y": 516,
                                                        "h": 87,
                                                        "w": 87
                                                    },
                                                    {
                                                        "x": 239,
                                                        "y": 535,
                                                        "h": 88,
                                                        "w": 88
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1085,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 904,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 512,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1085,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 137,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1085,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 64,
                                                    "y": 0,
                                                    "w": 952,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 269,
                                                    "y": 0,
                                                    "w": 543,
                                                    "h": 1085
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1085
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1802479877720883200"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 43700,
                            "favorited": false,
                            "full_text": "Job done ✅ \n\nOn to the next one! 💪🏻🦁 https://t.co/NkpVU81vUN",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 308,
                            "reply_count": 988,
                            "retweet_count": 1719,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1802479883320242317"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1791793054766055655",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1791793054766055655"
                            ],
                            "editable_until_msecs": "1716035328000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "1133311",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "note_tweet": {
                            "is_expandable": true,
                            "note_tweet_results": {
                                "result": {
                                    "id": "Tm90ZVR3ZWV0OjE3OTE3OTMwNTQ2ODIxNjExNTI=",
                                    "text": "What a week! So honoured to receive these prestigious awards! Thank you to everyone who voted for me, to the City staff and coaches, my family and of course, my teammates. \n\nI’m delighted with the way I’ve played so far this season and it wouldn’t have been possible without those around me 🩵",
                                    "entity_set": {
                                        "hashtags": [],
                                        "symbols": [],
                                        "urls": [],
                                        "user_mentions": []
                                    }
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 276,
                            "bookmarked": false,
                            "created_at": "Sat May 18 11:28:48 +0000 2024",
                            "conversation_id_str": "1791793054766055655",
                            "display_text_range": [
                                0,
                                280
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/awwf6xkktd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1791793054766055655/photo/1",
                                        "id_str": "1791793048558469120",
                                        "indices": [
                                            281,
                                            304
                                        ],
                                        "media_key": "3_1791793048558469120",
                                        "media_url_https": "https://pbs.twimg.com/media/GN26SMpXgAAeFrl.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/awwF6xkkTd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 890,
                                                        "y": 132,
                                                        "h": 284,
                                                        "w": 284
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 521,
                                                        "y": 77,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 295,
                                                        "y": 43,
                                                        "h": 94,
                                                        "w": 94
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 890,
                                                        "y": 132,
                                                        "h": 284,
                                                        "w": 284
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 392,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 476,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 734,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1791793048558469120"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/awwf6xkktd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1791793054766055655/photo/1",
                                        "id_str": "1791793048545890304",
                                        "indices": [
                                            281,
                                            304
                                        ],
                                        "media_key": "3_1791793048545890304",
                                        "media_url_https": "https://pbs.twimg.com/media/GN26SMmXkAALz-g.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/awwF6xkkTd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 700,
                                                        "y": 104,
                                                        "h": 290,
                                                        "w": 290
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 410,
                                                        "y": 60,
                                                        "h": 169,
                                                        "w": 169
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 232,
                                                        "y": 34,
                                                        "h": 96,
                                                        "w": 96
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 700,
                                                        "y": 104,
                                                        "h": 290,
                                                        "w": 290
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 85,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 427,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1791793048545890304"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/awwF6xkkTd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1791793054766055655/photo/1",
                                        "id_str": "1791793048558469120",
                                        "indices": [
                                            281,
                                            304
                                        ],
                                        "media_key": "3_1791793048558469120",
                                        "media_url_https": "https://pbs.twimg.com/media/GN26SMpXgAAeFrl.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/awwF6xkkTd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 890,
                                                        "y": 132,
                                                        "h": 284,
                                                        "w": 284
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 521,
                                                        "y": 77,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 295,
                                                        "y": 43,
                                                        "h": 94,
                                                        "w": 94
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 890,
                                                        "y": 132,
                                                        "h": 284,
                                                        "w": 284
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 392,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 476,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 734,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1791793048558469120"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/awwF6xkkTd",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1791793054766055655/photo/1",
                                        "id_str": "1791793048545890304",
                                        "indices": [
                                            281,
                                            304
                                        ],
                                        "media_key": "3_1791793048545890304",
                                        "media_url_https": "https://pbs.twimg.com/media/GN26SMmXkAALz-g.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/awwF6xkkTd",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 700,
                                                        "y": 104,
                                                        "h": 290,
                                                        "w": 290
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 410,
                                                        "y": 60,
                                                        "h": 169,
                                                        "w": 169
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 232,
                                                        "y": 34,
                                                        "h": 96,
                                                        "w": 96
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 700,
                                                        "y": 104,
                                                        "h": 290,
                                                        "w": 290
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 85,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 169,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 427,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1791793048545890304"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 48506,
                            "favorited": false,
                            "full_text": "What a week! So honoured to receive these prestigious awards! Thank you to everyone who voted for me, to the City staff and coaches, my family and of course, my teammates. \n\nI’m delighted with the way I’ve played so far this season and it wouldn’t have been possible without those https://t.co/awwF6xkkTd",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 549,
                            "reply_count": 1362,
                            "retweet_count": 6364,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1791793054766055655"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1798022474753507351",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1798022474753507351"
                            ],
                            "editable_until_msecs": "1717520538000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "56617",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 7,
                            "bookmarked": false,
                            "created_at": "Tue Jun 04 16:02:18 +0000 2024",
                            "conversation_id_str": "1798022474753507351",
                            "display_text_range": [
                                0,
                                229
                            ],
                            "entities": {
                                "hashtags": [
                                    {
                                        "indices": [
                                            226,
                                            229
                                        ],
                                        "text": "ad"
                                    }
                                ],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/oafyfgplw1",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1798022474753507351/video/1",
                                        "id_str": "1798022422181908480",
                                        "indices": [
                                            230,
                                            253
                                        ],
                                        "media_key": "13_1798022422181908480",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1798022422181908480/img/s8FImuzfHmA-yzTS.jpg",
                                        "type": "video",
                                        "url": "https://t.co/OaFYFgpLW1",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 720,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 720,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 720,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                1,
                                                1
                                            ],
                                            "duration_millis": 67400,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/pl/nzHJ9TTILiQt0-Wu.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 432000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/vid/avc1/320x320/hYkRDYz5Qrxqk63s.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/vid/avc1/540x540/isnfHvS2PNkdSWj1.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 1280000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/vid/avc1/720x720/59eXIIhOexXXJzXY.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1798022422181908480"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [
                                    {
                                        "display_url": "bit.ly/3TgCjUU",
                                        "expanded_url": "http://bit.ly/3TgCjUU",
                                        "url": "https://t.co/jBD7UeCRpF",
                                        "indices": [
                                            201,
                                            224
                                        ]
                                    }
                                ],
                                "user_mentions": [
                                    {
                                        "id_str": "533068325",
                                        "name": "McDonald’s Fun Football",
                                        "screen_name": "FunFootballUK",
                                        "indices": [
                                            47,
                                            61
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/OaFYFgpLW1",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1798022474753507351/video/1",
                                        "id_str": "1798022422181908480",
                                        "indices": [
                                            230,
                                            253
                                        ],
                                        "media_key": "13_1798022422181908480",
                                        "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1798022422181908480/img/s8FImuzfHmA-yzTS.jpg",
                                        "type": "video",
                                        "url": "https://t.co/OaFYFgpLW1",
                                        "additional_media_info": {
                                            "monetizable": false
                                        },
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 720,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 720,
                                                "w": 720,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 720,
                                            "width": 720,
                                            "focus_rects": []
                                        },
                                        "video_info": {
                                            "aspect_ratio": [
                                                1,
                                                1
                                            ],
                                            "duration_millis": 67400,
                                            "variants": [
                                                {
                                                    "content_type": "application/x-mpegURL",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/pl/nzHJ9TTILiQt0-Wu.m3u8?tag=16"
                                                },
                                                {
                                                    "bitrate": 432000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/vid/avc1/320x320/hYkRDYz5Qrxqk63s.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 832000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/vid/avc1/540x540/isnfHvS2PNkdSWj1.mp4?tag=16"
                                                },
                                                {
                                                    "bitrate": 1280000,
                                                    "content_type": "video/mp4",
                                                    "url": "https://video.twimg.com/amplify_video/1798022422181908480/vid/avc1/720x720/59eXIIhOexXXJzXY.mp4?tag=16"
                                                }
                                            ]
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "13_1798022422181908480"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 928,
                            "favorited": false,
                            "full_text": "Buzzing to get the call-up 🙌🏻\n\nI’m joining the @FunFootballUK squad to get thousands of kids playing this summer and beyond ⚽️\n\nAnd you can be one of them - click here to sign ip for a free session 👉🏻 https://t.co/jBD7UeCRpF\n\n#ad https://t.co/OaFYFgpLW1",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 4,
                            "reply_count": 16,
                            "retweet_count": 92,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1798022474753507351"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1811146385624027225",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjoyMzE5MTIxNjI2",
                                    "rest_id": "2319121626",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Square",
                                    "legacy": {
                                        "created_at": "Thu Jan 30 15:49:13 +0000 2014",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "The home of football on TNT Sports ⚽️",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "tntsports.co.uk",
                                                        "expanded_url": "https://www.tntsports.co.uk/",
                                                        "url": "https://t.co/MItWrRr1Ai",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 4147,
                                        "followers_count": 2152507,
                                        "friends_count": 536,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 0,
                                        "location": "",
                                        "media_count": 70177,
                                        "name": "Football on TNT Sports",
                                        "normal_followers_count": 2152507,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/2319121626/1725445992",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1846883759984910336/fcugOUTL_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "footballontnt",
                                        "statuses_count": 93967,
                                        "translator_type": "none",
                                        "url": "https://t.co/MItWrRr1Ai",
                                        "verified": false,
                                        "verified_type": "Business",
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1618219245334036481",
                                        "professional_type": "Business",
                                        "category": [
                                            {
                                                "id": 800,
                                                "name": "Sports, Fitness & Recreation",
                                                "icon_name": "IconBriefcaseStroke"
                                            }
                                        ]
                                    },
                                    "tipjar_settings": {
                                        "is_enabled": false,
                                        "bandcamp_handle": "",
                                        "bitcoin_handle": "",
                                        "cash_app_handle": "",
                                        "ethereum_handle": "",
                                        "gofundme_handle": "",
                                        "patreon_handle": "",
                                        "pay_pal_handle": "",
                                        "venmo_handle": ""
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1811146385624027225"
                            ],
                            "editable_until_msecs": "1720649522000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "621283",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                        "legacy": {
                            "bookmark_count": 173,
                            "bookmarked": false,
                            "created_at": "Wed Jul 10 21:12:02 +0000 2024",
                            "conversation_id_str": "1811146385624027225",
                            "display_text_range": [
                                0,
                                169
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/5afIYSqxNi",
                                        "expanded_url": "https://x.com/footballontnt/status/1811146385624027225/photo/1",
                                        "id_str": "1811146202395594753",
                                        "indices": [
                                            170,
                                            193
                                        ],
                                        "media_key": "3_1811146202395594753",
                                        "media_url_https": "https://pbs.twimg.com/media/GSJ74A4WUAEEbOz.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5afIYSqxNi",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 467,
                                                        "y": 131,
                                                        "h": 168,
                                                        "w": 168
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 373,
                                                        "y": 104,
                                                        "h": 134,
                                                        "w": 134
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 211,
                                                        "y": 59,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 467,
                                                        "y": 131,
                                                        "h": 168,
                                                        "w": 168
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1500,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1500,
                                            "width": 1200,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 672
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 1200
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 1368
                                                },
                                                {
                                                    "x": 187,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 1500
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 1500
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811146202395594753"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.x.com/5afIYSqxNi",
                                        "expanded_url": "https://x.com/footballontnt/status/1811146385624027225/photo/1",
                                        "id_str": "1811146202395594753",
                                        "indices": [
                                            170,
                                            193
                                        ],
                                        "media_key": "3_1811146202395594753",
                                        "media_url_https": "https://pbs.twimg.com/media/GSJ74A4WUAEEbOz.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/5afIYSqxNi",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 467,
                                                        "y": 131,
                                                        "h": 168,
                                                        "w": 168
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 373,
                                                        "y": 104,
                                                        "h": 134,
                                                        "w": 134
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 211,
                                                        "y": 59,
                                                        "h": 76,
                                                        "w": 76
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 467,
                                                        "y": 131,
                                                        "h": 168,
                                                        "w": 168
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1500,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 960,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 544,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1500,
                                            "width": 1200,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 672
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 1200
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 1368
                                                },
                                                {
                                                    "x": 187,
                                                    "y": 0,
                                                    "w": 750,
                                                    "h": 1500
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1200,
                                                    "h": 1500
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1811146202395594753"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 9836,
                            "favorited": false,
                            "full_text": "Phil Foden’s game by numbers Vs. The Netherlands:\n\n40/40 passes completed\n100% tackles won\n100% accurate long balls\n3 duels won\nHit the woodwork\n\nA live wire all game. \uD83D\uDC4F https://t.co/5afIYSqxNi",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 220,
                            "reply_count": 172,
                            "retweet_count": 825,
                            "retweeted": false,
                            "user_id_str": "2319121626",
                            "id_str": "1811146385624027225"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1798434762618700114",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1798434762618700114"
                            ],
                            "editable_until_msecs": "1717618835000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "433552",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 114,
                            "bookmarked": false,
                            "created_at": "Wed Jun 05 19:20:35 +0000 2024",
                            "conversation_id_str": "1798434762618700114",
                            "display_text_range": [
                                0,
                                36
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/i8k0yzkach",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1798434762618700114/photo/1",
                                        "id_str": "1798434756410949632",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1798434756410949632",
                                        "media_url_https": "https://pbs.twimg.com/media/GPVS4eeXQAAxyyP.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/i8K0YZKaCh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 414,
                                                        "y": 20,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 414,
                                                        "y": 20,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 260,
                                                        "y": 12,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 414,
                                                        "y": 20,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 40,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 243,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1798434756410949632"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/i8k0yzkach",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1798434762618700114/photo/1",
                                        "id_str": "1798434756385714176",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1798434756385714176",
                                        "media_url_https": "https://pbs.twimg.com/media/GPVS4eYWMAAZPBb.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/i8K0YZKaCh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 133,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 351,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1798434756385714176"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "41147159",
                                        "name": "Nike Football",
                                        "screen_name": "nikefootball",
                                        "indices": [
                                            20,
                                            33
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/i8K0YZKaCh",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1798434762618700114/photo/1",
                                        "id_str": "1798434756410949632",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1798434756410949632",
                                        "media_url_https": "https://pbs.twimg.com/media/GPVS4eeXQAAxyyP.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/i8K0YZKaCh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 414,
                                                        "y": 20,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 414,
                                                        "y": 20,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 260,
                                                        "y": 12,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 414,
                                                        "y": 20,
                                                        "h": 114,
                                                        "w": 114
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 40,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 243,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1798434756410949632"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/i8K0YZKaCh",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1798434762618700114/photo/1",
                                        "id_str": "1798434756385714176",
                                        "indices": [
                                            37,
                                            60
                                        ],
                                        "media_key": "3_1798434756385714176",
                                        "media_url_https": "https://pbs.twimg.com/media/GPVS4eYWMAAZPBb.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/i8K0YZKaCh",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": []
                                            },
                                            "medium": {
                                                "faces": []
                                            },
                                            "small": {
                                                "faces": []
                                            },
                                            "orig": {
                                                "faces": []
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1080,
                                                "w": 1080,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1080,
                                            "width": 1080,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 605
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 133,
                                                    "y": 0,
                                                    "w": 947,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 351,
                                                    "y": 0,
                                                    "w": 540,
                                                    "h": 1080
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1080,
                                                    "h": 1080
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1798434756385714176"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 35382,
                            "favorited": false,
                            "full_text": "Let’s go 👊🏻🏴󠁧󠁢󠁥󠁮󠁧󠁿\n\n@nikefootball 👌🏻 https://t.co/i8K0YZKaCh",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 78,
                            "reply_count": 211,
                            "retweet_count": 1741,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1798434762618700114"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1799086862063263891",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1799086862063263891"
                            ],
                            "editable_until_msecs": "1717774307000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "310542",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "quoted_status_result": {
                            "result": {
                                "__typename": "Tweet",
                                "rest_id": "1798776956910993833",
                                "core": {
                                    "user_results": {
                                        "result": {
                                            "__typename": "User",
                                            "id": "VXNlcjoxOTAzMzgyMDU0",
                                            "rest_id": "1903382054",
                                            "affiliates_highlighted_label": {},
                                            "is_blue_verified": true,
                                            "profile_image_shape": "Square",
                                            "legacy": {
                                                "created_at": "Wed Sep 25 08:23:07 +0000 2013",
                                                "default_profile": false,
                                                "default_profile_image": false,
                                                "description": "🏴󠁧󠁢󠁥󠁮󠁧󠁿❤️",
                                                "entities": {
                                                    "description": {
                                                        "urls": []
                                                    },
                                                    "url": {
                                                        "urls": [
                                                            {
                                                                "display_url": "englandfootball.com",
                                                                "expanded_url": "https://www.englandfootball.com",
                                                                "url": "https://t.co/eULxdoltKL",
                                                                "indices": [
                                                                    0,
                                                                    23
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                },
                                                "fast_followers_count": 0,
                                                "favourites_count": 15277,
                                                "followers_count": 6328325,
                                                "friends_count": 409,
                                                "has_custom_timelines": true,
                                                "is_translator": false,
                                                "listed_count": 7532,
                                                "location": "Germany",
                                                "media_count": 23425,
                                                "name": "England",
                                                "normal_followers_count": 6328325,
                                                "pinned_tweet_ids_str": [
                                                    "1812606390361342334"
                                                ],
                                                "possibly_sensitive": false,
                                                "profile_banner_url": "https://pbs.twimg.com/profile_banners/1903382054/1720982875",
                                                "profile_image_url_https": "https://pbs.twimg.com/profile_images/1724212442077478912/v_kJPhyb_normal.jpg",
                                                "profile_interstitial_type": "",
                                                "screen_name": "England",
                                                "statuses_count": 53192,
                                                "translator_type": "regular",
                                                "url": "https://t.co/eULxdoltKL",
                                                "verified": false,
                                                "verified_type": "Business",
                                                "withheld_in_countries": []
                                            },
                                            "professional": {
                                                "rest_id": "1481260802090938369",
                                                "professional_type": "Business",
                                                "category": []
                                            }
                                        }
                                    }
                                },
                                "unmention_data": {},
                                "edit_control": {
                                    "edit_tweet_ids": [
                                        "1798776956910993833"
                                    ],
                                    "editable_until_msecs": "1717700420000",
                                    "is_edit_eligible": false,
                                    "edits_remaining": "5"
                                },
                                "is_translatable": false,
                                "views": {
                                    "count": "4216512",
                                    "state": "EnabledWithCount"
                                },
                                "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                                "legacy": {
                                    "bookmark_count": 2216,
                                    "bookmarked": false,
                                    "created_at": "Thu Jun 06 18:00:20 +0000 2024",
                                    "conversation_id_str": "1798776956910993833",
                                    "display_text_range": [
                                        0,
                                        100
                                    ],
                                    "entities": {
                                        "hashtags": [
                                            {
                                                "indices": [
                                                    49,
                                                    60
                                                ],
                                                "text": "ThreeLions"
                                            },
                                            {
                                                "indices": [
                                                    90,
                                                    99
                                                ],
                                                "text": "EURO2024"
                                            }
                                        ],
                                        "media": [
                                            {
                                                "display_url": "pic.x.com/q9ugnzgs3p",
                                                "expanded_url": "https://twitter.com/England/status/1798776956910993833/video/1",
                                                "id_str": "1798776045388058624",
                                                "indices": [
                                                    101,
                                                    124
                                                ],
                                                "media_key": "13_1798776045388058624",
                                                "media_url_https": "https://pbs.twimg.com/media/GPaJga4WoAAL87G.jpg",
                                                "type": "video",
                                                "url": "https://t.co/q9UGNzGs3p",
                                                "additional_media_info": {
                                                    "title": "",
                                                    "description": "",
                                                    "embeddable": true,
                                                    "monetizable": false
                                                },
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 720,
                                                        "w": 720,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 720,
                                                        "w": 720,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 680,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 720,
                                                    "width": 720,
                                                    "focus_rects": []
                                                },
                                                "allow_download_status": {
                                                    "allow_download": false
                                                },
                                                "video_info": {
                                                    "aspect_ratio": [
                                                        1,
                                                        1
                                                    ],
                                                    "duration_millis": 164960,
                                                    "variants": [
                                                        {
                                                            "content_type": "application/x-mpegURL",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/pl/dPG7Ht6KLpPNq8us.m3u8?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 432000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/vid/avc1/320x320/SL0QshWvwK4NDi-p.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 832000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/vid/avc1/540x540/0PRxJSdomqEV3k-1.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 1280000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/vid/avc1/720x720/tVyjTQqeUvvl01-_.mp4?tag=14"
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "13_1798776045388058624"
                                                    }
                                                }
                                            }
                                        ],
                                        "symbols": [],
                                        "timestamps": [],
                                        "urls": [],
                                        "user_mentions": []
                                    },
                                    "extended_entities": {
                                        "media": [
                                            {
                                                "display_url": "pic.twitter.com/q9UGNzGs3p",
                                                "expanded_url": "https://twitter.com/England/status/1798776956910993833/video/1",
                                                "id_str": "1798776045388058624",
                                                "indices": [
                                                    101,
                                                    124
                                                ],
                                                "media_key": "13_1798776045388058624",
                                                "media_url_https": "https://pbs.twimg.com/media/GPaJga4WoAAL87G.jpg",
                                                "type": "video",
                                                "url": "https://t.co/q9UGNzGs3p",
                                                "additional_media_info": {
                                                    "title": "",
                                                    "description": "",
                                                    "embeddable": true,
                                                    "monetizable": false
                                                },
                                                "ext_media_availability": {
                                                    "status": "Available"
                                                },
                                                "sizes": {
                                                    "large": {
                                                        "h": 720,
                                                        "w": 720,
                                                        "resize": "fit"
                                                    },
                                                    "medium": {
                                                        "h": 720,
                                                        "w": 720,
                                                        "resize": "fit"
                                                    },
                                                    "small": {
                                                        "h": 680,
                                                        "w": 680,
                                                        "resize": "fit"
                                                    },
                                                    "thumb": {
                                                        "h": 150,
                                                        "w": 150,
                                                        "resize": "crop"
                                                    }
                                                },
                                                "original_info": {
                                                    "height": 720,
                                                    "width": 720,
                                                    "focus_rects": []
                                                },
                                                "allow_download_status": {
                                                    "allow_download": false
                                                },
                                                "video_info": {
                                                    "aspect_ratio": [
                                                        1,
                                                        1
                                                    ],
                                                    "duration_millis": 164960,
                                                    "variants": [
                                                        {
                                                            "content_type": "application/x-mpegURL",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/pl/dPG7Ht6KLpPNq8us.m3u8?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 432000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/vid/avc1/320x320/SL0QshWvwK4NDi-p.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 832000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/vid/avc1/540x540/0PRxJSdomqEV3k-1.mp4?tag=14"
                                                        },
                                                        {
                                                            "bitrate": 1280000,
                                                            "content_type": "video/mp4",
                                                            "url": "https://video.twimg.com/amplify_video/1798776045388058624/vid/avc1/720x720/tVyjTQqeUvvl01-_.mp4?tag=14"
                                                        }
                                                    ]
                                                },
                                                "media_results": {
                                                    "result": {
                                                        "media_key": "13_1798776045388058624"
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "favorite_count": 26849,
                                    "favorited": false,
                                    "full_text": "Our fans. Our players. Our summer.\n\nThis is your #ThreeLions squad announcement video for #EURO2024! https://t.co/q9UGNzGs3p",
                                    "is_quote_status": false,
                                    "lang": "en",
                                    "possibly_sensitive": false,
                                    "possibly_sensitive_editable": true,
                                    "quote_count": 2913,
                                    "reply_count": 445,
                                    "retweet_count": 4589,
                                    "retweeted": false,
                                    "user_id_str": "1903382054",
                                    "id_str": "1798776956910993833"
                                }
                            }
                        },
                        "legacy": {
                            "bookmark_count": 47,
                            "bookmarked": false,
                            "created_at": "Fri Jun 07 14:31:47 +0000 2024",
                            "conversation_id_str": "1799086862063263891",
                            "display_text_range": [
                                0,
                                130
                            ],
                            "entities": {
                                "hashtags": [],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "favorite_count": 7289,
                            "favorited": false,
                            "full_text": "It’s always an honour to get called up to play for my country. Really looking forward to this year’s Euros! Bring it on 💪🏻🦁🏴󠁧󠁢󠁥󠁮󠁧󠁿",
                            "is_quote_status": true,
                            "lang": "en",
                            "quote_count": 24,
                            "quoted_status_id_str": "1798776956910993833",
                            "quoted_status_permalink": {
                                "url": "https://t.co/iocpCNSdiC",
                                "expanded": "https://twitter.com/England/status/1798776956910993833",
                                "display": "x.com/England/status…"
                            },
                            "reply_count": 122,
                            "retweet_count": 368,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1799086862063263891"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1786852585959284889",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1786852585959284889"
                            ],
                            "editable_until_msecs": "1714857429000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "257753",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 75,
                            "bookmarked": false,
                            "created_at": "Sat May 04 20:17:09 +0000 2024",
                            "conversation_id_str": "1786852585959284889",
                            "display_text_range": [
                                0,
                                79
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/xfv9glyoye",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1786852585959284889/photo/1",
                                        "id_str": "1786852578740830208",
                                        "indices": [
                                            80,
                                            103
                                        ],
                                        "media_key": "3_1786852578740830208",
                                        "media_url_https": "https://pbs.twimg.com/media/GMws9AXWgAADJRO.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/XFV9gLyOYE",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 436,
                                                        "y": 1032,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 1308,
                                                        "y": 518,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 255,
                                                        "y": 604,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 766,
                                                        "y": 303,
                                                        "h": 97,
                                                        "w": 97
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 144,
                                                        "y": 342,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 434,
                                                        "y": 171,
                                                        "h": 55,
                                                        "w": 55
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 436,
                                                        "y": 1032,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 1308,
                                                        "y": 518,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 92,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 682,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 783,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 1041,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1786852578740830208"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/xfv9glyoye",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1786852585959284889/photo/1",
                                        "id_str": "1786852578770219008",
                                        "indices": [
                                            80,
                                            103
                                        ],
                                        "media_key": "3_1786852578770219008",
                                        "media_url_https": "https://pbs.twimg.com/media/GMws9AeW8AAY9hK.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/XFV9gLyOYE",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 954,
                                                        "y": 130,
                                                        "h": 72,
                                                        "w": 72
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 558,
                                                        "y": 76,
                                                        "h": 42,
                                                        "w": 42
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 316,
                                                        "y": 43,
                                                        "h": 23,
                                                        "w": 23
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 954,
                                                        "y": 130,
                                                        "h": 72,
                                                        "w": 72
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1360,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 797,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 452,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1360,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 344,
                                                    "y": 0,
                                                    "w": 1360,
                                                    "h": 1360
                                                },
                                                {
                                                    "x": 428,
                                                    "y": 0,
                                                    "w": 1193,
                                                    "h": 1360
                                                },
                                                {
                                                    "x": 684,
                                                    "y": 0,
                                                    "w": 680,
                                                    "h": 1360
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1360
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1786852578770219008"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/xfv9glyoye",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1786852585959284889/photo/1",
                                        "id_str": "1786852578736672768",
                                        "indices": [
                                            80,
                                            103
                                        ],
                                        "media_key": "3_1786852578736672768",
                                        "media_url_https": "https://pbs.twimg.com/media/GMws9AWXEAA1BVQ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/XFV9gLyOYE",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 520,
                                                        "y": 522,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 304,
                                                        "y": 305,
                                                        "h": 125,
                                                        "w": 125
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 172,
                                                        "y": 173,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 520,
                                                        "y": 522,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1870,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1096,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 621,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1870,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 245,
                                                    "w": 1870,
                                                    "h": 1047
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1870,
                                                    "h": 1870
                                                },
                                                {
                                                    "x": 74,
                                                    "y": 0,
                                                    "w": 1796,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 846,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1870,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1786852578736672768"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": [
                                    {
                                        "id_str": "2157651508",
                                        "name": "Erling Haaland",
                                        "screen_name": "ErlingHaaland",
                                        "indices": [
                                            63,
                                            77
                                        ]
                                    }
                                ]
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/XFV9gLyOYE",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1786852585959284889/photo/1",
                                        "id_str": "1786852578740830208",
                                        "indices": [
                                            80,
                                            103
                                        ],
                                        "media_key": "3_1786852578740830208",
                                        "media_url_https": "https://pbs.twimg.com/media/GMws9AXWgAADJRO.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/XFV9gLyOYE",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 436,
                                                        "y": 1032,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 1308,
                                                        "y": 518,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 255,
                                                        "y": 604,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 766,
                                                        "y": 303,
                                                        "h": 97,
                                                        "w": 97
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 144,
                                                        "y": 342,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 434,
                                                        "y": 171,
                                                        "h": 55,
                                                        "w": 55
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 436,
                                                        "y": 1032,
                                                        "h": 86,
                                                        "w": 86
                                                    },
                                                    {
                                                        "x": 1308,
                                                        "y": 518,
                                                        "h": 166,
                                                        "w": 166
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1366,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 800,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 454,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1366,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 92,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 682,
                                                    "y": 0,
                                                    "w": 1366,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 783,
                                                    "y": 0,
                                                    "w": 1198,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 1041,
                                                    "y": 0,
                                                    "w": 683,
                                                    "h": 1366
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1366
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1786852578740830208"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/XFV9gLyOYE",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1786852585959284889/photo/1",
                                        "id_str": "1786852578770219008",
                                        "indices": [
                                            80,
                                            103
                                        ],
                                        "media_key": "3_1786852578770219008",
                                        "media_url_https": "https://pbs.twimg.com/media/GMws9AeW8AAY9hK.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/XFV9gLyOYE",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 954,
                                                        "y": 130,
                                                        "h": 72,
                                                        "w": 72
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 558,
                                                        "y": 76,
                                                        "h": 42,
                                                        "w": 42
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 316,
                                                        "y": 43,
                                                        "h": 23,
                                                        "w": 23
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 954,
                                                        "y": 130,
                                                        "h": 72,
                                                        "w": 72
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1360,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 797,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 452,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1360,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 344,
                                                    "y": 0,
                                                    "w": 1360,
                                                    "h": 1360
                                                },
                                                {
                                                    "x": 428,
                                                    "y": 0,
                                                    "w": 1193,
                                                    "h": 1360
                                                },
                                                {
                                                    "x": 684,
                                                    "y": 0,
                                                    "w": 680,
                                                    "h": 1360
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1360
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1786852578770219008"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/XFV9gLyOYE",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1786852585959284889/photo/1",
                                        "id_str": "1786852578736672768",
                                        "indices": [
                                            80,
                                            103
                                        ],
                                        "media_key": "3_1786852578736672768",
                                        "media_url_https": "https://pbs.twimg.com/media/GMws9AWXEAA1BVQ.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/XFV9gLyOYE",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 520,
                                                        "y": 522,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 304,
                                                        "y": 305,
                                                        "h": 125,
                                                        "w": 125
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 172,
                                                        "y": 173,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 520,
                                                        "y": 522,
                                                        "h": 214,
                                                        "w": 214
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 2048,
                                                "w": 1870,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1096,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 621,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 2048,
                                            "width": 1870,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 245,
                                                    "w": 1870,
                                                    "h": 1047
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1870,
                                                    "h": 1870
                                                },
                                                {
                                                    "x": 74,
                                                    "y": 0,
                                                    "w": 1796,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 846,
                                                    "y": 0,
                                                    "w": 1024,
                                                    "h": 2048
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1870,
                                                    "h": 2048
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1786852578736672768"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 26263,
                            "favorited": false,
                            "full_text": "Huge three points at home! We keep going 👊🏻 \n\nCongrats my mate @ErlingHaaland 🎩 https://t.co/XFV9gLyOYE",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 28,
                            "reply_count": 170,
                            "retweet_count": 1785,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1786852585959284889"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1805973171687796761",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com 📩",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11651,
                                        "followers_count": 21333453,
                                        "friends_count": 2570,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27286,
                                        "location": "Milano, Italia",
                                        "media_count": 22882,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21333453,
                                        "pinned_tweet_ids_str": [
                                            "1811410781927342328"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 44909,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1805973171687796761"
                            ],
                            "editable_until_msecs": "1719416132000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "12616384",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 1322,
                            "bookmarked": false,
                            "created_at": "Wed Jun 26 14:35:32 +0000 2024",
                            "conversation_id_str": "1805973171687796761",
                            "display_text_range": [
                                0,
                                146
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/ibnthvfgea",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1805973171687796761/photo/1",
                                        "id_str": "1805973164725309440",
                                        "indices": [
                                            147,
                                            170
                                        ],
                                        "media_key": "3_1805973164725309440",
                                        "media_url_https": "https://pbs.twimg.com/media/GRAbBl1XEAAcqmk.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ibnthvfgea",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 246,
                                                        "h": 614,
                                                        "w": 614
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 407,
                                                        "y": 144,
                                                        "h": 359,
                                                        "w": 359
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 231,
                                                        "y": 81,
                                                        "h": 203,
                                                        "w": 203
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 246,
                                                        "h": 614,
                                                        "w": 614
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1585,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 929,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 526,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1585,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 281,
                                                    "y": 0,
                                                    "w": 1585,
                                                    "h": 1585
                                                },
                                                {
                                                    "x": 378,
                                                    "y": 0,
                                                    "w": 1390,
                                                    "h": 1585
                                                },
                                                {
                                                    "x": 677,
                                                    "y": 0,
                                                    "w": 793,
                                                    "h": 1585
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1585
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1805973164725309440"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/ibnthvfgea",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1805973171687796761/photo/1",
                                        "id_str": "1805973164725309440",
                                        "indices": [
                                            147,
                                            170
                                        ],
                                        "media_key": "3_1805973164725309440",
                                        "media_url_https": "https://pbs.twimg.com/media/GRAbBl1XEAAcqmk.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/ibnthvfgea",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 246,
                                                        "h": 614,
                                                        "w": 614
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 407,
                                                        "y": 144,
                                                        "h": 359,
                                                        "w": 359
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 231,
                                                        "y": 81,
                                                        "h": 203,
                                                        "w": 203
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 696,
                                                        "y": 246,
                                                        "h": 614,
                                                        "w": 614
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1585,
                                                "w": 2048,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 929,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 526,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1585,
                                            "width": 2048,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1147
                                                },
                                                {
                                                    "x": 281,
                                                    "y": 0,
                                                    "w": 1585,
                                                    "h": 1585
                                                },
                                                {
                                                    "x": 378,
                                                    "y": 0,
                                                    "w": 1390,
                                                    "h": 1585
                                                },
                                                {
                                                    "x": 677,
                                                    "y": 0,
                                                    "w": 793,
                                                    "h": 1585
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 2048,
                                                    "h": 1585
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1805973164725309440"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 117794,
                            "favorited": false,
                            "full_text": "🚨🏴󠁧󠁢󠁥󠁮󠁧󠁿 Phil Foden has temporarily left the England camp at Euro 2024 and returned to the UK for a pressing family matter, the FA have confirmed. https://t.co/ibnthvfgea",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 2168,
                            "reply_count": 2050,
                            "retweet_count": 6042,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1805973171687796761"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1805981666055237997",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjozMzAyNjI3NDg=",
                                    "rest_id": "330262748",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Wed Jul 06 10:58:55 +0000 2011",
                                        "default_profile": false,
                                        "default_profile_image": false,
                                        "description": "Here we go! © fabrizio.romano93@gmail.com 📩",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "m.youtube.com/@FabrizioRoman…",
                                                        "expanded_url": "https://m.youtube.com/@FabrizioRomanoYT",
                                                        "url": "https://t.co/btxI8gbc2z",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 11651,
                                        "followers_count": 21333454,
                                        "friends_count": 2570,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 27286,
                                        "location": "Milano, Italia",
                                        "media_count": 22882,
                                        "name": "Fabrizio Romano",
                                        "normal_followers_count": 21333454,
                                        "pinned_tweet_ids_str": [
                                            "1811410781927342328"
                                        ],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/330262748/1635957145",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1741753635158024192/j0m8Ucvv_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "FabrizioRomano",
                                        "statuses_count": 44909,
                                        "translator_type": "none",
                                        "url": "https://t.co/btxI8gbc2z",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "edit_tweet_ids": [
                                "1805981666055237997"
                            ],
                            "editable_until_msecs": "1719418157000",
                            "is_edit_eligible": true,
                            "edits_remaining": "5"
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "6482899",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 862,
                            "bookmarked": false,
                            "created_at": "Wed Jun 26 15:09:17 +0000 2024",
                            "conversation_id_str": "1805981666055237997",
                            "display_text_range": [
                                0,
                                153
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/lingod9qou",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1805981666055237997/photo/1",
                                        "id_str": "1805981660451643392",
                                        "indices": [
                                            154,
                                            177
                                        ],
                                        "media_key": "3_1805981660451643392",
                                        "media_url_https": "https://pbs.twimg.com/media/GRAiwG4XIAAD1bb.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/LinGoD9Qou",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 602,
                                                        "y": 827,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 127,
                                                        "h": 367,
                                                        "w": 367
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 602,
                                                        "y": 827,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 127,
                                                        "h": 367,
                                                        "w": 367
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 347,
                                                        "y": 476,
                                                        "h": 23,
                                                        "w": 23
                                                    },
                                                    {
                                                        "x": 268,
                                                        "y": 73,
                                                        "h": 211,
                                                        "w": 211
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 602,
                                                        "y": 827,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 127,
                                                        "h": 367,
                                                        "w": 367
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1022,
                                                "w": 1179,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1022,
                                                "w": 1179,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 589,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1022,
                                            "width": 1179,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1179,
                                                    "h": 660
                                                },
                                                {
                                                    "x": 107,
                                                    "y": 0,
                                                    "w": 1022,
                                                    "h": 1022
                                                },
                                                {
                                                    "x": 170,
                                                    "y": 0,
                                                    "w": 896,
                                                    "h": 1022
                                                },
                                                {
                                                    "x": 363,
                                                    "y": 0,
                                                    "w": 511,
                                                    "h": 1022
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1179,
                                                    "h": 1022
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1805981660451643392"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/LinGoD9Qou",
                                        "expanded_url": "https://twitter.com/FabrizioRomano/status/1805981666055237997/photo/1",
                                        "id_str": "1805981660451643392",
                                        "indices": [
                                            154,
                                            177
                                        ],
                                        "media_key": "3_1805981660451643392",
                                        "media_url_https": "https://pbs.twimg.com/media/GRAiwG4XIAAD1bb.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/LinGoD9Qou",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 602,
                                                        "y": 827,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 127,
                                                        "h": 367,
                                                        "w": 367
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 602,
                                                        "y": 827,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 127,
                                                        "h": 367,
                                                        "w": 367
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 347,
                                                        "y": 476,
                                                        "h": 23,
                                                        "w": 23
                                                    },
                                                    {
                                                        "x": 268,
                                                        "y": 73,
                                                        "h": 211,
                                                        "w": 211
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 602,
                                                        "y": 827,
                                                        "h": 41,
                                                        "w": 41
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 127,
                                                        "h": 367,
                                                        "w": 367
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1022,
                                                "w": 1179,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1022,
                                                "w": 1179,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 589,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1022,
                                            "width": 1179,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1179,
                                                    "h": 660
                                                },
                                                {
                                                    "x": 107,
                                                    "y": 0,
                                                    "w": 1022,
                                                    "h": 1022
                                                },
                                                {
                                                    "x": 170,
                                                    "y": 0,
                                                    "w": 896,
                                                    "h": 1022
                                                },
                                                {
                                                    "x": 363,
                                                    "y": 0,
                                                    "w": 511,
                                                    "h": 1022
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1179,
                                                    "h": 1022
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1805981660451643392"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 100357,
                            "favorited": false,
                            "full_text": "❤️🏴󠁧󠁢󠁥󠁮󠁧󠁿 Phil Foden, back home to be present for the birth of his third child.\n\nHe’s expected to be back with the England squad at Euro 2024  by Sunday. https://t.co/LinGoD9Qou",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 2249,
                            "reply_count": 1562,
                            "retweet_count": 4817,
                            "retweeted": false,
                            "user_id_str": "330262748",
                            "id_str": "1805981666055237997"
                        }
                    }
                }
            }
        },
        {
            "data": {
                "tweetResult": {
                    "result": {
                        "__typename": "Tweet",
                        "rest_id": "1777834755397935345",
                        "core": {
                            "user_results": {
                                "result": {
                                    "__typename": "User",
                                    "id": "VXNlcjo3MjkzNjU1NDY4NjE0OTgzNjg=",
                                    "rest_id": "729365546861498368",
                                    "affiliates_highlighted_label": {},
                                    "is_blue_verified": true,
                                    "profile_image_shape": "Circle",
                                    "legacy": {
                                        "created_at": "Sun May 08 17:41:12 +0000 2016",
                                        "default_profile": true,
                                        "default_profile_image": false,
                                        "description": "⚽️ @ManCity \n🏴󠁧󠁢󠁥󠁮󠁧󠁿 @England\n👟 @nikeuk",
                                        "entities": {
                                            "description": {
                                                "urls": []
                                            },
                                            "url": {
                                                "urls": [
                                                    {
                                                        "display_url": "instagram.com/philfoden",
                                                        "expanded_url": "https://instagram.com/philfoden",
                                                        "url": "https://t.co/EuRs9GZtNr",
                                                        "indices": [
                                                            0,
                                                            23
                                                        ]
                                                    }
                                                ]
                                            }
                                        },
                                        "fast_followers_count": 0,
                                        "favourites_count": 6985,
                                        "followers_count": 1614412,
                                        "friends_count": 160,
                                        "has_custom_timelines": true,
                                        "is_translator": false,
                                        "listed_count": 1023,
                                        "location": "Manchester, England",
                                        "media_count": 392,
                                        "name": "Phil Foden",
                                        "normal_followers_count": 1614412,
                                        "pinned_tweet_ids_str": [],
                                        "possibly_sensitive": false,
                                        "profile_banner_url": "https://pbs.twimg.com/profile_banners/729365546861498368/1675269419",
                                        "profile_image_url_https": "https://pbs.twimg.com/profile_images/1668996998425395200/JxcWsEig_normal.jpg",
                                        "profile_interstitial_type": "",
                                        "screen_name": "PhilFoden",
                                        "statuses_count": 843,
                                        "translator_type": "none",
                                        "url": "https://t.co/EuRs9GZtNr",
                                        "verified": false,
                                        "withheld_in_countries": []
                                    },
                                    "professional": {
                                        "rest_id": "1465423459371175943",
                                        "professional_type": "Creator",
                                        "category": []
                                    }
                                }
                            }
                        },
                        "unmention_data": {},
                        "edit_control": {
                            "initial_tweet_id": "1777834039556128804",
                            "edit_control_initial": {
                                "edit_tweet_ids": [
                                    "1777834039556128804",
                                    "1777834755397935345"
                                ],
                                "editable_until_msecs": "1712707240000",
                                "is_edit_eligible": true,
                                "edits_remaining": "4"
                            }
                        },
                        "previous_counts": {
                            "bookmark_count": 8,
                            "favorite_count": 1413,
                            "quote_count": 20,
                            "reply_count": 98,
                            "retweet_count": 97
                        },
                        "is_translatable": false,
                        "views": {
                            "count": "741953",
                            "state": "EnabledWithCount"
                        },
                        "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                        "legacy": {
                            "bookmark_count": 194,
                            "bookmarked": false,
                            "created_at": "Tue Apr 09 23:03:30 +0000 2024",
                            "conversation_id_str": "1777834755397935345",
                            "display_text_range": [
                                0,
                                69
                            ],
                            "entities": {
                                "hashtags": [],
                                "media": [
                                    {
                                        "display_url": "pic.x.com/yxm1h7leeb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1777834755397935345/photo/1",
                                        "id_str": "1777834011882143744",
                                        "indices": [
                                            70,
                                            93
                                        ],
                                        "media_key": "3_1777834011882143744",
                                        "media_url_https": "https://pbs.twimg.com/media/GKwinUvXwAAdOAm.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/YXM1h7lEeb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 625,
                                                        "y": 216,
                                                        "h": 94,
                                                        "w": 94
                                                    },
                                                    {
                                                        "x": 971,
                                                        "y": 745,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 752,
                                                        "y": 257,
                                                        "h": 253,
                                                        "w": 253
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 520,
                                                        "y": 180,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 620,
                                                        "h": 100,
                                                        "w": 100
                                                    },
                                                    {
                                                        "x": 626,
                                                        "y": 214,
                                                        "h": 210,
                                                        "w": 210
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 295,
                                                        "y": 102,
                                                        "h": 44,
                                                        "w": 44
                                                    },
                                                    {
                                                        "x": 458,
                                                        "y": 351,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 355,
                                                        "y": 121,
                                                        "h": 119,
                                                        "w": 119
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 625,
                                                        "y": 216,
                                                        "h": 94,
                                                        "w": 94
                                                    },
                                                    {
                                                        "x": 971,
                                                        "y": 745,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 752,
                                                        "y": 257,
                                                        "h": 253,
                                                        "w": 253
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 177,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 540,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1777834011882143744"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/yxm1h7leeb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1777834755397935345/photo/1",
                                        "id_str": "1777834011894710273",
                                        "indices": [
                                            70,
                                            93
                                        ],
                                        "media_key": "3_1777834011894710273",
                                        "media_url_https": "https://pbs.twimg.com/media/GKwinUyXgAEzPP9.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/YXM1h7lEeb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 753,
                                                        "y": 950,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 472,
                                                        "y": 376,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 627,
                                                        "y": 791,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 393,
                                                        "y": 313,
                                                        "h": 105,
                                                        "w": 105
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 355,
                                                        "y": 448,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 222,
                                                        "y": 177,
                                                        "h": 59,
                                                        "w": 59
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 753,
                                                        "y": 950,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 472,
                                                        "y": 376,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 137,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 177,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 720,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1777834011894710273"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.x.com/yxm1h7leeb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1777834755397935345/photo/1",
                                        "id_str": "1777834011886329856",
                                        "indices": [
                                            70,
                                            93
                                        ],
                                        "media_key": "3_1777834011886329856",
                                        "media_url_https": "https://pbs.twimg.com/media/GKwinUwXoAAvL-I.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/YXM1h7lEeb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 742,
                                                        "y": 98,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 559,
                                                        "y": 109,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 1016,
                                                        "y": 111,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 354,
                                                        "y": 324,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 856,
                                                        "y": 427,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 1078,
                                                        "y": 163,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 804,
                                                        "y": 174,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 255,
                                                        "y": 236,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 177,
                                                        "y": 558,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 663,
                                                        "y": 12,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 344,
                                                        "y": 22,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 1120,
                                                        "y": 29,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 887,
                                                        "y": 85,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1195,
                                                        "y": 108,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 936,
                                                        "y": 171,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 842,
                                                        "y": 251,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 1019,
                                                        "y": 264,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 676,
                                                        "y": 420,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 1044,
                                                        "y": 499,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 973,
                                                        "y": 563,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 1122,
                                                        "y": 568,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 64,
                                                        "y": 658,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 85,
                                                        "y": 489,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 575,
                                                        "y": 577,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 666,
                                                        "y": 613,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 225,
                                                        "y": 634,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 618,
                                                        "y": 81,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 90,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 846,
                                                        "y": 92,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 295,
                                                        "y": 270,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 713,
                                                        "y": 355,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 898,
                                                        "y": 135,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 670,
                                                        "y": 145,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 212,
                                                        "y": 196,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 147,
                                                        "y": 465,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 552,
                                                        "y": 10,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 286,
                                                        "y": 18,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 933,
                                                        "y": 24,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 739,
                                                        "y": 70,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 995,
                                                        "y": 90,
                                                        "h": 53,
                                                        "w": 53
                                                    },
                                                    {
                                                        "x": 780,
                                                        "y": 142,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 701,
                                                        "y": 209,
                                                        "h": 53,
                                                        "w": 53
                                                    },
                                                    {
                                                        "x": 849,
                                                        "y": 220,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 563,
                                                        "y": 350,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 870,
                                                        "y": 415,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 810,
                                                        "y": 469,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 935,
                                                        "y": 473,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 53,
                                                        "y": 548,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 70,
                                                        "y": 407,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 479,
                                                        "y": 480,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 555,
                                                        "y": 510,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 187,
                                                        "y": 528,
                                                        "h": 59,
                                                        "w": 59
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 350,
                                                        "y": 46,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 263,
                                                        "y": 51,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 479,
                                                        "y": 52,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 167,
                                                        "y": 153,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 404,
                                                        "y": 201,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 509,
                                                        "y": 76,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 379,
                                                        "y": 82,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 120,
                                                        "y": 111,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 83,
                                                        "y": 263,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 313,
                                                        "y": 5,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 162,
                                                        "y": 10,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 528,
                                                        "y": 13,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 40,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 564,
                                                        "y": 51,
                                                        "h": 30,
                                                        "w": 30
                                                    },
                                                    {
                                                        "x": 442,
                                                        "y": 80,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 397,
                                                        "y": 118,
                                                        "h": 30,
                                                        "w": 30
                                                    },
                                                    {
                                                        "x": 481,
                                                        "y": 124,
                                                        "h": 35,
                                                        "w": 35
                                                    },
                                                    {
                                                        "x": 319,
                                                        "y": 198,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 493,
                                                        "y": 235,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 459,
                                                        "y": 265,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 529,
                                                        "y": 268,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 30,
                                                        "y": 310,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 40,
                                                        "y": 230,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 271,
                                                        "y": 272,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 314,
                                                        "y": 289,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 106,
                                                        "y": 299,
                                                        "h": 33,
                                                        "w": 33
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 742,
                                                        "y": 98,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 559,
                                                        "y": 109,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 1016,
                                                        "y": 111,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 354,
                                                        "y": 324,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 856,
                                                        "y": 427,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 1078,
                                                        "y": 163,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 804,
                                                        "y": 174,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 255,
                                                        "y": 236,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 177,
                                                        "y": 558,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 663,
                                                        "y": 12,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 344,
                                                        "y": 22,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 1120,
                                                        "y": 29,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 887,
                                                        "y": 85,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1195,
                                                        "y": 108,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 936,
                                                        "y": 171,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 842,
                                                        "y": 251,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 1019,
                                                        "y": 264,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 676,
                                                        "y": 420,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 1044,
                                                        "y": 499,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 973,
                                                        "y": 563,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 1122,
                                                        "y": 568,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 64,
                                                        "y": 658,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 85,
                                                        "y": 489,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 575,
                                                        "y": 577,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 666,
                                                        "y": 613,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 225,
                                                        "y": 634,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 281,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 177,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 612,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1777834011886329856"
                                            }
                                        }
                                    }
                                ],
                                "symbols": [],
                                "timestamps": [],
                                "urls": [],
                                "user_mentions": []
                            },
                            "extended_entities": {
                                "media": [
                                    {
                                        "display_url": "pic.twitter.com/YXM1h7lEeb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1777834755397935345/photo/1",
                                        "id_str": "1777834011882143744",
                                        "indices": [
                                            70,
                                            93
                                        ],
                                        "media_key": "3_1777834011882143744",
                                        "media_url_https": "https://pbs.twimg.com/media/GKwinUvXwAAdOAm.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/YXM1h7lEeb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 625,
                                                        "y": 216,
                                                        "h": 94,
                                                        "w": 94
                                                    },
                                                    {
                                                        "x": 971,
                                                        "y": 745,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 752,
                                                        "y": 257,
                                                        "h": 253,
                                                        "w": 253
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 520,
                                                        "y": 180,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 809,
                                                        "y": 620,
                                                        "h": 100,
                                                        "w": 100
                                                    },
                                                    {
                                                        "x": 626,
                                                        "y": 214,
                                                        "h": 210,
                                                        "w": 210
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 295,
                                                        "y": 102,
                                                        "h": 44,
                                                        "w": 44
                                                    },
                                                    {
                                                        "x": 458,
                                                        "y": 351,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 355,
                                                        "y": 121,
                                                        "h": 119,
                                                        "w": 119
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 625,
                                                        "y": 216,
                                                        "h": 94,
                                                        "w": 94
                                                    },
                                                    {
                                                        "x": 971,
                                                        "y": 745,
                                                        "h": 120,
                                                        "w": 120
                                                    },
                                                    {
                                                        "x": 752,
                                                        "y": 257,
                                                        "h": 253,
                                                        "w": 253
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 177,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 540,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1777834011882143744"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/YXM1h7lEeb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1777834755397935345/photo/1",
                                        "id_str": "1777834011894710273",
                                        "indices": [
                                            70,
                                            93
                                        ],
                                        "media_key": "3_1777834011894710273",
                                        "media_url_https": "https://pbs.twimg.com/media/GKwinUyXgAEzPP9.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/YXM1h7lEeb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 753,
                                                        "y": 950,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 472,
                                                        "y": 376,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 627,
                                                        "y": 791,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 393,
                                                        "y": 313,
                                                        "h": 105,
                                                        "w": 105
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 355,
                                                        "y": 448,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 222,
                                                        "y": 177,
                                                        "h": 59,
                                                        "w": 59
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 753,
                                                        "y": 950,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 472,
                                                        "y": 376,
                                                        "h": 127,
                                                        "w": 127
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 137,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 177,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 720,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1777834011894710273"
                                            }
                                        }
                                    },
                                    {
                                        "display_url": "pic.twitter.com/YXM1h7lEeb",
                                        "expanded_url": "https://twitter.com/PhilFoden/status/1777834755397935345/photo/1",
                                        "id_str": "1777834011886329856",
                                        "indices": [
                                            70,
                                            93
                                        ],
                                        "media_key": "3_1777834011886329856",
                                        "media_url_https": "https://pbs.twimg.com/media/GKwinUwXoAAvL-I.jpg",
                                        "type": "photo",
                                        "url": "https://t.co/YXM1h7lEeb",
                                        "ext_media_availability": {
                                            "status": "Available"
                                        },
                                        "features": {
                                            "large": {
                                                "faces": [
                                                    {
                                                        "x": 742,
                                                        "y": 98,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 559,
                                                        "y": 109,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 1016,
                                                        "y": 111,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 354,
                                                        "y": 324,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 856,
                                                        "y": 427,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 1078,
                                                        "y": 163,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 804,
                                                        "y": 174,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 255,
                                                        "y": 236,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 177,
                                                        "y": 558,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 663,
                                                        "y": 12,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 344,
                                                        "y": 22,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 1120,
                                                        "y": 29,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 887,
                                                        "y": 85,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1195,
                                                        "y": 108,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 936,
                                                        "y": 171,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 842,
                                                        "y": 251,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 1019,
                                                        "y": 264,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 676,
                                                        "y": 420,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 1044,
                                                        "y": 499,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 973,
                                                        "y": 563,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 1122,
                                                        "y": 568,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 64,
                                                        "y": 658,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 85,
                                                        "y": 489,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 575,
                                                        "y": 577,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 666,
                                                        "y": 613,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 225,
                                                        "y": 634,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            },
                                            "medium": {
                                                "faces": [
                                                    {
                                                        "x": 618,
                                                        "y": 81,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 465,
                                                        "y": 90,
                                                        "h": 49,
                                                        "w": 49
                                                    },
                                                    {
                                                        "x": 846,
                                                        "y": 92,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 295,
                                                        "y": 270,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 713,
                                                        "y": 355,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 898,
                                                        "y": 135,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 670,
                                                        "y": 145,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 212,
                                                        "y": 196,
                                                        "h": 50,
                                                        "w": 50
                                                    },
                                                    {
                                                        "x": 147,
                                                        "y": 465,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 552,
                                                        "y": 10,
                                                        "h": 52,
                                                        "w": 52
                                                    },
                                                    {
                                                        "x": 286,
                                                        "y": 18,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 933,
                                                        "y": 24,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 739,
                                                        "y": 70,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 995,
                                                        "y": 90,
                                                        "h": 53,
                                                        "w": 53
                                                    },
                                                    {
                                                        "x": 780,
                                                        "y": 142,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 701,
                                                        "y": 209,
                                                        "h": 53,
                                                        "w": 53
                                                    },
                                                    {
                                                        "x": 849,
                                                        "y": 220,
                                                        "h": 62,
                                                        "w": 62
                                                    },
                                                    {
                                                        "x": 563,
                                                        "y": 350,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 870,
                                                        "y": 415,
                                                        "h": 58,
                                                        "w": 58
                                                    },
                                                    {
                                                        "x": 810,
                                                        "y": 469,
                                                        "h": 55,
                                                        "w": 55
                                                    },
                                                    {
                                                        "x": 935,
                                                        "y": 473,
                                                        "h": 56,
                                                        "w": 56
                                                    },
                                                    {
                                                        "x": 53,
                                                        "y": 548,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 70,
                                                        "y": 407,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 479,
                                                        "y": 480,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 555,
                                                        "y": 510,
                                                        "h": 65,
                                                        "w": 65
                                                    },
                                                    {
                                                        "x": 187,
                                                        "y": 528,
                                                        "h": 59,
                                                        "w": 59
                                                    }
                                                ]
                                            },
                                            "small": {
                                                "faces": [
                                                    {
                                                        "x": 350,
                                                        "y": 46,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 263,
                                                        "y": 51,
                                                        "h": 27,
                                                        "w": 27
                                                    },
                                                    {
                                                        "x": 479,
                                                        "y": 52,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 167,
                                                        "y": 153,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 404,
                                                        "y": 201,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 509,
                                                        "y": 76,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 379,
                                                        "y": 82,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 120,
                                                        "y": 111,
                                                        "h": 28,
                                                        "w": 28
                                                    },
                                                    {
                                                        "x": 83,
                                                        "y": 263,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 313,
                                                        "y": 5,
                                                        "h": 29,
                                                        "w": 29
                                                    },
                                                    {
                                                        "x": 162,
                                                        "y": 10,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 528,
                                                        "y": 13,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 418,
                                                        "y": 40,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 564,
                                                        "y": 51,
                                                        "h": 30,
                                                        "w": 30
                                                    },
                                                    {
                                                        "x": 442,
                                                        "y": 80,
                                                        "h": 34,
                                                        "w": 34
                                                    },
                                                    {
                                                        "x": 397,
                                                        "y": 118,
                                                        "h": 30,
                                                        "w": 30
                                                    },
                                                    {
                                                        "x": 481,
                                                        "y": 124,
                                                        "h": 35,
                                                        "w": 35
                                                    },
                                                    {
                                                        "x": 319,
                                                        "y": 198,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 493,
                                                        "y": 235,
                                                        "h": 33,
                                                        "w": 33
                                                    },
                                                    {
                                                        "x": 459,
                                                        "y": 265,
                                                        "h": 31,
                                                        "w": 31
                                                    },
                                                    {
                                                        "x": 529,
                                                        "y": 268,
                                                        "h": 32,
                                                        "w": 32
                                                    },
                                                    {
                                                        "x": 30,
                                                        "y": 310,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 40,
                                                        "y": 230,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 271,
                                                        "y": 272,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 314,
                                                        "y": 289,
                                                        "h": 36,
                                                        "w": 36
                                                    },
                                                    {
                                                        "x": 106,
                                                        "y": 299,
                                                        "h": 33,
                                                        "w": 33
                                                    }
                                                ]
                                            },
                                            "orig": {
                                                "faces": [
                                                    {
                                                        "x": 742,
                                                        "y": 98,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 559,
                                                        "y": 109,
                                                        "h": 59,
                                                        "w": 59
                                                    },
                                                    {
                                                        "x": 1016,
                                                        "y": 111,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 354,
                                                        "y": 324,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 856,
                                                        "y": 427,
                                                        "h": 60,
                                                        "w": 60
                                                    },
                                                    {
                                                        "x": 1078,
                                                        "y": 163,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 804,
                                                        "y": 174,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 255,
                                                        "y": 236,
                                                        "h": 61,
                                                        "w": 61
                                                    },
                                                    {
                                                        "x": 177,
                                                        "y": 558,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 663,
                                                        "y": 12,
                                                        "h": 63,
                                                        "w": 63
                                                    },
                                                    {
                                                        "x": 344,
                                                        "y": 22,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 1120,
                                                        "y": 29,
                                                        "h": 66,
                                                        "w": 66
                                                    },
                                                    {
                                                        "x": 887,
                                                        "y": 85,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 1195,
                                                        "y": 108,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 936,
                                                        "y": 171,
                                                        "h": 73,
                                                        "w": 73
                                                    },
                                                    {
                                                        "x": 842,
                                                        "y": 251,
                                                        "h": 64,
                                                        "w": 64
                                                    },
                                                    {
                                                        "x": 1019,
                                                        "y": 264,
                                                        "h": 75,
                                                        "w": 75
                                                    },
                                                    {
                                                        "x": 676,
                                                        "y": 420,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 1044,
                                                        "y": 499,
                                                        "h": 70,
                                                        "w": 70
                                                    },
                                                    {
                                                        "x": 973,
                                                        "y": 563,
                                                        "h": 67,
                                                        "w": 67
                                                    },
                                                    {
                                                        "x": 1122,
                                                        "y": 568,
                                                        "h": 68,
                                                        "w": 68
                                                    },
                                                    {
                                                        "x": 64,
                                                        "y": 658,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 85,
                                                        "y": 489,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 575,
                                                        "y": 577,
                                                        "h": 77,
                                                        "w": 77
                                                    },
                                                    {
                                                        "x": 666,
                                                        "y": 613,
                                                        "h": 78,
                                                        "w": 78
                                                    },
                                                    {
                                                        "x": 225,
                                                        "y": 634,
                                                        "h": 71,
                                                        "w": 71
                                                    }
                                                ]
                                            }
                                        },
                                        "sizes": {
                                            "large": {
                                                "h": 1440,
                                                "w": 1440,
                                                "resize": "fit"
                                            },
                                            "medium": {
                                                "h": 1200,
                                                "w": 1200,
                                                "resize": "fit"
                                            },
                                            "small": {
                                                "h": 680,
                                                "w": 680,
                                                "resize": "fit"
                                            },
                                            "thumb": {
                                                "h": 150,
                                                "w": 150,
                                                "resize": "crop"
                                            }
                                        },
                                        "original_info": {
                                            "height": 1440,
                                            "width": 1440,
                                            "focus_rects": [
                                                {
                                                    "x": 0,
                                                    "y": 281,
                                                    "w": 1440,
                                                    "h": 806
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 177,
                                                    "y": 0,
                                                    "w": 1263,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 612,
                                                    "y": 0,
                                                    "w": 720,
                                                    "h": 1440
                                                },
                                                {
                                                    "x": 0,
                                                    "y": 0,
                                                    "w": 1440,
                                                    "h": 1440
                                                }
                                            ]
                                        },
                                        "allow_download_status": {
                                            "allow_download": true
                                        },
                                        "media_results": {
                                            "result": {
                                                "media_key": "3_1777834011886329856"
                                            }
                                        }
                                    }
                                ]
                            },
                            "favorite_count": 61079,
                            "favorited": false,
                            "full_text": "Class night in Madrid, top support as usual 👌🏻 \n\nOnto the next one 👊🏻 https://t.co/YXM1h7lEeb",
                            "is_quote_status": false,
                            "lang": "en",
                            "possibly_sensitive": false,
                            "possibly_sensitive_editable": true,
                            "quote_count": 218,
                            "reply_count": 766,
                            "retweet_count": 4971,
                            "retweeted": false,
                            "user_id_str": "729365546861498368",
                            "id_str": "1777834755397935345"
                        }
                    }
                }
            }
        }
    ]
}